class $00df09d341073864$export$2e2bcd8739ae039 {
    #eventHandlers = {};
    /**
   * Adds an event handler for the specified event
   * @param event
   * @param handler
   * @returns A function that can be called to remove the event handler
   */ addEventListener(event, handler) {
        const handlers = this.#eventHandlers[event] ??= [];
        if (!handlers.includes(handler)) handlers.push(handler);
        return ()=>{
            const handlerIndex = handlers.indexOf(handler);
            if (handlerIndex !== -1) handlers.splice(handlerIndex, 1);
        };
    }
    removeEventListener(event, handler) {
        const handlers = this.#eventHandlers[event];
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
    }
    emit(event, payload) {
        this.#eventHandlers[event]?.forEach((handler)=>handler(payload));
    }
}


class $5082caf0e2beae35$var$ViewOptions extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    #showInstructions = false;
    #instructionsMode = 'auto';
    get instructionsMode() {
        return this.#instructionsMode;
    }
    set instructionsMode(mode) {
        if (mode !== this.#instructionsMode) {
            this.#instructionsMode = mode;
            this.emit('instructionsModeChange', mode);
        }
    }
    get showInstructions() {
        return this.#showInstructions;
    }
    set showInstructions(showInstructions) {
        if (showInstructions !== this.#showInstructions) {
            this.#showInstructions = showInstructions;
            this.emit('showInstructionsChange', {
                showInstructions: showInstructions
            });
        }
    }
}
const $5082caf0e2beae35$var$viewOptions = new $5082caf0e2beae35$var$ViewOptions();
var $5082caf0e2beae35$export$2e2bcd8739ae039 = $5082caf0e2beae35$var$viewOptions;


const $f003126099aabc1e$var$SLOW_PLAY_SPEED = 200;
var $f003126099aabc1e$var$PlayerMode = /*#__PURE__*/ function(PlayerMode) {
    PlayerMode[PlayerMode["CONTINUOUS"] = 0] = "CONTINUOUS";
    PlayerMode[PlayerMode["STEPS"] = 1] = "STEPS";
    return PlayerMode;
}($f003126099aabc1e$var$PlayerMode || {});
let $f003126099aabc1e$var$updateStepsTimeout;
class $f003126099aabc1e$export$2e2bcd8739ae039 {
    viewer;
    elements;
    stepCount;
    #isPlaying;
    #cancelNextPlayStep;
    #cancelHideInstruction;
    #showSteps = false;
    mode = 1;
    constructor(parentEl, viewer){
        this.viewer = viewer;
        this.elements = {
            player: parentEl,
            step: parentEl.querySelector('#step'),
            //stepInstructions: parentEl.querySelector('#step_instructions'),
            playerPosition: parentEl.querySelector('#player_position'),
            playBtn: parentEl.querySelector('#play_btn'),
            pauseBtn: parentEl.querySelector('#pause_btn'),
            text: parentEl.querySelector('#player_text'),
            prevBtn: parentEl.querySelector('#player_prev_btn'),
            nextBtn: parentEl.querySelector('#player_next_btn'),
            startBtn: parentEl.querySelector('#player_start_btn'),
            stepDirections: parentEl.querySelector('#player_step_directions'),
            stepDirectionsFrom: parentEl.querySelector('#player_step_directions_from'),
            stepDirectionsTo: parentEl.querySelector('#player_step_directions_to'),
            continuousMode: parentEl.querySelector('#player_continuous'),
            stepsMode: parentEl.querySelector('#player_steps'),
            instructionsToggleBtn: parentEl.querySelector('#player_instructions_toggle_btn')
        };
        this.stepCount = 0;
        this.#isPlaying = false;
        this.elements.playerPosition.addEventListener('input', ({ target: target })=>{
            if ('value' in target) this.goto(+target.value);
        });
        this.elements.playBtn.addEventListener('click', ()=>{
            this.play({
                restartIfAtEnd: true
            });
        });
        this.elements.pauseBtn.addEventListener('click', ()=>{
            this.pause();
        });
        this.elements.startBtn.addEventListener('click', ()=>{
            this.gotoStart();
        });
        this.elements.prevBtn.addEventListener('click', ()=>{
            this.prev();
        });
        this.elements.nextBtn.addEventListener('click', ()=>{
            this.next();
        });
        this.elements.instructionsToggleBtn.addEventListener('click', ()=>{
            const shouldShowInstructions = !(0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions;
            (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = shouldShowInstructions;
            if (shouldShowInstructions) this.gotoStart();
            else this.gotoEnd();
        });
        viewer.addEventListener('positionChange', ({ changeBy: changeBy })=>this.advance(changeBy));
        viewer.addEventListener('click', ()=>this.#isPlaying ? this.pause() : this.advance());
        viewer.addEventListener('touchStart', ()=>this.play({
                speed: $f003126099aabc1e$var$SLOW_PLAY_SPEED
            }));
        viewer.addEventListener('touchEnd', ()=>this.pause());
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).addEventListener('showInstructionsChange', ({ showInstructions: showInstructions })=>{
            if (showInstructions) this.#cancelHideInstruction?.();
            else {
                this.elements.player.classList.remove('with_steps');
                this.#showSteps = false;
            }
        });
    }
    updateStatus(isPlaying) {
        if (this.#isPlaying !== isPlaying) {
            this.elements.player.classList.toggle('playing');
            this.#isPlaying = isPlaying;
        }
    }
    update(stepCount, { draw: draw = true } = {}) {
        this.stepCount = stepCount;
        this.elements.playerPosition.setAttribute('max', String(this.stepCount));
        this.elements.step.innerText = `${this.stepCount}/${this.stepCount}`;
        // this.elements.text.style.removeProperty('width');
        // this.elements.text.style.width =
        //   (this.elements.text.clientWidth || 70) + 'px';
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = false;
        this.goto(this.stepCount, {
            updateStringArt: draw,
            showInstructions: false
        });
        this.#updateDirections();
    }
    updatePosition(position) {
        this.elements.step.innerText = `${position}/${this.stepCount}`;
        this.elements.playerPosition.value = String(position);
    }
    goto(position, { updateStringArt: updateStringArt = true, showInstructions: showInstructions = true } = {}) {
        if (position > this.stepCount || position < 1) return;
        clearTimeout($f003126099aabc1e$var$updateStepsTimeout);
        this.#cancelHideInstruction?.();
        this.pause();
        this.updatePosition(position);
        if (showInstructions) {
            (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = true;
            $f003126099aabc1e$var$updateStepsTimeout = setTimeout(()=>{
                if (!this.#showSteps) {
                    this.elements.player.classList.add('with_steps');
                    this.#showSteps = true;
                }
                this.#updateDirections(false);
            }, 200);
        }
        if (updateStringArt) this.viewer.goto(position);
        if ((0, $5082caf0e2beae35$export$2e2bcd8739ae039).instructionsMode === 'auto' && position === this.stepCount && (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions) {
            const hideIntructionsTimeout = setTimeout(()=>{
                (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = false;
            }, 1000);
            this.#cancelHideInstruction = ()=>clearTimeout(hideIntructionsTimeout);
        }
    }
    advance(value = 1) {
        this.goto(Math.max(1, Math.min(this.stepCount, Number(this.elements.playerPosition.value) + value)));
    }
    play({ restartIfAtEnd: restartIfAtEnd = false, speed: speed } = {}) {
        const isAtEnd = this.viewer.position === this.stepCount;
        if (isAtEnd && !restartIfAtEnd) return;
        this.updateStatus(true);
        this.#cancelNextPlayStep?.();
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = false;
        if (isAtEnd) this.viewer.goto(0);
        const step = ()=>{
            if (!this.viewer.next().done) {
                if (speed) {
                    const stepTimeout = setTimeout(step, speed);
                    this.#cancelNextPlayStep = ()=>clearTimeout(stepTimeout);
                } else {
                    const stepRafId = requestAnimationFrame(step);
                    this.#cancelNextPlayStep = ()=>cancelAnimationFrame(stepRafId);
                }
            } else this.updateStatus(false);
            this.updatePosition(this.viewer.position);
        };
        step();
    }
    pause() {
        this.#cancelNextPlayStep?.();
        this.updateStatus(false);
    }
    toggle() {
        if (this.#isPlaying) this.pause();
        else this.play();
    }
    prev() {
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = true;
        this.viewer.goto(this.viewer.position - 1);
        this.#updateDirections();
    }
    next() {
        if (this.viewer.position === this.stepCount) {
            (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = false;
            this.elements.nextBtn.setAttribute('disabled', 'disabled');
        } else {
            (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = true;
            this.viewer.goto(this.viewer.position + 1);
            this.#updateDirections();
        }
    }
    gotoStart() {
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = true;
        this.viewer.goto(0);
        this.#updateDirections();
    }
    gotoEnd() {
        this.viewer.goto(this.stepCount);
        this.#updateDirections();
    }
    #updateDirections(updatePosition = true) {
        if (updatePosition) this.updatePosition(this.viewer.position);
        const directions = this.viewer.getLastStringNailNumbers();
        if (directions) {
            this.elements.stepDirectionsFrom.textContent = directions[0].toString();
            this.elements.stepDirectionsTo.textContent = directions[1].toString();
        }
        if (this.viewer.position === 1) {
            this.elements.prevBtn.setAttribute('disabled', 'disabled');
            this.elements.startBtn.setAttribute('disabled', 'disabled');
            this.elements.nextBtn.removeAttribute('disabled');
        } else {
            this.elements.prevBtn.removeAttribute('disabled');
            this.elements.startBtn.removeAttribute('disabled');
            if (this.viewer.position === this.stepCount) this.elements.nextBtn.setAttribute('disabled', 'disabled');
            else this.elements.nextBtn.removeAttribute('disabled');
        }
    }
}


var $2d2165ae7b4acbcd$exports = {};
$2d2165ae7b4acbcd$exports = "fieldset{border:var(--border-light);background:#ffffff08;border-radius:9px;padding-inline:.5em}fieldset>legend{cursor:pointer;opacity:.8}fieldset>legend:hover{opacity:1}div{padding-top:8px}fieldset.minimized{background:0 0;border:none;padding:0}fieldset.minimized>legend{padding:0;transform:translate(-6px)}fieldset.minimized>div{display:none}legend:before{content:\"\";opacity:.7;vertical-align:top;margin-inline-end:2px;font-family:string_art_studio;font-size:20px;display:inline-block}fieldset.minimized>legend:before{transform:rotate(-90deg)}";


const $4a7965eeea97d4bb$var$sheet = new CSSStyleSheet();
$4a7965eeea97d4bb$var$sheet.replaceSync(String($2d2165ae7b4acbcd$exports));
class $4a7965eeea97d4bb$export$dbf21a0adc6a9ee0 extends HTMLElement {
    #legend;
    #fieldset;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $4a7965eeea97d4bb$var$sheet
        ];
        this.shadowRoot.innerHTML = `
      <fieldset>
        <legend></legend>
        <div>
            <slot></slot>
        </div>
      </fieldset>
      `;
        this.#legend = shadow.querySelector('legend');
        this.#fieldset = shadow.querySelector('fieldset');
        this.#legend.addEventListener('click', ()=>this.toggle());
    }
    static get observedAttributes() {
        return [
            'legend',
            'minimized'
        ];
    }
    connectedCallback() {
        this.syncAttributes();
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    syncAttributes() {
        if (this.hasAttribute('legend')) this.#legend.textContent = this.getAttribute('legend');
        else {
            this.#fieldset.classList.remove('minimized');
            this.#legend.textContent = '';
        }
        if (this.hasAttribute('minimized')) this.#fieldset.classList.add('minimized');
        else this.#fieldset.classList.remove('minimized');
    }
    toggle() {
        this.#fieldset.classList.toggle('minimized');
    }
    open() {
        this.#fieldset.classList.remove('minimized');
    }
    close() {
        this.#fieldset.classList.add('minimized');
    }
}
customElements.define('expandable-panel', $4a7965eeea97d4bb$export$dbf21a0adc6a9ee0);


var $c743accf33ce06b6$exports = {};
$c743accf33ce06b6$exports = ":root{--color-accent:#ff218f;--color-accent-hover:#b11b66;--color-buttons-dialog:#212124;--color-canvas-background:#0e0e0e;--color-config:#212124;--color-gray3:#262629;--color-header:#2b2b31;--color-lighter:#ffffff87;--color-link:#68c0ff;--color-link-hover:#85ccff;--color-player:#222226;--color-text:White;--color-text-hover:#85ccff;--color-input:#c51880;--color-input-hover:#961663;--color-input-active:#e20c8c;--color-dialog-background:#212124;--color-error:#c00;--horizontal-padding:16px;--vertical-padding:12px;--logo1:#9892ff;--logo1-active:#c5c2ff;--logo2:#d4c1ff;--border-light:solid 1px #3a3a3a;--border-lighter:dotted 1px #505050;--border-dialog:solid 1px #fff3;--circular_button_width:38px;--controls-height:50px;--header-height:45px;--select-height:49px;--sidebar-form-padding-top:16px;--sidebar-width:270px;--player-mobile-height:100px;--responsive-width:800px}span{white-space:nowrap}input{appearance:none;cursor:pointer;vertical-align:middle;border:2px solid #666;border-radius:2px;width:18px;height:18px;margin:0 2px;position:relative}input:checked{background-color:var(--color-input-active);border-color:var(--color-input)}input:checked:after{content:\"\";border:2px solid #fff;border-width:0 2px 2px 0;width:4px;height:11px;position:absolute;top:-1px;left:4px;transform:rotate(36deg)}label{margin-top:0;margin-inline-start:2px;font-size:14px;display:inline-block;position:relative;top:1px}";


const $3ce3bee09e11519c$var$sheet = new CSSStyleSheet();
$3ce3bee09e11519c$var$sheet.replaceSync(String($c743accf33ce06b6$exports));
class $3ce3bee09e11519c$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    #checked;
    disabled = false;
    #label;
    #input;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        shadow.adoptedStyleSheets = [
            $3ce3bee09e11519c$var$sheet
        ];
        this.shadowRoot.innerHTML = `
          <span>
            <input id="checkbox" type="checkbox">
            <label for="checkbox"></label>
          </span>
        `;
        this.#input = shadow.querySelector('input');
        this.#label = shadow.querySelector('label');
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'checked',
            'label',
            'disabled',
            'name'
        ];
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    get checked() {
        return this.#checked;
    }
    set checked(v) {
        if (this.#checked = v) this.#input.checked = true;
        else this.#input.checked = false;
        this.internals.setFormValue(this.#checked ? 'on' : null);
    }
    get value() {
        return this.checked;
    }
    set value(v) {
        this.checked = v;
    }
    connectedCallback() {
        this.syncAttributes();
        this.#input.addEventListener('input', ()=>{
            this.#checked = this.#input.checked;
            this.internals.setFormValue(this.#checked ? 'on' : null);
            this.dispatchEvent(new CustomEvent('input', {
                detail: {
                    checked: this.#checked
                }
            }));
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    checked: this.#checked
                },
                bubbles: true
            }));
        });
        this.internals.setFormValue(this.#checked ? 'on' : null);
        this.tabIndex = 0;
    }
    syncAttributes() {
        if (this.hasAttribute('label')) this.#label.textContent = this.hasAttribute('label') ? this.getAttribute('label') : '';
        if (this.hasAttribute('checked')) this.checked = true;
        if (this.hasAttribute('disabled')) this.disabled = true;
        if (this.hasAttribute('name')) this.internals.setFormValue(this.#checked ? 'on' : null);
    }
    focus() {
        this.#input.focus();
    }
    blur() {
        this.#input.blur();
    }
}
customElements.define('string-art-checkbox', $3ce3bee09e11519c$export$2e2bcd8739ae039);


const $c6b5ffbe96e4aeb4$var$DEFAULT_THUMB_COLOR = 'white';
const $c6b5ffbe96e4aeb4$var$FULL_GAMUT_GRADIENT = 'linear-gradient(to right in hsl longer hue, hsl(1 100 50), hsl(360 100 50))';
class $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    start = 1;
    colorThumb = false;
    reverse = false;
    type = 'hue';
    #input = null;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        this.shadowRoot.innerHTML = `
        <string-art-range-input min="1" max="360" step="1" />
    `;
        this.#input = this.shadowRoot.querySelector('string-art-range-input');
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'start',
            'colorthumb',
            'value',
            'reverse',
            'type'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'value') this.value = newVal;
        if (name === 'start') {
            this.start = parseInt(newVal, 10);
            this.#setBackground();
        }
        if (name === 'reverse') {
            this.reverse = !!newVal;
            this.#setBackground();
        }
        if (name === 'colorthumb') {
            this.colorThumb = !!newVal;
            this.#setThumbColor();
        // Update color thumb
        }
        if (name === 'type') {
            this.type = newVal === 'range' ? 'range' : 'hue';
            this.#setBackground();
        }
    }
    get value() {
        return this.#input.value;
    }
    set value(v) {
        this.#input.value = v;
        this.#setBackground();
        if (this.colorThumb) this.#setThumbColor();
    }
    connectedCallback() {
        if (this.hasAttribute('value')) this.value = parseInt(this.getAttribute('value'));
        if (this.hasAttribute('colorthumb')) this.colorThumb = true;
        this.#setThumbColor();
        this.#input.addEventListener('input', (e)=>this.#handleInput(e));
    }
    #handleInput(e) {
        const value = this.value;
        this.internals.setFormValue(String(value));
        this.dispatchEvent(new CustomEvent('input', {
            detail: {
                value: value
            }
        }));
        this.#setBackground();
        this.#setThumbColor();
    }
    disconnectedCallback() {
    // Destroy EditorControls here
    }
    focus() {}
    blur() {}
    #setBackground() {
        const background = this.type === 'range' ? `linear-gradient(to ${this.reverse ? 'left' : 'right'} in hsl ${this.value >= 180 ? 'longer' : 'shorter'} hue, hsl(${this.start} 100 50), hsl(${// Fixes a bug in Chrome, that for a 180 deg hue gradient, it always goes in reverse
        this.start + (this.value === 180 ? 181 : this.value)} 100 50))` : $c6b5ffbe96e4aeb4$var$FULL_GAMUT_GRADIENT;
        this.#input.setAttribute('background', background);
    }
    #setThumbColor() {
        const thumbColor = this.colorThumb ? `hsl(${this.value}deg 100 50)` : $c6b5ffbe96e4aeb4$var$DEFAULT_THUMB_COLOR;
        this.#input.setAttribute('thumbcolor', thumbColor);
    }
}
customElements.define('string-art-hue-input', $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039);


const $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE = 0.05;
const $01dabe55fddff864$var$THUMB_RADIUS = 8;
const $01dabe55fddff864$var$TICK_WIDTH = 2;
const $01dabe55fddff864$var$TICK_COLOR = 'rgba(0,0,0,.2)';
const $01dabe55fddff864$var$FAR_VALUES_DISTANCE = 0.2; // values are considered far from each other if they are at least a fifth of the width of the input apart
class $01dabe55fddff864$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    min;
    max;
    #input = null;
    #backgroundStyle = null;
    #snap = $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
    #prevValue = null;
    #prevSnapValue = null;
    #tickValues = null;
    #snapDistance = null;
    #background = null;
    #thumbColor = null;
    #snapDisabledTick = null;
    #resizeObserver;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        this.shadowRoot.innerHTML = `
          <style>
            input[type="range"] {
              width: 100%;
              appearance: none;
              -webkit-appearance: none; /* remove iOS default */
              background: transparent;
              border: none;
              margin: 2px;
              cursor: pointer;
            }

            input[type="range"]::-webkit-slider-thumb {
              appearance: none;
              -webkit-appearance: none;
              width: ${$01dabe55fddff864$var$THUMB_RADIUS * 2}px;
              height: ${$01dabe55fddff864$var$THUMB_RADIUS * 2}px;
              border-radius: 50%;
              background: var(--color-input);
              cursor: pointer;
              border: none;
              margin-top: -4px;
              z-index: 10;
              box-shadow: 0 0 5px rgba(0,0,0,.5)
            }

            input[type="range"]::-webkit-slider-thumb:hover {
              background: var(--color-input-hover);
            }
              
            input[type="range"]:active::-webkit-slider-thumb {
              background: var(--color-input-active);
            }

            input[type="range"]::-webkit-slider-runnable-track {
              height: 8px;
              border-radius: 4px;
              margin: 0;
            }
          </style>
          <style id="background"></style>
          <input type="range">
        `;
        this.#input = this.shadowRoot.querySelector('input[type="range"]');
        this.#backgroundStyle = this.shadowRoot.querySelector('#background');
        this.#snap = $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
        this.#prevSnapValue = null;
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'min',
            'max',
            'value',
            'step',
            'snap',
            'background',
            'thumbcolor'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'snap') this.#tickValues = this.getTickValues();
        else if (this.#input) this.#input[name] = newVal;
        if (name === 'min' || name === 'max') this[name] = Number(newVal);
        let value;
        if (name === 'value') value = Number(newVal);
        if (name === 'background') this.#background = newVal;
        if (name === 'thumbcolor') this.#thumbColor = newVal;
        if (this.min != null && this.max != null) {
            if (this.min > this.max) {
                this.max = this.min;
                this.#input.max = String(this.min);
            }
            this.#snapDistance = (this.max - this.min) * this.#snap || $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
            if (this.#tickValues && this.value != null) {
                const snappedValue = this.getClosestTick(value);
                if (snappedValue != null) this.#prevSnapValue = snappedValue;
            }
        }
        this.#setStyle();
    }
    get value() {
        return Number(this.#input.value);
    }
    set value(v) {
        this.#input.value = String(v);
        this.#setStyle();
    }
    connectedCallback() {
        [
            'min',
            'max',
            'value',
            'step'
        ].forEach((attr)=>{
            if (this.hasAttribute(attr)) this.#input[attr] = this.getAttribute(attr);
        });
        this.#tickValues = this.getTickValues();
        this.#resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries){
                const width = entry.contentRect.width;
                this.#setStyle();
            }
        });
        this.#resizeObserver.observe(this.#input);
        this.#input.addEventListener('input', ()=>this.handleInput());
        this.#input.addEventListener('keydown', (e)=>this.handleKeydown(e));
        this.#input.addEventListener('change', ()=>this.#snapDisabledTick = null);
        this.tabIndex = 0;
    }
    disconnectedCallback() {
        this.#resizeObserver.unobserve(this);
    }
    getTickValues() {
        const ticks = this.getAttribute('snap');
        const ticksMatch = ticks?.match(/\d+(\.\d+)?/g);
        if (!ticksMatch) return [];
        return ticksMatch.map(Number).filter((n)=>!isNaN(n)).sort();
    }
    #shouldAvoidSnap(newValue, closestTick) {
        if (closestTick == null) closestTick = this.getClosestTick(newValue);
        if (closestTick == null) return true;
        // If moving away from the snap value, don't snap:
        const distanceFromTick = Math.abs(newValue - closestTick);
        if (distanceFromTick >= this.#snapDistance / 2 && distanceFromTick > Math.abs(this.#prevValue - closestTick)) return true;
        return false;
    }
    // Checks whether two values are far apart,
    #areValuesFar(value1, value2) {
        const distance = Math.abs(value1 - value2) / (this.max - this.min);
        return distance >= $01dabe55fddff864$var$FAR_VALUES_DISTANCE;
    }
    focus() {
        this.#input.focus();
    }
    blur() {
        this.#input.blur();
    }
    handleInput() {
        const value = Number(this.#input.value);
        const closestTick = this.getClosestTick(value);
        this.internals.setFormValue(this.#input.value);
        if (closestTick != null && this.#snapDisabledTick !== closestTick && this.#shouldAvoidSnap(value, closestTick)) this.#snapDisabledTick = closestTick;
        if (closestTick !== this.#snapDisabledTick) {
            if (closestTick !== null) {
                this.#input.value = String(closestTick);
                if (closestTick !== this.#prevSnapValue) {
                    this.#vibrate();
                    this.#prevSnapValue = closestTick;
                }
            } else if (this.#prevSnapValue != null) this.#prevSnapValue = null;
        }
        if (this.#snapDisabledTick != null && closestTick == null && this.#areValuesFar(value, this.#snapDisabledTick)) this.#snapDisabledTick = null;
        this.#setStyle();
        this.#prevValue = value;
        this.dispatchEvent(new CustomEvent('input', {
            detail: {
                value: this.#input.value
            }
        }));
    }
    handleKeydown(event) {
        event.preventDefault();
        const step = Number(this.#input.step || 1);
        const value = Number(this.#input.value);
        let newValue;
        if (event.key === 'ArrowLeft') newValue = Math.max(this.min, value - step);
        else if (event.key === 'ArrowRight') newValue = Math.min(this.max, value + step);
        else if (event.key === 'ArrowUp') {
            const next = this.#tickValues.find((t)=>t > value);
            if (next !== undefined) newValue = next;
            else if (value !== this.max) // no next tick found, go to max
            newValue = this.max;
        } else if (event.key === 'ArrowDown') {
            const reversed = [
                ...this.#tickValues
            ].reverse();
            const prev = reversed.find((t)=>t < value);
            if (prev !== undefined) newValue = prev;
            else if (value !== this.min) newValue = this.min;
        }
        if (newValue != null) {
            this.value = newValue;
            this.#prevValue = newValue;
            // emit event and prevent default for arrow keys
            this.dispatchEvent(new CustomEvent('input', {
                detail: {
                    value: newValue
                },
                bubbles: true,
                composed: true
            }));
        }
        return false;
    }
    getClosestTick(value) {
        if (!this.#tickValues || this.#tickValues.length === 0) return null;
        for (const tickValue of this.#tickValues){
            const distance = Math.abs(value - tickValue);
            if (distance <= this.#snapDistance) return tickValue;
        }
        return null;
    }
    #vibrate() {
        if ('vibrate' in navigator) navigator.vibrate(10);
    }
    #setStyle() {
        const inputWidth = this.#input.clientWidth;
        if (!inputWidth) return;
        const valueInRange = this.value - this.min;
        const range = this.max - this.min;
        const availableWidth = inputWidth - 2 * $01dabe55fddff864$var$THUMB_RADIUS;
        const valueWidth = $01dabe55fddff864$var$THUMB_RADIUS + availableWidth * valueInRange / range;
        // The center of the thumb of the range input doesn't reach 0 and 100%, so the actual range to display leaves out the thumb's radius on the left and right.
        // Due to this, the ticks are placed in the constricted range of [THUMB_RADIUS::inputWidth - 2 * THUMB_RADIUS]
        const tickPositions = this.#tickValues?.filter((v)=>v !== this.min && v !== this.max).map((v)=>$01dabe55fddff864$var$THUMB_RADIUS + availableWidth * (v - this.min) / range - $01dabe55fddff864$var$TICK_WIDTH / 2);
        const tickPositionsInGradient = tickPositions?.map((p)=>`transparent ${p}px, ${$01dabe55fddff864$var$TICK_COLOR} ${p}px, ${$01dabe55fddff864$var$TICK_COLOR} ${p + $01dabe55fddff864$var$TICK_WIDTH}px, transparent ${p + $01dabe55fddff864$var$TICK_WIDTH}px`).join(', ');
        const ticksBackground = tickPositions?.length ? `linear-gradient(to right, ${tickPositionsInGradient}), ` : null;
        const styles = [
            `input[type="range"]::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}${this.#background ?? `linear-gradient(to right, var(--color-input) ${valueWidth}px, #ddd ${valueWidth}px)`};
      }${this.#background ? '' : `
       input[type="range"]:hover::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}linear-gradient(to right, var(--color-input-hover) ${valueWidth}px, #ddd ${valueWidth}px);
      }
        input[type="range"]:active::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}linear-gradient(to right, var(--color-input-active) ${valueWidth}px, #ddd ${valueWidth}px);
      }`}`
        ];
        if (this.#thumbColor != null) styles.push(`input[type="range"]::-webkit-slider-thumb { background: ${this.#thumbColor} !important}`);
        this.#backgroundStyle.innerHTML = styles.join('\n');
    }
}
customElements.define('string-art-range-input', $01dabe55fddff864$export$2e2bcd8739ae039);


function $8d5cef8e7fea78a8$export$f823a0c1cf7adf68(element) {
    element.removeAttribute('hidden');
}
function $8d5cef8e7fea78a8$export$fe8985bb6374093c(element) {
    element.setAttribute('hidden', 'hidden');
}
function $8d5cef8e7fea78a8$export$1a3b688c8bc0de17(element, isHidden) {
    if (isHidden != null) isHidden ? $8d5cef8e7fea78a8$export$fe8985bb6374093c(element) : $8d5cef8e7fea78a8$export$f823a0c1cf7adf68(element);
    else if (element.hasAttribute('hidden')) $8d5cef8e7fea78a8$export$f823a0c1cf7adf68(element);
    else $8d5cef8e7fea78a8$export$fe8985bb6374093c(element);
}



const $da037f8140467741$var$elements = {
    controls: document.querySelector('#controls'),
    controlsPanel: document.querySelector('#controls_panel'),
    design: document.querySelector('#design')
};
const $da037f8140467741$var$STATE_LOCAL_STORAGE_KEY = 'controls_state';
const $da037f8140467741$var$RANGE_SCROLL_LOCK_TIMEOUT = 120;
let $da037f8140467741$var$inputTimeout;
class $da037f8140467741$export$2e2bcd8739ae039 extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    config;
    controlsConfig;
    state;
    controlElements = {};
    #postponeRangeInput = false;
    #postponeRangeInputTimeout;
    #wrappedOnInput;
    #wrappedOnTouchStart;
    #wrappedOnTouchEnd;
    #wrappedOnRangeScroll;
    #currentInputRange;
    #currentInputRangeValue;
    #rangeLockTimeout;
    #lockRange = false;
    #boundToggleFieldset;
    constructor(controlsConfig, config){
        super();
        this.config = config;
        this.controlsConfig = controlsConfig;
        this.state = this._getState() ?? {
            groups: {}
        };
        this.#wrappedOnInput = this.#onInput.bind(this);
        $da037f8140467741$var$elements.controls.addEventListener('input', this.#wrappedOnInput);
        this.#wrappedOnTouchStart = this.#onTouchStart.bind(this);
        $da037f8140467741$var$elements.controls.addEventListener('touchstart', this.#wrappedOnTouchStart, {
            passive: true
        });
        $da037f8140467741$var$elements.controls.addEventListener('mousedown', this.#onMouseDown);
        this.#boundToggleFieldset = this.#toggleFieldset.bind(this);
        $da037f8140467741$var$elements.design.addEventListener('click', this.#boundToggleFieldset);
        $da037f8140467741$var$elements.design.addEventListener('keydown', this.#toggleFieldSetOnEnter);
        this.controlElements = {};
        this.renderControls();
        const menu = document.querySelector('#controls_menu');
        const controlsPanel = document.querySelector('#controls_panel');
        menu.addEventListener('click', (e)=>{
            if (e.target instanceof HTMLElement) {
                const href = e.target.closest('.controls_menu_item')?.getAttribute('href');
                e.preventDefault();
                if (href) {
                    if (href === '#controls_top') controlsPanel.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    else {
                        const menuTarget = document.querySelector(href);
                        if (menuTarget instanceof (0, $4a7965eeea97d4bb$export$dbf21a0adc6a9ee0)) {
                            menuTarget.open();
                            menuTarget.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }
                    }
                }
            }
        });
    }
    destroy() {
        $da037f8140467741$var$elements.controls.removeEventListener('input', this.#wrappedOnInput);
        $da037f8140467741$var$elements.design.removeEventListener('click', this.#boundToggleFieldset);
        $da037f8140467741$var$elements.design.removeEventListener('keydown', this.#toggleFieldSetOnEnter);
        $da037f8140467741$var$elements.controls.removeEventListener('touchstart', this.#wrappedOnTouchStart);
        $da037f8140467741$var$elements.controls.removeEventListener('mousedown', this.#onMouseDown);
        $da037f8140467741$var$elements.controls.innerHTML = '';
    }
    #toggleFieldset(e) {
        if (e.target.nodeName === 'LEGEND') {
            e.target.parentElement.classList.toggle('minimized');
            const groupId = e.target.parentElement.dataset.group;
            this.state = {
                ...this.state,
                groups: {
                    ...this.state.groups,
                    [groupId]: !e.target.parentElement.classList.contains('minimized')
                }
            };
            this._updateState(this.state);
        }
    }
    #toggleFieldSetOnEnter(e) {
        if (e.target.nodeName === 'LEGEND' && e.key === 'Enter') this.#toggleFieldset(e);
    }
    #onMouseDown() {
        // Clearing selection when starting to click in the controls, do avoid a buggy behavior,
        // when if a control's display value was selected (can happen by mistake), the drag of range input doesn't work.
        const selection = window.getSelection();
        if (selection) selection.removeAllRanges();
    }
    /**
   * Needed for range inputs, to avoid changing the value when the user drags to
   * scroll and accidentally touches a range input when intending to scroll.
   * @param {Event} e
   */ #onTouchStart(e) {
        if ($da037f8140467741$var$isRangeInput(e.target)) {
            this.#postponeRangeInput = true;
            this.#currentInputRange = e.target;
            this.#currentInputRangeValue = e.target.value;
            this.#rangeLockTimeout = window.setTimeout(()=>{
                this.#postponeRangeInput = false;
            }, $da037f8140467741$var$RANGE_SCROLL_LOCK_TIMEOUT);
            this.#wrappedOnTouchEnd = this.#onTouchEnd.bind(this);
            document.body.addEventListener('touchend', this.#wrappedOnTouchEnd, {
                passive: true
            });
            this.#wrappedOnRangeScroll = this.#onRangeScroll.bind(this);
            $da037f8140467741$var$elements.controlsPanel.addEventListener('scroll', this.#wrappedOnRangeScroll);
        }
    }
    #onTouchEnd() {
        document.body.removeEventListener('touchend', this.#wrappedOnTouchEnd);
        $da037f8140467741$var$elements.controlsPanel.removeEventListener('scroll', this.#wrappedOnRangeScroll);
        if (this.#lockRange) {
            this.#lockRange = false;
            if (this.#currentInputRange) this.#currentInputRange.value = this.#currentInputRangeValue;
        }
        this.#currentInputRange = this.#currentInputRangeValue = null;
    }
    #onRangeScroll() {
        this.#lockRange = true;
    }
    #onInput(e) {
        clearTimeout($da037f8140467741$var$inputTimeout);
        clearTimeout(this.#postponeRangeInputTimeout);
        if (this.#postponeRangeInput && $da037f8140467741$var$isRangeInput(e.target)) {
            e.preventDefault();
            this.#postponeRangeInputTimeout = window.setTimeout(()=>{
                this.#onInput(e);
            }, $da037f8140467741$var$RANGE_SCROLL_LOCK_TIMEOUT);
            return false;
        }
        if (this.#lockRange) {
            e.preventDefault();
            return false;
        }
        if (e.target instanceof HTMLInputElement || e.target instanceof (0, $3ce3bee09e11519c$export$2e2bcd8739ae039) || $da037f8140467741$var$isRangeInput(e.target) || e.target instanceof HTMLSelectElement) this.updateInput({
            inputElement: e.target,
            originalEvent: e,
            deferChange: true
        });
    }
    updateControlDisplayValue(controlKey) {
        const { config: config, displayValueElement: displayValueElement, input: input } = this.controlElements[controlKey];
        if (displayValueElement) {
            const formattedValue = config.displayValue ? config.displayValue(this.config) : input.value;
            displayValueElement.innerText = String(formattedValue);
        }
    }
    updateInput({ inputElement: inputElement, originalEvent: originalEvent, deferChange: deferChange = true }) {
        const controlKey = inputElement.id.replace(/^config_/, '');
        const inputValue = $da037f8140467741$var$getInputValue(inputElement);
        if (this.config[controlKey] === inputValue) return;
        const eventData = {
            control: this.controlElements[controlKey].config,
            value: inputValue,
            originalEvent: originalEvent
        };
        this.emit('input', eventData);
        const triggerChange = ()=>{
            this.emit('change', eventData);
            this.updateControlsVisibility();
            this.updateControlsLabels();
        };
        this.updateControlsAttributes();
        this.updateControlDisplayValue(controlKey);
        if (deferChange) $da037f8140467741$var$inputTimeout = window.setTimeout(triggerChange, 100);
        else triggerChange();
    }
    _getState() {
        const state = localStorage.getItem($da037f8140467741$var$STATE_LOCAL_STORAGE_KEY);
        if (state) try {
            return JSON.parse(state);
        } catch (e) {
            return null;
        }
        return null;
    }
    _updateState(newState) {
        if (newState) localStorage.setItem($da037f8140467741$var$STATE_LOCAL_STORAGE_KEY, JSON.stringify(newState));
        else localStorage.removeItem($da037f8140467741$var$STATE_LOCAL_STORAGE_KEY);
    }
    updateControlsAttributes(controlsConfig) {
        if (!controlsConfig) controlsConfig = this.controlsConfig;
        controlsConfig.forEach((control)=>{
            if (control.type === 'group') this.updateControlsAttributes(control.children);
            else if (control.attr) {
                const functionAttrs = Object.entries(control.attr).filter(([_, value])=>value instanceof Function);
                if (functionAttrs.length) {
                    const inputEl = this.controlElements[control.key].input;
                    if (inputEl) functionAttrs.forEach(([name, attributeValueFn])=>{
                        const newAttrValue = this.getConfigValue(attributeValueFn, this.config);
                        if (newAttrValue != inputEl.getAttribute(name)) {
                            inputEl.setAttribute(name, String(newAttrValue));
                            // If the min or max of the input changed and they're not within the new min/max, update the value of the input
                            if (name === 'min' && inputEl.value < newAttrValue || name === 'max' && inputEl.value > newAttrValue) {
                                inputEl.value = String(newAttrValue);
                                clearTimeout(inputEl.updateTimeout);
                                inputEl.updateTimeout = window.setTimeout(()=>{
                                    this.updateInput({
                                        inputElement: inputEl
                                    });
                                }, 100);
                            } else this.updateControlDisplayValue(control.key);
                        }
                    });
                }
            }
        });
    }
    updateControlsLabels(controlsConfig) {
        (controlsConfig ?? this.controlsConfig).forEach((control)=>{
            if (control.label instanceof Function) {
                const { label: labelEl, element: element } = this.controlElements[control.key];
                const labelText = control.label(this.config);
                if (control.type === 'checkbox') element.setAttribute('label', labelText);
                else if (control.type === 'group') element.setAttribute('legend', labelText);
                else if (labelEl) labelEl.innerText = labelText;
            }
            if (control.type === 'group') this.updateControlsLabels(control.children);
        });
    }
    updateControlsVisibility(controlsConfig) {
        (controlsConfig ?? this.controlsConfig).forEach((control)=>{
            if (control.show) {
                const shouldShowControl = control.show(this.config);
                const controlEl = this.controlElements[control.key].element;
                if (controlEl) (0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(controlEl, !shouldShowControl);
            }
            if (control.isDisabled) {
                const shouldDisableControl = control.isDisabled(this.config);
                const inputEl = this.controlElements[control.key].input;
                if (inputEl) {
                    if (shouldDisableControl) inputEl.setAttribute('disabled', 'disabled');
                    else inputEl.removeAttribute('disabled');
                }
            }
            if (control.children) this.updateControlsVisibility(control.children);
        });
    }
    renderControls(containerEl = $da037f8140467741$var$elements.controls, _controlsConfig, indexStart) {
        const controlsConfig = _controlsConfig ?? this.controlsConfig;
        containerEl.innerHTML = '';
        const controlsFragment = document.createDocumentFragment();
        indexStart = indexStart ?? 1;
        controlsConfig.forEach((controlConfig, controlIndex)=>{
            const controlId = `config_${String(controlConfig.key)}`;
            let controlEl;
            let inputEl;
            let displayValueElement;
            let label;
            if (controlConfig.type === 'group') {
                controlEl = document.createElement('expandable-panel');
                controlEl.setAttribute('legend', this.getConfigValue(controlConfig.label, this.config));
                controlEl.setAttribute('data-group', String(controlConfig.key));
                controlEl.className = 'control control_group';
                if (controlConfig.defaultValue === 'minimized') {
                    controlEl.setAttribute('minimized', 'minimized');
                    this.state.groups[String(controlConfig.key)] = false;
                }
                this.renderControls(controlEl, controlConfig.children);
            } else {
                controlEl = document.createElement('div');
                controlEl.className = 'control';
                if (controlConfig.type !== 'checkbox') {
                    label = document.createElement('label');
                    label.innerHTML = this.getConfigValue(controlConfig.label, this.config);
                    label.setAttribute('for', controlId);
                }
                inputEl = document.createElement($da037f8140467741$var$getElementTagNameForControlType(controlConfig.type));
                if ($da037f8140467741$var$isRangeInput(inputEl)) inputEl.classList.add('range-input');
                inputEl.setAttribute('tabindex', String(controlIndex));
                const inputValue = this.config[controlConfig.key] ?? this.getConfigValue(controlConfig.defaultValue, this.config);
                if (controlConfig.type === 'select') {
                    const selectOptions = document.createDocumentFragment();
                    controlConfig.options.forEach((_option)=>{
                        const { value: value, label: label } = typeof _option === 'string' ? {
                            value: _option,
                            label: _option
                        } : _option;
                        const optionEl = document.createElement('option');
                        optionEl.setAttribute('value', value);
                        optionEl.innerText = label;
                        selectOptions.appendChild(optionEl);
                    });
                    inputEl.appendChild(selectOptions);
                    inputEl.value = String(inputValue);
                    controlEl.appendChild(label);
                    controlEl.appendChild(inputEl);
                } else {
                    if (controlConfig.type !== 'range') inputEl.setAttribute('type', controlConfig.type);
                    if (controlConfig.type === 'checkbox') {
                        inputEl.checked = !!inputValue;
                        inputEl.setAttribute('label', this.getConfigValue(controlConfig.label, this.config));
                        controlEl.appendChild(inputEl);
                    } else {
                        controlEl.appendChild(label);
                        controlEl.appendChild(inputEl);
                        setTimeout(()=>{
                            inputEl.value = String(inputValue);
                        });
                        displayValueElement = document.createElement('span');
                        displayValueElement.id = `config_${String(controlConfig.key)}_value`;
                        displayValueElement.innerText = String(controlConfig.displayValue ? controlConfig.displayValue(this.config) : inputValue);
                        displayValueElement.className = 'control_input_value';
                        controlEl.appendChild(displayValueElement);
                    }
                }
                if (controlConfig.attr) Object.entries(controlConfig.attr).forEach(([attr, value])=>{
                    const realValue = this.getConfigValue(value, this.config);
                    inputEl.setAttribute(attr, String(realValue));
                });
                inputEl.id = controlId;
            }
            this.controlElements[controlConfig.key] = {
                config: controlConfig,
                displayValueElement: displayValueElement,
                input: inputEl,
                element: controlEl,
                label: label
            };
            controlEl.id = `control_${String(controlConfig.key)}`;
            controlsFragment.appendChild(controlEl);
        });
        containerEl.appendChild(controlsFragment);
        this.updateGroupsState();
        requestAnimationFrame(()=>this.updateControlsVisibility());
    }
    updateGroupsState() {
        const groups = $da037f8140467741$var$elements.design.querySelectorAll('[data-group]');
        groups.forEach((groupEl)=>{
            if (groupEl instanceof HTMLFieldSetElement) {
                const groupId = groupEl.dataset.group;
                const groupState = this.state.groups[groupId];
                if (typeof groupState === 'boolean') {
                    if (groupState) groupEl.classList.remove('minimized');
                    else groupEl.classList.add('minimized');
                }
            }
        });
    }
    getConfigValue(valueOrFn, config) {
        if (valueOrFn instanceof Function) return valueOrFn(config);
        return valueOrFn;
    }
}
function $da037f8140467741$var$getInputValue(inputElement) {
    if ($da037f8140467741$var$isRangeInput(inputElement)) return Number(inputElement.value);
    if (inputElement instanceof HTMLInputElement) {
        const type = inputElement.type;
        switch(type){
            case 'range':
                return parseFloat(inputElement.value);
            case 'hue':
                return inputElement.value;
            case 'checkbox':
                return inputElement.checked;
            case 'number':
                return parseFloat(inputElement.value);
            default:
                return inputElement.value;
        }
    } else if (inputElement instanceof (0, $3ce3bee09e11519c$export$2e2bcd8739ae039)) return inputElement.checked;
    else if (inputElement instanceof HTMLSelectElement) return inputElement.value;
}
function $da037f8140467741$var$getElementTagNameForControlType(controlType) {
    switch(controlType){
        case 'select':
            return 'select';
        case 'range':
            return 'string-art-range-input';
        case 'hue':
            return 'string-art-hue-input';
        case 'checkbox':
            return 'string-art-checkbox';
        default:
            return 'input';
    }
}
function $da037f8140467741$var$isRangeInput(element) {
    return element instanceof (0, $01dabe55fddff864$export$2e2bcd8739ae039) || element instanceof (0, $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039);
}



const $66d8ae1974721b90$var$DEFAULT_OPTIONS = {
    updateOnResize: true
};
class $66d8ae1974721b90$export$2e2bcd8739ae039 extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    parentElement;
    color;
    size;
    fixedSize;
    pixelRatio = 1;
    options;
    #isResizeFirstTime = true;
    /**
   * The current dimensions of the renderer. Should be fixed for device pixel ratio, if used by the renderer!
   */ currentSize;
    lastLine;
    lastStringCoordinates;
    hasInstructions = false;
    currentLayerOptions;
    #removeDevicePixelListener;
    #removeOnResizeListener;
    constructor(parentElement, options){
        super();
        this.options = options ?? $66d8ae1974721b90$var$DEFAULT_OPTIONS;
        const { updateOnResize: updateOnResize = true } = this.options;
        this.parentElement = parentElement;
        if (updateOnResize) this.#setOnResize();
    }
    #setOnResize() {
        const resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                if (!this.#isResizeFirstTime) {
                    if (!this.fixedSize) this.setSize([
                        entry.contentRect.width,
                        entry.contentRect.height
                    ]);
                }
                this.#isResizeFirstTime = false;
            }
        });
        this.#removeOnResizeListener = ()=>resizeObserver.disconnect();
        resizeObserver.observe(this.parentElement);
    }
    destroy() {
        if (this.parentElement) this.parentElement.innerHTML = '';
        this.#removeDevicePixelListener?.();
        this.#removeOnResizeListener?.();
    }
    get element() {
        throw new Error('element getter not implemented!');
    }
    setColor(color) {
        this.color = color;
    }
    resetSize() {
        this.fixedSize = null;
    }
    getSize() {
        return [
            this.parentElement.clientWidth,
            this.parentElement.clientHeight
        ];
    }
    /**
   * Returns the CSS pixel space dimensions of the renderer (as opposed to the device pixels, which uses device pixel ratio)
   * @returns
   */ getLogicalSize() {
        return this.getSize();
    }
    setStartingPoint(coordinates) {
        this.lastStringCoordinates = coordinates;
    }
    startLayer(options) {
        this.currentLayerOptions = options;
        if (options.color) this.setColor(options.color);
    }
    endLayer() {
        this.currentLayerOptions = null;
    }
    /**
   * Sets a fixed size for the renderer, which doesn't get updates on resize changes
   * A fixed size can be cancelled with `resetSize` or setSize(null).
   */ setFixedSize(size) {
        // First setting to null because the `setSize` method won't override an existing fixedSize
        this.fixedSize = null;
        this.setSize(size);
        this.fixedSize = size;
    }
    enablePixelRatio() {
        const dpr = window.devicePixelRatio || 1;
        this.pixelRatio = dpr;
        if (this.options.updateOnResize !== false) {
            const updatePixelRatio = ()=>{
                this.#removeDevicePixelListener?.();
                const mqString = `(resolution: ${dpr}dppx)`;
                const media = matchMedia(mqString);
                media.addEventListener('change', updatePixelRatio);
                this.#removeDevicePixelListener = ()=>{
                    media.removeEventListener('change', updatePixelRatio);
                };
                this.pixelRatio = window.devicePixelRatio;
                this.emit('devicePixelRatioChange', {
                    devicePixelRatio: this.pixelRatio
                });
            };
            updatePixelRatio();
        }
    }
    disablePixelRatio() {
        this.pixelRatio = 1;
        this.#removeDevicePixelListener?.();
    }
    renderInstructionsForLastLine() {
        this.renderInstructions(...this.lastLine);
    }
}


function $e2b746416d2bf62b$export$f81847884871263e(int1, int2) {
    if (!int2) return int1;
    return $e2b746416d2bf62b$export$f81847884871263e(int2, int1 % int2);
}
const $e2b746416d2bf62b$export$f4644083ce95e7e3 = Math.PI * 2;
function $e2b746416d2bf62b$export$643b64bfca4574ff(distortion) {
    return distortion < 0 ? [
        1 - Math.abs(distortion),
        1
    ] : [
        1 / (1 - distortion),
        1
    ];
}
function $e2b746416d2bf62b$export$27796bb1a51212b7(from, to) {
    return Math.hypot(to[0] - from[0], to[1] - from[1]);
}
function $e2b746416d2bf62b$export$a3992db8dd0fd9e6(v, decimalPoints) {
    const pow10 = Math.pow(10, decimalPoints);
    return Math.round(v * pow10) / pow10;
}
const $e2b746416d2bf62b$var$SMALLEST_DISTANCE = Math.pow(10, -8);
function $e2b746416d2bf62b$export$e2b09acd39c6280(points) {
    if (points.length < 2) return Infinity;
    const ptsByX = [
        ...points
    ].sort((a, b)=>a[0] - b[0]);
    const ptsByY = [
        ...points
    ].sort((a, b)=>a[1] - b[1]);
    // If two points are closest than SMALLEST_DISTANCE, it's considered that they're on the same place and the same, the distance isn't used
    const recurse = (px, py)=>{
        const n = px.length;
        if (n <= 3) {
            let min = Infinity;
            for(let i = 0; i < n; i++)for(let j = i + 1; j < n; j++){
                const pointsDist = $e2b746416d2bf62b$export$27796bb1a51212b7(px[i], px[j]);
                if (pointsDist >= $e2b746416d2bf62b$var$SMALLEST_DISTANCE) min = Math.min(min, pointsDist);
            }
            return min;
        }
        const mid = Math.floor(n / 2);
        const midX = px[mid][0];
        const leftX = px.slice(0, mid);
        const rightX = px.slice(mid);
        const leftY = [];
        const rightY = [];
        for (const p of py)(p[0] <= midX ? leftY : rightY).push(p);
        const dLeft = recurse(leftX, leftY);
        const dRight = recurse(rightX, rightY);
        let d = Math.min(dLeft, dRight);
        // Build strip around mid line
        const strip = py.filter((p)=>Math.abs(p[0] - midX) < d);
        // Check up to 7 points ahead for each in strip
        for(let i = 0; i < strip.length; i++)for(let j = i + 1; j < strip.length && strip[j][1] - strip[i][1] < d; j++){
            const stripDist = $e2b746416d2bf62b$export$27796bb1a51212b7(strip[i], strip[j]);
            if (stripDist >= $e2b746416d2bf62b$var$SMALLEST_DISTANCE) d = Math.min(d, stripDist);
        }
        return d;
    };
    return recurse(ptsByX, ptsByY);
}



const $b683a3137b30eaa9$var$INCH_TO_CM = 2.54;
Object.defineProperty(Number.prototype, 'toFixedPrecision', {
    value: function(fractionDigits) {
        const factor = Math.pow(10, fractionDigits);
        return Math.round(this * factor) / factor;
    },
    writable: true,
    configurable: true,
    enumerable: false
});
function $b683a3137b30eaa9$export$b81d802eaada750f(d1, d2) {
    return d1[0] === d2[0] && d1[1] === d2[1];
}
function $b683a3137b30eaa9$export$f3f3516e40845898(cm, dpi = 300) {
    return Math.floor(cm / $b683a3137b30eaa9$var$INCH_TO_CM * dpi);
}
function $b683a3137b30eaa9$export$d7223786e48f6cef(cm) {
    return cm / $b683a3137b30eaa9$var$INCH_TO_CM;
}
function $b683a3137b30eaa9$export$18bf5c4f04de9fc8(inch, dpi) {
    return inch * dpi;
}
function $b683a3137b30eaa9$export$3770e152b9978d1(cm, dpi) {
    return $b683a3137b30eaa9$export$18bf5c4f04de9fc8($b683a3137b30eaa9$export$d7223786e48f6cef(cm), dpi);
}
function $b683a3137b30eaa9$export$4fb29fadf64dd497(inch) {
    return inch * $b683a3137b30eaa9$var$INCH_TO_CM;
}
function $b683a3137b30eaa9$export$8a2c229e5a0b9f4f(pixels, dpi) {
    return pixels / dpi;
}
function $b683a3137b30eaa9$export$ff05d281b1c1eba7(pixels, dpi) {
    return $b683a3137b30eaa9$export$4fb29fadf64dd497($b683a3137b30eaa9$export$8a2c229e5a0b9f4f(pixels, dpi));
}
function $b683a3137b30eaa9$export$b4179f68b165b05c(dimensions) {
    return dimensions.map($b683a3137b30eaa9$export$d7223786e48f6cef);
}
function $b683a3137b30eaa9$export$593c4f3f624319dc(dimensions) {
    return dimensions.map($b683a3137b30eaa9$export$4fb29fadf64dd497);
}
const $b683a3137b30eaa9$var$LENGTH_UNITS = new Set([
    'cm',
    'inch'
]);
function $b683a3137b30eaa9$export$c566af9defc62c6(dimensions, mapper) {
    return dimensions.map(mapper);
}
function $b683a3137b30eaa9$export$6625f4a88a935670(value, from, to, dpi) {
    if (from === to) return value;
    if ($b683a3137b30eaa9$var$LENGTH_UNITS.has(from) !== $b683a3137b30eaa9$var$LENGTH_UNITS.has(to) && !dpi) throw new Error(`Can't convert from ${from} to ${to} without DPI!`);
    switch(from){
        case 'cm':
            switch(to){
                case 'inch':
                    return $b683a3137b30eaa9$export$d7223786e48f6cef(value);
                case 'px':
                    return $b683a3137b30eaa9$export$3770e152b9978d1(value, dpi);
            }
            return value;
        case 'inch':
            switch(to){
                case 'cm':
                    return $b683a3137b30eaa9$export$4fb29fadf64dd497(value);
                case 'px':
                    return $b683a3137b30eaa9$export$18bf5c4f04de9fc8(value, dpi);
            }
            return value;
        case 'px':
            switch(to){
                case 'cm':
                    return $b683a3137b30eaa9$export$ff05d281b1c1eba7(value, dpi);
                case 'inch':
                    return $b683a3137b30eaa9$export$8a2c229e5a0b9f4f(value, dpi);
            }
            return value;
    }
}
function $b683a3137b30eaa9$export$2e7f3602dd2acd76(dimensions, from, to, dpi) {
    return $b683a3137b30eaa9$export$c566af9defc62c6(dimensions, (v)=>$b683a3137b30eaa9$export$6625f4a88a935670(v, from, to, dpi));
}
const $b683a3137b30eaa9$export$e8dd885a22676074 = [
    {
        id: 'A4',
        dimensions: [
            21,
            29.7
        ]
    },
    {
        id: 'A3',
        dimensions: [
            29.7,
            42
        ]
    },
    {
        id: 'A2',
        dimensions: [
            42,
            59.4
        ]
    },
    {
        id: 'A1',
        dimensions: [
            59.4,
            84.1
        ]
    }
];
function $b683a3137b30eaa9$export$1d3cc206d049790e(...boundingRects) {
    return boundingRects.reduce((box, boundingRect)=>{
        const newBox = {
            ...box,
            left: Math.min(box.left, boundingRect.left),
            right: Math.max(box.right, boundingRect.right),
            top: Math.min(box.top, boundingRect.top),
            bottom: Math.max(box.bottom, boundingRect.bottom)
        };
        Object.assign(newBox, {
            width: newBox.right - newBox.left,
            height: newBox.bottom - newBox.top
        });
        return newBox;
    }, {
        top: Infinity,
        left: Infinity,
        bottom: -Infinity,
        right: -Infinity,
        width: 0,
        height: 0
    });
}
function $b683a3137b30eaa9$export$8c48870e8825fa45(coordinates) {
    if (coordinates.length === 0) throw new Error("Can't get bounding rect, no coordinates specified.");
    if (coordinates.length === 1) return {
        top: coordinates[0][1],
        bottom: coordinates[0][1],
        left: coordinates[0][0],
        right: coordinates[0][0],
        width: 0,
        height: 0
    };
    const sides = coordinates.reduce((box, point)=>({
            top: Math.min(box.top, point[1]),
            bottom: Math.max(box.bottom, point[1]),
            left: Math.min(box.left, point[0]),
            right: Math.max(box.right, point[0])
        }), {
        top: Infinity,
        left: Infinity,
        bottom: -Infinity,
        right: -Infinity
    });
    return {
        ...sides,
        width: sides.right - sides.left,
        height: sides.bottom - sides.top
    };
}
function $b683a3137b30eaa9$export$d2646d47608819e2(boundingRect) {
    return boundingRect.width / boundingRect.height;
}
function $b683a3137b30eaa9$export$18c295d7a6a8189d(size1, size2) {
    const ratio = Math.min(size2[0] / size1[0], size2[1] / size1[1]);
    return $b683a3137b30eaa9$export$c566af9defc62c6(size1, (v)=>v * ratio);
}
function $b683a3137b30eaa9$export$18675c441b273a07(size, center) {
    const rectHalfSize = $b683a3137b30eaa9$export$c91255cadecfe081(size);
    return {
        width: size[0],
        height: size[1],
        left: center[0] - rectHalfSize[0],
        right: center[0] + rectHalfSize[0],
        top: center[1] - rectHalfSize[1],
        bottom: center[1] + rectHalfSize[1]
    };
}
function $b683a3137b30eaa9$export$c91255cadecfe081(size) {
    return $b683a3137b30eaa9$export$c566af9defc62c6(size, (v)=>v / 2);
}
const $b683a3137b30eaa9$var$METRIC_UNITS = {
    m: 1,
    cm: 0.01,
    mm: 0.001
};
function $b683a3137b30eaa9$export$deca72617c96d902(length, sourceUnits, decimalPoints = 1) {
    const meters = length * $b683a3137b30eaa9$var$METRIC_UNITS[sourceUnits];
    if (meters >= 1) return (0, $e2b746416d2bf62b$export$a3992db8dd0fd9e6)(meters, decimalPoints).toLocaleString() + ' m';
    else if (meters < 0.01) return (0, $e2b746416d2bf62b$export$a3992db8dd0fd9e6)(meters * 1000, decimalPoints).toLocaleString() + ' mm';
    else return (0, $e2b746416d2bf62b$export$a3992db8dd0fd9e6)(meters * 100, decimalPoints).toLocaleString() + ' cm';
}



let $2f2e0bbe9a3a6970$var$lastId = 0;
const $2f2e0bbe9a3a6970$var$INSTRUCTIONS_NAIL_RADIUS = 4;
class $2f2e0bbe9a3a6970$export$2e2bcd8739ae039 extends (0, $66d8ae1974721b90$export$2e2bcd8739ae039) {
    #background;
    #currentColor;
    #layers;
    #instructions;
    #cancelInstructionsHide;
    constructor(parentElement, options){
        super(parentElement, options);
        const stringsCanvas = document.createElement('canvas');
        const nailsCanvas = document.createElement('canvas');
        const instructionsCanvas = document.createElement('canvas');
        stringsCanvas.setAttribute('data-id', String($2f2e0bbe9a3a6970$var$lastId++));
        this.#layers = {
            strings: {
                canvas: stringsCanvas,
                ctx: stringsCanvas.getContext('2d')
            },
            nails: {
                canvas: nailsCanvas,
                ctx: nailsCanvas.getContext('2d')
            },
            instructions: {
                canvas: instructionsCanvas,
                ctx: instructionsCanvas.getContext('2d')
            }
        };
        stringsCanvas.id = 'CanvasRenderer__strings';
        nailsCanvas.id = 'CanvasRenderer__nails';
        instructionsCanvas.id = 'CanvasRenderer_instructions';
        this.instructionsCtx.lineWidth = 4;
        this.instructionsCtx.strokeStyle = 'Red';
        this.canvases.forEach((canvas)=>{
            canvas.classList.add('CanvasRenderer__canvas');
            parentElement.appendChild(canvas);
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvas.style.width = '100%';
            canvas.style.height = '100%';
        });
        this.enablePixelRatio();
        this.ctxs.forEach((ctx)=>ctx.globalCompositeOperation = 'source-over');
        this.addEventListener('devicePixelRatioChange', ()=>{
            this.setSize([
                this.stringsCanvas.clientWidth,
                this.stringsCanvas.clientHeight
            ]);
        });
        this.resetSize(false);
    }
    get element() {
        return this.#layers.strings.canvas;
    }
    get canvases() {
        return [
            this.#layers.strings.canvas,
            this.#layers.nails.canvas,
            this.#layers.instructions.canvas
        ];
    }
    get ctxs() {
        return [
            this.#layers.strings.ctx,
            this.#layers.nails.ctx,
            this.#layers.instructions.ctx
        ];
    }
    get stringsCtx() {
        return this.#layers.strings.ctx;
    }
    get nailsCtx() {
        return this.#layers.nails.ctx;
    }
    get stringsCanvas() {
        return this.#layers.strings.canvas;
    }
    get instructionsCanvas() {
        return this.#layers.instructions.canvas;
    }
    get instructionsCtx() {
        return this.#layers.instructions.ctx;
    }
    resetSize(notifyOnChange = true) {
        super.resetSize();
        this.canvases.forEach((canvas)=>{
            canvas.removeAttribute('width');
            canvas.removeAttribute('height');
            canvas.style.removeProperty('width');
            canvas.style.removeProperty('height');
        });
        const newSize = this.getSize();
        this.canvases.forEach((canvas)=>{
            canvas.setAttribute('width', String(newSize[0]));
            canvas.setAttribute('height', String(newSize[1]));
        });
        if (!this.currentSize || !(0, $b683a3137b30eaa9$export$b81d802eaada750f)(newSize, this.currentSize)) {
            this.currentSize = newSize;
            if (notifyOnChange) this.emit('sizeChange', {
                size: newSize
            });
        }
        return newSize;
    }
    setSize(size) {
        if (!size) return this.resetSize();
        if (this.fixedSize) {
            console.warn(`Trying to set size for Renderer to [${size.join(', ')}], but size is fixed to [${this.fixedSize.join(', ')}].`);
            return this.fixedSize;
        }
        const realSize = size.map((v)=>v * this.pixelRatio);
        if (!this.currentSize || !(0, $b683a3137b30eaa9$export$b81d802eaada750f)(realSize, this.currentSize)) {
            this.canvases.forEach((canvas)=>{
                canvas.setAttribute('width', String(realSize[0]));
                canvas.setAttribute('height', String(realSize[1]));
                canvas.style.setProperty('width', `${size[0]}px`);
                canvas.style.setProperty('height', `${size[1]}px`);
            });
            this.currentSize = realSize;
            this.emit('sizeChange', {
                size: realSize
            });
        }
        return realSize;
    }
    resetStrings() {
        this.stringsCtx.clearRect(0, 0, ...this.getSize());
    }
    /**
   * Clears the stringsCanvas and resets the width and height
   */ resetNails() {
        this.#layers.nails.ctx.clearRect(0, 0, ...this.getSize());
    }
    setColor(color) {
        this.#currentColor = color;
        this.stringsCtx.strokeStyle = color;
    }
    setLineWidth(width) {
        this.stringsCtx.lineWidth = width;
    }
    setBackground(color) {
        if (this.#background = color) {
            this.parentElement.style.background = color;
            if (this.#instructions) this.#instructions.style.background = color;
        } else {
            this.parentElement.style.removeProperty('background');
            if (this.#instructions) this.#instructions.style.background = 'black';
        }
    }
    #setBackgroundOnCanvas(context, color) {
        context.globalCompositeOperation = 'destination-over';
        context.fillStyle = color;
        context.fillRect(0, 0, ...this.getSize());
        context.globalCompositeOperation = 'source-over';
    }
    getLogicalSize() {
        return this.fixedSize ?? [
            this.stringsCanvas.clientWidth,
            this.stringsCanvas.clientHeight
        ];
    }
    getSize() {
        return this.getLogicalSize().map((v)=>v * this.pixelRatio);
    }
    renderLine(from, to) {
        this.lastStringCoordinates = from;
        this.lineTo(to);
    }
    lineTo(to) {
        if (!this.lastStringCoordinates) throw new Error("no last string coordinates, can't lineTo");
        this.stringsCtx.beginPath();
        this.stringsCtx.moveTo(...this.lastStringCoordinates);
        this.stringsCtx.lineTo(...to);
        this.stringsCtx.stroke();
        this.lastLine = [
            this.lastStringCoordinates,
            to
        ];
        this.lastStringCoordinates = to;
    }
    renderNails(nails, { color: color, fontSize: fontSize, radius: radius, renderNumbers: renderNumbers, margin: margin = 0, numbersStart: numbersStart = 1 }) {
        const centerX = this.stringsCanvas.width / 2;
        this.nailsCtx.globalCompositeOperation = 'source-over';
        this.nailsCtx.beginPath();
        this.nailsCtx.fillStyle = color;
        this.nailsCtx.textBaseline = 'middle';
        this.nailsCtx.font = `${fontSize}px sans-serif`;
        const nailNumberOffset = radius + margin;
        let number = numbersStart;
        for (let [x, y] of nails){
            this.nailsCtx.moveTo(x + radius, y);
            this.nailsCtx.arc(x, y, radius, 0, (0, $e2b746416d2bf62b$export$f4644083ce95e7e3));
            if (renderNumbers && number != null) {
                const isRightAlign = x < centerX;
                const numberPosition = [
                    isRightAlign ? x - nailNumberOffset : x + nailNumberOffset,
                    y
                ];
                this.nailsCtx.textAlign = isRightAlign ? 'right' : 'left';
                this.nailsCtx.fillText(String(number), ...numberPosition);
            }
            number++;
        }
        this.nailsCtx.fill();
    }
    showInstructions() {
        this.#cancelInstructionsHide?.();
        if (!this.#instructions) {
            this.#instructions = document.createElement('div');
            this.#instructions.id = 'CanvasRenderer__instructions';
            const instructionsOverlay = document.createElement('div');
            instructionsOverlay.id = 'CanvasRenderer__instructions_overlay';
            instructionsOverlay.style = `background: ${this.parentElement.style.background ?? 'black'}; position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0.5`;
            this.#instructions.appendChild(instructionsOverlay);
            this.#instructions.appendChild(this.instructionsCanvas);
            this.parentElement.appendChild(this.#instructions);
        } else (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(this.#instructions);
    }
    hideInstructions() {
        if (this.#instructions) {
            let opacity = 1;
            const fadeOut = ()=>{
                opacity -= 0.02;
                this.#instructions.style.opacity = String(opacity);
                if (opacity > 0) {
                    const raf = requestAnimationFrame(fadeOut);
                    this.#cancelInstructionsHide = ()=>{
                        cancelAnimationFrame(raf);
                        this.#instructions.style.removeProperty('opacity');
                    };
                } else {
                    (0, $8d5cef8e7fea78a8$export$fe8985bb6374093c)(this.#instructions);
                    this.clearInstructions();
                    this.#instructions.style.removeProperty('opacity');
                }
            };
            fadeOut();
        }
    }
    renderInstructions(from, to) {
        this.showInstructions();
        const strokeColor = 'white';
        const fillColor = this.#currentColor ?? 'red';
        this.clearInstructions();
        this.instructionsCtx.clearRect(0, 0, ...this.getSize());
        this.instructionsCtx.beginPath();
        this.instructionsCtx.lineWidth = 3;
        let prevPosition = from;
        this.#drawArrow(prevPosition, to, {
            strokeColor: strokeColor,
            fillColor: fillColor
        });
        prevPosition = to;
        this.instructionsCtx.stroke();
        this.instructionsCtx.beginPath();
        [
            from,
            to
        ].forEach(([x, y])=>{
            this.instructionsCtx.moveTo(x + $2f2e0bbe9a3a6970$var$INSTRUCTIONS_NAIL_RADIUS, y);
            this.instructionsCtx.arc(x, y, $2f2e0bbe9a3a6970$var$INSTRUCTIONS_NAIL_RADIUS, 0, (0, $e2b746416d2bf62b$export$f4644083ce95e7e3));
        });
        this.instructionsCtx.strokeStyle = strokeColor;
        this.instructionsCtx.stroke();
        this.instructionsCtx.fillStyle = fillColor;
        this.instructionsCtx.fill();
        this.hasInstructions = true;
    }
    clearInstructions() {
        if (this.hasInstructions) {
            this.instructionsCtx.clearRect(0, 0, ...this.getSize());
            this.hasInstructions = false;
        }
    }
    #drawArrow(from, to, { strokeColor: strokeColor = 'white', fillColor: fillColor = 'red' }) {
        const arrowHeadSize = 15;
        const ctx = this.instructionsCtx;
        // Calculate angle of the line
        const angle = Math.atan2(to[1] - from[1], to[0] - from[0]);
        ctx.save(); // Save the current canvas state
        ctx.strokeStyle = strokeColor;
        ctx.fillStyle = fillColor; // For filling the arrowhead
        // Draw the main line
        ctx.beginPath();
        ctx.moveTo(from[0], from[1]);
        ctx.lineTo(to[0], to[1]);
        ctx.stroke();
        const arrowPos = [
            from[0] + (to[0] - from[0]) / 2,
            from[1] + (to[1] - from[1]) / 2
        ];
        // Draw the arrowhead
        ctx.beginPath();
        ctx.moveTo(arrowPos[0], arrowPos[1]);
        ctx.lineTo(arrowPos[0] - arrowHeadSize * Math.cos(angle - Math.PI / 6), arrowPos[1] - arrowHeadSize * Math.sin(angle - Math.PI / 6));
        ctx.lineTo(arrowPos[0] - arrowHeadSize * Math.cos(angle + Math.PI / 6), arrowPos[1] - arrowHeadSize * Math.sin(angle + Math.PI / 6));
        ctx.closePath(); // Connects the last point to the first, closing the triangle
        ctx.fill(); // Fills the arrowhead
        ctx.restore(); // Restore the canvas state
    }
    clear() {
        this.ctxs.forEach((ctx)=>ctx.clearRect(0, 0, ...this.getSize()));
    }
    toDataURL() {
        return this.getComposite().toDataURL();
    }
    async toBlob(type = 'png', quality = 1) {
        return new Promise((resolve, reject)=>{
            this.getComposite().toBlob((blob)=>blob ? resolve(blob) : reject(), `image/${type}`, Math.max(0, Math.min(quality, 1)));
        });
    }
    getComposite() {
        const compositeCanvas = document.createElement('canvas');
        compositeCanvas.width = this.stringsCanvas.width;
        compositeCanvas.height = this.stringsCanvas.height;
        const ctx = compositeCanvas.getContext('2d');
        if (this.#background) this.#setBackgroundOnCanvas(ctx, this.#background);
        this.canvases.filter((canvas)=>canvas !== this.instructionsCanvas).forEach((c)=>ctx.drawImage(c, 0, 0));
        return compositeCanvas;
    }
}




function* $b103c63dc979d40c$export$596571ef134d4065(controlsConfig, parent) {
    let index = 0;
    for (const control of controlsConfig){
        yield {
            control: control,
            index: index,
            parent: parent
        };
        if (control.children) yield* $b103c63dc979d40c$export$596571ef134d4065(control.children, {
            control: control,
            parent: parent,
            index: index
        });
        index++;
    }
}
function $b103c63dc979d40c$var$findControlConfigNode(controlsConfig, findFn) {
    for (const node of $b103c63dc979d40c$export$596571ef134d4065(controlsConfig)){
        if (findFn(node.control)) return node;
    }
    return null;
}
function $b103c63dc979d40c$var$getControlConfigNodeByKey(controlsConfig, controlKey) {
    return $b103c63dc979d40c$var$findControlConfigNode(controlsConfig, ({ key: key })=>key === controlKey);
}
function $b103c63dc979d40c$export$2d97e2da46663803(controlConfig, attributeName) {
    const attr = controlConfig.attr;
    if (!attr) return controlConfig;
    const attrCopy = {
        ...attr
    };
    delete attrCopy[attributeName];
    return {
        ...controlConfig,
        attr: attrCopy
    };
}
function $b103c63dc979d40c$export$68091c7c829a57b8(controlsConfig) {
    return controlsConfig.map((control)=>{
        const copy = {
            ...control
        };
        if (control.children) copy.children = $b103c63dc979d40c$export$68091c7c829a57b8(control.children);
        if (control.attr) copy.attr = {
            ...control.attr
        };
        return copy;
    });
}
function $b103c63dc979d40c$export$e6b0de4153cc8c78(controlsConfig, controlKey) {
    const controlNode = $b103c63dc979d40c$var$getControlConfigNodeByKey(controlsConfig, controlKey);
    if (controlNode) {
        const path = [
            controlNode.index
        ];
        let parentNode = controlNode.parent;
        while(parentNode){
            path.unshift(parentNode.index);
            parentNode = parentNode.parent;
        }
        return path;
    }
    return null;
}
function $b103c63dc979d40c$export$c4f94c8b3850a5a9(controlsConfig, insertAfterKey, controlsConfigToInsert) {
    const configCopy = $b103c63dc979d40c$export$68091c7c829a57b8(controlsConfig);
    const nodeToAddAfter = $b103c63dc979d40c$var$getControlConfigNodeByKey(configCopy, insertAfterKey);
    if (nodeToAddAfter) {
        const { index: index, parent: parent } = nodeToAddAfter;
        let list = parent?.control.children ?? configCopy;
        list.splice(index + 1, 0, ...controlsConfigToInsert);
        return configCopy;
    }
    return controlsConfig;
}
function $b103c63dc979d40c$export$d9fe7d5b8b296e7c(controlsConfig, controlPropMapper) {
    return controlPropMapper ? controlsConfig.map((control)=>{
        if (control.children) control = {
            ...control,
            children: $b103c63dc979d40c$export$d9fe7d5b8b296e7c(control.children, controlPropMapper)
        };
        return {
            ...control,
            ...controlPropMapper(control)
        };
    }) : controlsConfig;
}
function $b103c63dc979d40c$export$38c07eba5c3aa11b(configControls) {
    const defaultValues = {};
    for (const { control: { key: key, defaultValue: defaultValue } } of $b103c63dc979d40c$export$596571ef134d4065(configControls))if (!(defaultValue instanceof Function)) // @ts-ignore
    defaultValues[key] = defaultValue;
    return defaultValues;
}
function $b103c63dc979d40c$export$ab1c0bf676278196(configControls) {
    const configIndex = {};
    for (const { control: control } of $b103c63dc979d40c$export$596571ef134d4065(configControls))configIndex[control.key] = control;
    return configIndex;
}


const $9e482fa80a49eb9a$var$COLOR_CONTROLS = [
    {
        key: 'isMultiColor',
        label: 'Use multiple colors',
        defaultValue: false,
        type: 'checkbox',
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'colorCount',
        label: 'Colors count',
        defaultValue: 7,
        type: 'range',
        attr: {
            min: 1,
            max: 20,
            step: 1
        },
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'color',
        label: 'String color',
        defaultValue: '#ff4d00',
        type: 'color',
        show: ({ isMultiColor: isMultiColor })=>!isMultiColor,
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'multicolorStart',
        label: 'Multicolor start',
        defaultValue: 1,
        type: 'hue',
        attr: {
            colorthumb: true
        },
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'multicolorRange',
        label: 'Multicolor range',
        defaultValue: 360,
        type: 'hue',
        attr: {
            start: ({ multicolorStart: multicolorStart })=>multicolorStart,
            type: 'range'
        },
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'saturation',
        label: 'Saturation',
        defaultValue: 100,
        type: 'range',
        attr: {
            min: 0,
            max: 100,
            step: 1
        },
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        affectsNails: false,
        affectsStepCount: false
    },
    {
        key: 'lightness',
        label: 'Lightness',
        type: 'group',
        defaultValue: 'minimized',
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        children: [
            {
                key: 'multicolorByLightness',
                label: 'Multi lightness',
                defaultValue: false,
                type: 'checkbox',
                show: ({ isMultiColor: isMultiColor })=>isMultiColor,
                affectsNails: false,
                affectsStepCount: false
            },
            {
                key: 'minLightness',
                label: 'Minimum lightness',
                defaultValue: 0,
                type: 'range',
                attr: {
                    min: 0,
                    max: 100,
                    step: 1,
                    snap: '50',
                    thumbcolor: ({ minLightness: minLightness })=>`hsl(0 0 ${minLightness})`,
                    background: 'linear-gradient(to right, black, white)'
                },
                show: ({ multicolorByLightness: multicolorByLightness, isMultiColor: isMultiColor })=>multicolorByLightness && isMultiColor,
                affectsNails: false,
                affectsStepCount: false
            },
            {
                key: 'maxLightness',
                label: 'Maximum lightness',
                defaultValue: 100,
                type: 'range',
                attr: {
                    min: 0,
                    max: 100,
                    step: 1,
                    snap: '50',
                    thumbcolor: ({ maxLightness: maxLightness })=>`hsl(0 0 ${maxLightness})`,
                    background: 'linear-gradient(to right, black, white)'
                },
                show: ({ multicolorByLightness: multicolorByLightness, isMultiColor: isMultiColor })=>multicolorByLightness && isMultiColor,
                affectsNails: false,
                affectsStepCount: false
            }
        ]
    },
    {
        key: 'colorOrderGroup',
        type: 'group',
        label: 'Order',
        defaultValue: 'minimized',
        show: ({ isMultiColor: isMultiColor })=>isMultiColor,
        children: [
            {
                key: 'reverseColors',
                label: 'Reverse colors order',
                defaultValue: false,
                type: 'checkbox',
                show: ({ isMultiColor: isMultiColor })=>isMultiColor,
                affectsNails: false,
                affectsStepCount: false
            },
            {
                key: 'repeatColors',
                label: 'Repeat colors',
                defaultValue: true,
                type: 'checkbox',
                show: ({ isMultiColor: isMultiColor })=>isMultiColor,
                affectsNails: false,
                affectsStepCount: false
            },
            {
                key: 'mirrorColors',
                label: 'Mirror Colors',
                defaultValue: false,
                type: 'checkbox',
                show: ({ isMultiColor: isMultiColor, repeatColors: repeatColors })=>isMultiColor && repeatColors,
                affectsNails: false,
                affectsStepCount: false
            }
        ]
    }
];
var $9e482fa80a49eb9a$export$2e2bcd8739ae039 = $9e482fa80a49eb9a$var$COLOR_CONTROLS;


class $44d9dab6555abf73$export$2e2bcd8739ae039 {
    config;
    multiColorStep;
    multiColorLightnessStep;
    colors;
    constructor(config){
        this.config = config;
        const { multicolorRange: multicolorRange, colorCount: colorCount, multicolorByLightness: multicolorByLightness, minLightness: minLightness = 0, maxLightness: maxLightness = 100, multicolorStart: multicolorStart, darkMode: darkMode, saturation: saturation, reverseColors: reverseColors, repeatColors: repeatColors, mirrorColors: mirrorColors, isMultiColor: isMultiColor } = config;
        if (isMultiColor) {
            this.multiColorStep = multicolorRange / Math.max(1, colorCount - 1);
            this.multiColorLightnessStep = multicolorByLightness ? (maxLightness - minLightness) / (Math.max(colorCount, 2) - 1) : 1;
            this.colors = new Array(colorCount).fill(null).map((_, colorIndex)=>{
                const lightness = multicolorByLightness ? minLightness + this.multiColorLightnessStep * colorIndex : darkMode ? 50 : 40;
                return `hsl(${multicolorStart + colorIndex * this.multiColorStep}, ${saturation}%, ${lightness}%)`;
            });
            if (repeatColors && mirrorColors) {
                const [_firstColor, ...restColors] = this.colors;
                restColors.pop();
                this.colors = [
                    ...this.colors,
                    ...restColors.reverse()
                ];
            }
            if (reverseColors) this.colors.reverse();
        }
    }
    /**
   * Returns the color to be used in the provided layer index. If no multiColor is used, will use the 'color' config property.
   * @param {number} colorIndex
   * @returns string
   */ getColor(colorIndex) {
        const { isMultiColor: isMultiColor, colorCount: colorCount, color: color, repeatColors: repeatColors } = this.config;
        if (!isMultiColor) return color;
        if (colorIndex >= colorCount) colorIndex = repeatColors ? colorIndex % this.colors.length : this.colors.length - 1;
        return this.colors[colorIndex];
    }
    getColorMap(options) {
        options = Object.assign({}, this.config, options);
        if (!options.colorCount) throw new Error("Can't get color map, no colorCount provided!");
        const stepsPerColor = Math.max(1, Math.floor(options.stepCount / options.colorCount));
        const colorMap = new Map();
        for(let i = 0; i < options.colorCount; i++)colorMap.set(i * stepsPerColor, this.getColor(i));
        return colorMap;
    }
    static getConfig({ include: include, exclude: exclude, defaults: defaults = {}, customControls: customControls, propMapper: propMapper, groupLabel: groupLabel, maxColorCount: maxColorCount }) {
        const controls = (0, $b103c63dc979d40c$export$d9fe7d5b8b296e7c)(getControls(), propMapper);
        return {
            key: 'colorGroup',
            label: groupLabel ?? 'Color',
            type: 'group',
            children: [
                ...customControls ?? [],
                ...controls
            ]
        };
        function getControls(controlsConfig) {
            return (controlsConfig ?? (0, $b103c63dc979d40c$export$68091c7c829a57b8)((0, $9e482fa80a49eb9a$export$2e2bcd8739ae039))).filter(({ key: key })=>(!exclude || !exclude.includes(key)) && (!include || include.includes(key))).map((control)=>{
                const finalControl = {
                    ...control,
                    defaultValue: defaults[control.key] ?? control.defaultValue
                };
                if (control.type === 'group') finalControl.children = getControls(control.children);
                if (control.key === 'colorCount' && maxColorCount) finalControl.attr.max = maxColorCount;
                return finalControl;
            });
        }
    }
}




/**
 * Returns true if the two objects have the same values. Deep compares the objects.
 */ function $c29d66861308df7e$export$f05027632b38f3a4(obj1, obj2, /**
   * An array of keys to compare. If not specified, all keys are compared.
   */ props) {
    if (obj1 === obj2) return true;
    if (typeof obj1 === 'object' && typeof obj2 === 'object') {
        if (obj1 === null !== (obj2 === null)) return false;
        if (obj1 instanceof Array && obj2 instanceof Array) {
            if (obj1.length !== obj2.length) return false;
            for(let i = 0; i < obj1.length; i++){
                if (!$c29d66861308df7e$export$f05027632b38f3a4(obj1[i], obj2[i])) return false;
            }
            return true;
        }
        if (!props) {
            props = Object.keys(obj1);
            if (props.length !== Object.keys(obj2).length) return false;
        }
        if (props && props.some((p)=>!$c29d66861308df7e$export$f05027632b38f3a4(obj1[p], obj2[p]))) return false;
        return true;
    }
    return obj1 === obj2;
}
function $c29d66861308df7e$export$781522908e4e76a1(obj, mapper) {
    const mappedObj = {};
    Object.entries(obj).forEach(([key, value])=>mappedObj[mapper(key, value)] = value);
    return mappedObj;
}




class $9ee6280c93a20bac$export$5d318302d9efabc7 extends (0, $66d8ae1974721b90$export$2e2bcd8739ae039) {
    strings = [];
    nails = [];
    lineWidth = 1;
    size = [
        0,
        0
    ];
    background;
    constructor(size){
        super(null, {
            updateOnResize: false
        });
        this.size = size;
    }
    resetStrings() {
        this.strings.length = 0;
    }
    resetNails() {
        this.nails.length = 0;
    }
    setLineWidth(width) {
        this.lineWidth = width;
    }
    renderLine(from, to) {
        this.strings.push([
            from,
            to
        ]);
    }
    renderInstructions(from, to) {}
    clearInstructions() {}
    lineTo(to) {
        this.strings.push([
            [
                0,
                0
            ],
            to
        ]);
    }
    renderNails(nails, options) {
        for (let nail of nails)this.nails.push(nail);
    }
    clear() {
        this.resetStrings();
        this.resetNails();
    }
    toDataURL() {
        return '';
    }
    getSize() {
        return this.size;
    }
    setSize(size) {
        return this.size = size;
    }
    setBackground(color) {
        this.background = color;
    }
    showInstructions() {}
    hideInstructions() {}
}


const $fa5e071b86283164$var$DEFAULT_NAIL_RADIUS = 1.5;
class $fa5e071b86283164$export$f14c78f74247c3d extends (0, $9ee6280c93a20bac$export$5d318302d9efabc7) {
    #threadsLength = 0;
    #nailCount = 0;
    #lastPoint;
    #currentColor;
    #threadsLengthPerColor;
    #nailCoords;
    #nailThreadLength;
    constructor(size){
        super(size);
        this.#threadsLengthPerColor = new Map();
        this.#nailCoords = [];
        this.#nailThreadLength = this.#getNailThreadLength($fa5e071b86283164$var$DEFAULT_NAIL_RADIUS);
    }
    get threadsLength() {
        return {
            total: Math.round(this.#threadsLength),
            perColor: Array.from(this.#threadsLengthPerColor.entries()).map(([color, length])=>({
                    color: color,
                    length: length
                }))
        };
    }
    get nailCount() {
        return this.#nailCount;
    }
    resetStrings() {
        this.#threadsLength = 0;
        this.#threadsLengthPerColor = new Map();
    }
    renderLine(from, to) {
        const lineLength = (0, $e2b746416d2bf62b$export$27796bb1a51212b7)(from, to) + this.#nailThreadLength;
        this.#threadsLength += lineLength;
        this.#threadsLengthPerColor.set(this.#currentColor, this.#threadsLengthPerColor.get(this.#currentColor) + lineLength);
        this.#lastPoint = to;
    }
    resetNails() {
        this.#nailCount = 0;
        this.#nailCoords.length = 0;
    }
    renderNails(nails, { radius: radius }) {
        for (let nail of nails){
            this.#nailCount++;
            this.#nailCoords.push(nail);
        }
        this.#nailThreadLength = this.#getNailThreadLength(radius);
    }
    setStartingPoint(coordinates) {
        this.#lastPoint = coordinates;
    }
    setColor(color) {
        this.#currentColor = color;
        if (!this.#threadsLengthPerColor.has(color)) this.#threadsLengthPerColor.set(color, 0);
    }
    lineTo(to) {
        if (!this.#lastPoint) throw new Error("no last string coordinates, can't lineTo");
        this.renderLine(this.#lastPoint, to);
    }
    getInfo() {
        return {
            nailsCount: this.#nailCount,
            threadsLength: this.threadsLength,
            closestDistanceBetweenNails: (0, $e2b746416d2bf62b$export$e2b09acd39c6280)(this.#nailCoords)
        };
    }
    #getNailThreadLength(nailRadius) {
        // Assuming two rounds around each nail, to be on the safe side when measuring total thread length
        return (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * nailRadius * 2;
    }
}


class $3c868d3c6cbc42ab$export$2e2bcd8739ae039 {
    renderer;
    nails;
    #lastNail;
    #lastString;
    constructor(renderer, nails){
        this.renderer = renderer;
        this.nails = nails;
    }
    startLayer({ name: name, color: color }) {
        if (color) this.renderer.setColor(color);
    }
    goto(nailKey, groupKey) {
        const coordinates = this.nails.getNailCoordinates(nailKey, groupKey);
        this.renderer.setStartingPoint(coordinates);
        this.#lastNail = {
            nailKey: nailKey,
            groupKey: groupKey
        };
    }
    stringTo(nailKey, groupKey) {
        this.renderer.lineTo(this.nails.getNailCoordinates(nailKey, groupKey));
        const nail = {
            nailKey: nailKey,
            groupKey: groupKey
        };
        this.#lastString = [
            this.#lastNail,
            nail
        ];
        this.#lastNail = nail;
    }
    getLastStringNailNumbers() {
        return this.#lastString?.map(({ nailKey: nailKey, groupKey: groupKey })=>this.nails.getNailNumber(nailKey, groupKey));
    }
}


const $eb81ebf35fbd30cd$export$e60cfe038231c681 = {
    dark: '#0e0e0e',
    light: '#ffffff'
};



const $85e40adea6d09b93$export$c90b7c9bd11bfec0 = [
    {
        key: 'strings',
        label: 'Strings',
        type: 'group',
        defaultValue: 'minimized',
        children: [
            {
                key: 'showStrings',
                label: 'Show strings',
                defaultValue: true,
                type: 'checkbox',
                isDisabled: ({ showNails: showNails })=>!showNails,
                affectsNails: false
            },
            {
                key: 'stringWidth',
                label: 'String width',
                defaultValue: 1,
                type: 'range',
                attr: {
                    min: 0.2,
                    max: 4,
                    step: 0.1,
                    snap: '1'
                },
                show: ({ showStrings: showStrings })=>showStrings,
                affectsNails: false
            }
        ]
    },
    {
        key: 'nails',
        label: 'Nails',
        type: 'group',
        defaultValue: 'minimized',
        children: [
            {
                key: 'showNails',
                label: 'Show nails',
                defaultValue: true,
                type: 'checkbox',
                isDisabled: ({ showStrings: showStrings })=>!showStrings,
                affectsStrings: false
            },
            {
                key: 'showNailNumbers',
                label: 'Show nail numbers',
                defaultValue: false,
                type: 'checkbox',
                show: ({ showNails: showNails })=>showNails,
                affectsStrings: false
            },
            {
                key: 'nailNumbersFontSize',
                label: 'Nail numbers font size',
                defaultValue: 10,
                type: 'range',
                attr: {
                    min: 6,
                    max: 32,
                    step: 0.5
                },
                displayValue: ({ nailNumbersFontSize: nailNumbersFontSize })=>`${nailNumbersFontSize}px`,
                show: ({ showNails: showNails, showNailNumbers: showNailNumbers })=>showNails && showNailNumbers,
                affectsStrings: false
            },
            {
                key: 'margin',
                label: 'Margin',
                defaultValue: 20,
                type: 'number',
                attr: {
                    min: 0,
                    max: 500,
                    step: 1
                },
                displayValue: ({ margin: margin })=>`${margin}px`,
                isStructural: true
            },
            {
                key: 'nailRadius',
                label: 'Nail size',
                defaultValue: 1.5,
                type: 'range',
                attr: {
                    min: 0.5,
                    max: 5,
                    step: 0.25,
                    snap: '1.5'
                },
                show: ({ showNails: showNails })=>showNails,
                affectsStrings: false
            },
            {
                key: 'nailsColor',
                label: 'Nails color',
                defaultValue: '#ffffff',
                type: 'color',
                show: ({ showNails: showNails })=>showNails,
                affectsStrings: false
            }
        ]
    },
    {
        key: 'background',
        label: 'Background',
        type: 'group',
        defaultValue: 'minimized',
        children: [
            {
                key: 'darkMode',
                label: 'Dark mode',
                defaultValue: true,
                type: 'checkbox',
                affectsNails: false,
                affectsStrings: false
            },
            {
                key: 'customBackgroundColor',
                label: 'Custom background color',
                defaultValue: false,
                type: 'checkbox',
                affectsNails: false,
                affectsStrings: false
            },
            {
                key: 'backgroundColor',
                label: 'Background color',
                defaultValue: (0, $eb81ebf35fbd30cd$export$e60cfe038231c681).dark,
                type: 'color',
                show: ({ customBackgroundColor: customBackgroundColor })=>customBackgroundColor,
                affectsNails: false,
                affectsStrings: false
            }
        ]
    }
];



class $ed62eab3f3d51c1d$var$StringArt extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    link;
    linkText;
    defaultValues = {};
    stepCount = null;
    position = 0;
    calc;
    color;
    stringsIterator;
    nails;
    controller;
    #config;
    #controlsIndex;
    #defaultConfig;
    #taskController;
    constructor(){
        super();
    }
    /**
   * Can be implemented in extending classes for a more efficient implementation. This is just a fallback
   * @param size
   * @param precision
   * @returns
   */ getNailCount(size, precision) {
        const renderer = new (0, $fa5e071b86283164$export$f14c78f74247c3d)(size);
        this.draw(renderer, {
            precision: precision
        });
        return renderer.nailCount;
    }
    getNailsCoordinates() {
        return this.nails.getAllNailsCoordinates();
    }
    getNailNumber(nailKey, groupKey) {
        return this.nails.getNailNumber(nailKey, groupKey);
    }
    thumbnailConfig;
    /**
   * Set testStepCountConfig to automatically test that the step count is correct for the given configurations
   */ testStepCountConfig;
    static type;
    get configControls() {
        return (this.controls ?? []).concat((0, $85e40adea6d09b93$export$c90b7c9bd11bfec0));
    }
    get controlsIndex() {
        if (!this.#controlsIndex) this.#controlsIndex = (0, $b103c63dc979d40c$export$ab1c0bf676278196)(this.configControls);
        return this.#controlsIndex;
    }
    get type() {
        return this.constructor.type;
    }
    /**
   * A pattern is considered a template if the id is the same as the type. These are built-in patterns.
   */ get isTemplate() {
        return this.type === this.id;
    }
    get defaultConfig() {
        if (!this.#defaultConfig) this.#defaultConfig = Object.assign((0, $b103c63dc979d40c$export$38c07eba5c3aa11b)(this.configControls), this.defaultValues);
        return this.#defaultConfig;
    }
    get config() {
        return this.#config ?? this.defaultConfig;
    }
    set config(value) {
        this.#config = Object.assign({}, this.defaultConfig, value);
    }
    get isDefaultConfig() {
        return (0, $c29d66861308df7e$export$f05027632b38f3a4)(this.config, this.#defaultConfig);
    }
    /**
   * Marks the current config as default. Useful for saved patterns
   */ markConfigAsDefault() {
        this.#defaultConfig = this.config;
    }
    resetDefaultConfig() {
        this.#defaultConfig = null;
    }
    /**
   * Assigns the partial config to the current configuration of the StringArt
   * @param config
   */ assignConfig(config) {
        this.#config = Object.assign({}, this.config, config);
    }
    /**
   * Sets the config of the StringArt and updates using `onConfigChange`
   * @param config
   */ setConfig(config) {
        const currentConfig = this.config;
        this.config = config;
        if (this.onConfigChange) {
            const changedControlKeys = Object.keys(currentConfig).filter((key)=>config[key] !== currentConfig[key]);
            this.onConfigChange(changedControlKeys.map((key)=>({
                    control: this.controlsIndex[key],
                    value: config[key]
                })));
        }
    }
    /**
   * Child classes can define this method to clear any structural cache when config values for `isStructural=true` controls change.
   */ resetStructure() {
        this.calc = null;
        this.nails = null;
    }
    /**
   * Base method for getCalc
   * @param options
   * @returns
   */ getCalc(options) {
        return {};
    }
    onConfigChange(controls) {
        if (controls.some(({ control: control })=>control.isStructural)) {
            this.resetStructure();
            if (this.stepCount != null && controls.some(({ control: control })=>control.affectsStepCount !== false)) this.stepCount = null;
        }
    }
    onResize() {
        this.resetStructure();
    }
    setConfigValue(controlKey, value) {
        if (this.#config && this.#config[controlKey] === value) return;
        this.#config = {
            ...this.#config ?? this.defaultConfig,
            [controlKey]: value
        };
        if (this.onConfigChange) this.onConfigChange([
            {
                control: this.controlsIndex[controlKey],
                value: value
            }
        ].filter(({ control: control })=>!!control));
    }
    setUpDraw(options) {}
    initColor() {
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)(this.config);
    }
    afterDraw() {
        this.emit('drawdone', null);
    }
    /**
   * Sets up the pattern for rendering, by:
   * 1. Clearing strings and nails from the renderer (if required for any of them)
   * 2. Creates the Nails object
   * 3. Sets the strings line width
   * 4. Calls the pattern's `setUpDraw` method.
   * @param renderer
   * @param param1
   */ initDraw(renderer, { redrawNails: redrawNails = true, redrawStrings: redrawStrings = true, sizeChanged: sizeChanged, precision: precision } = {}) {
        if (sizeChanged) this.resetStructure();
        if (redrawStrings) renderer.resetStrings();
        if (redrawNails) {
            this.nails = null;
            renderer.resetNails();
        }
        renderer.clearInstructions();
        renderer.setLineWidth(this.config.stringWidth);
        const size = renderer.getSize();
        const options = {
            size: size
        };
        if (!this.calc) this.calc = this.getCalc(options);
        if (!this.nails) this.nails = this.getNails(precision);
        this.color = this.initColor();
        this.setUpDraw(options);
    }
    draw(renderer, options = {}) {
        if (!options.enableScheduler) {
            this.#draw(renderer, options);
            return ()=>{};
        }
        if (this.#taskController && !this.#taskController.signal.aborted) this.#taskController.abort('Redraw');
        this.#taskController = new TaskController({
            priority: 'background'
        });
        scheduler.postTask(()=>this.#draw(renderer, options), {
            signal: this.#taskController.signal
        }).catch((reason)=>{
        // The controller was aborted
        });
        return ()=>{
            this.#taskController?.abort('Cancelled');
        };
    }
    /**
   * Draws the string art on the renderer
   */ #draw(renderer, { position: position, controller: controller, ...drawOptions } = {}) {
        this.initDraw(renderer, drawOptions);
        const { showNails: showNails, darkMode: darkMode, backgroundColor: backgroundColor, customBackgroundColor: customBackgroundColor, enableBackground: enableBackground } = this.config;
        renderer.setBackground(enableBackground !== false ? customBackgroundColor ? backgroundColor : darkMode ? (0, $eb81ebf35fbd30cd$export$e60cfe038231c681).dark : (0, $eb81ebf35fbd30cd$export$e60cfe038231c681).light : null);
        if (showNails && drawOptions.redrawNails !== false) this.nails.draw(renderer, {
            color: this.config.nailsColor,
            fontSize: this.config.nailNumbersFontSize,
            radius: this.config.nailRadius,
            renderNumbers: this.config.showNailNumbers
        });
        this.controller = controller ?? new (0, $3c868d3c6cbc42ab$export$2e2bcd8739ae039)(renderer, this.nails);
        if (drawOptions.redrawStrings !== false && this.config.showStrings) {
            this.stringsIterator = this.drawStrings(this.controller);
            this.position = 0;
            while(!this.drawNext().done && (position == null || this.position < position));
        }
        return ()=>{
            this.#taskController?.abort('Cancelled');
        };
    }
    getLastStringNailNumbers() {
        return this.controller.getLastStringNailNumbers();
    }
    goto(renderer, position, { showInstructions: showInstructions = true } = {}) {
        if (position === this.position) return;
        if (this.stringsIterator && position > this.position) {
            while(!this.drawNext().done && this.position < position);
        } else this.draw(renderer, {
            position: position,
            redrawNails: false
        });
        if (showInstructions) renderer.renderInstructionsForLastLine();
    }
    /**
   *
   * @returns Advance the strings iterator by one. If the iterator is done, calls this.afterDraw().
   */ drawNext() {
        const result = this.stringsIterator.next();
        if (result.done) this.afterDraw();
        else this.position++;
        return result;
    }
    copy(overrideConfig) {
        const PatternCtor = this.constructor;
        const patternCopy = new PatternCtor();
        patternCopy.config = {
            ...this.config,
            ...overrideConfig ?? {}
        };
        return patternCopy;
    }
}
var $ed62eab3f3d51c1d$export$2e2bcd8739ae039 = $ed62eab3f3d51c1d$var$StringArt;


const $6e85582323150d4b$var$easing = {
    linear: (x)=>x,
    inOutCirc (x) {
        return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
    },
    easeOutQuint (x) {
        return 1 - Math.pow(1 - x, 5);
    },
    easeOutCubic (x) {
        return 1 - Math.pow(1 - x, 4);
    },
    fastSlowFast (t) {
        // Clamp t to [0,1] just to be safe
        t = Math.max(0, Math.min(1, t));
        // Custom easing formula: accelerates, slows in middle, then accelerates again
        return 0.5 * (1 - Math.cos(Math.PI * t)) ** 1.5;
    },
    fastInOutSquare (x) {
        return x <= 0.5 ? (1 - Math.pow(1 - x * 2, 2)) / 2 : 0.5 + Math.pow(x * 2 - 1, 2) / 2;
    },
    fastInOutCubic (x) {
        return x <= 0.5 ? (1 - Math.pow(1 - x * 2, 3)) / 2 : 0.5 + Math.pow(x * 2 - 1, 3) / 2;
    },
    fastInOutQuint (x) {
        return x <= 0.5 ? (1 - Math.pow(1 - x * 2, 5)) / 2 : 0.5 + Math.pow(x * 2 - 1, 5) / 2;
    },
    fastInOut (pow, x) {
        return x <= 0.5 ? (1 - Math.pow(1 - x * 2, pow)) / 2 : 0.5 + Math.pow(x * 2 - 1, pow) / 2;
    },
    fastInOutFixed (pow, fastArea, x) {
        if (x > fastArea && x < 1 - fastArea) {
            const y1 = (1 - Math.pow(1 - fastArea * 2, pow)) / 2;
            const y2 = 0.5 + Math.pow((1 - fastArea) * 2 - 1, pow) / 2;
            return y1 + (x - fastArea) * (y2 - y1) / (1 - 2 * fastArea);
        }
        return x <= fastArea ? (1 - Math.pow(1 - x * 2, pow)) / 2 : 0.5 + Math.pow(x * 2 - 1, pow) / 2;
    },
    easeOutFixed (pow, fixedAreaSize, x) {
        const fixedAreaStart = 1 - fixedAreaSize;
        if (x < fixedAreaStart || fixedAreaSize === 0) return 1 - Math.pow(1 - x, pow);
        const fixedAreaResultStart = 1 - Math.pow(1 - fixedAreaStart, pow);
        return fixedAreaResultStart + (1 - fixedAreaResultStart) * (x - fixedAreaStart) / fixedAreaSize;
    }
};
// @ts-ignore
$6e85582323150d4b$var$easing.fastInOut.requirePower = true;
// @ts-ignore
$6e85582323150d4b$var$easing.fastInOutFixed.requirePower = true;
// @ts-ignore
$6e85582323150d4b$var$easing.fastInOutFixed.requireFastArea = true;
// @ts-ignore
$6e85582323150d4b$var$easing.easeOutFixed.requirePower = true;
// @ts-ignore
$6e85582323150d4b$var$easing.easeOutFixed.requireFastArea = true;
var $6e85582323150d4b$export$2e2bcd8739ae039 = $6e85582323150d4b$var$easing;






class $d8b2fd23c47cc34c$export$2e2bcd8739ae039 {
    options;
    #nails;
    constructor(options){
        this.options = options;
        this.#nails = new Map();
    }
    get length() {
        return this.#nails.size;
    }
    get coordinates() {
        return this.#nails.values();
    }
    addNail(key, coordinates) {
        if (this.#nails.has(key)) console.warn(`Attempting to add a nail to NailsGroup, with already existing key, [${key}].`);
        this.#nails.set(key, coordinates);
    }
    addGroup(nailsGroup) {
        throw new Error('Adding sub groups not implemented yet.');
    }
    getNailCoordinates(key) {
        return this.#nails.get(key);
    }
    /**
   * Returns a map of
   * @param precision
   * @returns
   */ getNailNumbers({ precision: precision = 1, startNumber: startNumber = 1 } = {}) {
        const addedCoordinates = new Map();
        const nailNumbers = new Map();
        let nailNumber = startNumber;
        for (const [key, coordinates] of this.#nails.entries()){
            const hash = 1e5 * Math.round(coordinates[0] * precision) + Math.round(coordinates[1] * precision);
            if (addedCoordinates.has(hash)) nailNumbers.set(key, addedCoordinates.get(hash));
            else {
                nailNumbers.set(key, nailNumber);
                addedCoordinates.set(hash, nailNumber);
            }
            nailNumber++;
        }
        return nailNumbers;
    }
    getNailsCoordinates() {
        const nailsNumbers = this.getNailNumbers();
        const coordinates = new Array(nailsNumbers.size);
        nailsNumbers.entries().forEach(([nailKey, nailNumber])=>{
            coordinates[nailNumber - 1] = this.getNailCoordinates(nailKey);
        });
        return coordinates;
    }
    *getUniqueNails(precision = 1) {
        const addedCoordinates = new Set();
        for (const coordinates of this.#nails.values()){
            const hash = 1e5 * Math.round(coordinates[0] * precision) + Math.round(coordinates[1] * precision);
            if (!addedCoordinates.has(hash)) {
                yield coordinates;
                addedCoordinates.add(hash);
            }
        }
    }
    forEach(callback) {
        this.#nails.forEach((coordinates, number)=>callback(coordinates, number));
    }
}


class $a2a2cf72b22d53bf$export$2e2bcd8739ae039 {
    precision;
    #groups;
    #defaultNailsGroup;
    #nailNumbers;
    constructor(precision){
        this.precision = precision;
        this.#defaultNailsGroup = new (0, $d8b2fd23c47cc34c$export$2e2bcd8739ae039)();
        this.#groups = new Map([
            [
                null,
                this.#defaultNailsGroup
            ]
        ]);
    }
    get isEmpty() {
        return this.#groups.values().toArray().every((group)=>!group.length);
    }
    addNail(key, coordinates) {
        this.#defaultNailsGroup.addNail(key, coordinates);
    }
    addGroup(nailsGroup, key) {
        if (this.#groups.has(key)) throw new Error(`Nails already has a group with key [${key}]`);
        this.#groups.set(key, nailsGroup);
    }
    getGroup(groupKey) {
        if (!this.#groups.has(groupKey)) throw new Error(`Nails group '${groupKey}' not found.`);
        return this.#groups.get(groupKey);
    }
    #setNailNumbers() {
        this.#nailNumbers = new Map();
        let groupNumbersStart = 1;
        for (const [key, group] of this.#groups.entries()){
            this.#nailNumbers.set(key, group.getNailNumbers({
                precision: this.precision,
                startNumber: groupNumbersStart
            }));
            groupNumbersStart += group.length;
        }
    }
    /**
   * Returns an array of the coordinates of all nails, in all groups.
   * The indexes of the array are the numbers of the nails, as displayed on the pattern
   */ getAllNailsCoordinates() {
        const coordinates = [];
        for (const group of this.#groups.values())coordinates.push(group.getNailsCoordinates());
        return coordinates.flat();
    }
    getNailNumber(nailKey, groupKey) {
        if (!this.#nailNumbers) this.#setNailNumbers();
        return this.#nailNumbers.get(groupKey ?? null).get(nailKey);
    }
    getNailCoordinates(nailKey, groupKey = null) {
        const coordinates = this.#groups.get(groupKey)?.getNailCoordinates(nailKey);
        if (!coordinates) throw new Error(`Key [${nailKey}] not found in ${groupKey == null ? 'default nails group' : `nails group [${groupKey}]`}.`);
        return coordinates;
    }
    draw(renderer, options) {
        let numbersStart = 1;
        for (const group of this.#groups.values()){
            renderer.renderNails(this.precision || options.renderNumbers ? group.getUniqueNails(this.precision) : group.coordinates, {
                ...options,
                ...group.options,
                numbersStart: numbersStart
            });
            numbersStart += group.length;
        }
    }
}


class $55d14da464282011$export$2e2bcd8739ae039 {
    getUniqueKey;
    constructor(config){
        this.getUniqueKey = config.getUniqueKey;
    }
    getAspectRatio() {
        const rect = this.getBoundingRect();
        return rect.width / rect.height;
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.addNails(nails);
        return nails;
    }
}



function $96d8651f67c6b219$export$f481ea230fad194b(value) {
    return `${Math.round(value * 100)}%`;
}
function $96d8651f67c6b219$export$b5632b5e53e50dc(value, decimalPoints = 0) {
    return `${(0, $e2b746416d2bf62b$export$a3992db8dd0fd9e6)((value ?? 0) * 360, decimalPoints)}\xb0`;
}
function $96d8651f67c6b219$export$9a00dee1beb8f576(value) {
    return value[0].toLocaleUpperCase() + value.slice(1);
}


function $c190f550efa69733$export$7f1ebd623f131021(size, mapper) {
    return new Array(size).fill(null).map((_, i)=>mapper(i));
}





class $281c51d967a471db$export$17d680238e50603e extends (0, $55d14da464282011$export$2e2bcd8739ae039) {
    config;
    from;
    to;
    /**
   * distance between from and to, [x,y]
   */ distance;
    spaces;
    constructor(config){
        super(config);
        if (config.n < 1) throw new Error(`Can't create a Line with n less than 1.`);
        if (config.drawEndIndex != null && config.drawEndIndex >= config.n) throw new Error(`drawEndIndex (${config.drawEndIndex}) can't be greater than or equal to n (${config.n}).`);
        if (config.drawStartIndex != null && (config.drawStartIndex >= config.n || config.drawStartIndex < 0)) throw new Error(`drawStartIndex (${config.drawStartIndex}) can't be less than 0 or greater than or equal to n (${config.n}).`);
        this.config = config;
        const { rotation: rotation, from: from, to: to, n: n } = config;
        if (rotation) {
            const rotationAngle = -(0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * rotation;
            const rotationCenter = this.#getRotationCenterCoordinates();
            this.from = this.#rotatePoint(from, rotationCenter, rotationAngle);
            this.to = this.#rotatePoint(to, rotationCenter, rotationAngle);
        } else {
            this.from = config.from;
            this.to = config.to;
        }
        this.distance = [
            this.to[0] - this.from[0],
            this.to[1] - this.from[1]
        ];
        this.spaces = n - 1;
    }
    #getRotationCenterCoordinates() {
        const { from: from, to: to, rotationCenter: rotationCenter } = this.config;
        if (!rotationCenter || rotationCenter === 'center') return [
            from[0] + (to[0] - from[0]) / 2,
            from[1] + (to[1] - from[1]) / 2
        ];
        else switch(rotationCenter){
            case 'from':
                return from;
            case 'to':
                return to;
            default:
                return rotationCenter;
        }
    }
    #rotatePoint(point, rotationCenter, rotationAngle) {
        const xDist = point[0] - rotationCenter[0];
        const yDist = point[1] - rotationCenter[1];
        const pointDistanceToCenter = Math.hypot(xDist, yDist);
        if (!pointDistanceToCenter) return point;
        const startingAngle = Math.asin(xDist / pointDistanceToCenter) + (yDist < 0 ? Math.PI : 0);
        return [
            rotationCenter[0] + Math.sin(startingAngle + rotationAngle) * pointDistanceToCenter,
            rotationCenter[1] + Math.cos(startingAngle + rotationAngle) * pointDistanceToCenter
        ];
    }
    getPoint(index) {
        const { from: from } = this;
        return (0, $b683a3137b30eaa9$export$c566af9defc62c6)(from, (v, i)=>v + this.distance[i] * index / this.spaces);
    }
    getNailIndex(index) {
        const realIndex = index - (this.config.drawStartIndex ?? 0);
        return this.getUniqueKey?.(realIndex) ?? realIndex;
    }
    addNails(nails) {
        const { drawStartIndex: startIndex = 0, drawEndIndex: endIndex } = this.config;
        const lastIndex = endIndex ?? this.config.n - 1;
        for(let i = startIndex; i <= lastIndex; i++){
            const index = i - startIndex;
            nails.addNail(this.getUniqueKey?.(index) ?? index, this.getPoint(i));
        }
    }
    getNailCount() {
        const lastIndexCount = this.config.drawEndIndex != null ? this.config.drawEndIndex + 1 : this.config.n;
        return lastIndexCount - (this.config.drawStartIndex ?? 0);
    }
    getBoundingRect() {
        const { from: from, to: to } = this;
        return {
            width: Math.abs(this.distance[0]),
            height: Math.abs(this.distance[1]),
            top: Math.min(to[1], from[1]),
            bottom: Math.max(to[1], from[1]),
            left: Math.min(from[0], to[0]),
            right: Math.max(from[0], to[0])
        };
    }
    getAspectRatio() {
        const { width: width, height: height } = this.getBoundingRect();
        return width / height;
    }
}


class $cf574edfbef72605$export$2e2bcd8739ae039 extends (0, $55d14da464282011$export$2e2bcd8739ae039) {
    config;
    #calc;
    constructor(config){
        super(config), this.config = config;
        this.#calc = this.#getCalc();
    }
    get center() {
        return this.#calc.center;
    }
    get radius() {
        return this.#calc.radius;
    }
    /**
   * The angle inside the polygon between two sides
   */ get interiorAngle() {
        return (this.config.sides - 2) * Math.PI / this.config.sides;
    }
    get sideSize() {
        return this.#calc.sideSize;
    }
    get radiusNailsCount() {
        return this.#calc.radiusNailsCount;
    }
    #fitSize({ center: center, size: configSize, verticesCosSin: verticesCosSin }) {
        const radius = 1;
        const maxPointIndexes = [
            0,
            0
        ];
        const maxCoordinates = [
            ...verticesCosSin[0]
        ];
        for(let s = 1; s < this.config.sides; s++){
            if (verticesCosSin[s][0] > maxCoordinates[0]) maxPointIndexes[0] = s;
            if (verticesCosSin[s][1] > maxCoordinates[1]) maxPointIndexes[1] = s;
        }
        const boundingRect = (0, $b683a3137b30eaa9$export$8c48870e8825fa45)(verticesCosSin);
        const scale = Math.min(configSize[0] / boundingRect.width, configSize[1] / boundingRect.height);
        const fittedRect = (0, $b683a3137b30eaa9$export$c566af9defc62c6)([
            boundingRect.width,
            boundingRect.height
        ], (v)=>v * scale);
        const fittedRadius = radius * scale;
        const centerdFittedRect = (0, $b683a3137b30eaa9$export$18675c441b273a07)(fittedRect, center);
        const newCenter = [
            centerdFittedRect.right - boundingRect.right * scale,
            centerdFittedRect.bottom - boundingRect.bottom * scale
        ];
        return {
            center: newCenter,
            radius: fittedRadius
        };
    }
    #getPoints() {
        const { fitSize: fitSize, rotation: rotation = 0, size: size, sides: sides, center: configCenter, margin: margin = 0, radius: radiusConfig } = this.config;
        const rotationRadians = (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * rotation;
        let center = configCenter ?? (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        const angle = (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / sides;
        const startingAngle = sides % 2 ? -Math.PI / 2 : sides / 2 % 2 ? 0 : Math.PI / sides;
        const verticesCosSin = (0, $c190f550efa69733$export$7f1ebd623f131021)(sides, (s)=>{
            const pointAngle = angle * s + startingAngle + rotationRadians;
            return [
                Math.cos(pointAngle),
                Math.sin(pointAngle)
            ];
        });
        let radius = 0;
        if (fitSize) {
            const fitted = this.#fitSize({
                center: center,
                size: (0, $b683a3137b30eaa9$export$c566af9defc62c6)(size, (v)=>v - 2 * margin),
                verticesCosSin: verticesCosSin
            });
            center = fitted.center;
            radius = fitted.radius;
        } else {
            const getRadius = ()=>{
                const smallestSide = Math.min(...(0, $b683a3137b30eaa9$export$c566af9defc62c6)(size, (v)=>v - 2 * margin));
                return smallestSide / 2;
            };
            radius = radiusConfig ?? getRadius();
        }
        return {
            center: center,
            vertices: verticesCosSin.map((cosSin)=>cosSin.map((v, i)=>center[i] + v * radius)),
            radius: radius
        };
    }
    #getSideLines(vertices, startIndex) {
        return (0, $c190f550efa69733$export$7f1ebd623f131021)(this.config.sides, (side)=>{
            const lineStartIndex = startIndex + side * (this.config.nailsPerSide - 1);
            return new (0, $281c51d967a471db$export$17d680238e50603e)({
                from: vertices[side],
                to: vertices[(side + 1) % this.config.sides],
                n: this.config.nailsPerSide,
                drawEndIndex: Math.max(0, this.config.nailsPerSide - 2),
                getUniqueKey: this.getUniqueKey ? (k)=>this.getUniqueKey(lineStartIndex + k) : (k)=>lineStartIndex + k
            });
        });
    }
    #getCenterLines(center, vertices, n, nailIndexesPerCenterLine) {
        const { drawSides: drawSides = true, drawCenterNail: drawCenterNail } = this.config;
        const startIndex = drawCenterNail ? 1 : 0;
        return (0, $c190f550efa69733$export$7f1ebd623f131021)(this.config.sides, (side)=>{
            const lineStartIndex = startIndex + side * nailIndexesPerCenterLine;
            return new (0, $281c51d967a471db$export$17d680238e50603e)({
                from: center,
                to: vertices[side],
                n: n,
                drawStartIndex: 1,
                drawEndIndex: drawSides ? n - 2 : n,
                getUniqueKey: this.getUniqueKey ? (k)=>this.getUniqueKey(lineStartIndex + k) : (k)=>lineStartIndex + k
            });
        });
    }
    #getCalc() {
        const { nailsPerSide: nailsPerSide, radiusNailsCountSameAsSides: radiusNailsCountSameAsSides = false, drawCenter: drawCenter, drawCenterNail: drawCenterNail, sides: sides, drawSides: drawSides = true } = this.config;
        const { center: center, vertices: vertices, radius: radius } = this.#getPoints();
        const sideSize = (0, $e2b746416d2bf62b$export$27796bb1a51212b7)(vertices[0], vertices[1]);
        const nailsDistance = sideSize / (nailsPerSide - 1);
        const radiusNailsCount = radiusNailsCountSameAsSides ? nailsPerSide : Math.max(2, Math.floor(radius / nailsDistance));
        const nailIndexesPerCenterLine = radiusNailsCount - 1 - (drawSides ? 1 : 0);
        return {
            center: center,
            radius: radius,
            sideSize: sideSize,
            radiusNailsCount: radiusNailsCount,
            vertices: vertices,
            sideLines: this.#getSideLines(vertices, (drawCenterNail ? 1 : 0) + (drawCenter ? nailIndexesPerCenterLine * sides : 0)),
            centerLines: drawCenter ? this.#getCenterLines(center, vertices, radiusNailsCount, nailIndexesPerCenterLine) : null
        };
    }
    #getPositionForIndex(index) {
        const { nailsPerSide: nailsPerSide } = this.config;
        const position = index / nailsPerSide;
        const side = Math.floor(position);
        const sideIndex = index % nailsPerSide;
        return {
            side: side,
            index: sideIndex
        };
    }
    getPoint(index) {
        return this.getSidePoint(this.#getPositionForIndex(index));
    }
    getSideNailIndex(side, index) {
        if (index == undefined) {
            // overload where the index is for the whole polygon
            const position = this.#getPositionForIndex(side);
            return this.#calc.sideLines[position.side].getNailIndex(position.index);
        }
        return this.#calc.sideLines[side].getNailIndex(index);
    }
    getSidePoint({ side: side, index: index }) {
        return this.#calc.sideLines[side].getPoint(index);
    }
    getCenterPoint({ side: side, index: index }) {
        if (index < 0) throw new Error(`Can't get polygon center point for index = (${index}).`);
        if (side < 0) throw new Error(`Can't get polygon center point for side = (${index}).`);
        return this.#calc.centerLines[side].getPoint(index);
    }
    getCenterNailIndex(side, index) {
        if (index === 0) return this.getUniqueKey?.(0) ?? 0;
        return this.#calc.centerLines[side].getNailIndex(index);
    }
    getBoundingRect() {
        return (0, $b683a3137b30eaa9$export$8c48870e8825fa45)(this.#calc.vertices);
    }
    getAspectRatio() {
        return (0, $b683a3137b30eaa9$export$d2646d47608819e2)(this.getBoundingRect());
    }
    addNails(nails) {
        const { sideLines: sideLines, centerLines: centerLines, center: center } = this.#calc;
        const { sides: sides, drawCenter: drawCenter = false, drawCenterNail: drawCenterNail = false, drawSides: drawSides = true } = this.config;
        if (drawCenterNail) nails.addNail(this.getUniqueKey?.(0) ?? 0, center);
        if (drawCenter) for(let side = 0; side < sides; side++)centerLines[side].addNails(nails);
        if (drawSides) for(let side = 0; side < sides; side++)sideLines[side].addNails(nails);
    }
    getNailCount() {
        const { drawCenter: drawCenter = false, drawCenterNail: drawCenterNail, drawSides: drawSides = true } = this.config;
        let nailCount = 0;
        if (drawCenterNail || drawCenter && drawCenterNail !== false) nailCount += 1;
        let sideNailCount = 0;
        if (drawCenter) sideNailCount += this.#calc.centerLines[0].getNailCount();
        if (drawSides) sideNailCount += this.#calc.sideLines[0].getNailCount();
        return nailCount + this.config.sides * sideNailCount;
    }
    /**
   * Returns the shortest distance between the polygon's center and any of the side lines
   */ getApothem() {
        return this.radius * Math.cos(Math.PI / this.config.sides);
    }
    static rotationConfig = {
        key: 'rotation',
        label: 'Rotation',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: 0,
            max: 1,
            step: 0.0025
        },
        displayValue: ({ rotation: rotation, sides: sides })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(rotation / (2 * sides), 1),
        isStructural: true,
        affectsStepCount: false
    };
}





class $06de6887437e6fa7$export$2e2bcd8739ae039 extends (0, $55d14da464282011$export$2e2bcd8739ae039) {
    easingFunction;
    config;
    center;
    xyRadius;
    rotationAngle = 0;
    indexAngle;
    isReverse = false;
    radius;
    arc = (0, $e2b746416d2bf62b$export$f4644083ce95e7e3);
    isPartialArc = false;
    excludedNailIndexes;
    constructor(config){
        super(config);
        this.setConfig(config);
    }
    getPoint(index) {
        const realIndex = this.#getNailIndex(index);
        const angle = this.easingFunction(realIndex / (this.config.n - (this.isPartialArc ? 1 : 0))) * this.arc + this.rotationAngle + (this.config.angleStart ?? 0);
        const point = [
            this.center[0] + Math.sin(angle) * this.xyRadius[0],
            this.center[1] + Math.cos(angle) * this.xyRadius[1]
        ];
        return point;
    }
    #getNailIndex(index = 0) {
        const withReverse = this.isReverse ? this.config.n - 1 - index : index;
        return (withReverse < 0 ? this.config.n + withReverse : withReverse) % this.config.n;
    }
    getNailKey(index) {
        const realIndex = this.#getNailIndex(index);
        return this.getUniqueKey?.(realIndex) ?? realIndex;
    }
    getAspectRatio() {
        if (!this.config.distortion) return 1;
        const aspectRatio = (0, $e2b746416d2bf62b$export$643b64bfca4574ff)(this.config.distortion);
        return aspectRatio[0] / aspectRatio[1];
    }
    /**
   * The bounding rect of the Circle is not just [diameter, diameter], because a 3 nail circle is a triangle, for example,
   * in which case the bounding rect won't take that fill rect. Using a Polygon instead, which is more precise.
   */ getBoundingRect() {
        const { n: n, rotation: rotation } = this.config;
        if (n < 16) {
            const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                sides: n,
                rotation: rotation,
                size: [
                    this.radius * 2,
                    this.radius * 2
                ],
                nailsPerSide: 1,
                center: this.center
            });
            return polygon.getBoundingRect();
        }
        return {
            top: this.center[1] - this.xyRadius[1],
            left: this.center[0] - this.xyRadius[0],
            right: this.center[0] + this.xyRadius[0],
            bottom: this.center[1] + this.xyRadius[1],
            width: this.xyRadius[0] * 2,
            height: this.xyRadius[1] * 2
        };
    }
    setConfig(config) {
        if (!(0, $c29d66861308df7e$export$f05027632b38f3a4)(config, this.config)) {
            const { n: n, size: size, margin: margin = 0, rotation: rotation = 0, center: configCenter, radius: radius, reverse: reverse = false, angleStart: angleStart, angleEnd: angleEnd } = config;
            const center = configCenter ?? (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
            const clampedRadius = Math.max(1, (radius ?? Math.min(...(0, $b683a3137b30eaa9$export$c91255cadecfe081)(size))) - margin);
            let xyRadius = [
                clampedRadius,
                clampedRadius
            ];
            if (config.distortion) {
                const aspectRatio = (0, $e2b746416d2bf62b$export$643b64bfca4574ff)(config.distortion);
                const distortedBox = aspectRatio.map((v)=>clampedRadius * v);
                xyRadius = (0, $b683a3137b30eaa9$export$18c295d7a6a8189d)(distortedBox, size.map((v)=>Math.max(0, v / 2 - margin)));
            }
            // Normally, the whole circle is rendered, but if angleStart and angleEnd are configured and valid, and arc between them is rendered:
            this.isPartialArc = angleStart && angleEnd && angleEnd > angleStart;
            const arc = this.isPartialArc ? angleEnd - angleStart : (0, $e2b746416d2bf62b$export$f4644083ce95e7e3);
            const props = {
                center: center,
                radius: clampedRadius,
                xyRadius: xyRadius,
                indexAngle: arc / (this.isPartialArc ? n - 1 : n),
                rotationAngle: -(0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * rotation,
                isReverse: reverse,
                arc: arc
            };
            const easingFunction = config.displacementFunc ? (0, $6e85582323150d4b$export$2e2bcd8739ae039)[config.displacementFunc] : (0, $6e85582323150d4b$export$2e2bcd8739ae039).linear;
            const easingParams = [];
            // @ts-ignore
            if (easingFunction.requirePower) easingParams.push(config.displacementMag);
            // @ts-ignore
            if (easingFunction.requireFastArea) easingParams.push(config.displacementFastArea);
            const easingFunctionWithParams = easingParams.length ? easingFunction.bind(null, ...easingParams) : easingFunction;
            this.easingFunction = easingFunctionWithParams;
            this.config = config;
            Object.assign(this, props);
        }
    }
    /**
   * Given a Nails instance, uses it to draw the nails of this Circle
   * @param {Nails} nails
   * @param {{nailsNumberStart?: number, getNumber?: Function}} param1
   */ addNails(nails, { filter: filter } = {}) {
        for(let i = 0; i < this.config.n; i++)if (!filter || filter(i)) nails.addNail(this.getUniqueKey?.(i) ?? i, this.getPoint(i));
    }
    *drawRingLayer(controller, { ringSize: ringSize, nailGroup: nailGroup }) {
        const { n: n } = this.config;
        const ringDistance = Math.floor(ringSize * n);
        let targetIndex = 0;
        let isPrevSide = false;
        controller.goto(this.getNailKey(0), nailGroup);
        for(let i = 0; i < n; i++){
            targetIndex = isPrevSide ? i : targetIndex + ringDistance;
            yield controller.stringTo(this.getNailKey(targetIndex), nailGroup);
            if (i < n - 1) {
                targetIndex++;
                yield controller.stringTo(this.getNailKey(targetIndex), nailGroup);
            }
            isPrevSide = !isPrevSide;
        }
    }
    getRingStepCount() {
        return this.config.n * 2 - 1;
    }
    getNailCount() {
        // TODO: addNails uses filter, should it be used here too?
        return this.config.n;
    }
    static rotationConfig = {
        key: 'rotation',
        label: 'Rotation',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: 0,
            max: 1 + 1 / 360,
            step: 1 / 360,
            snap: '0.25, 0.5, 0.75'
        },
        displayValue: ({ rotation: rotation })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(rotation),
        isStructural: true,
        affectsStepCount: false
    };
    static nailsConfig = {
        key: 'n',
        label: 'Number of nails',
        defaultValue: 144,
        type: 'range',
        attr: {
            min: 3,
            max: 300,
            step: 1
        },
        isStructural: true
    };
    static displacementConfig = {
        key: 'displacement',
        label: 'Displacement',
        type: 'group',
        children: [
            {
                key: 'displacementFunc',
                label: 'Displacement function',
                defaultValue: 'linear',
                type: 'select',
                options: Object.keys((0, $6e85582323150d4b$export$2e2bcd8739ae039)),
                isStructural: true,
                affectsStepCount: false
            },
            {
                key: 'displacementMag',
                label: 'Displacement magnitude',
                defaultValue: 3,
                type: 'range',
                attr: {
                    min: 0,
                    max: 10,
                    step: 0.1
                },
                // @ts-ignore
                show: ({ displacementFunc: displacementFunc })=>(0, $6e85582323150d4b$export$2e2bcd8739ae039)[displacementFunc].requirePower,
                isStructural: true,
                affectsStepCount: false
            },
            {
                key: 'displacementFastArea',
                label: 'Displacement fast area',
                defaultValue: 0.4,
                type: 'range',
                attr: {
                    min: 0,
                    max: 0.5,
                    step: 0.01
                },
                show: ({ displacementFunc: displacementFunc })=>// @ts-ignore
                    (0, $6e85582323150d4b$export$2e2bcd8739ae039)[displacementFunc].requireFastArea,
                isStructural: true,
                affectsStepCount: false
            }
        ]
    };
    static distortionConfig = {
        key: 'distortion',
        label: 'Distortion',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: -0.99,
            max: 0.99,
            step: 0.01,
            snap: '0'
        },
        isStructural: true,
        affectsStepCount: false
    };
}



const $b45c5717991b3431$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        colorCount: 7,
        color: '#ffbb29',
        multicolorRange: 21,
        multicolorStart: 32,
        multicolorByLightness: true,
        minLightness: 36,
        maxLightness: 98
    }
});
class $b45c5717991b3431$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'spiral';
    id = 'spiral';
    name = 'Spiral';
    controls = [
        // @ts-ignore
        {
            ...(0, $06de6887437e6fa7$export$2e2bcd8739ae039).nailsConfig,
            defaultValue: 200
        },
        {
            key: 'repetition',
            label: 'Repetition',
            defaultValue: 5,
            type: 'range',
            attr: {
                min: 1,
                max: 20,
                step: 1
            },
            affectsNails: false,
            isStructural: true
        },
        {
            key: 'innerLength',
            label: 'Spiral thickness',
            defaultValue: 0.5,
            type: 'range',
            attr: {
                min: ({ n: n })=>1 / n,
                max: 1,
                step: ({ n: n })=>1 / n
            },
            displayValue: ({ n: n, innerLength: innerLength })=>Math.round(n * innerLength),
            affectsNails: false
        },
        {
            ...(0, $b103c63dc979d40c$export$2d97e2da46663803)((0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig, 'snap'),
            defaultValue: 0.75
        },
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        $b45c5717991b3431$var$COLOR_CONFIG
    ];
    colorMap;
    getCalc({ size: size }) {
        const { n: n, rotation: rotation, margin: margin, repetition: repetition, distortion: distortion } = this.config;
        const circleConfig = {
            size: size,
            n: n,
            margin: margin,
            rotation: rotation,
            distortion: distortion
        };
        return {
            circle: new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig),
            realRepetition: repetition * 2 - 1
        };
    }
    setUpDraw() {
        if (this.color.config.colorCount) this.colorMap = this.color.getColorMap({
            stepCount: this.getStepCount(),
            colorCount: this.color.config.colorCount
        });
    }
    getAspectRatio(options) {
        const { circle: circle } = this.getCalc(options);
        return circle.getAspectRatio();
    }
    *drawSpiral(controller, { shift: shift = 0, color: color = '#ffffff' } = {}) {
        const { innerLength: innerLength, n: n } = this.config;
        let currentInnerLength = Math.round(innerLength * n);
        let repetitionCount = 0;
        controller.startLayer({
            color: color
        });
        controller.goto(shift);
        let prevPointIndex = shift;
        let isPrevPoint = false;
        for(let i = 0; currentInnerLength > 0; i++){
            if (this.colorMap) {
                if (this.colorMap.has(i)) controller.startLayer({
                    color: this.colorMap.get(i)
                });
            }
            prevPointIndex = isPrevPoint ? prevPointIndex - currentInnerLength + 1 : prevPointIndex + currentInnerLength;
            if (repetitionCount === this.calc.realRepetition) {
                currentInnerLength--;
                repetitionCount = 0;
                prevPointIndex++;
            } else repetitionCount++;
            controller.stringTo(prevPointIndex % n);
            yield;
            isPrevPoint = !isPrevPoint;
        }
    }
    *drawStrings(controller) {
        yield* this.drawSpiral(controller, {
            color: this.color.getColor(0)
        });
    }
    getStepCount() {
        const { innerLength: innerLength, repetition: repetition, n: n } = this.config;
        return Math.round(n * (innerLength * 2) * repetition);
    }
    getNails(precision) {
        return this.calc.circle.getNails(precision);
    }
    thumbnailConfig = ({ n: n })=>({
            n: Math.min(n, 60)
        });
}











class $8786bcda2cdcea99$var$Spirals extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'spirals';
    name = 'Spirals';
    id = 'spirals';
    link = 'https://www.etsy.com/il-en/listing/974865185/3d-string-art-spiral-mandala-wall?ref=shop_home_active_10&frs=1';
    controls = [
        {
            key: 'nSpirals',
            label: 'Number of spirals',
            defaultValue: 3,
            type: 'range',
            attr: {
                min: 2,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'nailsPerSpiral',
            label: 'Nails per spiral',
            type: 'range',
            defaultValue: 80,
            attr: {
                min: 3,
                max: 300,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'angle',
            label: 'Angle',
            type: 'range',
            defaultValue: 0.52,
            attr: {
                min: 0,
                max: 2,
                step: 0.026
            },
            displayValue: ({ angle: angle })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(angle),
            isStructural: true,
            affectsStepCount: false
        },
        {
            key: 'radiusEasing',
            label: 'Radius easing',
            defaultValue: 1.8,
            type: 'range',
            attr: {
                min: 1,
                max: 10,
                step: 0.1
            },
            isStructural: true,
            affectsStepCount: false
        },
        {
            key: 'angleEasing',
            label: 'Angle easing',
            defaultValue: 1.3,
            type: 'range',
            attr: {
                min: 1,
                max: 10,
                step: 0.1
            },
            isStructural: true,
            affectsStepCount: false
        },
        {
            ...(0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig,
            defaultValue: 65 / 360
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                colorCount: 4,
                color: '#00d5ff',
                multicolorRange: 1,
                multicolorStart: 190,
                multicolorByLightness: true,
                minLightness: 50,
                maxLightness: 88,
                reverseColors: true
            }
        })
    ];
    colorMap;
    getCalc({ size: size }) {
        const { nSpirals: nSpirals, rotation: rotation, margin: margin, angle: angle } = this.config;
        const maxRadius = Math.min(...size) / 2 - margin;
        return {
            spiralRotations: (0, $c190f550efa69733$export$7f1ebd623f131021)(nSpirals, (i)=>i * (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / nSpirals),
            rotationAngle: -(0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * rotation,
            angle: angle * (0, $e2b746416d2bf62b$export$f4644083ce95e7e3),
            center: (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size),
            radius: maxRadius
        };
    }
    setUpDraw() {
        this.colorMap = this.color.getColorMap({
            stepCount: this.getStepCount()
        });
    }
    /**
   * TODO: The aspect ratio isn't really 1, but it's hard to calculate. Will tackle it in the future
   */ getAspectRatio() {
        return 1;
    }
    *generatePoints() {
        const { nSpirals: nSpirals, nailsPerSpiral: nailsPerSpiral } = this.config;
        for(let i = 1; i < nailsPerSpiral; i++)for(let s = 0; s < nSpirals; s++)yield [
            s,
            i
        ];
    }
    getPoint(spiralIndex, index) {
        const { center: center, radius: maxRadius, angle: totalAngle } = this.calc;
        const { nailsPerSpiral: nailsPerSpiral, radiusEasing: radiusEasing, angleEasing: angleEasing } = this.config;
        const position = index / (nailsPerSpiral - 1);
        const angle = this.calc.rotationAngle + (0, $6e85582323150d4b$export$2e2bcd8739ae039).easeOutFixed(angleEasing, 0, position) * totalAngle + this.calc.spiralRotations[spiralIndex];
        const radius = (0, $6e85582323150d4b$export$2e2bcd8739ae039).easeOutFixed(radiusEasing, 0, position) * maxRadius;
        return [
            center[0] + radius * Math.sin(angle),
            center[1] + radius * Math.cos(angle)
        ];
    }
    *drawStrings(controller) {
        const points = this.generatePoints();
        let index = 0;
        controller.startLayer({
            color: this.color.getColor(0)
        });
        controller.goto(0);
        for (const _ of points){
            if (this.colorMap) {
                const stepColor = this.colorMap.get(index);
                if (stepColor) controller.startLayer({
                    color: stepColor
                });
            }
            controller.stringTo(index);
            yield;
            index++;
        }
    }
    getStepCount() {
        const { nSpirals: nSpirals, nailsPerSpiral: nailsPerSpiral } = this.config;
        return (nailsPerSpiral - 1) * nSpirals;
    }
    getNails(precision) {
        const points = this.generatePoints();
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        let i = 0;
        for (const [side, index] of points){
            nails.addNail(i, this.getPoint(side, index));
            i++;
        }
        return nails;
    }
    getNailCount() {
        const { nSpirals: nSpirals, nailsPerSpiral: nailsPerSpiral } = this.config;
        return nSpirals * (nailsPerSpiral - 1);
    }
    thumbnailConfig = ({ nailsPerSpiral: nailsPerSpiral })=>({
            nailsPerSpiral: Math.min(30, nailsPerSpiral)
        });
}
var $8786bcda2cdcea99$export$2e2bcd8739ae039 = $8786bcda2cdcea99$var$Spirals;







class $2bf6005aa150cc2c$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'mandala';
    name = 'Mandala';
    id = 'mandala';
    link = 'https://www.youtube.com/watch?v=qhbuKbxJsk8';
    linkText = 'Learn';
    controls = [
        {
            key: 'n',
            label: 'Number of nails',
            defaultValue: 180,
            type: 'range',
            attr: {
                min: 3,
                max: 400,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'base',
            label: 'Multiplication',
            defaultValue: 2,
            type: 'range',
            attr: {
                min: 2,
                max: 99,
                step: 1
            },
            affectsNails: false
        },
        {
            key: 'layers',
            label: 'Layers',
            defaultValue: 7,
            type: 'range',
            attr: {
                min: 1,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig,
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                multicolorRange: 165,
                multicolorStart: 256,
                color: '#ff4d00'
            },
            exclude: [
                'colorCount'
            ]
        })
    ];
    get n() {
        return this.calc.n;
    }
    getCalc({ size: size }) {
        const { n: nConfig, layers: layers, layerFill: layerFill, rotation: rotation, distortion: distortion, margin: margin, reverse: reverse, base: base } = this.config;
        const extraNails = nConfig % layers;
        const n = nConfig - extraNails; // The number of nails should be a multiple of the layers, so the strings are exactly on the nails.
        const circleConfig = {
            size: size,
            n: n,
            margin: margin,
            rotation: rotation,
            distortion: distortion,
            reverse: reverse
        };
        return {
            n: n,
            stringsPerLayer: layerFill ? Math.floor(n * layerFill) : n,
            layerShift: Math.floor(n / layers / (base % 2 ? 2 : 1)),
            circle: new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig)
        };
    }
    initColor() {
        const { layers: layers } = this.config;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            colorCount: layers
        });
    }
    getAspectRatio(options) {
        const calc = this.getCalc(options);
        return calc.circle.getAspectRatio();
    }
    *drawMultiplicationLayer(controller, layerIndex) {
        const { reverse: reverse, base: base } = this.config;
        const { n: n, layerShift: layerShift, stringsPerLayer: stringsPerLayer, circle: circle } = this.calc;
        const direction = reverse ? 1 : -1;
        const shift = layerShift * layerIndex * direction;
        const color = this.color.getColor(layerIndex);
        controller.startLayer({
            color: color,
            name: String(layerIndex)
        });
        controller.goto(circle.getNailKey(shift));
        for(let i = 1; i < stringsPerLayer; i += 2){
            const multipliedIndex = i * base % n + shift;
            const positions = [
                i + shift,
                multipliedIndex,
                multipliedIndex + base,
                i + shift + 1
            ];
            for (const position of positions){
                controller.stringTo(circle.getNailKey(position));
                yield;
            }
        }
    }
    *drawStrings(controller) {
        const { layers: layers } = this.config;
        for(let layer = 0; layer < layers; layer++)yield* this.drawMultiplicationLayer(controller, layer);
    }
    getNails(precision) {
        return this.calc.circle.getNails(precision);
    }
    getStepCount(options) {
        const { layers: layers, layerFill: layerFill } = this.config;
        const { n: n } = this.getCalc(options);
        const stringsPerLayer = layerFill ? Math.floor(n * layerFill) : n;
        return (layers ?? 1) * (2 * (stringsPerLayer - 1));
    }
    getNailCount() {
        const { n: nConfig, layers: layers } = this.config;
        const extraNails = nConfig % layers;
        return nConfig - extraNails;
    }
    // @ts-ignore
    thumbnailConfig = ({ n: n })=>({
            n: Math.min(n, 70)
        });
}




class $51855848c5e96fff$export$2e2bcd8739ae039 extends (0, $2bf6005aa150cc2c$export$2e2bcd8739ae039) {
    static type = 'wave';
    id = 'wave';
    name = 'Wave';
    link = 'https://www.etsy.com/il-en/listing/943140543/personalized-gift-string-art-mandala?ref=sim_rv-5&pro=1';
    controls = [
        {
            ...(0, $06de6887437e6fa7$export$2e2bcd8739ae039).nailsConfig,
            defaultValue: 200
        },
        {
            key: 'layerFill',
            label: 'Layer fill',
            defaultValue: 0.5,
            type: 'range',
            attr: {
                min: ({ n: n })=>1 / n,
                max: 1,
                step: ({ n: n })=>1 / n
            },
            displayValue: ({ layerFill: layerFill })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(layerFill),
            affectsNails: false,
            isStructural: true
        },
        (0, $b103c63dc979d40c$export$2d97e2da46663803)((0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig, 'snap'),
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        {
            key: 'layers',
            label: 'Layers',
            defaultValue: 11,
            type: 'range',
            attr: {
                min: 1,
                max: 20,
                step: 1
            }
        },
        {
            key: 'layerSpread',
            label: 'Layer spread',
            defaultValue: 0.075,
            type: 'range',
            attr: {
                min: 0,
                max: 1,
                step: ({ n: n })=>1 / n
            },
            displayValue: ({ layerSpread: layerSpread, n: n })=>Math.round(layerSpread * n),
            affectsNails: false,
            isStructural: true
        },
        {
            key: 'reverse',
            label: 'Reverse',
            defaultValue: true,
            type: 'checkbox',
            isStructural: true
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                multicolorRange: 196,
                multicolorStart: 273,
                color: '#ffffff',
                multicolorByLightness: true,
                minLightness: 10,
                maxLightness: 90
            },
            exclude: [
                'colorCount'
            ]
        })
    ];
    defaultValues = {
        base: 2,
        rotation: 176 / 360
    };
    getCalc(options) {
        const { n: n, layerSpread: layerSpread } = this.config;
        return {
            ...super.getCalc(options),
            layerShift: Math.round(n * layerSpread)
        };
    }
    *drawStrings(controller) {
        const { layers: layers } = this.config;
        for(let layer = 0; layer < layers; layer++)yield* this.drawMultiplicationLayer(controller, layer);
    }
}








class $0421ce1534490d1b$var$Eye extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'eye';
    name = 'Vortex';
    id = 'eye';
    link = 'https://www.etsy.com/listing/489853161/rose-of-space-string-art-sacred-geometry?ga_order=most_relevant&ga_search_type=all&ga_view_type=gallery&ga_search_query=string+art&ref=sr_gallery_1&epik=dj0yJnU9WXNpM1BDTnNkLVBtcWdCa3AxN1J5QUZRY1FlbkJ5Z18mcD0wJm49ZXdJb2JXZmVpNVVwN1NKQ3lXMy10ZyZ0PUFBQUFBR0ZuUzZv';
    controls = [
        {
            key: 'n',
            label: 'Number of nails per side',
            defaultValue: 82,
            type: 'range',
            attr: {
                min: 3,
                max: 200,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'sides',
            label: 'Sides',
            defaultValue: 4,
            type: 'range',
            attr: {
                min: 3,
                max: 10,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'layers',
            label: 'Layers',
            defaultValue: 13,
            type: 'range',
            attr: {
                min: 1,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'angle',
            label: 'Layer angle',
            defaultValue: 0.65,
            displayValue: ({ angle: angle, sides: sides })=>`${Math.round(180 * angle / sides)}\xb0`,
            type: 'range',
            attr: {
                min: 0.01,
                max: 1,
                step: 0.01
            },
            isStructural: true,
            show: ({ layers: layers })=>layers > 1
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                color: '#ffffff',
                multicolorRange: 107,
                multicolorStart: 226,
                multicolorByLightness: false,
                minLightness: 40,
                maxLightness: 50,
                colorCount: 2,
                repeatColors: true
            },
            customControls: [
                {
                    key: 'colorPerLayer',
                    label: 'Color per layer',
                    defaultValue: false,
                    type: 'checkbox',
                    show: ({ isMultiColor: isMultiColor })=>isMultiColor,
                    affectsNails: false
                }
            ]
        })
    ];
    defaultValues = {
        nailsColor: '#000000'
    };
    getCalc({ size: size }) {
        const { n: nConfig, angle: angle, layers: layerCount, margin: margin = 0, sides: sides } = this.config;
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        // If the angle is 1 (meaning a inner polygon reaches the middle of an outter polygon), making sure the number of nails per side is odd, so there's a middle nail
        const n = !(nConfig % 2) ? nConfig + 1 : nConfig;
        const basePolygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            size: size,
            sides: sides,
            nailsPerSide: n,
            center: center,
            fitSize: true,
            margin: margin
        });
        const nailSpacing = basePolygon.sideSize / (n - 1);
        const spacesChangePerLayer = Math.max(1, Math.floor(angle * n / 2));
        const piSides = Math.PI / sides;
        const layers = [
            {
                polygon: basePolygon,
                layerAngle: 0,
                layerSize: basePolygon.sideSize,
                layerSideNailCount: n,
                layerSpaceCount: n - 1,
                layerIndexStart: 0,
                nailSpacing: nailSpacing
            }
        ];
        let totalNailsCount = basePolygon.getNailCount();
        for(let layerIndex = 1; layerIndex < layerCount; layerIndex++){
            const previousLayer = layers[layerIndex - 1];
            const spaces = previousLayer ? Math.max(1, Math.floor(angle * previousLayer.layerSideNailCount / 2)) : spacesChangePerLayer;
            if (!previousLayer || previousLayer.layerSpaceCount <= 3 || previousLayer.layerSpaceCount <= spaces) break;
            const layerAngle = Math.PI / sides - Math.atan(previousLayer.nailSpacing * (previousLayer.layerSpaceCount / 2 - spaces) / previousLayer.polygon.getApothem());
            if (layerAngle <= 0) break;
            const radius = previousLayer.polygon.radius * Math.cos(piSides) / Math.cos(layerAngle - piSides);
            const layerSize = 2 * radius * Math.sin(Math.PI / sides);
            let layerSideNailCount = Math.ceil(layerSize / nailSpacing);
            if (angle === 1 && !(layerSideNailCount % 2)) layerSideNailCount--;
            if (layerSideNailCount < 3) break;
            const layerIndexStart = totalNailsCount;
            const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                sides: sides,
                nailsPerSide: layerSideNailCount,
                rotation: layerAngle / (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) + (previousLayer?.polygon.config.rotation ?? 0),
                center: layers[0].polygon.center,
                radius: radius,
                getUniqueKey: layerIndexStart ? (k)=>layerIndexStart + k : undefined
            });
            totalNailsCount += polygon.getNailCount();
            const layerSpaceCount = layerSideNailCount - 1;
            layers.push({
                layerAngle: layerAngle * layerIndex,
                layerSize: layerSize,
                layerSideNailCount: layerSideNailCount,
                layerSpaceCount: layerSpaceCount,
                polygon: polygon,
                nailSpacing: layerSize / layerSpaceCount,
                layerIndexStart: layerIndexStart
            });
        }
        const layersCount = layers.length;
        return {
            nailSpacing: nailSpacing,
            layers: layers,
            center: center,
            totalNailsCount: totalNailsCount,
            layersCount: layersCount
        };
    }
    getAspectRatio() {
        return 1;
    }
    *drawSide(controller, { side: side, color: color = '#ffffff', layer: layer }) {
        const nextSide = (side + 1) % this.config.sides;
        controller.startLayer({
            color: color
        });
        for(let i = 0; i < layer.layerSpaceCount; i++){
            controller.goto(layer.polygon.getSideNailIndex(side, i));
            controller.stringTo(layer.polygon.getSideNailIndex(nextSide, i));
            yield;
        }
    }
    *#drawLayer(controller, layerIndex) {
        const { colorPerLayer: colorPerLayer, sides: sides } = this.config;
        for(let i = 0; i < sides; i++)yield* this.drawSide(controller, {
            color: this.color.getColor(colorPerLayer ? layerIndex : i),
            side: i,
            layer: this.calc.layers[layerIndex]
        });
    }
    *drawStrings(controller) {
        for(let layer = this.calc.layers.length - 1; layer >= 0; layer--)yield* this.#drawLayer(controller, layer);
    }
    getStepCount(options) {
        return (this.calc ?? this.getCalc(options)).totalNailsCount;
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        for(let layer = 0; layer < this.calc.layersCount; layer++){
            const { polygon: polygon } = this.calc.layers[layer];
            polygon.addNails(nails);
        }
        return nails;
    }
    thumbnailConfig = ({ n: n, layers: layers })=>({
            n: Math.min(n, 25),
            layers: Math.min(layers, 7)
        });
}
var $0421ce1534490d1b$export$2e2bcd8739ae039 = $0421ce1534490d1b$var$Eye;










class $a643183efb8a0ce0$export$2e2bcd8739ae039 extends (0, $55d14da464282011$export$2e2bcd8739ae039) {
    config;
    center;
    calc;
    constructor(config){
        super(config);
        this.setConfig(config);
    }
    static getCalc({ radius: radius, sides: sides, sideNails: sideNails, rotation: rotation, centerRadius: centerRadiusFraction = 0, maxCurveSize: maxCurveSize = 1, sidesCenterRadiusShift: sidesCenterRadiusShift }) {
        const centerRadius = radius * centerRadiusFraction;
        const nailSpacing = (radius - centerRadius) / (sideNails - 1); // The distance between nails on the same side, in px
        const sidesAngle = Math.PI * 2 / sides; // The angle, in radians, between each side
        const rotationAngle = rotation ? -Math.PI * 2 * rotation / sides : 0;
        return {
            sideAngle: sidesAngle,
            nailSpacing: nailSpacing,
            centerRadius: centerRadius,
            linesPerRound: sides % 2 ? sides * 2 : sides,
            sidesConnectionCount: Math.floor(Math.min(1, maxCurveSize) * sideNails),
            sideSize: radius - centerRadius,
            sides: new Array(sides).fill(null).map((_, side)=>{
                const sideAngle = side * sidesAngle + rotationAngle;
                return {
                    sinSideAngle: Math.sin(sideAngle),
                    cosSideAngle: Math.cos(sideAngle)
                };
            }),
            sidesCenterRadius: sidesCenterRadiusShift ? sidesCenterRadiusShift.map((v)=>centerRadius * v) : null,
            hasCenterNail: !centerRadius,
            sidesNailCount: centerRadius ? sideNails : sideNails - 1
        };
    }
    getPoint(index) {
        const position = index / this.config.sideNails;
        const side = Math.floor(position);
        const sideIndex = index % this.config.sideNails;
        return this.getSidePoint(side, sideIndex);
    }
    getSidePoint(side = 0, index = 0) {
        const radius = this.calc.centerRadius + index * this.calc.nailSpacing - (this.calc.sidesCenterRadius?.[side] ?? 0);
        const { sinSideAngle: sinSideAngle, cosSideAngle: cosSideAngle } = this.calc.sides[side];
        return [
            this.center[0] + sinSideAngle * radius,
            this.center[1] + cosSideAngle * radius
        ];
    }
    getSideNailKey(side, index) {
        if (index === 0 && this.calc.hasCenterNail) return this.config.getUniqueKey?.(0) ?? 0;
        const nailIndex = side * this.calc.sidesNailCount + index;
        return this.config.getUniqueKey?.(nailIndex) ?? nailIndex;
    }
    setConfig(config) {
        if ((0, $c29d66861308df7e$export$f05027632b38f3a4)(config, this.config, [
            'radius',
            'sides',
            'sideNails',
            'rotation',
            'center',
            'size',
            'centerRadius',
            'maxCurveSize'
        ])) return;
        if (!config.center && !config.size) throw new Error('StarShape requires a config value for either center or size.');
        const center = config.center ?? (0, $b683a3137b30eaa9$export$c91255cadecfe081)(config.size);
        this.config = config;
        this.center = center;
        this.calc = $a643183efb8a0ce0$export$2e2bcd8739ae039.getCalc(config);
    }
    /**
   * Given a Nails instance, uses it to draw the nails of this Circle
   */ addNails(nails, { reverseOrder: reverseOrder } = {}) {
        const { sides: sides, sideNails: sideNails } = this.config;
        let nailIndex = 0;
        if (this.calc.hasCenterNail) {
            nails.addNail(this.getUniqueKey?.(nailIndex) ?? nailIndex, this.getSidePoint(0, 0));
            nailIndex++;
        }
        for(let side = 0; side < sides; side++)for(let i = this.calc.hasCenterNail ? 1 : 0; i < sideNails; i++){
            const sideIndex = reverseOrder ? sideNails - i : i;
            nails.addNail(this.getUniqueKey?.(nailIndex) ?? nailIndex, this.getSidePoint(side, sideIndex));
            nailIndex++;
        }
    }
    getNailCount() {
        const { sides: sides, sideNails: sideNails, centerRadius: centerRadius } = this.config;
        const renderCenterNail = centerRadius == null || centerRadius === 0;
        return sides * sideNails - (renderCenterNail ? sides - 1 : 0);
    }
    // In this pattern, strings are connected in a "merry-go-round" way, around the star.
    // With even sides count, the strings go around the star once, while with odd sides count, each round goes twice around the star.
    // The threading is: star at the center (or centerRadius, if > 0), then next side at the edge (outtermost nail) or the size param which represents the count of nails to use,
    // then back to the center for the next side,   // until all sides have been connected both center and edge (for odd-side-count stars) or until all sides have been
    // connected (for odd-side-count), then move up one nail from the center and start another round.
    *drawStar(controller, { size: size } = {}) {
        const { sideNails: sideNailsConfig, sides: sides } = this.config;
        const { sidesConnectionCount: sidesConnectionCount, linesPerRound: linesPerRound } = this.calc;
        const sideNails = size ? Math.max(1, Math.min(Math.floor(size), sideNailsConfig)) : sideNailsConfig;
        const minNailIndex = Math.max(0, sideNails - sidesConnectionCount);
        let alternate = false;
        const rounds = sides % 2 ? Math.ceil(Math.min(sideNails, sidesConnectionCount) / 2) : sideNails - minNailIndex;
        let prevPointIndex = minNailIndex;
        controller.goto(this.getSideNailKey(0, minNailIndex));
        for(let round = 0; round < rounds; round++){
            const isLastRound = round === rounds - 1;
            let side = 0;
            for(let i = 0; i < linesPerRound; i++){
                side = (side + 1) % sides;
                alternate = !alternate;
                prevPointIndex = alternate ? sideNails - round - 1 : round + minNailIndex;
                yield controller.stringTo(this.getSideNailKey(side, prevPointIndex));
                if (isLastRound && i === sides - 1 && sides % 2 && sideNails % 2) break;
            }
            if (!isLastRound) {
                prevPointIndex = alternate ? prevPointIndex - 1 : prevPointIndex + 1;
                yield controller.stringTo(this.getSideNailKey(0, prevPointIndex));
            }
        }
    }
    getStepCount(size) {
        return $a643183efb8a0ce0$export$2e2bcd8739ae039.getStepCount(this.config, {
            size: size
        });
    }
    static getStepCount({ sides: sides, sideNails: sideNailsConfig, maxCurveSize: maxCurveSize = 1 }, { size: size } = {}) {
        const sidesConnectionCount = Math.floor(Math.min(1, maxCurveSize) * sideNailsConfig);
        const sideNails = size ? Math.min(Math.floor(size), sideNailsConfig) : sideNailsConfig;
        const minNailIndex = Math.max(0, sideNails - sidesConnectionCount);
        const rounds = sides % 2 ? Math.ceil(Math.min(sideNails, sidesConnectionCount) / 2) : sideNails - minNailIndex;
        const linesPerRound = sides % 2 ? sides * 2 : sides;
        const isOdd = sides % 2 && sideNails % 2;
        return rounds * (linesPerRound + 1) - (isOdd ? sides : 0) - 1;
    }
    getBoundingRect() {
        const { radius: radius, sides: sides, rotation: rotation, sideNails: sideNails } = this.config;
        const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            size: [
                radius * 2,
                radius * 2
            ],
            sides: sides,
            nailsPerSide: sideNails,
            margin: 0,
            rotation: rotation
        });
        return polygon.getBoundingRect();
    }
    getAspectRatio() {
        return (0, $b683a3137b30eaa9$export$d2646d47608819e2)(this.getBoundingRect());
    }
    static nailsConfig = {
        key: 'sideNails',
        label: 'Nails per side',
        defaultValue: 40,
        type: 'range',
        attr: {
            min: 1,
            max: 200,
            step: 1
        },
        isStructural: true
    };
    static sidesConfig = {
        key: 'sides',
        label: 'Sides',
        defaultValue: 3,
        type: 'range',
        attr: {
            min: 3,
            max: 40,
            step: 1
        },
        isStructural: true
    };
    static maxCurveSize = {
        key: 'maxCurveSize',
        label: 'Max curve size',
        description: 'The maximum number of connections used to create a curve between two sides.',
        defaultValue: 1,
        type: 'range',
        displayValue: ({ maxCurveSize: maxCurveSize, sideNails: sideNails })=>Math.floor(maxCurveSize * sideNails),
        attr: {
            min: 0,
            max: 1,
            step: ({ sideNails: sideNails })=>1 / sideNails
        },
        isStructural: true
    };
    static centerRadiusConfig = {
        key: 'centerRadius',
        label: 'Center radius',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: 0,
            max: ({ sideNails: sideNails })=>(sideNails - 1) / sideNails,
            step: 0.01
        },
        displayValue: ({ centerRadius: centerRadius })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerRadius),
        isStructural: true
    };
    static rotationConfig = {
        key: 'rotation',
        label: 'Rotation',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: 0,
            max: 1,
            step: 0.01,
            snap: '0.5'
        },
        displayValue: ({ rotation: rotation, sides: sides })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(rotation / sides),
        isStructural: true,
        affectsStepCount: false
    };
    static StarConfig = [
        $a643183efb8a0ce0$export$2e2bcd8739ae039.nailsConfig,
        $a643183efb8a0ce0$export$2e2bcd8739ae039.sidesConfig,
        $a643183efb8a0ce0$export$2e2bcd8739ae039.centerRadiusConfig,
        $a643183efb8a0ce0$export$2e2bcd8739ae039.maxCurveSize,
        $a643183efb8a0ce0$export$2e2bcd8739ae039.rotationConfig
    ];
}




class $d7beb6e24667d074$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'star';
    name = 'Star';
    id = 'star';
    link = 'https://www.etsy.com/listing/557818258/string-art-meditation-geometric-yoga?epik=dj0yJnU9Mm1hYmZKdks1eTc3bVY2TkVhS2p2Qlg0N2dyVWJxaTEmcD0wJm49MGlWSXE1SVJ2Vm0xZ0xtaGhITDBWQSZ0PUFBQUFBR0Zwd2lj';
    controls = [
        {
            key: 'sides',
            label: 'Sides',
            defaultValue: 3,
            type: 'range',
            attr: {
                min: 3,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'sideNails',
            label: 'Nails per side',
            defaultValue: 40,
            type: 'range',
            attr: {
                min: 2,
                max: 200,
                step: 1
            },
            isStructural: true
        },
        // @ts-ignore
        (0, $a643183efb8a0ce0$export$2e2bcd8739ae039).centerRadiusConfig,
        {
            key: 'ringSize',
            label: 'Outer ring size',
            defaultValue: 0.1,
            type: 'range',
            attr: {
                min: 0,
                max: 0.5,
                step: ({ sideNails: sideNails, sides: sides })=>1 / (sideNails * sides)
            },
            displayValue: ({ sideNails: sideNails, sides: sides, ringSize: ringSize })=>Math.floor(ringSize * sideNails * sides),
            affectsNails: false
        },
        (0, $b103c63dc979d40c$export$2d97e2da46663803)((0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig, 'snap'),
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        {
            key: 'renderStar',
            label: 'Show star',
            type: 'checkbox',
            defaultValue: true,
            affectsNails: false,
            isStructural: true
        },
        {
            key: 'colorGroup',
            label: 'Color',
            type: 'group',
            children: [
                {
                    key: 'isSingleColor',
                    label: 'Is single color',
                    type: 'checkbox',
                    defaultValue: false,
                    affectsNails: false,
                    affectsStepCount: false
                },
                {
                    key: 'singleColor',
                    label: 'Color',
                    defaultValue: '#2ec0ff',
                    type: 'color',
                    affectsNails: false,
                    affectsStepCount: false,
                    show: ({ isSingleColor: isSingleColor })=>isSingleColor
                },
                {
                    key: 'innerColor',
                    label: 'Star color',
                    defaultValue: '#2ec0ff',
                    type: 'color',
                    affectsNails: false,
                    affectsStepCount: false,
                    show: ({ isSingleColor: isSingleColor, renderStar: renderStar })=>!isSingleColor && renderStar
                },
                {
                    key: 'outerColor',
                    label: 'Outter color',
                    defaultValue: '#2a82c6',
                    type: 'color',
                    affectsNails: false,
                    affectsStepCount: false,
                    show: ({ isSingleColor: isSingleColor })=>!isSingleColor
                },
                {
                    key: 'ringColor',
                    label: 'Ring color',
                    defaultValue: '#2ec0ff',
                    type: 'color',
                    affectsNails: false,
                    affectsStepCount: false,
                    show: ({ isSingleColor: isSingleColor })=>!isSingleColor
                }
            ]
        }
    ];
    getCalc({ size: size }) {
        const { sides: sides, rotation: rotation, distortion: distortion, sideNails: sideNails, margin: margin = 0 } = this.config;
        const circleConfig = {
            size: size,
            n: sides * (sideNails - 1),
            margin: margin,
            rotation: rotation ? rotation / sides : 0,
            distortion: distortion
        };
        const circle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig);
        const starConfig = {
            ...this.config,
            radius: circle.radius,
            size: size,
            getUniqueKey: (k)=>circleConfig.n + k
        };
        return {
            circle: circle,
            star: new (0, $a643183efb8a0ce0$export$2e2bcd8739ae039)(starConfig)
        };
    }
    getAspectRatio(options) {
        const { circle: circle, star: star } = this.getCalc(options);
        const circleRect = circle.getBoundingRect();
        const starRect = star.getBoundingRect();
        const width = Math.max(circleRect.width, starRect.width);
        const height = Math.max(circleRect.height, starRect.height);
        return width / height;
    }
    getArcPoint({ side: side, sideIndex: sideIndex }) {
        return this.calc.circle.getPoint(side * (this.config.sideNails - 1) + sideIndex);
    }
    *drawCircleLayer(controller) {
        const { sides: sides, sideNails: sideNails, isSingleColor: isSingleColor } = this.config;
        const { star: star } = this.calc;
        if (!isSingleColor) controller.startLayer({
            color: !this.config.isSingleColor ? this.config.outerColor : null,
            name: 'Circle backdrop'
        });
        let alternate = false;
        let isStar = false;
        const rounds = sides % 2 ? Math.ceil(sideNails / 2) : sideNails - 1;
        let side = 0;
        const linesPerRound = sides % 2 ? sides * 4 : sides * 2;
        controller.goto(star.getSideNailKey(0, 0));
        for(let round = 0; round < rounds; round++){
            const isLastRound = round === rounds - 1;
            const linesThisRound = sides % 2 && (round === 0 || isLastRound && sideNails % 2) ? linesPerRound - 2 * sides : linesPerRound;
            for(let i = 0; i < linesThisRound; i++){
                const pointPosition = {
                    side: side,
                    sideIndex: alternate ? sideNails - round - 1 : round
                };
                yield controller.stringTo(isStar ? star.getSideNailKey(pointPosition.side, pointPosition.sideIndex) : pointPosition.side * (sideNails - 1) + pointPosition.sideIndex);
                isStar = !isStar;
                if (isStar) {
                    side = (side + 1) % sides;
                    alternate = !alternate;
                }
            }
            if (!isLastRound) {
                yield controller.stringTo(star.getSideNailKey(0, round + 1));
                isStar = false;
                alternate = false;
            }
        }
    }
    *drawStrings(controller) {
        const { ringSize: ringSize, ringColor: ringColor, isSingleColor: isSingleColor, singleColor: singleColor, renderStar: renderStar = true, innerColor: innerColor } = this.config;
        if (isSingleColor) controller.startLayer({
            color: singleColor
        });
        yield* this.drawCircleLayer(controller);
        if (ringSize !== 0) {
            controller.startLayer({
                name: 'Ring',
                color: isSingleColor ? null : ringColor
            });
            yield* this.calc.circle.drawRingLayer(controller, {
                ringSize: ringSize
            });
        }
        if (renderStar) {
            controller.startLayer({
                color: !isSingleColor ? innerColor : null,
                name: 'Star'
            });
            yield* this.calc.star.drawStar(controller);
        }
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.circle.addNails(nails);
        this.calc.star.addNails(nails);
        return nails;
    }
    getStepCount(options) {
        const { ringSize: ringSize, sides: sides, sideNails: sideNails, renderStar: renderStar } = this.config;
        const calc = this.getCalc(options);
        const ringCount = ringSize ? calc.circle.getRingStepCount() : 0;
        const circleRounds = sides % 2 ? Math.ceil(sideNails / 2) : sideNails - 1;
        const circleLinesPerRound = sides % 2 ? sides * 4 : sides * 2;
        const circleStepsToRemove = sides % 2 ? sides * 2 + (sideNails % 2 ? sides * 2 : 0) : 0;
        const circleCount = circleRounds * (circleLinesPerRound + 1) - circleStepsToRemove - 1;
        const starCount = renderStar ? (0, $a643183efb8a0ce0$export$2e2bcd8739ae039).getStepCount(this.config) : 0;
        return circleCount + ringCount + starCount;
    }
    getNailCount() {
        const { sides: sides, sideNails: sideNails, centerRadius: centerRadius } = this.config;
        const circleNails = sides * (sideNails - 1);
        return sides * (sideNails - 1) + circleNails - (centerRadius ? 0 : sides - 1);
    }
    thumbnailConfig = ({ sideNails: sideNails })=>({
            sideNails: Math.min(sideNails, 18)
        });
    testStepCountConfig = [
        {
            sides: 3,
            sideNails: 4,
            ringSize: 0,
            renderStar: false
        },
        {
            sides: 3,
            sideNails: 11,
            ringSize: 0,
            renderStar: false
        },
        {
            sides: 4,
            sideNails: 11,
            ringSize: 0,
            renderStar: false
        },
        {
            sides: 4,
            sideNails: 10,
            ringSize: 0,
            renderStar: false
        }
    ];
}









const $62acf81e555101f1$var$LAYER_DEFAULTS = [
    {
        start: 0.25,
        end: 1,
        color: '#a94fb0'
    },
    {
        start: 0.125,
        end: 0.888,
        color: '#ec6ad0'
    },
    {
        start: 0,
        end: 0.826,
        color: '#f08ad5',
        reverse: true
    }
];
class $62acf81e555101f1$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'assymetry';
    name = 'Assymetry';
    id = 'assymetry';
    link = 'https://www.etsy.com/il-en/listing/1018950430/calming-wall-art-in-light-blue-for';
    controls = [
        {
            ...(0, $06de6887437e6fa7$export$2e2bcd8739ae039).nailsConfig,
            label: 'Circle number of nails'
        },
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig,
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        {
            key: 'layers',
            label: 'Layers',
            type: 'group',
            // @ts-expect-error: dynamic key is safe because we know the keys match Layers
            children: $62acf81e555101f1$var$LAYER_DEFAULTS.map(({ start: start, end: end, color: color, reverse: reverse }, i)=>{
                const layer = i + 1;
                return {
                    key: `layer${layer}`,
                    label: `Layer ${layer}`,
                    type: 'group',
                    children: [
                        {
                            key: `show${layer}`,
                            label: 'Enable',
                            defaultValue: true,
                            type: 'checkbox',
                            isStructural: true
                        },
                        {
                            key: `start${layer}`,
                            label: 'Star position',
                            defaultValue: start,
                            type: 'range',
                            attr: {
                                min: 0,
                                max: 0.5,
                                step: ({ n: n })=>1 / n
                            },
                            displayValue: (config)=>Math.round(config.n * config[`start${layer}`]),
                            show: (config)=>config[`show${layer}`],
                            isStructural: true
                        },
                        {
                            key: `end${layer}`,
                            label: 'End Position',
                            defaultValue: end,
                            type: 'range',
                            attr: {
                                min: 0,
                                max: 1,
                                step: ({ n: n })=>1 / n
                            },
                            displayValue: (config)=>Math.round(config.n * config[`end${layer}`]),
                            show: (config)=>config[`show${layer}`],
                            affectsNails: false,
                            isStructural: true
                        },
                        {
                            key: `color${layer}`,
                            label: 'Color',
                            defaultValue: color,
                            type: 'color',
                            show: (config)=>config[`show${layer}`],
                            affectsNails: false,
                            isStructural: true
                        },
                        {
                            key: `reverse${layer}`,
                            label: 'Reverse',
                            defaultValue: reverse === true,
                            type: 'checkbox',
                            show: (config)=>config[`show${layer}`],
                            affectsNails: false,
                            isStructural: true
                        }
                    ]
                };
            })
        }
    ];
    getAspectRatio() {
        const calc = this.calc ?? this.getCalc({
            size: [
                100,
                100
            ]
        });
        return calc.circle.getAspectRatio();
    }
    getCalc({ size: size }) {
        const { rotation: rotation, n: n, margin: margin = 0, distortion: distortion } = this.config;
        const lineNailCount = Math.round(n / (0, $e2b746416d2bf62b$export$f4644083ce95e7e3));
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        const circleConfig = {
            size: size,
            center: center,
            n: n,
            margin: margin,
            rotation: rotation - 0.25,
            distortion: distortion,
            getUniqueKey: (k)=>lineNailCount + k
        };
        const circle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig);
        const lineSize = circle.radius;
        const lineSpacing = lineSize / lineNailCount;
        const firstCirclePoint = circle.getPoint(0);
        const totalNailCount = lineNailCount + n;
        const totalIndexCount = totalNailCount + lineNailCount;
        const layers = (0, $c190f550efa69733$export$7f1ebd623f131021)(3, (i)=>getLayer.call(this, i + 1)).filter(({ enable: enable })=>enable);
        const line = new (0, $281c51d967a471db$export$17d680238e50603e)({
            from: center,
            to: circle.getPoint(0),
            n: lineNailCount + 1
        });
        return {
            circle: circle,
            line: line,
            lineSpacing: lineSpacing,
            lineNailCount: lineNailCount,
            firstCirclePoint: firstCirclePoint,
            layers: layers,
            totalNailCount: totalNailCount,
            totalIndexCount: totalIndexCount
        };
        function getLayer(layerIndex) {
            const start = Math.round(n * this.config['start' + layerIndex]) + lineNailCount;
            let endIndex = Math.round(this.config['end' + layerIndex] * totalIndexCount) - start;
            // Making sure that we get to the last possible nail (due to fractions in the `step` property of the end control, that doesn't reach to 1)
            if (endIndex === totalIndexCount - start - 1) endIndex++;
            return {
                start: start,
                endIndex: endIndex,
                color: this.config['color' + layerIndex],
                enable: this.config['show' + layerIndex],
                isReverse: this.config['reverse' + layerIndex]
            };
        }
    }
    *drawCircle(controller, { endIndex: endIndex, color: color, isReverse: isReverse, start: start }) {
        const { lineNailCount: lineNailCount, totalNailCount: totalNailCount } = this.calc;
        const lastNailIndex = totalNailCount - 1;
        let prevPointIndex;
        let isPrevSide = false;
        controller.startLayer({
            color: color
        });
        const self = this;
        const advance = isReverse ? -1 : 1;
        controller.goto(getCoordinatesForIndex(getPointIndex(0)));
        for(let index = 0; index <= endIndex; index++){
            if (index) {
                controller.stringTo(getCoordinatesForIndex(prevPointIndex + advance));
                yield;
            }
            prevPointIndex = getPointIndex(isPrevSide ? index : index + start);
            controller.stringTo(getCoordinatesForIndex(prevPointIndex));
            yield;
            isPrevSide = !isPrevSide;
        }
        function getPointIndex(index) {
            return isReverse ? self.calc.totalIndexCount - index : index;
        }
        function getCoordinatesForIndex(index) {
            const exceeds = index - lastNailIndex;
            if (exceeds > 0) return lineNailCount - exceeds + 1;
            return index % totalNailCount;
        }
    }
    *drawStrings(controller) {
        for (const layer of this.calc.layers)yield* this.drawCircle(controller, layer);
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.line.addNails(nails);
        this.calc.circle.addNails(nails);
        return nails;
    }
    getStepCount(options) {
        const { layers: layers } = this.getCalc(options);
        return layers.reduce((stepCount, layer)=>stepCount + layer.endIndex * 2 + 1, 0);
    }
    getNailCount(size) {
        const calc = this.calc ?? this.getCalc({
            size: size
        });
        return calc.circle.config.n + calc.lineNailCount;
    }
    thumbnailConfig = ({ n: n })=>({
            n: Math.min(n, 50)
        });
}







const $0cd4a0f8cb92c220$var$rotationConfig = {
    label: 'Rotation',
    defaultValue: 0,
    type: 'range',
    attr: {
        min: 0,
        max: 1 + 1 / 360,
        step: 1 / 360
    },
    isStructural: true,
    affectsStepCount: false
};
function $0cd4a0f8cb92c220$var$getCircleConfig(i) {
    const show = (config)=>config[`show${i}`];
    return {
        key: `layer${i}`,
        label: `Layer ${i}`,
        type: 'group',
        children: [
            {
                key: `show${i}`,
                label: 'Enable',
                defaultValue: true,
                type: 'checkbox',
                isStructural: true
            },
            {
                key: `n${i}`,
                label: 'Nails count',
                type: 'range',
                attr: {
                    min: 1,
                    max: 300,
                    step: 1
                },
                show: show,
                isStructural: true
            },
            {
                key: `radius${i}`,
                label: 'Radius',
                type: 'range',
                attr: {
                    min: 0.01,
                    max: 1,
                    step: 0.01
                },
                show: show,
                isStructural: true
            },
            {
                key: `x${i}`,
                label: 'Position X',
                type: 'range',
                attr: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                show: show,
                isStructural: true
            },
            {
                key: `y${i}`,
                label: 'Position Y',
                type: 'range',
                attr: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                show: show,
                isStructural: true
            },
            {
                ...$0cd4a0f8cb92c220$var$rotationConfig,
                key: `rotation${i}`,
                displayValue: (config)=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(config[`rotation${i}`]),
                show: show
            },
            {
                key: `reverse${i}`,
                label: 'Reverse',
                type: 'checkbox',
                isStructural: true,
                show: show
            }
        ]
    };
}
class $0cd4a0f8cb92c220$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'freestyle';
    name = 'Freestyle';
    id = 'freestyle';
    link = 'https://www.etsy.com/il-en/listing/1018950430/calming-wall-art-in-light-blue-for';
    controls = [
        {
            key: 'color',
            label: 'Color',
            defaultValue: '#ec6ad0',
            type: 'color',
            affectsNails: false,
            affectsStepCount: false
        },
        {
            key: 'layers',
            label: 'Layers',
            type: 'group',
            // @ts-ignore
            children: (0, $c190f550efa69733$export$7f1ebd623f131021)(3, (i)=>$0cd4a0f8cb92c220$var$getCircleConfig(i + 1))
        }
    ];
    defaultValues = {
        n1: 80,
        n2: 80,
        n3: 80,
        radius1: 0.5,
        radius2: 0.5,
        radius3: 0.5,
        x1: 0.5,
        x2: 0,
        x3: 1,
        y1: 0,
        y2: 1,
        y3: 1,
        reverse1: false,
        reverse2: false,
        reverse3: false
    };
    getAspectRatio({ size: size }) {
        // TODO: Move the aspect ratio of this pattern to a config, then remove the options param from StringArt.getAspectRatio.
        return size[0] / size[1];
    }
    getCalc({ size: size }) {
        const { margin: margin = 0 } = this.config;
        const maxRadius = Math.min(...size.map((v)=>v - 2 * margin)) / 2;
        let totalNailCount = 0;
        const layers = (0, $c190f550efa69733$export$7f1ebd623f131021)(3, (layerIndex)=>{
            const prop = (prop)=>this.config[prop + (layerIndex + 1)];
            if (!prop('show')) return null;
            const props = {
                isReverse: prop('reverse'),
                position: [
                    prop('x'),
                    prop('y')
                ],
                radius: maxRadius * prop('radius'),
                rotation: prop('rotation')
            };
            const nailsIndexStart = totalNailCount;
            const circle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
                radius: props.radius,
                size: size,
                center: props.position.map((v, i)=>props.radius + margin + (size[i] - (props.radius + margin) * 2) * v),
                n: prop('n'),
                rotation: props.rotation,
                reverse: props.isReverse,
                getUniqueKey: layerIndex ? (k)=>nailsIndexStart + k : undefined
            });
            totalNailCount += circle.config.n;
            return {
                circle: circle,
                ...props
            };
        }).filter(Boolean);
        return {
            layers: layers,
            roundsCount: Math.max(...layers.map((l)=>l.circle.config.n))
        };
    }
    getPoint(layer, index) {
        return layer.circle.getPoint(index);
    }
    *drawStrings(controller) {
        const { color: color } = this.config;
        const layerCount = this.calc.layers.length;
        controller.startLayer({
            color: color
        });
        controller.goto(0);
        for(let i = 0; i < this.calc.roundsCount; i++)for(let layerIndex = 0; layerIndex < this.calc.layers.length; layerIndex++){
            const nextLayerIndex = (layerIndex + 1) % layerCount;
            controller.stringTo(this.calc.layers[nextLayerIndex].circle.getNailKey(i));
            yield;
        }
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.layers.forEach(({ circle: circle }, i)=>circle.addNails(nails));
        return nails;
    }
    getStepCount(options) {
        const { layers: layers, roundsCount: roundsCount } = this.getCalc(options);
        return layers.length * roundsCount;
    }
    thumbnailConfig = ({ n1: n1, n2: n2, n3: n3 })=>({
            n1: Math.min(n1, 40),
            n2: Math.min(n2, 40),
            n3: Math.min(n3, 40)
        });
}





const $24f8ffaba9bb597d$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        color: '#ff0000',
        multicolorRange: 1,
        multicolorStart: 0,
        multicolorByLightness: true,
        minLightness: 20,
        maxLightness: 50
    },
    exclude: [
        'colorCount'
    ]
});
class $24f8ffaba9bb597d$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'polygon';
    name = 'Polygon';
    id = 'polygon';
    controls = [
        {
            key: 'sides',
            label: 'Sides',
            defaultValue: 5,
            type: 'range',
            attr: {
                min: 3,
                max: 10,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'n',
            label: 'Nails per side',
            defaultValue: 60,
            type: 'range',
            attr: {
                min: 2,
                max: 100,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'bezier',
            label: 'Bezier',
            defaultValue: 2,
            type: 'range',
            attr: {
                min: 1,
                max: 4,
                step: 1
            },
            show: ({ sides: sides })=>sides > 4,
            affectsNails: false,
            affectsStepCount: false
        },
        (0, $cf574edfbef72605$export$2e2bcd8739ae039).rotationConfig,
        $24f8ffaba9bb597d$var$COLOR_CONFIG
    ];
    defaultValues = {
        nailsColor: '#5c5c5c',
        nailRadius: 1
    };
    colorMap;
    getCalc({ size: size }) {
        const { n: n, rotation: rotation, sides: sides, margin: margin } = this.config;
        const polygonConfig = {
            sides: sides,
            rotation: rotation / (sides * 2),
            margin: margin,
            size: size,
            nailsPerSide: n,
            fitSize: true
        };
        return {
            polygon: new (0, $cf574edfbef72605$export$2e2bcd8739ae039)(polygonConfig)
        };
    }
    initColor() {
        const { sides: sides, isMultiColor: isMultiColor } = this.config;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            isMultiColor: isMultiColor,
            colorCount: sides
        });
    }
    setUpDraw(options) {
        super.setUpDraw(options);
        if (this.config.isMultiColor) this.colorMap = this.color.getColorMap({
            stepCount: this.getStepCount(),
            colorCount: this.color.config.colorCount
        });
        else this.colorMap = null;
    }
    getAspectRatio(options) {
        const { polygon: polygon } = this.getCalc(options);
        return polygon.getAspectRatio();
    }
    *drawStrings(controller) {
        const { sides: sides, bezier: bezier, n: n } = this.config;
        const limitedBezier = Math.min(bezier, Math.ceil(sides / 2) - 1);
        const polygon = this.calc.polygon;
        controller.goto(this.calc.polygon.getSideNailIndex(0, 0));
        for(let side = 0; side < sides; side++){
            const nextSide = (side + limitedBezier) % sides;
            controller.startLayer({
                color: this.color.getColor(side)
            });
            for(let i = 0; i < n - 1; i++){
                if (i) yield controller.stringTo(polygon.getSideNailIndex(side, i));
                yield controller.stringTo(polygon.getSideNailIndex(nextSide, i));
                if (i < n - 2) {
                    i++;
                    yield controller.stringTo(polygon.getSideNailIndex(nextSide, i));
                    yield controller.stringTo(polygon.getSideNailIndex(side, i));
                }
                if (i === n - 2) {
                    if (!(n % 2)) yield controller.stringTo(polygon.getSideNailIndex((nextSide + 1) % sides, 0));
                    yield controller.stringTo(polygon.getSideNailIndex(nextSide, 0));
                }
            }
        }
        yield controller.stringTo(this.calc.polygon.getSideNailIndex(1, 0));
    }
    getStepCount() {
        const { sides: sides, n: n } = this.config;
        return sides * (2 * n - 1 - (n % 2 ? 1 : 0)) + 1;
    }
    getNails(precision) {
        return this.calc.polygon.getNails(precision);
    }
    testStepCountConfig = [
        {
            sides: 4,
            n: 10
        },
        {
            sides: 4,
            n: 11
        },
        {
            sides: 3,
            n: 11
        },
        {
            sides: 3,
            n: 10
        },
        {
            sides: 5,
            n: 2
        },
        {
            sides: 3,
            n: 2
        }
    ];
    thumbnailConfig = ({ n: n })=>({
            n: Math.min(n, 20)
        });
}








const $36e817b73108416a$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        color: '#29f1ff',
        multicolorRange: 132,
        multicolorStart: 53,
        multicolorByLightness: false,
        minLightness: 30,
        maxLightness: 70
    },
    exclude: [
        'colorCount'
    ]
});
class $36e817b73108416a$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'flower';
    name = 'Flower';
    id = 'flower';
    link = 'https://www.sqrt.ch/Buch/fadenmodell4_100.svg';
    controls = [
        {
            key: 'sides',
            label: 'Sides',
            defaultValue: 4,
            type: 'range',
            attr: {
                min: 3,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'n',
            label: 'Nails per side',
            defaultValue: 60,
            type: 'range',
            attr: {
                min: 2,
                max: 100,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'layers',
            label: 'Layers',
            defaultValue: 2,
            type: 'range',
            attr: {
                min: 1,
                max: 10,
                step: 1
            },
            isStructural: true
        },
        (0, $cf574edfbef72605$export$2e2bcd8739ae039).rotationConfig,
        $36e817b73108416a$var$COLOR_CONFIG
    ];
    defaultValues = {
        nailsColor: '#29f1ff',
        nailRadius: 1,
        stringWidth: 0.5
    };
    getCalc({ size: size }) {
        const { n: n, rotation: rotation, sides: sides, layers: layers, margin: margin } = this.config;
        const layerAngleShift = 1 / (sides * layers);
        let totalNailsCount = 0;
        const polygons = (0, $c190f550efa69733$export$7f1ebd623f131021)(layers, (i)=>{
            const layerIndexStart = totalNailsCount;
            const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                sides: sides,
                rotation: rotation / sides + i * layerAngleShift,
                margin: margin,
                size: size,
                nailsPerSide: n,
                radiusNailsCountSameAsSides: true,
                drawCenter: true,
                drawCenterNail: i === 0,
                getUniqueKey: i === 0 ? undefined : (k)=>layerIndexStart + k
            });
            totalNailsCount += polygon.getNailCount();
            return polygon;
        });
        return {
            polygons: polygons
        };
    }
    initColor() {
        const { layers: layers, isMultiColor: isMultiColor } = this.config;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            isMultiColor: isMultiColor,
            colorCount: layers
        });
    }
    getAspectRatio() {
        const calc = this.calc ?? this.getCalc({
            size: [
                100,
                100
            ]
        });
        const boundingRect = (0, $b683a3137b30eaa9$export$1d3cc206d049790e)(...calc.polygons.map((p)=>p.getBoundingRect()));
        return (0, $b683a3137b30eaa9$export$d2646d47608819e2)(boundingRect);
    }
    *drawStrings(controller) {
        const { sides: sides, layers: layers, n: n } = this.config;
        for(let layer = 0; layer < layers; layer++){
            controller.startLayer({
                color: this.color.getColor(layer),
                name: String(layer)
            });
            const polygon = this.calc.polygons[layer];
            let alternate = false;
            controller.goto(0);
            for(let side = 0; side < sides; side++){
                const prevSide = side === 0 ? sides - 1 : side - 1;
                const nextSide = (side + 1) % sides;
                controller.stringTo(polygon.getSideNailIndex(prevSide, 0));
                yield;
                controller.stringTo(polygon.getSideNailIndex(side, 0));
                yield;
                controller.stringTo(polygon.getSideNailIndex(nextSide, 0));
                yield;
                for(let index = 1; index < n - 1; index++){
                    controller.stringTo(polygon.getSideNailIndex(alternate ? prevSide : side, alternate ? index : n - index - 1));
                    yield;
                    controller.stringTo(polygon.getCenterNailIndex(side, n - index - 1));
                    yield;
                    controller.stringTo(polygon.getSideNailIndex(alternate ? side : prevSide, alternate ? n - index - 1 : index));
                    yield;
                    alternate = !alternate;
                }
            }
        }
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.polygons.forEach((polygon, i)=>{
            polygon.addNails(nails);
        });
        return nails;
    }
    getStepCount() {
        const { sides: sides, n: n, layers: layers } = this.config;
        return layers * sides * (3 + 3 * (n - 2));
    }
    getNailCount(size) {
        const { layers: layers } = this.config;
        const calc = this.calc ?? this.getCalc({
            size: size
        });
        const polygon = calc.polygons[0];
        return layers * (polygon.getNailCount() - 1) + 1;
    }
    thumbnailConfig = ({ n: n })=>({
            n: Math.min(n, 20)
        });
    testStepCountConfig = [
        {
            sides: 3,
            n: 2,
            layers: 1
        }
    ];
}










const $13d3b02459490214$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        color: '#ffffff',
        multicolorRange: 102,
        multicolorStart: 239,
        multicolorByLightness: false,
        minLightness: 30,
        maxLightness: 70,
        colorCount: 4
    },
    exclude: [
        'repeatColors',
        'mirrorColors'
    ]
});
class $13d3b02459490214$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'maurer_rose';
    name = 'Maurer Rose';
    id = 'maurer_rose';
    link = 'https://blog.glitch.land/en/posts/maurer-rose/';
    linkText = 'Learn';
    controls = [
        {
            key: 'n',
            label: 'N',
            defaultValue: 4,
            type: 'range',
            attr: {
                min: 2,
                max: 12,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'maxSteps',
            label: 'Max steps',
            defaultValue: 512,
            type: 'range',
            attr: {
                min: 3,
                max: 720,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'angle',
            label: 'Angle',
            defaultValue: 341,
            type: 'range',
            attr: {
                min: 1,
                max: 720,
                step: 1
            },
            displayValue: ({ angle: angle })=>`${angle}\xb0`,
            isStructural: true
        },
        (0, $b103c63dc979d40c$export$2d97e2da46663803)((0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig, 'snap'),
        $13d3b02459490214$var$COLOR_CONFIG
    ];
    colorMap;
    setUpDraw() {
        const { isMultiColor: isMultiColor, colorCount: colorCount } = this.config;
        if (!this.stepCount) this.stepCount = this.getStepCount();
        if (isMultiColor) this.colorMap = this.color.getColorMap({
            stepCount: this.stepCount,
            colorCount: colorCount
        });
        else this.colorMap = null;
    }
    getAspectRatio({ size: size }) {
        const { n: n, rotation: rotation, margin: margin } = this.config;
        // Use a Polygon and getBoundingRect to calculate the aspectRatio
        const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            size: size,
            sides: n % 2 ? n : n * 2,
            nailsPerSide: 10,
            margin: margin,
            rotation: rotation,
            center: (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size)
        });
        return polygon.getAspectRatio();
    }
    getCalc({ size: size }) {
        const { angle: angle, rotation: rotation, maxSteps: maxSteps, margin: margin } = this.config;
        return {
            angleRadians: (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * angle / maxSteps,
            radius: Math.min(...size) / 2 - margin,
            currentSize: (0, $b683a3137b30eaa9$export$c566af9defc62c6)(size, (v)=>v - margin * 2),
            rotationAngle: -Math.PI * 2 * rotation,
            center: (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size)
        };
    }
    getPoint(index) {
        const { rotationAngle: rotationAngle, angleRadians: angleRadians, radius: radius, center: center } = this.calc;
        const k = index * angleRadians;
        const r = radius * Math.sin(this.config.n * k);
        const point = [
            center[0] - r * Math.cos(k - rotationAngle),
            center[1] - r * Math.sin(k - rotationAngle)
        ];
        return point;
    }
    *generatePoints(start = 0) {
        const count = this.getStepCount();
        for(let i = start; i < count + 1; i++)yield i;
    }
    *drawStrings(controller) {
        const points = this.generatePoints(1);
        controller.startLayer({
            color: this.color.getColor(0)
        });
        controller.goto(0);
        for (const index of points){
            if (this.colorMap) {
                const stepColor = this.colorMap.get(index);
                if (stepColor) controller.startLayer({
                    color: stepColor
                });
            }
            controller.stringTo(index);
            yield;
        }
    }
    getStepCount() {
        if (this.stepCount) return this.stepCount;
        const { maxSteps: maxSteps, angle: angle, n: n } = this.config;
        const angleGcd = (0, $e2b746416d2bf62b$export$f81847884871263e)(maxSteps, angle);
        let steps = maxSteps / angleGcd;
        if (!(steps % 2) && n % 2) steps /= 2;
        return Math.round(steps);
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        const points = this.generatePoints();
        for (const index of points)nails.addNail(index, this.getPoint(index));
        return nails;
    }
}












const $324d244b6e96daed$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        color: '#29f1ff',
        multicolorRange: 30,
        multicolorStart: 25,
        multicolorByLightness: true,
        minLightness: 40,
        maxLightness: 95,
        colorCount: 3,
        repeatColors: true,
        saturation: 83,
        reverseColors: true
    },
    customControls: [
        {
            key: 'colorPerLevel',
            label: 'Color per level',
            defaultValue: true,
            type: 'checkbox',
            affectsNails: false
        }
    ]
});
const $324d244b6e96daed$var$ANGLE = -(0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / 6; // The angle of a equilateral triangle;
const $324d244b6e96daed$var$SIDE_ANGLES = new Array(6).fill(null).map((_, i)=>Math.PI / 2 + $324d244b6e96daed$var$ANGLE * i);
class $324d244b6e96daed$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'flower_of_life';
    name = 'Flower of Life';
    id = 'flower_of_life';
    link = 'https://www.reddit.com/r/psychedelicartwork/comments/mk97gi/rainbow_flower_of_life_uv_reactive_string_art/';
    controls = [
        {
            key: 'levels',
            label: 'Levels',
            defaultValue: 3,
            type: 'range',
            attr: {
                min: 1,
                max: 10,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'density',
            label: 'Density',
            defaultValue: 10,
            type: 'range',
            attr: {
                min: 1,
                max: 50,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'globalRotation',
            label: 'Rotation',
            defaultValue: 0,
            type: 'range',
            attr: {
                min: 0,
                max: 30,
                step: 1
            },
            displayValue: ({ globalRotation: globalRotation })=>`${globalRotation}\xb0`,
            isStructural: true,
            affectsStepCount: false
        },
        {
            key: 'fillGroup',
            label: 'Fill',
            type: 'group',
            children: [
                {
                    key: 'fill',
                    label: 'Show fill',
                    defaultValue: true,
                    type: 'checkbox',
                    isStructural: true,
                    affectsNails: false
                },
                {
                    key: 'fillColor',
                    label: 'Fill color',
                    defaultValue: '#292e29',
                    type: 'color',
                    show: ({ fill: fill })=>fill,
                    affectsNails: false
                }
            ]
        },
        {
            key: 'ringGroup',
            label: 'Ring',
            type: 'group',
            children: [
                {
                    key: 'renderRing',
                    label: 'Show outer ring',
                    type: 'checkbox',
                    defaultValue: true,
                    isStructural: true
                },
                {
                    key: 'ringNailCount',
                    label: 'Ring nail count',
                    defaultValue: 144,
                    type: 'range',
                    attr: {
                        min: 3,
                        max: 360,
                        step: 1
                    },
                    show: ({ renderRing: renderRing })=>renderRing,
                    isStructural: true
                },
                {
                    key: 'ringSize',
                    label: 'Outer ring size',
                    defaultValue: 0.23,
                    type: 'range',
                    attr: {
                        min: 0,
                        max: 0.5,
                        step: 0.01
                    },
                    show: ({ renderRing: renderRing })=>renderRing,
                    displayValue: ({ ringSize: ringSize })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(ringSize),
                    isStructural: true
                },
                {
                    key: 'ringPadding',
                    label: 'Ring padding',
                    defaultValue: 0.06,
                    type: 'range',
                    attr: {
                        min: 0,
                        max: 0.5,
                        step: 0.01
                    },
                    show: ({ renderRing: renderRing })=>renderRing,
                    isStructural: true,
                    displayValue: ({ ringPadding: ringPadding })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(ringPadding)
                },
                {
                    key: 'ringColor',
                    label: 'Ring color',
                    defaultValue: '#e8b564',
                    type: 'color',
                    show: ({ renderRing: renderRing })=>renderRing,
                    affectsNails: false
                }
            ]
        },
        {
            key: 'renderTriangles',
            label: 'Show triangles',
            defaultValue: true,
            type: 'checkbox',
            isStructural: true,
            affectsNails: false
        },
        {
            key: 'renderCaps',
            label: 'Show caps',
            defaultValue: true,
            type: 'checkbox',
            show: ({ renderTriangles: renderTriangles })=>renderTriangles,
            isStructural: true
        },
        $324d244b6e96daed$var$COLOR_CONFIG
    ];
    defaultValues = {
        nailsColor: '#474747'
    };
    colorMap;
    getCalc(options) {
        const { size: size } = options;
        const { levels: levels, density: density, margin: margin, globalRotation: globalRotation, renderCaps: renderCaps, renderRing: renderRing, ringNailCount: ringNailCount, ringSize: ringSize, ringPadding: ringPadding } = this.config;
        const globalRotationRadians = globalRotation * Math.PI / 180 + Math.PI / 6;
        const radius = renderRing ? Math.min(...size.map((v)=>v / 2 - margin)) : null;
        const ringDistance = renderRing ? Math.floor(ringSize * ringNailCount / 2) : 0; // The number of nails to count for strings in the outer ring
        const ringWidth = renderRing ? radius * (1 - Math.cos((0, $e2b746416d2bf62b$export$f4644083ce95e7e3) * (ringDistance / ringNailCount) / 2)) : 0;
        const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            size: size,
            margin: margin + ringWidth + (renderRing && ringSize ? ringPadding * radius : 0),
            rotation: globalRotationRadians,
            fitSize: false,
            nailsPerSide: 2
        });
        const edgeSize = polygon.sideSize / levels;
        const nailsLength = edgeSize / (2 * Math.cos(Math.PI / 6));
        let ringCircle;
        if (renderRing && ringSize) ringCircle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
            size: size,
            n: ringNailCount,
            margin: margin,
            rotation: globalRotation
        });
        const countPerLevelSide = new Array(levels + (renderCaps ? 1 : 0)).fill(null).map((_, level)=>level * 2 + 1);
        return {
            edgeSize: edgeSize,
            triangleHeight: edgeSize * Math.sqrt(3) / 2,
            nailsLength: nailsLength,
            triangleCenterDistance: edgeSize / 2,
            nailDistance: nailsLength / density,
            triangleCount: 6 * levels ** 2,
            countPerLevelSide: countPerLevelSide,
            globalRotationRadians: globalRotationRadians,
            radius: radius,
            ringCircle: ringCircle,
            center: (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size)
        };
    }
    initColor() {
        const { isMultiColor: isMultiColor, levels: levels, colorPerLevel: colorPerLevel, colorCount: colorCount, ...config } = this.config;
        const realColorCount = isMultiColor ? colorPerLevel ? levels : Math.min(colorCount, levels) : 1;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...config,
            isMultiColor: isMultiColor,
            colorCount: realColorCount
        });
    }
    setUpDraw(options) {
        if (!this.stepCount) this.stepCount = this.getStepCount(options);
        if (this.config.isMultiColor) this.colorMap = this.color.getColorMap({
            stepCount: this.color.config.colorCount,
            colorCount: this.color.config.colorCount
        });
        else this.colorMap = null;
    }
    getAspectRatio() {
        return 1;
    }
    #getTrianglePoints(calc, { center: center, rotation: rotation, isCapLevel: isCapLevel, triangleIndexInSide: triangleIndexInSide, withPoint: withPoint }) {
        let missingSide;
        if (isCapLevel) {
            const triangleIndex = (triangleIndexInSide + 2) % 3;
            missingSide = this.#getNextIndexInTriangle(triangleIndex);
        }
        // For each side of the triangle, the first point is the center of the triangle:
        const trianglePoints = new Array(3).fill(null).map((_, i)=>i === missingSide ? [] : [
                center
            ]);
        withPoint(0, 0, center);
        for(let side = 0; side < 3; side++){
            if (isCapLevel && side === missingSide) continue;
            const sideAngle = rotation + side * ((0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / 3);
            const triangleSidePoints = trianglePoints[side];
            const cosSideAngle = Math.cos(sideAngle);
            const sinSideAngle = Math.sin(sideAngle);
            for(let n = 1; n <= this.config.density; n++){
                const nNailDistance = n * calc.nailDistance;
                const point = [
                    center[0] + nNailDistance * cosSideAngle,
                    center[1] + nNailDistance * sinSideAngle
                ];
                triangleSidePoints.push(point);
                withPoint(side, n, point);
            }
        }
        return trianglePoints;
    }
    getNails(precision) {
        const { levels: levels, renderCaps: renderCaps } = this.config;
        const largeDistance = this.calc.nailsLength;
        const smallDistance = this.calc.triangleHeight - largeDistance;
        const levelsCount = renderCaps ? levels + 1 : levels;
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        for(let level = 0; level < levelsCount; level++){
            const isCapLevel = renderCaps && level === levels;
            const levelSideTriangleCount = this.calc.countPerLevelSide[level];
            // Caching distances to avoid repeated calculations for each side:
            const levelPositions = (0, $c190f550efa69733$export$7f1ebd623f131021)(levelSideTriangleCount, (n)=>{
                const isFlipped = n % 2 === 0;
                const trianglePosition = [
                    this.calc.triangleCenterDistance * (n - level),
                    level * this.calc.triangleHeight + (isFlipped ? largeDistance : smallDistance)
                ];
                return {
                    rotation: Math.atan(trianglePosition[0] / trianglePosition[1]),
                    distanceFromCenter: Math.hypot(trianglePosition[0], trianglePosition[1])
                };
            });
            let triangleIndexInLevel = 0;
            for(let side = 0; side < 6; side++){
                const sideRotation = $324d244b6e96daed$var$SIDE_ANGLES[side];
                for(let n = 0; n < levelSideTriangleCount; n++){
                    if (isCapLevel && n % 2 === 0) {
                        // Cap triangles are only odd indexes
                        triangleIndexInLevel++;
                        continue;
                    }
                    const { distanceFromCenter: distanceFromCenter, rotation: rotation } = levelPositions[n];
                    const triangleCenterAngle = sideRotation - rotation - this.calc.globalRotationRadians;
                    const rotatedTrianglePosition = [
                        this.calc.center[0] + distanceFromCenter * Math.cos(triangleCenterAngle),
                        this.calc.center[1] - distanceFromCenter * Math.sin(triangleCenterAngle)
                    ];
                    this.#getTrianglePoints(this.calc, {
                        center: rotatedTrianglePosition,
                        rotation: sideRotation + side * (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / 3 - n * $324d244b6e96daed$var$ANGLE + this.calc.globalRotationRadians,
                        isCapLevel: isCapLevel,
                        triangleIndexInSide: n,
                        withPoint: (side, index, point)=>{
                            nails.addNail(this.#getPointKey(level, triangleIndexInLevel, side, index), point);
                        }
                    });
                    triangleIndexInLevel++;
                }
            }
        }
        if (this.config.renderRing) {
            const ringNailsGroup = new (0, $d8b2fd23c47cc34c$export$2e2bcd8739ae039)();
            this.calc.ringCircle.addNails(ringNailsGroup);
            nails.addGroup(ringNailsGroup, 'ring');
        }
        return nails;
    }
    *generateTriangleStrings(controller, { level: level, indexInSide: indexInSide, triangleIndex: triangleIndex, isCapLevel: isCapLevel }) {
        controller.startLayer({
            color: this.color.getColor(level),
            name: 'triangles'
        });
        const { density: density } = this.config;
        const initialSide = isCapLevel ? this.#getNextIndexInTriangle(indexInSide % 3) : 0;
        const lastSide = isCapLevel ? initialSide : 2;
        const lastIndex = isCapLevel ? density : density - 1;
        for(let side = initialSide; side <= lastSide; side++){
            const nextSide = this.#getNextIndexInTriangle(side, 1);
            controller.goto(this.#getPointKey(level, triangleIndex, 0, 0));
            for(let n = 0; n <= lastIndex; n++){
                const isNextSide = n % 2 === 0;
                const nextSidePoint = isNextSide ? density - n : n;
                const targetSide = isNextSide ? nextSide : side;
                controller.stringTo(this.#getPointKey(level, triangleIndex, targetSide, nextSidePoint));
                yield;
                if (n < density) {
                    controller.stringTo(this.#getPointKey(level, triangleIndex, targetSide, isNextSide ? nextSidePoint - 1 : nextSidePoint + 1));
                    yield;
                }
            }
        }
    }
    *generateFill(controller, { triangle1Index: triangle1Index, triangle2Index: triangle2Index, triangle1Level: triangle1Level, triangle2Level: triangle2Level, triangleIndexInSide: triangleIndexInSide, isNextLevel: isNextLevel }) {
        const { density: density, fillColor: fillColor } = this.config;
        const levelSideCount = this.calc.countPerLevelSide[triangle1Level];
        const angleShift = triangle1Index % levelSideCount % 3;
        controller.startLayer({
            color: fillColor,
            name: 'fill'
        });
        const isLastTriangleInSide = triangleIndexInSide === levelSideCount - 1;
        const firstSide = angleShift;
        const sideIndex = isNextLevel ? [
            this.#getNextIndexInTriangle(angleShift),
            this.#getNextIndexInTriangle(angleShift, -1)
        ] : [
            firstSide,
            this.#getNextIndexInTriangle(firstSide, triangleIndexInSide % 2 ? 1 : -1)
        ];
        for(let s = 0; s < 2; s++){
            const order = generateOrderInSide.call(this, s);
            for (const { pointIndex: pointIndex, triangle1Side: triangle1Side, triangle2Side: triangle2Side } of order){
                controller.goto(this.#getPointKey(triangle1Level, triangle1Index, triangle1Side, pointIndex));
                controller.stringTo(this.#getPointKey(triangle2Level, triangle2Index, triangle2Side, pointIndex));
                yield;
            }
        }
        function* generateOrderInSide(side) {
            const triangle1Side = sideIndex[side];
            const triangle2Side = getNextTriangleSide.call(this);
            const last = side ? density : density - 1;
            if (side === 0) for(let n = 0; n <= last; n++)yield {
                pointIndex: density - n,
                triangle1Side: triangle1Side,
                triangle2Side: triangle2Side
            };
            else for(let n = last; n >= 1; n--)yield {
                pointIndex: density - n,
                triangle1Side: triangle1Side,
                triangle2Side: triangle2Side
            };
            function getNextTriangleSide() {
                if (isNextLevel) return this.#getNextIndexInTriangle(triangle1Side);
                else {
                    if (side === 0 && isLastTriangleInSide) return 1;
                    else {
                        if (side === 1 && isLastTriangleInSide) return 0;
                        else return this.#getNextIndexInTriangle(triangle1Side, 1);
                    }
                }
            }
        }
    }
    #getNextIndexInTriangle(index, direction = 1) {
        const result = index + direction;
        if (result < 0) return 2;
        if (result > 2) return 0;
        return result;
    }
    *drawStrings(controller) {
        const { fill: fill, renderTriangles: renderTriangles, renderCaps: renderCaps, levels: levels, renderRing: renderRing, ringSize: ringSize, ringColor: ringColor } = this.config;
        const levelsCount = renderCaps ? levels + 1 : levels;
        for(let levelIndex = 0; levelIndex < levelsCount; levelIndex++){
            const isCapLevel = levelIndex === levels;
            const levelTriangleCount = 6 * (levelIndex * 2 + 1);
            const lastIndexInLevel = levelTriangleCount - 1;
            for(let triangleIndex = 0; triangleIndex < levelTriangleCount; triangleIndex++){
                const levelSideCount = this.calc.countPerLevelSide[levelIndex];
                const triangleIndexInSide = triangleIndex % levelSideCount;
                if (fill && !isCapLevel) {
                    if (triangleIndex === 0) yield* this.generateFill(controller, {
                        triangle1Index: lastIndexInLevel,
                        triangle2Index: triangleIndex,
                        triangle1Level: levelIndex,
                        triangle2Level: levelIndex,
                        triangleIndexInSide: lastIndexInLevel % levelSideCount
                    });
                    if (triangleIndex !== lastIndexInLevel) yield* this.generateFill(controller, {
                        triangle1Index: triangleIndex,
                        triangle2Index: triangleIndex + 1,
                        triangle1Level: levelIndex,
                        triangle2Level: levelIndex,
                        triangleIndexInSide: triangleIndexInSide
                    });
                    if (triangleIndexInSide % 2 === 0 && (renderCaps && renderTriangles || levelIndex < levels - 1)) {
                        const side = Math.floor(triangleIndex / levelSideCount);
                        const nextLevelSideCount = this.calc.countPerLevelSide[levelIndex + 1];
                        const nextLevelTriangleIndex = side * nextLevelSideCount + triangleIndexInSide + 1;
                        yield* this.generateFill(controller, {
                            triangle1Index: triangleIndex,
                            triangle2Index: nextLevelTriangleIndex,
                            triangle1Level: levelIndex,
                            triangle2Level: levelIndex + 1,
                            triangleIndexInSide: triangleIndexInSide,
                            isNextLevel: true
                        });
                    }
                }
                if (renderTriangles && (!isCapLevel || triangleIndexInSide % 2)) yield* this.generateTriangleStrings(controller, {
                    level: levelIndex,
                    indexInSide: triangleIndexInSide,
                    triangleIndex: triangleIndex,
                    isCapLevel: isCapLevel
                });
            }
        }
        if (renderRing && ringSize) {
            controller.startLayer({
                name: 'Ring',
                color: ringColor
            });
            yield* this.calc.ringCircle.drawRingLayer(controller, {
                ringSize: ringSize / 2,
                nailGroup: 'ring'
            });
        }
    }
    getStepCount(options) {
        if (this.stepCount) return this.stepCount;
        const calc = this.calc ?? this.getCalc(options);
        const { density: density, renderTriangles: renderTriangles, renderCaps: renderCaps, levels: levels, fill: fill } = this.config;
        const { triangleCount: triangleCount, ringCircle: ringCircle } = calc;
        const capCount = renderTriangles && renderCaps ? levels * 6 : 0;
        // First we count how many fills there are. The calculation is like this:
        // For each level, there's a fill between each triangle
        // Also, for each level, there are (level - 1) * 6 fills, where the level is zero-based (the first level is 0)
        // Finally, if there are caps, each cap has a fill
        let fillCount = 0;
        if (fill) {
            const getTriangleCountForLevel = (level)=>6 * (level * 2 + 1);
            for(let level = 0; level < levels; level++){
                const levelTrianglecount = getTriangleCountForLevel(level);
                fillCount += levelTrianglecount + level * 6;
            }
            fillCount += capCount;
        }
        const fillStepCount = fillCount * density * 2;
        const capSteps = capCount * (2 * density + 1);
        return (renderTriangles ? triangleCount * density * 6 : 0) + capSteps + fillStepCount + (ringCircle ? ringCircle.getRingStepCount() : 0);
    }
    getNailCount() {
        return this.#getTrianglesNailsCount() + (this.config.renderRing ? this.config.ringNailCount : 0);
    }
    #getTrianglesNailsCount() {
        const { levels: levels, renderCaps: renderCaps, density: density } = this.config;
        const triangleCount = 6 * levels ** 2;
        const capsCount = renderCaps ? levels * 6 : 0;
        // jointsCount is the number of joints that are shared by multiple triangles, not counting the center joint
        const jointsCount = levels * (levels + 1) / 2 * 6 + 1;
        const nailsPerTriangleWithoutJoints = (density - 1) * 3 + 1;
        const capsNailCount = capsCount * ((density - 1) * 2 + 1);
        return triangleCount * nailsPerTriangleWithoutJoints + jointsCount + capsNailCount;
    }
    #getPointKey(level, triangle, side, index) {
        return index ? 1e6 * level + 1e3 * triangle + side * 1e2 + index : 1e6 * level + 1e3 * triangle;
    }
    thumbnailConfig = ({ density: density })=>({
            density: Math.min(density, 3)
        });
}





const $697ac479630237ad$var$spreadModes = {
    evenly: {
        f: (layerIndex, { ringSize: ringSize, layers: layers, n: n })=>{
            const firstLayerDistance = Math.floor(n * ringSize);
            return Math.floor((layers - layerIndex) * firstLayerDistance / layers);
        },
        name: 'Evenly'
    },
    distance: {
        f: (layerIndex, { n: n, ringSize: ringSize, layerDistance: layerDistance })=>{
            const firstLayerDistance = Math.floor(n * ringSize);
            if (layerIndex > 0) return firstLayerDistance - layerIndex * layerDistance;
            return firstLayerDistance;
        },
        name: 'Specific distance'
    }
};
const $697ac479630237ad$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        color: '#ff0000',
        multicolorRange: 133,
        multicolorStart: 239,
        multicolorByLightness: false,
        minLightness: 30,
        maxLightness: 70,
        colorCount: 4
    },
    customControls: [
        {
            key: 'colorPerLayer',
            label: 'Color per layer',
            defaultValue: true,
            type: 'checkbox',
            affectsNails: false
        }
    ]
});
class $697ac479630237ad$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'comet';
    name = 'Comet';
    id = 'comet';
    controls = [
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).nailsConfig,
        {
            key: 'layers',
            label: 'Layers',
            defaultValue: 5,
            type: 'range',
            attr: {
                min: 1,
                max: 20,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'ringSize',
            label: 'First layer size',
            description: 'Nail count from the top center nail to the first connected nail in the first layer',
            defaultValue: 0.3,
            type: 'range',
            attr: {
                min: 0,
                max: 1,
                step: 0.01
            },
            displayValue: ({ ringSize: ringSize, n: n })=>Math.floor(n * ringSize),
            isStructural: true,
            affectsNails: false
        },
        {
            key: 'layerSpread',
            label: 'Layer Spread',
            type: 'select',
            defaultValue: 'distance',
            options: Object.entries($697ac479630237ad$var$spreadModes).map(([key, { name: name }])=>({
                    value: key,
                    label: name
                })),
            isStructural: true,
            affectsNails: false
        },
        {
            key: 'layerDistance',
            label: 'Layer Distance',
            type: 'range',
            attr: {
                min: 1,
                max: ({ n: n, layers: layers })=>Math.floor(n / 2 / layers),
                step: 1
            },
            defaultValue: 1,
            isStructural: true,
            show: ({ layerSpread: layerSpread })=>layerSpread !== 'evenly',
            affectsNails: false
        },
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig,
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
        (0, $06de6887437e6fa7$export$2e2bcd8739ae039).displacementConfig,
        $697ac479630237ad$var$COLOR_CONFIG
    ];
    defaultValues = {
        n: 51,
        layers: 11,
        colorPerLayer: true,
        multicolorRange: 203,
        multicolorStart: 137,
        ringSize: 0.47,
        rotation: 0.25,
        distortion: 0.38,
        displacementFunc: 'fastInOut',
        displacementMag: 1.8,
        displacementFastArea: 0.43,
        layerSpread: 'distance',
        layerDistance: 1
    };
    getCalc(options) {
        const circleConfig = {
            size: options.size,
            n: this.config.n,
            margin: this.config.margin,
            rotation: this.config.rotation,
            distortion: this.config.distortion,
            displacementFunc: this.config.displacementFunc,
            displacementMag: this.config.displacementMag,
            displacementFastArea: this.config.displacementFastArea
        };
        return {
            circle: new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig)
        };
    }
    initColor() {
        const { isMultiColor: isMultiColor, colorCount: colorCount, layers: layers, colorPerLayer: colorPerLayer } = this.config;
        const realColorCount = isMultiColor ? colorPerLayer ? layers : Math.min(colorCount, layers) : 1;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            isMultiColor: isMultiColor,
            colorCount: realColorCount
        });
    }
    getAspectRatio(calcOptions) {
        const calc = this.getCalc(calcOptions);
        return calc.circle.getAspectRatio();
    }
    getLayerRingDistance(layerIndex) {
        const spread = $697ac479630237ad$var$spreadModes[this.config.layerSpread];
        if (!spread) throw new Error(`Invalid spread mode, "${this.config.layerSpread}"!`);
        return Math.max(1, spread.f(layerIndex, this.config));
    }
    getLayerRingStepCount(layerIndex) {
        const layerRingDistance = this.getLayerRingDistance(layerIndex);
        return (this.config.n - layerRingDistance + 1) * 2 - 1;
    }
    *#drawLayer(controller, layerIndex = 0) {
        const { n: n } = this.config;
        const ringDistance = this.getLayerRingDistance(layerIndex);
        const stepCount = n - ringDistance + 1;
        let prevPointIndex = 0;
        controller.startLayer({
            color: this.color.getColor(layerIndex),
            name: String(layerIndex)
        });
        controller.goto(0);
        for(let i = 0; i <= n - ringDistance; i++){
            controller.stringTo((i + ringDistance) % n);
            yield;
            if (i !== stepCount - 1) {
                prevPointIndex = i + 1;
                controller.stringTo(prevPointIndex);
                yield;
            }
        }
    }
    *drawStrings(controller) {
        for(let layer = 0; layer < this.config.layers; layer++)yield* this.#drawLayer(controller, layer);
    }
    getStepCount() {
        if (this.stepCount) return this.stepCount;
        const { layers: layers } = this.config;
        return new Array(layers).fill(0).reduce((totalStepCount, _, layerIndex)=>totalStepCount + this.getLayerRingStepCount(layerIndex), 0);
    }
    getNailCount() {
        return this.config.n;
    }
    getNails(precision) {
        return this.calc.circle.getNails(precision);
    }
    thumbnailConfig = ({ n: n, layers: layers })=>({
            n: Math.min(n, n % 2 ? 29 : 28),
            layers: Math.min(layers, 8)
        });
    testStepCountConfig = [
        {
            n: 28,
            layers: 8,
            ringSize: 0.46,
            layerSpread: 'distance',
            layerDistance: 2,
            distortion: -0.33
        }
    ];
}














class $0f5f4bf46951eedf$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'sun';
    name = 'Sun';
    id = 'sun';
    controls = [
        {
            key: 'starGroup',
            label: 'Star',
            type: 'group',
            children: [
                ...(0, $b103c63dc979d40c$export$c4f94c8b3850a5a9)([
                    // @ts-ignore
                    ...(0, $a643183efb8a0ce0$export$2e2bcd8739ae039).StarConfig,
                    // @ts-ignore
                    (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
                        defaults: {
                            isMultiColor: true,
                            multicolorRange: 1,
                            multicolorStart: 237,
                            color: '#ffffff',
                            saturation: 40,
                            multicolorByLightness: true,
                            minLightness: 20,
                            maxLightness: 97
                        },
                        exclude: [
                            'colorCount'
                        ]
                    })
                ], 'sides', [
                    {
                        key: 'layers',
                        label: 'Layers',
                        defaultValue: 4,
                        type: 'range',
                        attr: {
                            min: 1,
                            max: 20,
                            step: 1
                        },
                        isStructural: true
                    },
                    {
                        key: 'layerSpread',
                        label: 'Layer spread',
                        defaultValue: 0.1625,
                        type: 'range',
                        displayValue: ({ layerSpread: layerSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(layerSpread),
                        attr: {
                            min: 0.01,
                            max: 1,
                            step: 0.02
                        },
                        show: ({ layers: layers })=>layers !== 1,
                        isStructural: true
                    },
                    {
                        key: 'starRadius',
                        label: 'Star Radius',
                        defaultValue: 1,
                        type: 'range',
                        displayValue: ({ starRadius: starRadius })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(starRadius),
                        attr: {
                            min: 0.2,
                            max: 1,
                            step: 0.01
                        },
                        isStructural: true,
                        affectsStepCount: false
                    }
                ])
            ]
        },
        {
            key: 'backdrop',
            label: 'Backdrop',
            type: 'group',
            children: [
                {
                    key: 'backdropSize',
                    label: 'Backdrop size',
                    defaultValue: 0.5,
                    type: 'range',
                    displayValue: ({ backdropSize: backdropSize })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(backdropSize),
                    attr: {
                        min: 0,
                        max: 1,
                        step: ({ sideNails: sideNails })=>1 / sideNails
                    },
                    isStructural: true
                },
                {
                    key: 'backdropRadius',
                    label: 'Backdrop radius',
                    defaultValue: 1,
                    type: 'range',
                    displayValue: ({ backdropRadius: backdropRadius })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(backdropRadius),
                    attr: {
                        min: 0,
                        max: 1,
                        step: 0.01
                    },
                    isStructural: true,
                    affectsStepCount: false
                },
                {
                    key: 'backdropShift',
                    label: 'Backdrop shift',
                    defaultValue: 0,
                    type: 'range',
                    displayValue: ({ backdropShift: backdropShift })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(backdropShift),
                    attr: {
                        min: 0,
                        max: 1,
                        step: ({ sideNails: sideNails, backdropSize: backdropSize })=>(1 / (sideNails * (1 - backdropSize))).toFixed(3)
                    },
                    isStructural: true,
                    affectsStepCount: false,
                    affectsNails: false
                },
                {
                    key: 'backdropSkip',
                    label: 'Backdrop skip',
                    description: "If yes, connections in the backdrop are from the backdrop's nail to the second-nearest side, not the ones near it",
                    defaultValue: false,
                    type: 'checkbox',
                    isStructural: true,
                    affectsStepCount: false,
                    show: ({ sides: sides })=>sides > 3
                },
                (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
                    defaults: {
                        isMultiColor: true,
                        multicolorRange: 20,
                        multicolorStart: 0,
                        color: '#ffffff',
                        saturation: 57,
                        multicolorByLightness: true,
                        minLightness: 20,
                        maxLightness: 40
                    },
                    propMapper: ({ key: key, show: show })=>{
                        const newKey = 'backdrop' + key[0].toUpperCase() + key.slice(1);
                        const control = {
                            key: 'backdrop' + key[0].toUpperCase() + key.slice(1),
                            show: show ? ({ backdropIsMultiColor: backdropIsMultiColor })=>key === 'color' ? !backdropIsMultiColor : backdropIsMultiColor : null
                        };
                        if (key === 'multicolorRange') control.attr = {
                            start: ({ backdropMulticolorStart: backdropMulticolorStart })=>backdropMulticolorStart,
                            type: 'range'
                        };
                        return control;
                    },
                    groupLabel: 'Backdrop color',
                    maxColorCount: 2
                })
            ]
        }
    ];
    getCommonControls() {
        return (0, $b103c63dc979d40c$export$c4f94c8b3850a5a9)((0, $85e40adea6d09b93$export$c90b7c9bd11bfec0), 'nailsColor', [
            {
                key: 'backdropNailsColor',
                label: 'Backdrop nails color',
                type: 'color',
                defaultValue: '#ffffff',
                show: ({ showNails: showNails })=>showNails,
                affectsStrings: false
            },
            {
                key: 'backdropNailsRadius',
                label: 'Backdrop nails radius',
                type: 'range',
                defaultValue: 1.5,
                attr: {
                    min: 0.5,
                    max: 5,
                    step: 0.25
                },
                show: ({ showNails: showNails })=>showNails,
                affectsStrings: false
            }
        ]);
    }
    #backdropColor;
    defaultValues = {
        sideNails: 50,
        sides: 16,
        layers: 4,
        layerSpread: 0.77,
        backdropSize: 0.26,
        backdropRadius: 0.9,
        backdropShift: 0.59,
        backdropColorCount: 2,
        centerRadius: 0.2,
        maxCurveSize: 0.64,
        rotation: 0.5,
        saturation: 73,
        multicolorStart: 206,
        multicolorRange: 1,
        multicolorByLightness: true,
        minLightness: 35,
        maxLightness: 100,
        nailsColor: '#000000',
        backdropNailsColor: '#ffffff',
        backdropNailsRadius: 2.275
    };
    getCalc({ size: size }) {
        const { margin: margin = 0, sideNails: sideNails, backdropRadius: backdropRadiusConfig = 1, backdropSize: backdropSize, rotation: rotation, sides: sides, starRadius: starRadiusConfig = 1 } = this.config;
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        const radius = Math.min(...center) - margin;
        const starRadius = backdropSize && starRadiusConfig < backdropRadiusConfig ? radius * starRadiusConfig / backdropRadiusConfig : radius;
        const backdropRadius = backdropRadiusConfig < starRadiusConfig ? radius * backdropRadiusConfig / starRadiusConfig : radius;
        const starConfig = {
            ...this.config,
            radius: starRadius,
            size: size
        };
        const circleConfig = {
            size: size,
            n: sides,
            rotation: -1 / sides / 2 + (rotation ? rotation / sides : 0),
            radius: backdropRadius
        };
        return {
            backdropNails: Math.floor(sideNails * backdropSize),
            star: new (0, $a643183efb8a0ce0$export$2e2bcd8739ae039)(starConfig),
            circle: new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)(circleConfig)
        };
    }
    initColor() {
        const { layers: layers } = this.config;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            colorCount: layers
        });
    }
    setUpDraw() {
        const { backdropColorCount: backdropColorCount } = this.config;
        // @ts-ignore this is fine for now, until the color config is managed in a single control
        this.#backdropColor = new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...(0, $c29d66861308df7e$export$781522908e4e76a1)(this.config, (key)=>{
                const match = key.match(/^backdrop(\w)(.+)/);
                return match ? match[1].toLowerCase() + match[2] : key;
            }),
            colorCount: backdropColorCount
        });
    }
    getAspectRatio(options) {
        const calc = this.getCalc(options);
        const boundingRect = (0, $b683a3137b30eaa9$export$1d3cc206d049790e)(calc.circle.getBoundingRect(), calc.star.getBoundingRect());
        return (0, $b683a3137b30eaa9$export$d2646d47608819e2)(boundingRect);
    }
    *drawBackdrop(controller) {
        // For each side, add a nail between two star sides, at the specified backdropRadius.
        // For the backdrop size, connect the nail to the number of points in the star for the two sides near the backdrop nail
        const { backdropNails: backdropNails, circle: circle, star: star } = this.calc;
        const { sides: sides, backdropShift: backdropShift, sideNails: sideNails, backdropSkip: backdropSkip, backdropIsMultiColor: backdropIsMultiColor, backdropColorCount: backdropColorCount } = this.config;
        const shouldSkip = backdropSkip && sides > 3;
        let currentSide = 0;
        const shift = Math.floor(backdropShift * (sideNails - backdropNails));
        let currentSideIndex = shift + backdropNails - 1;
        function* genSideDirections(side) {
            let alternate = false;
            const direction = side % 2 ? 1 : -1; // 1 if backdrop threading starts at the bottom and goes up, -1 if it goes down
            controller.goto(star.getSideNailKey(side, currentSideIndex));
            const backdropNailKey = circle.getNailKey(shouldSkip ? (side + 1) % sides : side);
            for(let i = 0; i < backdropNails; i++){
                yield controller.stringTo(backdropNailKey, 'backdrop');
                currentSide = (alternate ? side : side + (shouldSkip ? 3 : 1)) % sides;
                yield controller.stringTo(star.getSideNailKey(currentSide, currentSideIndex));
                if (i < backdropNails - 1) {
                    alternate = !alternate;
                    currentSideIndex += direction;
                    yield controller.stringTo(star.getSideNailKey(currentSide, currentSideIndex));
                }
            }
        }
        function* genAllSidesDirections() {
            for(let side = 0; side < sides; side++)yield* genSideDirections(side);
        }
        if (!backdropIsMultiColor || backdropColorCount === 1) {
            controller.startLayer({
                name: 'Backdrop',
                color: this.#backdropColor.getColor(0)
            });
            yield* genAllSidesDirections();
        } else {
            const layers = new Map((0, $c190f550efa69733$export$7f1ebd623f131021)(2, (i)=>[
                    i,
                    {
                        name: `Backdrop #${i + 1}`,
                        color: this.#backdropColor.getColor(i)
                    }
                ]));
            for(let side = 0; side < sides; side++){
                controller.startLayer(layers.get(side % 2));
                yield* genSideDirections(side);
            }
        }
    }
    *drawStrings(controller) {
        yield* this.drawBackdrop(controller);
        for(let layerIndex = 0; layerIndex < this.config.layers; layerIndex++){
            controller.startLayer({
                name: `Layer ${layerIndex + 1}`,
                color: this.color.getColor(layerIndex)
            });
            yield* this.calc.star.drawStar(controller, {
                size: this.#getLayerSize(layerIndex)
            });
        }
    }
    getNails(precision) {
        const { backdropSize: backdropSize, backdropNailsColor: backdropNailsColor, backdropNailsRadius: backdropNailsRadius } = this.config;
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.star.addNails(nails);
        if (backdropSize) {
            const backdropNailsGroup = new (0, $d8b2fd23c47cc34c$export$2e2bcd8739ae039)({
                color: backdropNailsColor,
                radius: backdropNailsRadius
            });
            this.calc.circle.addNails(backdropNailsGroup);
            nails.addGroup(backdropNailsGroup, 'backdrop');
        }
        return nails;
    }
    #getLayerSize(layer) {
        const { layers: layers, layerSpread: layerSpread, sideNails: sideNails } = this.config;
        return Math.max(1, sideNails - layer * Math.max(1, Math.floor(sideNails / layers * layerSpread)));
    }
    getStepCount(options) {
        const { layers: layers, sides: sides } = this.config;
        const { backdropNails: backdropNails } = this.getCalc(options);
        const backdropStepCount = sides * (backdropNails * 3 - 1);
        let stepCount = backdropStepCount;
        for(let layer = 0; layer < layers; layer++){
            const layerSize = this.#getLayerSize(layer);
            stepCount += (0, $a643183efb8a0ce0$export$2e2bcd8739ae039).getStepCount(this.config, {
                size: layerSize
            });
        }
        return stepCount;
    }
    thumbnailConfig = ({ sideNails: sideNails, backdropNailsRadius: backdropNailsRadius })=>({
            sideNails: Math.min(sideNails, 10),
            backdropNailsRadius: Math.min(backdropNailsRadius, 0.5)
        });
}











class $8c28f16f24dd1c79$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'lotus';
    name = 'Lotus';
    id = 'lotus';
    controls = [
        {
            key: 'sides',
            label: 'Sides',
            description: 'How many petals there are in the Lotus',
            type: 'range',
            defaultValue: 18,
            attr: {
                min: 5,
                max: 64,
                step: 1
            },
            isStructural: true
        },
        {
            key: 'density',
            label: 'Density',
            type: 'range',
            defaultValue: 15,
            attr: {
                min: 1,
                max: 30,
                step: 1
            },
            isStructural: true
        },
        (0, $b103c63dc979d40c$export$2d97e2da46663803)((0, $06de6887437e6fa7$export$2e2bcd8739ae039).rotationConfig, 'snap'),
        {
            key: 'removeSections',
            label: 'Remove sections',
            type: 'range',
            attr: {
                min: 0,
                max: 1,
                step: ({ sides: sides, renderCenter: renderCenter })=>1 / $8c28f16f24dd1c79$var$getSectionCountToRemove(sides)
            },
            defaultValue: 4 / 7,
            displayValue: ({ removeSections: removeSections, sides: sides, renderCenter: renderCenter })=>Math.round(removeSections * $8c28f16f24dd1c79$var$getSectionCountToRemove(sides)),
            isStructural: true
        },
        {
            key: 'renderCenter',
            label: 'Render center',
            type: 'checkbox',
            defaultValue: true,
            isStructural: true
        },
        {
            key: 'centerRadius',
            label: 'Center radius',
            type: 'range',
            defaultValue: 1,
            attr: {
                min: 0,
                max: 1,
                step: 0.01
            },
            displayValue: ({ centerRadius: centerRadius })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerRadius),
            show: ({ renderCenter: renderCenter })=>renderCenter,
            isStructural: true,
            affectsStepCount: false
        },
        {
            key: 'renderCenterNails',
            label: 'Render center nails',
            type: 'checkbox',
            defaultValue: false,
            isStructural: true
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                multicolorStart: 20,
                multicolorRange: 26,
                multicolorByLightness: true,
                minLightness: 32,
                maxLightness: 85,
                saturation: 100,
                colorCount: 6,
                mirrorColors: true
            },
            customControls: [
                {
                    key: 'radialColor',
                    label: 'Radial color',
                    defaultValue: false,
                    type: 'checkbox',
                    affectsNails: false,
                    affectsStepCount: false
                }
            ],
            maxColorCount: 32
        })
    ];
    defaultValues = {
        nailsColor: '#a08346'
    };
    getCalc({ size: size }) {
        const { sides: sides, density: density, margin: margin, rotation: rotation, removeSections: removeSections, centerRadius: centerRadiusPercent, renderCenter: renderCenter, renderCenterNails: renderCenterNails } = this.config;
        const d = 0.5; // The helper circle's center is right between the pattern center and the edge
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        let radius = Math.min(...size) * d / 2;
        const sideAngle = (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) / sides;
        const densityNailCount = density * sides;
        const baseCircleConfig = {
            n: densityNailCount,
            center: [
                0,
                0
            ],
            size: [
                0,
                0
            ],
            radius: 0,
            rotation: 0
        };
        let petalSectionsToRemove = 0;
        if (removeSections) {
            const maxPetalSectionsToRemove = $8c28f16f24dd1c79$var$getSectionCountToRemove(sides);
            petalSectionsToRemove = Math.min(maxPetalSectionsToRemove, Math.round(removeSections * maxPetalSectionsToRemove));
            const angleStart = sideAngle * petalSectionsToRemove;
            // Since we removed sections and now the pattern is smaller than the canvas size, we fit the remaining shape to fit on canvas
            // this is done by:
            // 1. Calculating the new outer edge of the shape, after removing sections
            // 2. Increase the size of the circles that create petals by the inverse ratio of the new to original size
            // 3. Since the circles are now larger, increase the number of nails in the circles by the size ratio, to maintain density.
            const topSectionHeight = 2 * radius * Math.sin((Math.PI - angleStart) / 2);
            const fitAspectRatio = (2 * radius - margin) / topSectionHeight;
            baseCircleConfig.n = removeSectionsNailCount(fixNailsCount(densityNailCount * fitAspectRatio), petalSectionsToRemove);
            radius *= fitAspectRatio;
            Object.assign(baseCircleConfig, {
                angleStart: angleStart,
                angleEnd: (0, $e2b746416d2bf62b$export$f4644083ce95e7e3) - angleStart
            });
        }
        Object.assign(baseCircleConfig, {
            size: [
                radius - margin / 2,
                radius - margin / 2
            ],
            radius: radius - margin / 2
        });
        // Draw circles around the center point. For this, create a helper Circle, so its points can be used as centers for the lotus circles:
        const helperCircle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
            n: sides,
            size: size.map((v)=>v * d - margin),
            center: center,
            radius: radius - margin / 2,
            rotation: rotation
        });
        const nailsCountBeforeCircles = renderCenter ? centerRadiusPercent ? sides : 1 : 0;
        const circles = (0, $c190f550efa69733$export$7f1ebd623f131021)(sides, (i)=>{
            const circleIndexStart = nailsCountBeforeCircles + baseCircleConfig.n * i;
            return new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
                ...baseCircleConfig,
                center: helperCircle.getPoint(i),
                rotation: rotation - i / sides,
                getUniqueKey: (k)=>circleIndexStart + k
            });
        });
        const sections = $8c28f16f24dd1c79$var$getSectionsCount(sides);
        const nailsPerSection = Math.floor(baseCircleConfig.n / (sides - 2 * petalSectionsToRemove));
        let excludedNailRange = null;
        if (!renderCenterNails) {
            const innerSectionNailsStart = (sections - 1 - petalSectionsToRemove - (renderCenter ? 0 : 1)) * nailsPerSection + 1;
            const innerSectionNailsEnd = baseCircleConfig.n - innerSectionNailsStart - (petalSectionsToRemove ? 1 : 0);
            excludedNailRange = [
                innerSectionNailsStart,
                innerSectionNailsEnd
            ];
        }
        const calc = {
            circles: circles,
            sideAngle: sideAngle,
            sections: $8c28f16f24dd1c79$var$getSectionsCount(sides),
            removedSections: petalSectionsToRemove,
            nailsPerSection: Math.floor(baseCircleConfig.n / (sides - 2 * petalSectionsToRemove)),
            nailsPerCircle: baseCircleConfig.n,
            center: center,
            excludedNailRange: excludedNailRange
        };
        if (renderCenter && centerRadiusPercent) {
            // If a center radius value larger than 0 is configured, the inner section's connect point isn't the center of the pattern,
            // but points around it, so we create a circle to function as points for the inner section patches to connect to.
            const lastSection = calc.sections - 1 - calc.removedSections;
            const maxCenterRadiusPoint = circles[0].getPoint(lastSection * calc.nailsPerSection);
            const maxCenterRadius = Math.floor((0, $e2b746416d2bf62b$export$27796bb1a51212b7)(helperCircle.center, maxCenterRadiusPoint));
            const centerCircleRadius = centerRadiusPercent * maxCenterRadius;
            calc.centerCircle = new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
                n: sides,
                center: helperCircle.center,
                size: [
                    centerCircleRadius,
                    centerCircleRadius
                ],
                radius: centerCircleRadius,
                rotation: rotation + -Math.ceil((sides - 4) / 2) / 2 / sides
            });
        }
        return calc;
        function fixNailsCount(nailsCount) {
            return Math.max(sides, nailsCount - nailsCount % sides);
        }
        function removeSectionsNailCount(fullCircleNailCount, sectionsToRemove) {
            return Math.round(fullCircleNailCount * (1 - 2 * sectionsToRemove / sides) + 1);
        }
    }
    initColor() {
        let colorCount = this.config.radialColor ? this.calc.sections - this.calc.removedSections - 1 : this.config.colorCount;
        if (!this.config.renderCenter && this.config.radialColor) colorCount--;
        return new (0, $44d9dab6555abf73$export$2e2bcd8739ae039)({
            ...this.config,
            colorCount: colorCount
        });
    }
    getAspectRatio(options) {
        const calc = this.getCalc(options);
        const boundingRect = (0, $b683a3137b30eaa9$export$1d3cc206d049790e)(...calc.circles.map((c)=>c.getBoundingRect()));
        return (0, $b683a3137b30eaa9$export$d2646d47608819e2)(boundingRect);
    }
    #getPatchColor(circleIndex, section) {
        const { radialColor: radialColor } = this.config;
        const { removedSections: removedSections } = this.calc;
        return this.color.getColor(radialColor ? section - removedSections : circleIndex);
    }
    *#drawPatch(controller, circleIndex, section) {
        const { sides: sides } = this.config;
        const { sections: sections, nailsPerSection: nailsPerSection, nailsPerCircle: nailsPerCircle, removedSections: removedSections } = this.calc;
        const color = this.#getPatchColor(circleIndex, section);
        const circle = this.calc.circles[circleIndex];
        const prevCircle = this.calc.circles[circleIndex === 0 ? sides - 1 : circleIndex - 1];
        controller.startLayer({
            color: color
        });
        if (section === 0) {
            // For first section (outtermost): connectPoint is `prevCircle[sideAngle * 2]
            const connectPoint = prevCircle.getNailKey(nailsPerSection * 2);
            for(let i = nailsPerCircle - nailsPerSection; i < nailsPerCircle; i++){
                controller.goto(circle.getNailKey(i));
                controller.stringTo(connectPoint);
                yield;
            }
            for(let i = 0; i <= nailsPerSection; i++){
                controller.goto(circle.getNailKey(i));
                controller.stringTo(connectPoint);
                yield;
            }
        } else {
            // For middle sections, connectPoint is `circleIndex - 1`, (sideAngle * section + 1). Connect circleIndex[section] and `circleIndex + section`[section]
            const isLastSection = section === sections - 2;
            const connectPoint = isLastSection ? this.calc.centerCircle ? circleIndex : 0 : prevCircle.getNailKey(nailsPerSection * (section + 2 - removedSections) - (sides % 2 && section === sections - 2 ? nailsPerSection / 2 : 0));
            const firstCircle = this.calc.circles[(circleIndex + section) % sides];
            const firstCircleStart = nailsPerCircle - (section + 1 - removedSections) * nailsPerSection - (removedSections ? 1 : 0);
            for(let i = 0; i <= nailsPerSection; i++){
                controller.goto(firstCircle.getNailKey(firstCircleStart + i));
                controller.stringTo(connectPoint);
                yield;
            }
            const startIndex = (section - removedSections) * nailsPerSection + 1;
            for(let i = startIndex; i < startIndex + nailsPerSection; i++){
                controller.goto(circle.getNailKey(i));
                controller.stringTo(connectPoint);
                yield;
            }
        }
    }
    *drawStrings(controller) {
        for (const { side: side, section: section } of this.#generatePatches())yield* this.#drawPatch(controller, side, section);
    }
    *#generatePatches() {
        const { radialColor: radialColor, sides: sides, renderCenter: renderCenter } = this.config;
        const { sections: sections, removedSections: removedSections } = this.calc;
        const lastSection = sections - (renderCenter ? 1 : 2);
        if (radialColor) {
            for(let section = removedSections; section < lastSection; section++)for(let side = 0; side < sides; side++)yield {
                side: side,
                section: section
            };
        } else {
            for(let side = 0; side < sides; side++)for(let section = removedSections; section < lastSection; section++)yield {
                side: side,
                section: section
            };
        }
    }
    getNails(precision) {
        const { renderCenter: renderCenter } = this.config;
        const { circles: circles, centerCircle: centerCircle, excludedNailRange: excludedNailRange, nailsPerSection: nailsPerSection } = this.calc;
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        if (renderCenter) {
            if (centerCircle) centerCircle.addNails(nails);
            else nails.addNail(0, this.calc.center);
        }
        circles.forEach((circle, i)=>{
            circle.addNails(nails, {
                filter: excludedNailRange ? (circleNailIndex)=>{
                    if (!renderCenter && circleNailIndex === excludedNailRange[0] + nailsPerSection - 1) return true;
                    return circleNailIndex < excludedNailRange[0] || circleNailIndex > excludedNailRange[1];
                } : undefined
            });
        });
        return nails;
    }
    getStepCount(options) {
        const { nailsPerSection: nailsPerSection, sections: sections, removedSections: removedSections } = this.calc ?? this.getCalc(options);
        const { sides: sides } = this.config;
        const patchCount = 2 * nailsPerSection + 1;
        const sideStepCount = patchCount * (sections - removedSections - 1);
        return sides * sideStepCount;
    }
    thumbnailConfig = ({ density: density })=>({
            density: Math.min(density, 5)
        });
    testStepCountConfig = [
        {
            renderCenter: true,
            centerRadius: 0
        }
    ];
}
function $8c28f16f24dd1c79$var$getSectionsCount(sides) {
    return sides % 2 ? Math.ceil(sides / 2) : sides / 2;
}
function $8c28f16f24dd1c79$var$getSectionCountToRemove(sides) {
    return $8c28f16f24dd1c79$var$getSectionsCount(sides) - 3;
}









const $b533ea359183b19e$var$COLOR_CONFIG = (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
    defaults: {
        isMultiColor: true,
        colorCount: 7,
        color: '#ffbb29',
        multicolorRange: 21,
        multicolorStart: 32,
        multicolorByLightness: true,
        minLightness: 36,
        maxLightness: 98
    }
});
function $b533ea359183b19e$var$getShapeControlsGroup(label, shapeIndex) {
    return {
        key: `shape${shapeIndex}`,
        label: label,
        type: 'group',
        // @ts-ignore
        children: [
            {
                key: `shape${shapeIndex}Type`,
                label: 'Type',
                type: 'select',
                defaultValue: 'circle',
                options: [
                    {
                        value: 'circle',
                        label: 'Circle'
                    },
                    {
                        value: 'polygon',
                        label: 'Polygon'
                    }
                ],
                isStructural: true
            },
            shapeIndex === 2 ? {
                key: `shape${shapeIndex}Size`,
                label: 'Size',
                type: 'range',
                attr: {
                    min: 0.1,
                    max: 1,
                    step: 0.01
                },
                defaultValue: 1,
                displayValue: (config)=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(config[`shape${shapeIndex}Size`]),
                isStructural: true,
                affectsStepCount: false
            } : undefined,
            {
                key: `shape${shapeIndex}Sides`,
                label: 'Sides',
                type: 'range',
                attr: {
                    min: 3,
                    max: 24,
                    step: 1
                },
                defaultValue: 7,
                isStructural: true,
                show: (config)=>config[`shape${shapeIndex}Type`] === 'polygon'
            },
            {
                ...(0, $06de6887437e6fa7$export$2e2bcd8739ae039).distortionConfig,
                key: `shape${shapeIndex}Distortion`,
                show: (config)=>config[`shape${shapeIndex}Type`] === 'circle'
            },
            shapeIndex === 2 ? {
                key: 'identicalNailCount',
                label: 'Nail count as outer shape',
                type: 'checkbox',
                defaultValue: false,
                isStructural: true
            } : null,
            {
                key: `shape${shapeIndex}NailCount`,
                label: 'Nail count',
                type: 'range',
                attr: {
                    min: 3,
                    max: 400,
                    step: 1
                },
                defaultValue: 100,
                isStructural: true,
                show: ({ identicalNailCount: identicalNailCount })=>shapeIndex === 1 || !identicalNailCount
            },
            {
                key: `shape${shapeIndex}Rotation`,
                label: 'Rotation',
                type: 'range',
                attr: {
                    min: 0,
                    max: 1,
                    step: 0.0027
                },
                defaultValue: 0,
                displayValue: (config)=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(config[`shape${shapeIndex}Rotation`]),
                isStructural: true
            }
        ].filter(Boolean)
    };
}
class $b533ea359183b19e$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'dance_of_planets';
    name = 'Dance of Planets';
    id = 'dance_of_planets';
    controls = [
        $b533ea359183b19e$var$getShapeControlsGroup('Outer shape', 1),
        $b533ea359183b19e$var$getShapeControlsGroup('Inner shape', 2),
        {
            type: 'range',
            key: 'rounds',
            label: 'Rounds',
            attr: {
                min: 1,
                max: 30,
                step: 1
            },
            defaultValue: 1,
            affectsNails: false
        },
        {
            key: 'reverse',
            type: 'checkbox',
            label: 'Reverse order',
            description: 'If on, while the first shape advances in one direction, the second shape advances in the opposite direction',
            defaultValue: false,
            isStructural: false,
            affectsNails: false
        },
        $b533ea359183b19e$var$COLOR_CONFIG
    ];
    defaultValues = {
        shape1Type: 'circle',
        shape1NailCount: 150,
        shape1Rotation: 0,
        shape2Type: 'circle',
        shape2Size: 0.8,
        shape2NailCount: 117,
        shape2Distortion: -0.12,
        shape2Rotation: 0.216,
        rounds: 2,
        multicolorRange: 132,
        multicolorStart: 198,
        isMultiColor: true,
        multicolorByLightness: false,
        colorCount: 2
    };
    colorMap;
    getCalc({ size: size }) {
        const { margin: margin } = this.config;
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        function getShape({ type: type, diameter: diameter = 1, nailCount: nailCount, sides: sides, rotation: rotation = 0, distortion: distortion, getUniqueKey: getUniqueKey }) {
            if (type === 'circle') return new (0, $06de6887437e6fa7$export$2e2bcd8739ae039)({
                size: (0, $b683a3137b30eaa9$export$c566af9defc62c6)(size, (v)=>v * diameter),
                n: Math.round(nailCount),
                radius: Math.min(...size) * diameter / 2,
                center: center,
                margin: margin,
                reverse: true,
                rotation: rotation,
                distortion: distortion,
                getUniqueKey: getUniqueKey
            });
            else {
                sides = sides ?? 3;
                nailCount = Math.max(nailCount, sides);
                return new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                    size: (0, $b683a3137b30eaa9$export$c566af9defc62c6)(size, (v)=>v * diameter),
                    sides: sides ?? 3,
                    nailsPerSide: Math.round(nailCount / sides),
                    center: center,
                    margin: margin,
                    rotation: rotation,
                    getUniqueKey: getUniqueKey
                });
            }
        }
        const shape1 = getShape({
            type: this.config.shape1Type,
            nailCount: this.config.shape1NailCount,
            sides: this.config.shape1Sides,
            rotation: this.config.shape1Rotation,
            distortion: this.config.shape1Distortion
        });
        const shape1NailCount = shape1.getNailCount();
        const shape2 = getShape({
            type: this.config.shape2Type,
            diameter: this.config.shape2Size,
            nailCount: this.config.identicalNailCount ? shape1NailCount : this.config.shape2NailCount,
            sides: this.config.shape2Sides,
            rotation: this.config.shape2Rotation,
            distortion: this.config.shape2Distortion,
            getUniqueKey: (k)=>k + shape1NailCount
        });
        return {
            shape1: shape1,
            shape2: shape2,
            shape1NailCount: shape1NailCount,
            shape2NailCount: shape2.getNailCount()
        };
    }
    setUpDraw() {
        const { colorCount: colorCount } = this.config;
        if (colorCount) this.colorMap = this.color.getColorMap({
            stepCount: this.#getConnectionCount(),
            colorCount: colorCount
        });
    }
    getAspectRatio() {
        const { shape1: shape1, shape2: shape2 } = this.calc ?? this.getCalc({
            size: [
                100,
                100
            ]
        });
        const rect1 = shape1.getBoundingRect();
        const rect2 = shape2.getBoundingRect();
        return Math.max(rect1.width, rect2.width) / Math.max(rect1.height, rect2.height);
    }
    #getConnectionCount() {
        const { shape1NailCount: shape1NailCount, shape2NailCount: shape2NailCount } = this.calc;
        const greaterNailCount = Math.max(shape1NailCount, shape2NailCount);
        return greaterNailCount * this.config.rounds;
    }
    *drawStrings(controller) {
        const { shape1NailCount: shape1NailCount, shape2NailCount: shape2NailCount } = this.calc;
        const { reverse: reverse } = this.config;
        const steps = this.#getConnectionCount();
        controller.goto(0);
        let toShape2 = true;
        const getShape2Index = reverse ? (step)=>shape1NailCount + shape2NailCount - (step % shape2NailCount || shape2NailCount) : (step)=>shape1NailCount + step % shape2NailCount;
        for(let step = 0; step < steps; step++){
            const stepColor = this.colorMap.get(step);
            if (stepColor) controller.startLayer({
                color: stepColor
            });
            controller.stringTo(toShape2 ? getShape2Index(step) : step % shape1NailCount);
            yield;
            if (step !== steps - 1) {
                controller.stringTo(toShape2 ? getShape2Index(step + 1) : (step + 1) % shape1NailCount);
                yield;
                toShape2 = !toShape2;
            }
        }
    }
    getStepCount(options) {
        if (!this.calc) this.calc = this.getCalc(options);
        return this.#getConnectionCount() * 2 - 1;
    }
    getNailCount(size) {
        const calc = this.getCalc({
            size: size
        });
        return calc.shape1NailCount + calc.shape2NailCount;
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.shape1.addNails(nails);
        this.calc.shape2.addNails(nails);
        return nails;
    }
    #getShapeNailCount(shapeType, nailCount, sides) {
        if (shapeType === 'circle') return nailCount;
        return nailCount <= sides ? sides : nailCount - nailCount % sides;
    }
    thumbnailConfig = (config)=>{
        const MAX_NAIL_COUNT = 80;
        // the nail count of either shape shouldn't exceed the MAX_NAIL_COUNT,
        // but the ratio between the two counts needs to be preserved, so the pattern in the thumbnail looks similar
        let shape1NailCount = this.#getShapeNailCount(config.shape1Type, config.shape1NailCount, config.shape1Sides);
        let shape2NailCount = config.identicalNailCount ? shape1NailCount : config.shape2NailCount;
        if (shape1NailCount <= MAX_NAIL_COUNT && shape2NailCount <= MAX_NAIL_COUNT) return {};
        const ratio = shape1NailCount / shape2NailCount;
        if (ratio >= 1) {
            // shape1 has a larger or equal nail count than shape2
            shape1NailCount = MAX_NAIL_COUNT;
            shape2NailCount = MAX_NAIL_COUNT / ratio;
        } else {
            shape2NailCount = MAX_NAIL_COUNT;
            shape1NailCount = MAX_NAIL_COUNT * ratio;
        }
        return {
            shape1NailCount: shape1NailCount,
            shape2NailCount: shape2NailCount
        };
    };
}






function $840f8587212e5f96$export$8c6413e26c58b77c(...shapes) {
    if (!shapes.length) return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
    };
    const firstShapeRect = shapes[0].getBoundingRect();
    if (shapes.length === 1) return firstShapeRect;
    const rect = shapes.slice(1).reduce((rect, shape)=>{
        const shapeBoundingRect = shape.getBoundingRect();
        return {
            top: Math.min(rect.top, shapeBoundingRect.top),
            bottom: Math.max(rect.bottom, shapeBoundingRect.bottom),
            left: Math.min(rect.left, shapeBoundingRect.left),
            right: Math.max(rect.right, shapeBoundingRect.right),
            width: 0,
            height: 0
        };
    }, firstShapeRect);
    Object.assign(rect, {
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    });
    return rect;
}






function $52c18a720ac0380b$var$getOtherOrientationLabel(orientation) {
    return orientation === 'h' ? 'vertical' : 'horizontal';
}
function $52c18a720ac0380b$var$getOrientationLabel(orientation) {
    return orientation === 'h' ? 'horizontal' : 'vertical';
}
class $52c18a720ac0380b$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    static type = 'crosses';
    name = 'Crosses';
    id = 'crosses';
    controls = [
        {
            type: 'range',
            key: 'n',
            label: 'Nails per side',
            attr: {
                min: 2,
                max: 100,
                step: 1
            },
            defaultValue: 25,
            isStructural: true
        },
        {
            key: 'orientation',
            type: 'select',
            label: 'Orientation',
            defaultValue: 'v',
            options: [
                {
                    value: 'v',
                    label: "\u2195 Vertical"
                },
                {
                    value: 'h',
                    label: "\u2194 Horizontal"
                }
            ],
            affectsStepCount: false,
            isStructural: true
        },
        {
            key: 'sidesRotation',
            type: 'range',
            label: 'Sides rotation',
            attr: {
                min: -0.25,
                max: 0.25,
                step: 0.005,
                snap: '0'
            },
            displayValue: ({ sidesRotation: sidesRotation })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(sidesRotation),
            defaultValue: 0,
            affectsStepCount: false,
            isStructural: true
        },
        {
            key: 'fineControl',
            type: 'checkbox',
            label: 'Fine control',
            defaultValue: false,
            affectsStepCount: false,
            isStructural: true
        },
        {
            key: 'lockGap',
            type: 'checkbox',
            label: 'Lock horizontal/vertical gap',
            defaultValue: true,
            isStructural: true,
            affectsStepCount: false,
            show: ({ fineControl: fineControl })=>!fineControl
        },
        {
            key: 'lengthGap',
            type: 'range',
            label: ({ orientation: orientation, lockGap: lockGap })=>lockGap ? 'Gap' : `${(0, $96d8651f67c6b219$export$9a00dee1beb8f576)($52c18a720ac0380b$var$getOrientationLabel(orientation))} gap`,
            attr: {
                min: 0,
                max: 1,
                step: 0.01
            },
            displayValue: ({ lengthGap: lengthGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(lengthGap),
            defaultValue: 0.27,
            affectsStepCount: false,
            isStructural: true,
            show: ({ fineControl: fineControl })=>!fineControl
        },
        {
            key: 'widthGap',
            type: 'range',
            label: ({ orientation: orientation })=>`${(0, $96d8651f67c6b219$export$9a00dee1beb8f576)($52c18a720ac0380b$var$getOtherOrientationLabel(orientation))} gap`,
            attr: {
                min: 0,
                max: 5,
                step: 0.01
            },
            displayValue: ({ widthGap: widthGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(widthGap),
            defaultValue: 0.43,
            affectsStepCount: false,
            isStructural: true,
            show: ({ lockGap: lockGap, fineControl: fineControl })=>!fineControl && !lockGap
        },
        {
            key: 'center',
            type: 'group',
            label: "Center \u25C8",
            show: ({ fineControl: fineControl })=>fineControl,
            children: [
                {
                    key: 'centerLengthSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${$52c18a720ac0380b$var$getOrientationLabel(orientation)} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ centerLengthSpread: centerLengthSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerLengthSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'centerLengthGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${$52c18a720ac0380b$var$getOrientationLabel(orientation)} gap`,
                    attr: {
                        min: 0,
                        max: 5,
                        step: 0.01
                    },
                    displayValue: ({ centerLengthGap: centerLengthGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerLengthGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'symmetricCenter',
                    type: 'checkbox',
                    label: ({ orientation: orientation })=>`Symmetric ${$52c18a720ac0380b$var$getOtherOrientationLabel(orientation)} center`,
                    defaultValue: true,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'centerSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${$52c18a720ac0380b$var$getOtherOrientationLabel(orientation)} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ centerSpread: centerSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>symmetricCenter
                },
                {
                    key: 'centerWidthGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${$52c18a720ac0380b$var$getOtherOrientationLabel(orientation)} gap`,
                    attr: {
                        min: 0,
                        max: 5,
                        step: 0.01
                    },
                    displayValue: ({ centerWidthGap: centerWidthGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerWidthGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>symmetricCenter
                },
                {
                    key: 'centerStartSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${orientation === 'v' ? 'left' : 'up'} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ centerStartSpread: centerStartSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerStartSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>!symmetricCenter
                },
                {
                    key: 'centerStartGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${orientation === 'v' ? 'left' : 'up'} gap`,
                    attr: {
                        min: 0,
                        max: 5,
                        step: 0.01
                    },
                    displayValue: ({ centerStartGap: centerStartGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerStartGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>!symmetricCenter
                },
                {
                    key: 'centerEndSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${orientation === 'v' ? 'right' : 'down'} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ centerEndSpread: centerEndSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerEndSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>!symmetricCenter
                },
                {
                    key: 'centerEndGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Center ${orientation === 'v' ? 'right' : 'down'} gap`,
                    attr: {
                        min: 0,
                        max: 5,
                        step: 0.01
                    },
                    displayValue: ({ centerEndGap: centerEndGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(centerEndGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true,
                    show: ({ symmetricCenter: symmetricCenter })=>!symmetricCenter
                }
            ]
        },
        {
            key: 'edges',
            label: "Edges \u25C5 \u25BB",
            type: 'group',
            show: ({ fineControl: fineControl })=>fineControl,
            children: [
                {
                    key: 'edgesSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Edges ${$52c18a720ac0380b$var$getOrientationLabel(orientation)} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ edgesSpread: edgesSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(edgesSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'edgesGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Edges ${$52c18a720ac0380b$var$getOrientationLabel(orientation)} gap`,
                    attr: {
                        min: 0,
                        max: 1,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ edgesGap: edgesGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(edgesGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'edgesWidthSpread',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Edges ${$52c18a720ac0380b$var$getOtherOrientationLabel(orientation)} spread`,
                    attr: {
                        min: 0.2,
                        max: 5,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ edgesWidthSpread: edgesWidthSpread })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(edgesWidthSpread),
                    defaultValue: 1,
                    affectsStepCount: false,
                    isStructural: true
                },
                {
                    key: 'edgesWidthGap',
                    type: 'range',
                    label: ({ orientation: orientation })=>`Edges ${$52c18a720ac0380b$var$getOtherOrientationLabel(orientation)} gap`,
                    attr: {
                        min: 0,
                        max: 1,
                        step: 0.01,
                        snap: '1'
                    },
                    displayValue: ({ edgesWidthGap: edgesWidthGap })=>(0, $96d8651f67c6b219$export$f481ea230fad194b)(edgesWidthGap),
                    defaultValue: 0,
                    affectsStepCount: false,
                    isStructural: true
                }
            ]
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                colorCount: 2,
                color: '#ffffff',
                multicolorRange: 1,
                multicolorStart: 1,
                multicolorByLightness: true,
                minLightness: 40,
                maxLightness: 100,
                reverseColors: true
            },
            customControls: [
                {
                    key: 'setCenterColor',
                    label: 'Manually set center color',
                    defaultValue: false,
                    type: 'checkbox',
                    affectsNails: false,
                    affectsStepCount: false
                },
                {
                    key: 'centerColor',
                    type: 'color',
                    label: 'Center color',
                    defaultValue: '#ffd500',
                    show: ({ setCenterColor: setCenterColor })=>setCenterColor,
                    affectsNails: false,
                    affectsStepCount: false
                }
            ],
            exclude: [
                'repeatColors'
            ],
            maxColorCount: 2
        })
    ];
    getCalc({ size: size }) {
        const { n: n, orientation: orientation, margin: margin, lengthGap: verticalGapPercent, widthGap: widthGap, lockGap: lockGap, fineControl: fineControl, centerWidthGap: centerWidthGap, centerSpread: centerSpread, symmetricCenter: symmetricCenter, centerLengthGap: centerLengthGapPercent, centerLengthSpread: centerLengthSpreadPercent, centerStartGap: centerStartGap, centerStartSpread: centerStartSpread, centerEndGap: centerEndGap, centerEndSpread: centerEndSpread, edgesGap: edgesGap, edgesSpread: edgesSpread, edgesWidthGap: edgesWidthGap, edgesWidthSpread: edgesWidthSpread, sidesRotation: sidesRotation } = this.config;
        const center = (0, $b683a3137b30eaa9$export$c91255cadecfe081)(size);
        const isVertical = orientation === 'v';
        let height = (isVertical ? size[1] : size[0]) - 2 * margin;
        const maxVerticalGap = height * 0.8 / 3;
        let centerLengthGap = (fineControl ? centerLengthGapPercent : verticalGapPercent) * maxVerticalGap;
        let sideLengthGap = fineControl ? (height * 0.8 - verticalGapPercent * maxVerticalGap) * edgesGap / 2 : verticalGapPercent * maxVerticalGap;
        const centerLengthSpread = fineControl ? centerLengthSpreadPercent : 1;
        // lineLength is for the two center vertical lines
        let lineLength = (height - (centerLengthGap + 2 * sideLengthGap)) / (2 * (fineControl ? centerLengthSpread : 1) + 2 * (fineControl ? edgesSpread : 1));
        let widthShift = 0;
        // sideLineLength are the two vertical lines at the edges - top and bottom
        let sideLineLength = fineControl ? lineLength * edgesSpread : lineLength;
        const orientationDimensionIndex = isVertical ? 0 : 1;
        function getBoundingRect() {
            const getSides = (widthGap, sideLength, overrides)=>{
                return [
                    center[orientationDimensionIndex] - (overrides?.gap1 ?? widthGap) * lineLength - (overrides?.length1 ?? sideLength) + widthShift,
                    center[orientationDimensionIndex] + (overrides?.gap2 ?? widthGap) * lineLength + (overrides?.length2 ?? sideLength) + widthShift
                ];
            };
            const edges = fineControl ? null : getSides(lockGap ? verticalGapPercent : widthGap, lineLength);
            const [centerStart, centerEnd] = fineControl ? getSides(centerWidthGap, centerSpread * lineLength, symmetricCenter ? undefined : {
                gap1: centerStartGap,
                gap2: centerEndGap,
                length1: centerStartSpread * lineLength,
                length2: centerEndSpread * lineLength
            }) : edges;
            const [edgesWidthStart, edgesWidthEnd] = fineControl ? getSides(edgesWidthGap, edgesWidthSpread * lineLength) : edges;
            const [rotatedEdgesWidthStart, rotatedEdgesWidthEnd] = getSides(edgesWidthGap, Math.cos(sidesRotation * (0, $e2b746416d2bf62b$export$f4644083ce95e7e3)) * (fineControl ? edgesWidthSpread : 1) * lineLength);
            const length = 2 * (sideLineLength + lineLength * centerLengthSpread + sideLengthGap) + centerLengthGap;
            const lengthStart = center[isVertical ? 1 : 0] - length / 2;
            const distanceToFirstEdge = centerLengthGap / 2 + lineLength * centerLengthSpread + sideLengthGap / 2 + Math.sin(sidesRotation * (0, $e2b746416d2bf62b$export$f4644083ce95e7e3)) * lineLength * edgesWidthSpread;
            const [rotatedEdgesLegthStart, rotatedEdgesLengthEnd] = [
                center[isVertical ? 1 : 0] - distanceToFirstEdge,
                center[isVertical ? 1 : 0] + distanceToFirstEdge
            ];
            const widthStart = Math.min(rotatedEdgesWidthStart, centerStart);
            const widthEnd = Math.max(rotatedEdgesWidthEnd, centerEnd);
            const heightStart = Math.min(lengthStart, rotatedEdgesLegthStart);
            const heightEnd = Math.max(lengthStart + length, rotatedEdgesLengthEnd);
            return {
                lengthStart: lengthStart,
                edgesWidthStart: edgesWidthStart,
                edgesWidthEnd: edgesWidthEnd,
                centerStart: centerStart,
                centerEnd: centerEnd,
                width: widthEnd - widthStart,
                widthStart: widthStart,
                widthEnd: widthEnd,
                heightStart: heightStart,
                height: heightEnd - heightStart
            };
        }
        let boundingRect = getBoundingRect();
        const sizeWithoutMargins = size.map((v)=>v - 2 * margin);
        const sizeWidth = sizeWithoutMargins[orientationDimensionIndex];
        const sizeHeight = sizeWithoutMargins[isVertical ? 1 : 0];
        const sizeRatio = Math.min(sizeWidth / boundingRect.width, sizeHeight / boundingRect.height);
        const centeredWidthStart = center[orientationDimensionIndex] - boundingRect.width / 2;
        let shouldRefreshBoundingRect = false;
        const newWidthShift = Math.trunc(centeredWidthStart) - Math.trunc(boundingRect.widthStart);
        if (newWidthShift !== widthShift) {
            widthShift = newWidthShift;
            shouldRefreshBoundingRect = true;
        }
        if (sizeRatio < 1) {
            height *= sizeRatio;
            centerLengthGap *= sizeRatio;
            lineLength *= sizeRatio;
            widthShift *= sizeRatio;
            sideLineLength *= sizeRatio;
            shouldRefreshBoundingRect = true;
            sideLengthGap *= sizeRatio;
        }
        if (shouldRefreshBoundingRect) boundingRect = getBoundingRect();
        const { lengthStart: lengthStart, width: width } = boundingRect;
        function getVerticalPosition(index) {
            let lineStart = lengthStart;
            if (index === 0) return {
                vertical: lineStart,
                horizontal: -1,
                length: sideLineLength
            };
            lineStart += sideLengthGap + sideLineLength;
            if (index === 1) return {
                vertical: lineStart,
                horizontal: lineStart - sideLengthGap / 2,
                length: lineLength * centerLengthSpread
            };
            lineStart += lineLength * centerLengthSpread + centerLengthGap;
            if (index === 2) return {
                vertical: lineStart,
                horizontal: lineStart - centerLengthGap / 2,
                length: lineLength * centerLengthSpread
            };
            lineStart += lineLength * centerLengthSpread + sideLengthGap;
            return {
                vertical: lineStart,
                horizontal: lineStart - sideLengthGap / 2,
                length: sideLineLength
            };
        }
        const verticalPositions = (0, $c190f550efa69733$export$7f1ebd623f131021)(4, getVerticalPosition);
        const verticalCenter = (isVertical ? center[0] : center[1]) + widthShift;
        function getVerticalLine(index) {
            const { vertical: vertical, length: length } = verticalPositions[index];
            const from = [
                verticalCenter,
                vertical
            ];
            const to = [
                verticalCenter,
                vertical + length
            ];
            if (!isVertical) {
                from.reverse();
                to.reverse();
            }
            const lineStartIndex = index * n;
            return new (0, $281c51d967a471db$export$17d680238e50603e)({
                from: from,
                to: to,
                n: n,
                getUniqueKey: (k)=>lineStartIndex + k
            });
        }
        const verticalLines = (0, $c190f550efa69733$export$7f1ebd623f131021)(4, getVerticalLine);
        const getRowLineRotationConfig = (row, index)=>{
            if (!sidesRotation || row === 1) return null;
            let rotation = sidesRotation;
            if (!isVertical) rotation *= -1;
            if (index === 1 && row === 0 || index === 0 && row === 2) rotation *= -1;
            return {
                rotation: rotation,
                rotationCenter: 'to'
            };
        };
        function getHorizontalLineLength(row, index) {
            if (!fineControl) return lineLength;
            if (row === 1) {
                if (symmetricCenter) return lineLength * centerSpread;
                return lineLength * (index === 0 ? centerStartSpread : centerEndSpread);
            }
            return lineLength * edgesWidthSpread;
        }
        const horizontalLines = (0, $c190f550efa69733$export$7f1ebd623f131021)(3, (row)=>{
            const horizontalStart = row === 1 ? boundingRect.centerStart : boundingRect.edgesWidthStart;
            const horizontalEnd = row === 1 ? boundingRect.centerEnd : boundingRect.edgesWidthEnd;
            const rowTop = verticalPositions[row + 1].horizontal;
            // In case of fine control and non-symmetric center, the center width lines (potentially) have different sizes
            const startLength = getHorizontalLineLength(row, 0);
            const endLength = getHorizontalLineLength(row, 1);
            const horizontalLinesIndexStart = n * 4;
            const firstRowIndexStart = horizontalLinesIndexStart + n * row * 2;
            const secondRowIndexStart = horizontalLinesIndexStart + n * (row * 2 + 1);
            return [
                new (0, $281c51d967a471db$export$17d680238e50603e)({
                    ...getRowLineRotationConfig(row, 0),
                    ...isVertical ? {
                        from: [
                            horizontalStart,
                            rowTop
                        ],
                        to: [
                            horizontalStart + startLength,
                            rowTop
                        ],
                        n: n
                    } : {
                        from: [
                            rowTop,
                            horizontalStart
                        ],
                        to: [
                            rowTop,
                            horizontalStart + startLength
                        ],
                        n: n
                    },
                    getUniqueKey: (k)=>firstRowIndexStart + k
                }),
                new (0, $281c51d967a471db$export$17d680238e50603e)({
                    ...getRowLineRotationConfig(row, 1),
                    ...isVertical ? {
                        from: [
                            horizontalEnd,
                            rowTop
                        ],
                        to: [
                            horizontalEnd - endLength,
                            rowTop
                        ],
                        n: n
                    } : {
                        from: [
                            rowTop,
                            horizontalEnd
                        ],
                        to: [
                            rowTop,
                            horizontalEnd - endLength
                        ],
                        n: n
                    },
                    getUniqueKey: (k)=>secondRowIndexStart + k
                })
            ];
        });
        return {
            verticalLines: verticalLines,
            horizontalLines: horizontalLines,
            width: width,
            height: height,
            horizontalLinesIndexStart: n * 4
        };
    }
    getAspectRatio() {
        const { verticalLines: verticalLines, horizontalLines: horizontalLines } = this.calc ?? this.getCalc({
            size: [
                100,
                100
            ]
        });
        const boundingRect = (0, $840f8587212e5f96$export$8c6413e26c58b77c)(...verticalLines.concat(horizontalLines.flat()));
        return boundingRect.width / boundingRect.height;
    }
    *connectLines(controller, { verticalLineIndex: verticalLineIndex, row: row, isReverse: isReverse = false, color: color }) {
        const { n: n } = this.config;
        const { verticalLines: verticalLines, horizontalLines: horizontalLines } = this.calc;
        const rowLines = horizontalLines[row];
        controller.startLayer({
            color: color
        });
        controller.goto(rowLines[0].getNailIndex(0));
        let alternate = false;
        let side;
        for(let i = 0; i < n; i++){
            if (side != null) {
                controller.stringTo(rowLines[side].getNailIndex(i));
                yield;
            }
            controller.stringTo(verticalLines[verticalLineIndex].getNailIndex(isReverse ? i : n - 1 - i));
            yield;
            side = alternate ? 0 : 1;
            controller.stringTo(rowLines[side].getNailIndex(i));
            yield;
            alternate = !alternate;
        }
    }
    *drawStrings(controller) {
        const { setCenterColor: setCenterColor, centerColor: centerColor } = this.config;
        const connections = [
            [
                0,
                0
            ],
            [
                0,
                1
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                3,
                2
            ],
            [
                3,
                1
            ],
            [
                2,
                1
            ],
            [
                2,
                2
            ],
            [
                1,
                2
            ],
            [
                2,
                0
            ]
        ];
        for (const [verticalLineIndex, horizontalRow] of connections){
            const isReverse = horizontalRow < verticalLineIndex;
            let color;
            if (setCenterColor) {
                const isCenter = (verticalLineIndex === 1 || verticalLineIndex === 2) && horizontalRow === 1;
                if (isCenter) color = centerColor;
            }
            if (!color) color = this.color.getColor(horizontalRow > verticalLineIndex || verticalLineIndex - horizontalRow > 1 ? 1 : 0);
            yield* this.connectLines(controller, {
                verticalLineIndex: verticalLineIndex,
                row: horizontalRow,
                isReverse: isReverse,
                color: color
            });
        }
    }
    getStepCount() {
        const { n: n } = this.config;
        return 10 * (3 * n - 1);
    }
    getNailCount() {
        return this.config.n * 10;
    }
    getNails(precision) {
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        this.calc.verticalLines.forEach((line, i)=>line.addNails(nails));
        this.calc.horizontalLines.forEach((sideLines)=>{
            for (const line of sideLines)line.addNails(nails);
        });
        return nails;
    }
    thumbnailConfig = (config)=>({
            n: Math.min(10, config.n)
        });
}







const $dbc1b13ecf21fc92$var$leavesCommonControls = [
    {
        key: 'angle',
        label: 'Layer angle',
        defaultValue: 0.088,
        displayValue: ({ angle: angle })=>`${(0, $e2b746416d2bf62b$export$a3992db8dd0fd9e6)(180 * angle / 3, 2)}\xb0`,
        type: 'range',
        attr: {
            min: 0.02,
            max: 0.15,
            step: 0.001
        },
        isStructural: true
    },
    {
        key: 'maxDensity',
        label: 'Max density',
        defaultValue: 5,
        type: 'range',
        attr: {
            min: 1,
            max: 20,
            step: 0.01
        },
        isStructural: true
    },
    {
        key: 'rotation',
        label: 'Rotation',
        defaultValue: 0,
        type: 'range',
        attr: {
            min: 0,
            max: 1,
            step: 0.0025
        },
        displayValue: ({ rotation: rotation })=>(0, $96d8651f67c6b219$export$b5632b5e53e50dc)(rotation),
        isStructural: true,
        affectsStepCount: false
    }
];
var $dbc1b13ecf21fc92$export$2e2bcd8739ae039 = $dbc1b13ecf21fc92$var$leavesCommonControls;





function* $2d2ca01e62aa4a00$export$4c65d5dcf353da68(countPerSide, sides = [
    0,
    1
]) {
    let alternate = false;
    for(let index = 0; index < countPerSide; index++){
        yield {
            side: sides[alternate ? 1 : 0],
            index: index
        };
        yield {
            side: sides[alternate ? 0 : 1],
            index: index
        };
        alternate = !alternate;
    }
}
function $2d2ca01e62aa4a00$export$a5b6fb2bea486e8b(countPerSide) {
    return countPerSide * 2;
}




class $14bb238598f616ed$export$2e2bcd8739ae039 extends (0, $ed62eab3f3d51c1d$export$2e2bcd8739ae039) {
    getInnerRotationParams({ sides: sides, baseSideSize: baseSideSize }) {
        const { angle: angle, maxDensity: maxDensity } = this.config;
        const key = [
            sides,
            maxDensity,
            baseSideSize,
            angle
        ].join('_');
        const cached = this.getInnerRotationParams[key];
        if (cached) return cached;
        const piSides = Math.PI / sides;
        const interiorAngle = (sides - 2) * Math.PI / sides;
        const layerAngleChange = Math.atan((1 - 2 * angle) / Math.tan(interiorAngle / 2));
        const layerAngle = piSides - layerAngleChange;
        const sizeRatio = Math.cos(piSides) / Math.cos(-layerAngleChange);
        const depth = Math.max(1, Math.ceil(Math.log(maxDensity / (baseSideSize * angle)) / Math.log(sizeRatio)));
        const params = {
            layerAngle: layerAngle,
            sizeRatio: sizeRatio,
            depth: depth
        };
        this.getInnerRotationParams[key] = params;
        return params;
    }
    getNailIndex(tile, side, index) {
        return (tile.nailIndexStart ?? 0) + side + index * tile.polygon.config.sides;
    }
    *drawSpiralsOnly(controller) {
        const { tiles: tiles } = this.calc;
        controller.startLayer({
            color: this.color.getColor(0),
            name: '1'
        });
        controller.goto(0);
        for(let tile = 0; tile < tiles.length; tile++)yield* this.drawMonochromeTile(controller, tiles[tile]);
    }
    *connectSides(controller, tileIndex, fromSide, toSide) {
        let isFirst = true;
        const tile = this.calc.tiles[tileIndex];
        for (const { side: side, index: index } of (0, $2d2ca01e62aa4a00$export$4c65d5dcf353da68)(tile.depth, [
            fromSide,
            toSide
        ]))if (isFirst) {
            controller.goto(this.getNailIndex(tile, side, index));
            isFirst = false;
        } else yield controller.stringTo(this.getNailIndex(tile, side, index));
    }
    getColor(tile, side) {
        return this.color.getColor(tile % 2 ? side === 1 ? 2 : side === 2 ? 1 : side : side);
    }
    *drawTile(controller, tileIndex, excludedSides) {
        const tile = this.calc.tiles[tileIndex];
        for(let side = 0; side < tile.polygon.config.sides; side++){
            if (excludedSides?.has(side)) continue;
            controller.startLayer({
                name: side.toString(),
                color: this.getColor(tileIndex, side)
            });
            yield* this.connectSides(controller, tileIndex, side, (side + 1) % tile.polygon.config.sides);
        }
    }
    *drawMonochromeTile(controller, tile) {
        const startIndex = tile.nailIndexStart ?? 0;
        controller.goto(startIndex);
        const nailsPerTile = tile.polygon.config.sides * tile.depth;
        for(let i = 1; i < nailsPerTile; i++){
            if (!(i % tile.polygon.config.sides)) yield controller.stringTo(startIndex + i - tile.polygon.config.sides);
            yield controller.stringTo(startIndex + i);
        }
    }
    *drawTiles(controller, excludedSides) {
        for(let tile = 0; tile < this.calc.tiles.length; tile++)yield* this.drawTile(controller, tile, excludedSides);
    }
    *drawLeavesTile(controller, tile) {
        const startIndex = tile.polygon.getSideNailIndex(0);
        controller.goto(startIndex);
        const nailsPerTile = tile.polygon.config.sides * tile.depth;
        for(let i = 1; i < nailsPerTile; i++){
            if (!(i % tile.polygon.config.sides)) yield controller.stringTo(startIndex + i - tile.polygon.config.sides);
            yield controller.stringTo(startIndex + i);
        }
    }
    *connectTileSides(controller, tile, fromSide, toSide) {
        let isFirst = true;
        for (const { side: side, index: index } of (0, $2d2ca01e62aa4a00$export$4c65d5dcf353da68)(tile.depth, [
            fromSide,
            toSide
        ]))if (isFirst) {
            controller.goto(this.getNailIndex(tile, side, index));
            isFirst = false;
        } else yield controller.stringTo(this.getNailIndex(tile, side, index));
    }
    *drawStrings(controller) {
        if (this.config.isMultiColor && this.config.colorCount > 1) yield* this.drawTiles(controller);
        else yield* this.drawSpiralsOnly(controller);
    }
    getStepCount(options) {
        const { tiles: tiles } = this.calc ?? this.getCalc(options);
        return tiles.reduce((stepCount, tile)=>stepCount + (this.config.isMultiColor && this.config.colorCount > 1 ? tile.polygon.config.sides * (tile.depth * 2 - 1) : tile.depth * (tile.polygon.config.sides + 1) - 2), 0);
    }
    getPolygonsForTile(tile) {
        const sides = tile.polygon.config.sides;
        const { layerAngle: layerAngle, sizeRatio: sizeRatio, depth: nailsPerSide } = this.getInnerRotationParams({
            sides: sides,
            baseSideSize: tile.polygon.sideSize
        });
        const polygons = [
            tile.polygon
        ].concat((0, $c190f550efa69733$export$7f1ebd623f131021)(nailsPerSide - 1, (i)=>{
            const layer = i + 1;
            const polygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                sides: sides,
                nailsPerSide: 2,
                rotation: (tile.polygon.config.rotation ?? 0) + (tile.direction ?? 1) * layerAngle * layer / (0, $e2b746416d2bf62b$export$f4644083ce95e7e3),
                center: tile.polygon.center,
                radius: tile.polygon.radius * Math.pow(sizeRatio, layer),
                getUniqueKey: (k)=>(tile.nailIndexStart ?? 0) + sides * layer + k
            });
            return polygon;
        }));
        return polygons;
    }
    getNails(precision) {
        const { tiles: tiles } = this.calc;
        const nails = new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)(precision);
        tiles.forEach((tile)=>{
            const polygons = this.getPolygonsForTile(tile);
            polygons.forEach((polygon)=>polygon.addNails(nails));
        });
        return nails;
    }
    thumbnailConfig = {
        maxDensity: 1
    };
}


class $b3d1160eb7b4a3e4$export$2e2bcd8739ae039 extends (0, $14bb238598f616ed$export$2e2bcd8739ae039) {
    static type = 'hexagon_spades';
    id = 'hexagon_spades';
    name = 'Hexagon Spades';
    controls = [
        ...(0, $dbc1b13ecf21fc92$export$2e2bcd8739ae039),
        {
            key: 'mirrorTiling',
            label: 'Mirror tiling',
            defaultValue: true,
            type: 'checkbox',
            isStructural: true,
            affectsStepCount: false
        },
        {
            key: 'crossWeave',
            label: 'Cross weave',
            defaultValue: false,
            type: 'checkbox',
            isStructural: false
        },
        {
            key: 'withSides',
            label: 'With sides',
            defaultValue: true,
            type: 'checkbox',
            isStructural: false
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                colorCount: 3,
                color: '#ffffff',
                multicolorRange: 88,
                multicolorStart: 180,
                multicolorByLightness: true,
                minLightness: 60,
                maxLightness: 64,
                reverseColors: true
            },
            maxColorCount: 10
        })
    ];
    getCalc({ size: size }) {
        const { margin: margin, rotation: rotation, maxDensity: maxDensity, angle: angle, mirrorTiling: mirrorTiling } = this.config;
        const patternPolygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            size: size,
            fitSize: true,
            margin: margin,
            nailsPerSide: 2,
            rotation: rotation
        });
        const interiorAngle = 1 * Math.PI / 3;
        const centerHelperPolygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            radius: patternPolygon.radius / (2 * Math.cos(interiorAngle / 2)),
            nailsPerSide: 2,
            rotation: rotation + 1 / 12,
            center: patternPolygon.center
        });
        const { depth: depth } = this.getInnerRotationParams({
            sides: 3,
            baseSideSize: patternPolygon.sideSize
        });
        const nailsPerPolygon = depth * 3;
        const tiles = (0, $c190f550efa69733$export$7f1ebd623f131021)(6, (i)=>{
            const nailIndexStart = nailsPerPolygon * i;
            return {
                polygon: new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                    radius: centerHelperPolygon.sideSize,
                    sides: 3,
                    nailsPerSide: 2,
                    center: centerHelperPolygon.getSidePoint({
                        side: i,
                        index: 0
                    }),
                    rotation: rotation + 1 / centerHelperPolygon.config.sides * (i + 1),
                    getUniqueKey: i ? (k)=>k + nailsPerPolygon * i : undefined
                }),
                depth: depth,
                direction: mirrorTiling ? i % 2 ? -1 : 1 : 1,
                nailIndexStart: nailIndexStart
            };
        });
        return {
            tiles: tiles
        };
    }
    #getColor(tile, side) {
        return this.color.getColor(tile % 2 ? side === 1 ? 2 : side === 2 ? 1 : side : side);
    }
    *#drawAll(controller) {
        const { withSides: withSides } = this.config;
        const { tiles: tiles } = this.calc;
        for(let tileIndex = 0; tileIndex < tiles.length; tileIndex++){
            const sideIndex = 1;
            controller.startLayer({
                name: sideIndex.toString(),
                color: this.#getColor(tileIndex, sideIndex)
            });
            const nextTile = tiles[(tileIndex + 1) % tiles.length];
            const nextSide = (sideIndex + 1) % 3;
            const nextUpperSide = nextSide;
            const nextTileSide = sideIndex - 1;
            const tile = tiles[tileIndex];
            controller.goto(this.getNailIndex(tile, nextSide, 0));
            yield controller.stringTo(this.getNailIndex(tile, sideIndex, 0));
            for(let i = 1; i < tile.depth; i++){
                yield controller.stringTo(this.getNailIndex(tile, sideIndex, i));
                yield controller.stringTo(this.getNailIndex(tile, nextSide, i));
                yield controller.stringTo(this.getNailIndex(nextTile, nextUpperSide, i));
                yield controller.stringTo(this.getNailIndex(nextTile, nextTileSide, i));
                yield controller.stringTo(this.getNailIndex(tile, sideIndex, i));
            // stringTo tile.side(i) to tile.nextSide(i), then to nextTile.nextSide(i) then tile.side(i).
            }
            if (withSides) {
                controller.startLayer({
                    name: 'Sides',
                    color: this.color.getColor(0)
                });
                yield* this.connectSides(controller, tileIndex, 1, 0);
            } else // Close the outward-pointing leaves, since there are no sides to close them
            for(let i = tile.depth - 1; i >= 0; i--)yield controller.stringTo(this.getNailIndex(nextTile, nextTileSide, i));
        }
    }
    *drawStrings(controller) {
        if (this.config.crossWeave) yield* this.#drawAll(controller);
        else if (this.config.isMultiColor && this.config.colorCount > 1 || !this.config.withSides) yield* this.drawTiles(controller, this.config.withSides ? null : new Set([
            0
        ]));
        else yield* this.drawSpiralsOnly(controller);
    }
    getStepCount(options) {
        const { crossWeave: crossWeave, withSides: withSides } = this.config;
        const { tiles: tiles } = this.calc ?? this.getCalc(options);
        const nailsPerSide = tiles[0].depth;
        const nailsPerTile = nailsPerSide * 3;
        if (crossWeave) return tiles.length * ((nailsPerSide - 1) * 5 + (withSides ? nailsPerSide * 2 - 1 : nailsPerSide) + 1);
        else if (this.config.isMultiColor && this.config.colorCount > 1 || !this.config.withSides) return tiles.length * (3 - (withSides ? 0 : 1)) * (nailsPerSide * 2 - 1);
        else return tiles.length * Math.floor((nailsPerTile - 1) * (1 + 1 / 3));
    }
    getAspectRatio({ size: size }) {
        const { margin: margin, rotation: rotation } = this.config;
        const patternPolygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            size: size,
            fitSize: true,
            margin: margin,
            nailsPerSide: 2,
            rotation: rotation
        });
        return patternPolygon.getAspectRatio();
    }
}







class $fe8a0c0a19864006$export$2e2bcd8739ae039 extends (0, $14bb238598f616ed$export$2e2bcd8739ae039) {
    static type = 'star_of_david';
    id = 'star_of_david';
    name = 'Star of David';
    controls = [
        ...(0, $dbc1b13ecf21fc92$export$2e2bcd8739ae039),
        {
            key: 'mirrorTiling',
            label: 'Mirror tiling',
            defaultValue: false,
            type: 'checkbox',
            isStructural: true,
            affectsStepCount: false
        },
        (0, $44d9dab6555abf73$export$2e2bcd8739ae039).getConfig({
            defaults: {
                isMultiColor: true,
                colorCount: 6,
                color: '#ffffff',
                multicolorStart: 45,
                multicolorRange: 1,
                multicolorByLightness: true,
                minLightness: 60,
                maxLightness: 100,
                reverseColors: false
            },
            maxColorCount: 6
        })
    ];
    defaultValues = {
        maxDensity: 2.66,
        angle: 0.063
    };
    getCalc({ size: size }) {
        const { margin: margin, rotation: rotation, mirrorTiling: mirrorTiling } = this.config;
        const outerHexagon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            size: size,
            fitSize: true,
            margin: margin,
            nailsPerSide: 2,
            rotation: 1 / 12 + rotation
        });
        const hexagon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            radius: outerHexagon.radius / (2 * Math.cos(Math.PI / 6)),
            center: outerHexagon.center,
            nailsPerSide: 2,
            rotation: rotation
        });
        const triangleRadius = hexagon.sideSize / (2 * Math.cos(Math.PI / 6));
        const trianglesCenterHexagon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            radius: hexagon.getApothem() + triangleRadius / 2,
            center: outerHexagon.center,
            nailsPerSide: 2,
            rotation: 1 / 12 + rotation
        });
        const { depth: hexagonDepth } = this.getInnerRotationParams({
            sides: 6,
            baseSideSize: hexagon.sideSize
        });
        const { depth: triangleDepth } = this.getInnerRotationParams({
            sides: 3,
            baseSideSize: hexagon.sideSize
        });
        const trianglesStartIndex = hexagonDepth * 6;
        const nailsPerTriangle = triangleDepth * 3;
        const triangles = (0, $c190f550efa69733$export$7f1ebd623f131021)(6, (i)=>new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
                sides: 3,
                center: trianglesCenterHexagon.getSidePoint({
                    side: i,
                    index: 0
                }),
                radius: triangleRadius,
                nailsPerSide: 2,
                rotation: rotation + i * 1 / 6,
                getUniqueKey: (k)=>trianglesStartIndex + nailsPerTriangle * i + k
            }));
        const tiles = [
            {
                polygon: hexagon,
                depth: hexagonDepth
            },
            ...triangles.map((polygon, i)=>({
                    polygon: polygon,
                    depth: triangleDepth,
                    direction: mirrorTiling ? 1 : -1,
                    nailIndexStart: trianglesStartIndex + nailsPerTriangle * i
                }))
        ];
        return {
            tiles: tiles
        };
    }
    getColor(tile, side) {
        if (tile) return side === 2 ? this.color.getColor(tile - 1) : this.color.getColor(this.config.colorCount === 2 ? tile : tile + side);
        return this.color.getColor(tile % 2 ? side === 1 ? 2 : side === 2 ? 1 : side : side);
    }
    getAspectRatio({ size: size }) {
        const { margin: margin, rotation: rotation } = this.config;
        const patternPolygon = new (0, $cf574edfbef72605$export$2e2bcd8739ae039)({
            sides: 6,
            size: size,
            fitSize: true,
            margin: margin,
            nailsPerSide: 2,
            rotation: rotation
        });
        return patternPolygon.getAspectRatio();
    }
    testStepCountConfig = [
        {
            isMultiColor: false,
            colorCount: 1
        }
    ];
}


const $3eff4f8917d513a6$var$patternTypes = [
    (0, $d7beb6e24667d074$export$2e2bcd8739ae039),
    (0, $62acf81e555101f1$export$2e2bcd8739ae039),
    (0, $2bf6005aa150cc2c$export$2e2bcd8739ae039),
    (0, $b45c5717991b3431$export$2e2bcd8739ae039),
    (0, $8786bcda2cdcea99$export$2e2bcd8739ae039),
    (0, $51855848c5e96fff$export$2e2bcd8739ae039),
    (0, $0421ce1534490d1b$export$2e2bcd8739ae039),
    (0, $0cd4a0f8cb92c220$export$2e2bcd8739ae039),
    (0, $24f8ffaba9bb597d$export$2e2bcd8739ae039),
    (0, $36e817b73108416a$export$2e2bcd8739ae039),
    (0, $13d3b02459490214$export$2e2bcd8739ae039),
    (0, $324d244b6e96daed$export$2e2bcd8739ae039),
    (0, $697ac479630237ad$export$2e2bcd8739ae039),
    (0, $0f5f4bf46951eedf$export$2e2bcd8739ae039),
    (0, $8c28f16f24dd1c79$export$2e2bcd8739ae039),
    (0, $b533ea359183b19e$export$2e2bcd8739ae039),
    (0, $52c18a720ac0380b$export$2e2bcd8739ae039),
    (0, $b3d1160eb7b4a3e4$export$2e2bcd8739ae039),
    (0, $fe8a0c0a19864006$export$2e2bcd8739ae039)
];
var $3eff4f8917d513a6$export$2e2bcd8739ae039 = $3eff4f8917d513a6$var$patternTypes;



function $92270d8b7d92e411$export$15be7981f451f84d(type) {
    let Pattern = (0, $3eff4f8917d513a6$export$2e2bcd8739ae039).find(({ type: _type })=>_type === type);
    if (!Pattern) throw new Error(`Unknown pattern type, "${type}"!`);
    // @ts-ignore
    return new Pattern();
}
function $92270d8b7d92e411$export$1b06808e3c79c7e0() {
    // @ts-ignore
    const patterns = (0, $3eff4f8917d513a6$export$2e2bcd8739ae039).map((PatternType)=>new PatternType());
    return patterns;
}
function $92270d8b7d92e411$export$ebb1a6b9e8c15cc2(patternId) {
    let pattern = (0, $3eff4f8917d513a6$export$2e2bcd8739ae039).find(({ type: type })=>type === patternId);
    if (pattern) // @ts-ignore
    return new pattern();
    else return (0, $00643d12b3a54506$export$2e2bcd8739ae039).getPatternByID(patternId);
}


const $d8f8628a77747326$var$MAX_FLOAT_DECIMALS = 6;
function $d8f8628a77747326$export$fa8157df3262779b(pattern) {
    const { defaultConfig: defaultConfig, config: config } = pattern;
    const nonDefaultConfigValues = Object.entries(config).map(([key, value])=>{
        if (value === defaultConfig[key]) return null;
        if (typeof value === 'boolean') return `!${value ? 1 : 0}`;
        if (typeof value === 'number') return parseFloat(value.toFixed($d8f8628a77747326$var$MAX_FLOAT_DECIMALS));
        return value;
    });
    while(nonDefaultConfigValues[nonDefaultConfigValues.length - 1] === null)nonDefaultConfigValues.pop();
    if (!nonDefaultConfigValues.length) return '';
    const serializedConfigValues = nonDefaultConfigValues.join('_').replace(/\_{2,}/g, (match)=>'~' + match.length + '_');
    return serializedConfigValues;
}
const $d8f8628a77747326$var$numberRegExp = /^\-?\d+(\.\d+)?$/;
const $d8f8628a77747326$var$booleanRegExp = /^(?:!)([01])$/;
function $d8f8628a77747326$export$39ef19ebad6081a3(pattern, serializedCofig) {
    const serializedConfigValues = serializedCofig.replace(/(?:~)(\d+)(?:_)/g, (_, commaCount)=>new Array(+commaCount).fill('_').join('')).split('_').map((v)=>{
        if (v === '') return null;
        if ($d8f8628a77747326$var$numberRegExp.test(v)) return parseFloat(v);
        const booleanMatch = v.match($d8f8628a77747326$var$booleanRegExp);
        if (booleanMatch) return booleanMatch[1] === '1';
        return v;
    });
    const configKeys = Object.keys(pattern.defaultConfig);
    return serializedConfigValues.reduce((config, serializedValue, i)=>{
        if (serializedValue !== null) {
            const key = configKeys[i];
            return {
                ...config,
                [key]: serializedValue
            };
        }
        return config;
    }, {});
}


function $2509ceef6c629a64$export$87dcc7060093bbda(pattern, { renderer: renderer, patternAsTemplate: patternAsTemplate = false } = {}) {
    const configQuery = pattern.isDefaultConfig ? undefined : (0, $d8f8628a77747326$export$fa8157df3262779b)(pattern);
    return `/?pattern=${!patternAsTemplate ? pattern.id : pattern.type}${configQuery ? `&config=${encodeURIComponent(configQuery)}` : ''}${renderer === 'svg' ? '&renderer=svg' : ''}`;
}
function $2509ceef6c629a64$export$e2de15bbd9edf9c6() {
    const queryParams = new URLSearchParams(document.location.search);
    return {
        pattern: queryParams.get('pattern'),
        config: queryParams.get('config'),
        name: queryParams.get('name'),
        renderer: queryParams.get('renderer') === 'svg' ? 'svg' : null,
        dialog: queryParams.get('dialog')
    };
}
function $2509ceef6c629a64$export$a2e7490059781fcf(params) {
    const urlParams = new URLSearchParams();
    for(const key in params){
        const value = params[key];
        if (value) urlParams.append(key, value);
    }
    return urlParams.toString();
}
function $2509ceef6c629a64$export$235d49e7d4705350() {
    return document.location.pathname.replace(/\/$/, '').replace(/^\//, '');
}



class $a244379bf8b3b658$var$Routing extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    #popStateListener;
    #currentRenderer = 'canvas';
    #currentDialog = null;
    #currentFolder = null;
    constructor(){
        super();
        const onPopState = this.#popStateListener = ({ state: state })=>{
            this.#updateFromState(state ?? {});
        };
        if (typeof window !== 'undefined') window.addEventListener('popstate', onPopState);
    }
    #updateFromState(state) {
        const { pattern: patternId, name: patternName, config: config, renderer: renderer = 'canvas', dialog: dialog, folder: folder } = state;
        const actualRenderer = renderer === 'svg' ? 'svg' : 'canvas';
        if (actualRenderer !== this.#currentRenderer) {
            this.#currentRenderer = actualRenderer;
            this.emit('renderer', actualRenderer);
        }
        if (patternId) {
            const pattern = (0, $92270d8b7d92e411$export$ebb1a6b9e8c15cc2)(patternId);
            if (pattern) {
                if (patternName) pattern.name = patternName;
                if (config) // @ts-ignore
                pattern.setConfig((0, $d8f8628a77747326$export$39ef19ebad6081a3)(pattern, config));
                this.emit('pattern', {
                    pattern: pattern,
                    renderer: actualRenderer
                });
            } else throw new Error(`Unknown pattern with ID "${patternId}".`);
        } else this.emit('main', null);
        if (dialog && dialog !== this.#currentDialog) this.navigateToDialog(dialog, false);
        else if (this.#currentDialog && !dialog) this.closeDialog(false);
        if (folder != this.#currentFolder) {
            this.emit('folder', this.#currentFolder = folder ?? 'design');
            this.#currentFolder = folder;
        }
    }
    init() {
        if (history.state?.patternId) this.#updateFromState(history.state);
        else {
            const queryParams = (0, $2509ceef6c629a64$export$e2de15bbd9edf9c6)();
            this.#updateFromState(queryParams);
        }
    }
    destroy() {
        window.removeEventListener('popstate', this.#popStateListener);
    }
    navigateToMain() {
        history.pushState({
            patternId: null
        }, 'String Art Studio', './');
        this.emit('main', null);
    }
    navigateToPattern(pattern, { renderer: renderer = 'canvas', replaceState: replaceState = false } = {}) {
        const configQuery = pattern.isDefaultConfig ? undefined : (0, $d8f8628a77747326$export$fa8157df3262779b)(pattern);
        const setHistoryState = (replaceState ? history.replaceState : history.pushState).bind(history);
        setHistoryState({
            pattern: pattern.id,
            config: configQuery,
            renderer: renderer,
            name: pattern.name
        }, pattern.name, (0, $2509ceef6c629a64$export$87dcc7060093bbda)(pattern, {
            renderer: renderer,
            patternAsTemplate: false
        }));
        if (!replaceState) this.emit('pattern', {
            pattern: pattern,
            renderer: renderer
        });
        if (this.#currentDialog) this.closeDialog(false);
        this.emit('folder', 'design');
    }
    navigateToFolder(folder) {
        this.#currentFolder = folder;
        history.pushState({
            ...history.state,
            folder: folder
        }, null, `/${folder === 'design' ? '' : folder}${document.location.search}`);
    }
    navigateToDialog(dialogId, pushState = true) {
        const params = (0, $2509ceef6c629a64$export$e2de15bbd9edf9c6)();
        if (this.#currentDialog) {
            if (this.#currentDialog != dialogId) {
                this.emit('dialogClosed', params.dialog);
                this.#currentDialog = null;
            } else return;
        }
        if (pushState) {
            if (dialogId) params.dialog = dialogId;
            else {
                if (!params.dialog) return;
                delete params.dialog;
            }
            history.pushState({
                ...params,
                folder: history.state.folder
            }, null, `/${history.state.folder === 'design' || !history.state.folder ? '' : history.state.folder}?${(0, $2509ceef6c629a64$export$a2e7490059781fcf)(params)}`);
        }
        if (dialogId) {
            this.#currentDialog = dialogId;
            this.emit('dialog', dialogId);
        }
    }
    closeDialog(setState = true) {
        if (this.#currentDialog) {
            this.emit('dialogClosed', this.#currentDialog);
            this.#currentDialog = null;
            if (setState) history.back();
        }
    }
}
const $a244379bf8b3b658$var$routing = new $a244379bf8b3b658$var$Routing();
var $a244379bf8b3b658$export$2e2bcd8739ae039 = $a244379bf8b3b658$var$routing;


const $174f2c93f6348ee5$var$promptDialogId = 'prompt_dialog';
let $174f2c93f6348ee5$var$closeDialog;
function $174f2c93f6348ee5$export$195ba6d62321b933({ value: value, dialogId: dialogId, ...options }) {
    let dialog = document.querySelector(`#${$174f2c93f6348ee5$var$promptDialogId}`);
    if (!dialog) {
        dialog = document.createElement('input-dialog');
        dialog.id = $174f2c93f6348ee5$var$promptDialogId;
        document.body.appendChild(dialog);
    }
    [
        'title',
        'description',
        'submit',
        'cancel',
        'type',
        'submitIcon'
    ].forEach((attr)=>{
        if (options[attr] != null && options[attr] !== '') dialog.setAttribute(getAttributeForProp(attr), options[attr]);
        else dialog.removeAttribute(attr);
    });
    (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToDialog(dialogId);
    $174f2c93f6348ee5$var$closeDialog = ()=>{
        dialog.close();
        $174f2c93f6348ee5$var$closeDialog = null;
    };
    return dialog.show(value).finally(()=>{
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).closeDialog();
    });
    function getAttributeForProp(prop) {
        switch(prop){
            case 'title':
                return 'dialog-title';
            case 'submitIcon':
                return 'submit-icon';
            default:
                return prop;
        }
    }
}
const $174f2c93f6348ee5$var$CONFIRM_DIALOG_ID = 'confirm_dialog';
function $174f2c93f6348ee5$export$715f9d76bb8c1fea(options) {
    let dialog = document.querySelector(`#${$174f2c93f6348ee5$var$CONFIRM_DIALOG_ID}`);
    if (!dialog) {
        dialog = document.createElement('confirm-dialog');
        dialog.id = $174f2c93f6348ee5$var$CONFIRM_DIALOG_ID;
        document.body.appendChild(dialog);
    }
    [
        'title',
        'description',
        'submit',
        'cancel',
        'type'
    ].forEach((attr)=>{
        if (options[attr] != null && options[attr] !== '') dialog.setAttribute(attr === 'title' ? 'dialog-title' : attr, options[attr]);
        else dialog.removeAttribute(attr);
    });
    (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToDialog(options.dialogId);
    $174f2c93f6348ee5$var$closeDialog = ()=>{
        dialog.close();
        $174f2c93f6348ee5$var$closeDialog = null;
    };
    return dialog.show().finally(()=>{
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).closeDialog();
    });
}
(0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('dialogClosed', ()=>{
    $174f2c93f6348ee5$var$closeDialog?.();
});







const $0649237e9259f2a7$var$SVG_NS = 'http://www.w3.org/2000/svg';
class $0649237e9259f2a7$export$2e2bcd8739ae039 extends (0, $66d8ae1974721b90$export$2e2bcd8739ae039) {
    svg;
    backgroundGroup;
    background = null;
    linesGroup;
    nailsGroup;
    nailsCirclesGroup;
    nailsTextGroup;
    currentColor = null;
    lineWidth = 1;
    currentLineGroup = null;
    constructor(parentElement){
        super(parentElement);
        this.svg = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'svg');
        this.svg.style.setProperty('display', 'block');
        this.backgroundGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
        this.backgroundGroup.setAttribute('data-id', 'background');
        this.linesGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
        this.linesGroup.setAttribute('data-id', 'lines');
        this.nailsGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
        this.nailsGroup.setAttribute('data-id', 'nails');
        this.nailsCirclesGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
        this.nailsCirclesGroup.setAttribute('data-id', 'nailsCircles');
        this.nailsTextGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
        this.nailsTextGroup.setAttribute('data-id', 'nailsText');
        this.nailsGroup.appendChild(this.nailsCirclesGroup);
        this.nailsGroup.appendChild(this.nailsTextGroup);
        this.svg.appendChild(this.backgroundGroup);
        this.svg.appendChild(this.linesGroup);
        this.svg.appendChild(this.nailsGroup);
        this.svg.setAttribute('xmlns', $0649237e9259f2a7$var$SVG_NS);
        parentElement.appendChild(this.svg);
    }
    get element() {
        return this.svg;
    }
    resetSize() {
        super.resetSize();
        this.svg.style.removeProperty('width');
        this.svg.style.removeProperty('height');
        const newDimensions = this.getSize().map(Math.trunc);
        const [width, height] = newDimensions;
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'viewBox', `0 0 ${width} ${height}`);
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'width', String(width));
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'height', String(height));
        this.svg.style.width = width + 'px';
        this.svg.style.height = height + 'px';
        if (!this.currentSize || !(0, $b683a3137b30eaa9$export$b81d802eaada750f)(newDimensions, this.currentSize)) {
            this.currentSize = newDimensions;
            this.emit('sizeChange', {
                size: newDimensions
            });
        }
        return newDimensions;
    }
    resetNails() {
        this.nailsCirclesGroup.innerHTML = '';
        this.nailsTextGroup.innerHTML = '';
    }
    resetStrings() {
        this.linesGroup.innerHTML = '';
        this.currentColor = null;
        this.lineWidth = null;
    }
    setColor(color) {
        if (color !== this.currentColor) {
            this.currentLineGroup = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'g');
            this.currentLineGroup.setAttribute('stroke', color);
            this.currentLineGroup.setAttribute('stroke-width', String(this.lineWidth));
            this.linesGroup.appendChild(this.currentLineGroup);
            this.currentColor = color;
        }
    }
    setLineWidth(width) {
        this.lineWidth = width ?? '1';
        this.linesGroup.setAttribute('stroke-width', String(width ?? 1));
        this.linesGroup.childNodes.forEach((group)=>{
            if (group instanceof SVGGElement) group.setAttribute('stroke-width', String(width ?? 1));
        });
    }
    setBackground(color) {
        if (color) {
            if (!this.background) {
                this.background = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'rect');
                this.background.setAttribute('width', '100%');
                this.background.setAttribute('height', '100%');
                this.backgroundGroup.appendChild(this.background);
            }
            this.background.setAttribute('fill', color);
        } else {
            this.background = null;
            this.backgroundGroup.innerHTML = '';
        }
    }
    getSize() {
        return [
            this.svg.clientWidth,
            this.svg.clientHeight
        ];
    }
    setSize(size) {
        if (!size) return this.resetSize();
        if (this.fixedSize) {
            console.warn(`Trying to set size for Renderer to [${size.join(', ')}], but size is fixed to [${this.fixedSize.join(', ')}].`);
            return this.fixedSize;
        }
        this.svg.removeAttributeNS($0649237e9259f2a7$var$SVG_NS, 'width');
        this.svg.removeAttributeNS($0649237e9259f2a7$var$SVG_NS, 'height');
        this.svg.style.width = `${size[0]}px`;
        this.svg.style.height = `${size[1]}px`;
        const realSize = size.map(Math.trunc);
        const [width, height] = realSize;
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'viewBox', `0 0 ${width} ${height}`);
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'width', String(width));
        this.svg.setAttributeNS($0649237e9259f2a7$var$SVG_NS, 'height', String(height));
        if (!this.currentSize || !(0, $b683a3137b30eaa9$export$b81d802eaada750f)(realSize, this.currentSize)) {
            this.currentSize = realSize;
            this.emit('sizeChange', {
                size: realSize
            });
        }
        return realSize;
    }
    renderLine(from, to) {
        this.lastStringCoordinates = from;
        this.lineTo(to);
    }
    lineTo(to) {
        if (!this.lastStringCoordinates) throw new Error("no last string coordinates, can't lineTo");
        const line = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'line');
        line.setAttribute('x1', String(Math.trunc(this.lastStringCoordinates[0])));
        line.setAttribute('y1', String(Math.trunc(this.lastStringCoordinates[1])));
        line.setAttribute('x2', String(Math.trunc(to[0])));
        line.setAttribute('y2', String(Math.trunc(to[1])));
        this.currentLineGroup.appendChild(line);
        this.lastStringCoordinates = to;
    }
    clearInstructions() {
    // TODO: Implement this
    }
    renderInstructions(from, to) {
    // TODO: Implement this
    }
    renderInstructionsForLastLine() {
    // TODO: Implement this
    }
    hideInstructions() {
    // TODO: Implement this
    }
    showInstructions() {
    // TODO: Implement this
    }
    renderNails(nails, { color: color, fontSize: fontSize, radius: radius, renderNumbers: renderNumbers, margin: margin = 0, numbersStart: numbersStart = 1 }) {
        const centerX = this.getSize()[0] / 2;
        //this.nailsCirclesGroup.innerHTML = this.nailsTextGroup.innerHTML = '';
        const circlesFragment = document.createDocumentFragment();
        const textFragment = document.createDocumentFragment();
        const nailNumberOffset = radius + margin;
        this.nailsTextGroup.style.fontSize = String(fontSize);
        let number = numbersStart;
        for (let [x, y] of nails){
            const circle = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'circle');
            circle.setAttribute('cx', String(x));
            circle.setAttribute('cy', String(y));
            circle.setAttribute('r', String(radius));
            circlesFragment.appendChild(circle);
            if (renderNumbers && number != null) {
                const isRightAlign = x < centerX;
                const numberPosition = [
                    isRightAlign ? x - nailNumberOffset : x + nailNumberOffset,
                    y
                ];
                const textEl = document.createElementNS($0649237e9259f2a7$var$SVG_NS, 'text');
                textEl.innerHTML = String(number);
                textEl.setAttribute('x', String(numberPosition[0]));
                textEl.setAttribute('y', String(numberPosition[1]));
                if (isRightAlign) textEl.setAttribute('text-anchor', 'end');
                textFragment.appendChild(textEl);
            }
            number++;
        }
        this.nailsCirclesGroup.appendChild(circlesFragment);
        this.nailsTextGroup.appendChild(textFragment);
        if (color != null) {
            this.nailsCirclesGroup.setAttribute('fill', color);
            this.nailsTextGroup.setAttribute('fill', color);
        }
    }
    clear() {
        this.linesGroup.innerHTML = '';
        this.nailsGroup.innerHTML = '';
    }
    toDataURL() {
        return '';
    }
}


function $b7266296a7c0118e$export$bb3b75778e3e272({ data: data, filename: filename }) {
    const dataUrl = URL.createObjectURL(data);
    const downloadLink = document.createElement('a');
    downloadLink.href = dataUrl;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(dataUrl);
}
function $b7266296a7c0118e$export$d7a1803f0e752f79(contents, filename, mimeType = 'text/plain') {
    const data = new Blob([
        contents
    ], {
        type: mimeType
    });
    $b7266296a7c0118e$export$bb3b75778e3e272({
        data: data,
        filename: filename
    });
}
async function $b7266296a7c0118e$export$ef63c67b3e1358f7(pattern, { type: type, ...options }) {
    const overridingConfig = $b7266296a7c0118e$export$a4f48c82401c4(options);
    if (overridingConfig) {
        pattern = pattern.copy();
        pattern.assignConfig(overridingConfig);
    }
    if (options.units) options = {
        ...options,
        size: (0, $b683a3137b30eaa9$export$2e7f3602dd2acd76)(options.size, options.units, 'px', options.dpi)
    };
    const downloadData = type === 'svg' ? $b7266296a7c0118e$var$patternToSVGDownloadData(pattern, options) : await $b7266296a7c0118e$var$patternToImageDownloadData(pattern, options);
    $b7266296a7c0118e$export$bb3b75778e3e272(downloadData);
}
function $b7266296a7c0118e$export$a4f48c82401c4(options) {
    const config = {};
    if (options.margin) config.margin = (0, $b683a3137b30eaa9$export$6625f4a88a935670)(options.margin, options.units ?? 'px', 'px', options.dpi);
    if (options.isNailsMap) Object.assign(config, {
        darkMode: false,
        showNails: true,
        showNailNumbers: options.includeNailNumbers,
        showStrings: false,
        nailsColor: '#000000',
        backgroundColor: '#ffffff'
    });
    if (options.enableBackground != null) Object.assign(config, {
        enableBackground: options.enableBackground
    });
    return Object.keys(config).length === 0 ? null : config;
}
async function $b7266296a7c0118e$var$patternToImageDownloadData(pattern, { size: size, filename: filename, imageType: imageType }) {
    const parentElement = document.createElement('article');
    const renderer = new (0, $2f2e0bbe9a3a6970$export$2e2bcd8739ae039)(parentElement, {
        updateOnResize: false
    });
    renderer.disablePixelRatio();
    renderer.setFixedSize(size);
    pattern.draw(renderer);
    return {
        data: await renderer.toBlob(imageType),
        filename: `${filename ?? pattern.name}.${imageType ?? 'png'}`
    };
}
function $b7266296a7c0118e$var$patternToSVGDownloadData(pattern, { size: size, filename: filename }) {
    const parentEl = document.createElement('article');
    parentEl.style.width = size[0] + 'px';
    parentEl.style.height = size[1] + 'px';
    document.body.appendChild(parentEl);
    const renderer = new (0, $0649237e9259f2a7$export$2e2bcd8739ae039)(parentEl);
    renderer.setFixedSize(size);
    pattern.draw(renderer);
    const svgData = renderer.svg.outerHTML;
    const svgBlob = new Blob([
        svgData
    ], {
        type: 'image/svg+xml;charset=utf-8'
    });
    return {
        data: svgBlob,
        filename: filename ?? pattern.name + '.svg'
    };
}



const $00643d12b3a54506$var$APP_DATA_STORAGE_KEY = 'string_art_app_data';
class $00643d12b3a54506$export$2e2bcd8739ae039 extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    elements;
    currentPattern;
    constructor(){
        super();
        this.elements = {
            saveDialog: document.querySelector('#save_dialog')
        };
        document.querySelector('#save_btn').addEventListener('click', ()=>{
            if (this.currentPattern.isTemplate) this.showSaveAsDialog();
            else this.saveCurrentPattern();
        });
    }
    showSaveAsDialog() {
        const nextId = this.#getNextAvailableId();
        const defaultName = (0, $2509ceef6c629a64$export$e2de15bbd9edf9c6)().name ?? `Pattern #${nextId}`;
        (0, $174f2c93f6348ee5$export$195ba6d62321b933)({
            title: 'Save pattern',
            description: 'Name this pattern:',
            submit: 'Save',
            value: defaultName,
            dialogId: 'save_as'
        }).then((patternName)=>{
            this.saveNewPattern({
                type: this.currentPattern.type,
                config: this.currentPattern.config,
                name: patternName == null || patternName === '' ? defaultName : patternName
            });
        }, ()=>{});
    }
    setPattern(pattern) {
        this.currentPattern = pattern;
    }
    static patternDataToStringArt({ type: type, ...patternData }) {
        const pattern = (0, $92270d8b7d92e411$export$15be7981f451f84d)(type);
        Object.assign(pattern, patternData);
        pattern.markConfigAsDefault();
        return pattern;
    }
    static getSavedPatterns() {
        const { patterns: patterns } = this.loadAppData();
        return patterns.map(this.patternDataToStringArt);
    }
    static getPatternByID(patternId) {
        const patternData = this.loadPatternDataById(patternId);
        return patternData ? this.patternDataToStringArt(patternData) : null;
    }
    static loadPatternDataById(patternId) {
        const { patterns: patterns } = this.loadAppData();
        return patterns.find(({ id: id })=>id === patternId);
    }
    #getNextAvailableId() {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        const lastId = appData?.patterns?.length ? Number(appData.patterns[appData.patterns.length - 1].id) : 0;
        const nextId = isNaN(lastId) ? 1 : lastId + 1;
        return String(nextId);
    }
    saveNewPattern(patternData) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        const nextId = this.#getNextAvailableId();
        const newPatternData = {
            ...patternData,
            id: nextId
        };
        appData.patterns.push(newPatternData);
        $00643d12b3a54506$export$2e2bcd8739ae039.saveAppData(appData);
        this.emit('newPattern', {
            pattern: $00643d12b3a54506$export$2e2bcd8739ae039.patternDataToStringArt(newPatternData)
        });
        return newPatternData;
    }
    savePattern(patternData) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        const patternIndex = appData.patterns.findIndex(({ id: id })=>id === this.currentPattern.id);
        if (patternIndex !== -1) {
            appData.patterns[patternIndex] = patternData;
            $00643d12b3a54506$export$2e2bcd8739ae039.saveAppData(appData);
            this.emit('save', {
                pattern: $00643d12b3a54506$export$2e2bcd8739ae039.patternDataToStringArt(patternData)
            });
        }
    }
    saveCurrentPattern() {
        const newPatternData = {
            id: this.currentPattern.id,
            name: this.currentPattern.name,
            type: this.currentPattern.type,
            config: this.currentPattern.config
        };
        this.savePattern(newPatternData);
        return newPatternData;
    }
    renameCurrentPattern() {
        (0, $174f2c93f6348ee5$export$195ba6d62321b933)({
            title: 'Rename',
            description: 'Name this pattern:',
            submit: 'Save',
            value: this.currentPattern.name,
            dialogId: 'rename'
        }).then((newPatternName)=>{
            if (newPatternName !== this.currentPattern.name) {
                const patternData = $00643d12b3a54506$export$2e2bcd8739ae039.loadPatternDataById(this.currentPattern.id);
                patternData.name = newPatternName;
                this.savePattern(patternData);
            }
            this.currentPattern.name = newPatternName;
        });
    }
    deletePattern() {
        (0, $174f2c93f6348ee5$export$715f9d76bb8c1fea)({
            title: 'Delete pattern',
            description: 'Are you sure you wish to delete this pattern?',
            submit: 'Delete',
            type: 'error',
            dialogId: 'delete'
        }).then(()=>{
            const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
            const patternIndex = appData.patterns.findIndex(({ id: id })=>id === this.currentPattern.id);
            if (patternIndex === -1) throw new Error(`Can't delete pattern with ID "${this.currentPattern.id}", it's not found!`);
            const patternData = appData.patterns.splice(patternIndex, 1)[0];
            $00643d12b3a54506$export$2e2bcd8739ae039.saveAppData(appData);
            const pattern = $00643d12b3a54506$export$2e2bcd8739ae039.patternDataToStringArt(patternData);
            pattern.resetDefaultConfig();
            this.emit('deletePattern', {
                pattern: pattern
            });
        }, ()=>{});
    }
    exportAllPatterns() {
        const data = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        // Create a Blob with the JSON string and specify the MIME type
        const blob = new Blob([
            JSON.stringify(data, null, 2)
        ], {
            type: 'application/json'
        });
        (0, $b7266296a7c0118e$export$bb3b75778e3e272)({
            data: blob,
            filename: 'String Art Studio patterns.json'
        });
    }
    importPatterns({ patterns: patterns }) {
        if (!patterns) throw new Error('Data does not include patterns.');
        patterns.forEach(({ id: id, ...patternData })=>this.saveNewPattern(patternData));
    }
    static savePatternDownloadData(patternId, data) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        if (!appData.downloadData) appData.downloadData = {};
        appData.downloadData[patternId] = data;
        this.saveAppData(appData);
    }
    static savePatternDownloadInstructionsData(patternId, data) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        if (!appData.downloadInstructionsData) appData.downloadInstructionsData = {};
        appData.downloadInstructionsData[patternId] = data;
        this.saveAppData(appData);
    }
    static getPatternDownloadData(patternId) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        return appData.downloadData?.[patternId];
    }
    static getPatternDownloadInstructionsData(patternId) {
        const appData = $00643d12b3a54506$export$2e2bcd8739ae039.loadAppData();
        return appData.downloadInstructionsData?.[patternId];
    }
    static loadAppData() {
        const rawData = localStorage.getItem($00643d12b3a54506$var$APP_DATA_STORAGE_KEY);
        try {
            return rawData ? JSON.parse(rawData) : {
                patterns: [],
                downloadData: {},
                downloadInstructionsData: {}
            };
        } catch (error) {
            throw new Error('App data is corrupted, failed to load it. ' + error.message);
        }
    }
    static saveAppData(appData) {
        localStorage.setItem($00643d12b3a54506$var$APP_DATA_STORAGE_KEY, JSON.stringify(appData));
    }
}





const $8a4d6517fbd25a59$var$THUMBNAIL_WIDTH_PX = '100px';
const $8a4d6517fbd25a59$var$MINIMIZED_CLASS = 'minimized';
class $8a4d6517fbd25a59$export$45b50bca1da1e9b3 extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    elements = {
        root: document.querySelector('#pattern_select_panel'),
        thumbnails: document.querySelector('#thumbnails'),
        toggleBtn: document.querySelector('#pattern_select_btn'),
        dropdown: document.querySelector('#pattern_select_dropdown'),
        patternName: document.querySelector('#pattern_name')
    };
    pattern;
    thumbnailsRendered = false;
    _onClickOutside;
    constructor(persistance){
        super();
        this.elements.toggleBtn.addEventListener('click', ()=>this.toggle());
        persistance.addEventListener('newPattern', ({ pattern: pattern })=>{
            if (this.isOpen) this.createThumbnails();
            else this.thumbnailsRendered = false;
            this.setCurrentPattern(pattern);
            this.emit('select', {
                patternId: pattern.id
            });
        });
        persistance.addEventListener('save', ({ pattern: pattern })=>{
            if (this.isOpen) this.createThumbnails();
            else this.thumbnailsRendered = false;
            this.setCurrentPattern(pattern);
        });
        persistance.addEventListener('deletePattern', ({ pattern: pattern })=>{
            if (this.isOpen) {
                const thumbnail = this.elements.thumbnails.querySelector(`[data-pattern="${pattern.id}"]`);
                thumbnail.remove();
            } else this.thumbnailsRendered = false;
        });
        this.elements.thumbnails.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const link = e.target instanceof HTMLElement && e.target.closest('[data-pattern]');
            if (!link) return false;
            this.emit('select', {
                patternId: link.dataset.pattern
            });
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('dialog', (dialog)=>{
            if (dialog === 'thumbnails') {
                if (!this.isOpen) this.open();
            } else this.close();
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('dialogClosed', (dialog)=>{
            if (dialog === 'thumbnails') this.close();
        });
    }
    get isOpen() {
        return !this.elements.root.classList.contains($8a4d6517fbd25a59$var$MINIMIZED_CLASS);
    }
    toggle() {
        if (!this.isOpen) {
            this.open();
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToDialog('thumbnails');
        } else if (this.pattern) {
            this.close();
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).closeDialog();
        }
    }
    open() {
        if (!this.isOpen) {
            this.elements.root.classList.remove($8a4d6517fbd25a59$var$MINIMIZED_CLASS);
            if (!this.thumbnailsRendered) {
                this.createThumbnails();
                this.thumbnailsRendered = true;
            }
            this._onClickOutside = (e)=>{
                if (e.target instanceof HTMLElement && !e.target.closest('#pattern_select_panel')) this.toggle();
            };
            document.body.addEventListener('mousedown', this._onClickOutside);
        }
    }
    close() {
        if (this.isOpen) {
            this.elements.root.classList.add($8a4d6517fbd25a59$var$MINIMIZED_CLASS);
            document.body.removeEventListener('mousedown', this._onClickOutside);
            this._onClickOutside = null;
        }
    }
    setCurrentPattern(pattern) {
        this.pattern = pattern;
        this.elements.patternName.innerText = pattern?.name ?? 'Choose a pattern';
    }
    #createThumbnailsSection(title, patterns) {
        const section = document.createElement('section');
        const sectionTitle = document.createElement('h3');
        sectionTitle.className = 'pattern_select_thumbnails_title';
        sectionTitle.innerText = title;
        section.appendChild(sectionTitle);
        const thumbnailsList = document.createElement('ul');
        thumbnailsList.className = 'pattern_select_thumbnails';
        section.appendChild(thumbnailsList);
        const thumbnailsFragment = document.createDocumentFragment();
        const patternThumbnails = {};
        patterns.forEach((pattern)=>{
            const patternLink = document.createElement('a');
            patternLink.style.width = patternLink.style.height = $8a4d6517fbd25a59$var$THUMBNAIL_WIDTH_PX;
            patternThumbnails[pattern.id] = patternLink;
            const thumbnailConfig = pattern.thumbnailConfig;
            pattern.assignConfig({
                margin: 1,
                enableBackground: !pattern.config.darkMode || pattern.config.customBackgroundColor,
                nailRadius: 0.5,
                ...thumbnailConfig instanceof Function ? thumbnailConfig(pattern.config) : thumbnailConfig
            });
            const li = document.createElement('li');
            thumbnailsFragment.appendChild(li);
            patternLink.href = `?pattern=${pattern.id}`;
            patternLink.setAttribute('data-pattern', pattern.id);
            patternLink.title = pattern.name;
            li.appendChild(patternLink);
        });
        thumbnailsList.appendChild(thumbnailsFragment);
        this.elements.thumbnails.appendChild(section);
        patterns.forEach((pattern)=>{
            const renderer = new (0, $2f2e0bbe9a3a6970$export$2e2bcd8739ae039)(patternThumbnails[pattern.id], {
                updateOnResize: false
            });
            renderer.setSize([
                100,
                100
            ]);
            try {
                pattern.draw(renderer);
            } catch (error) {
                console.error(`Failed to render thumbnail for pattern [id=${pattern.id}]`, error);
            }
        });
    }
    createThumbnails() {
        this.elements.thumbnails.innerHTML = '';
        const savedPatterns = (0, $00643d12b3a54506$export$2e2bcd8739ae039).getSavedPatterns();
        if (savedPatterns.length) this.#createThumbnailsSection('My Patterns', (0, $00643d12b3a54506$export$2e2bcd8739ae039).getSavedPatterns());
        const patterns = (0, $92270d8b7d92e411$export$1b06808e3c79c7e0)();
        this.#createThumbnailsSection('Built-in patterns', patterns);
    }
}




async function $38bb4a85553a6bfc$export$ed80d9de1d9df928(input) {
    try {
        navigator.share(await $38bb4a85553a6bfc$var$getShareData(input));
    } catch (error) {
        alert('Error: ' + error.message);
    }
}
async function $38bb4a85553a6bfc$export$4fa6f570da04f7cc() {
    if (!navigator.share) return false;
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, 1, 1);
    const dataURL = canvas.toDataURL();
    const shareData = await $38bb4a85553a6bfc$var$dataURLToShareData(dataURL, 'test', 'test.jpg');
    return navigator.canShare(shareData);
}
async function $38bb4a85553a6bfc$var$dataURLToShareData(dataURL, text, filename, url) {
    const blob = await (await fetch(dataURL)).blob();
    const files = [
        new File([
            blob
        ], filename, {
            type: blob.type,
            lastModified: new Date().getTime()
        })
    ];
    return {
        url: url ?? window.location.href,
        files: files,
        title: document.title,
        text: text
    };
}
async function $38bb4a85553a6bfc$var$getShareData({ renderer: renderer, pattern: pattern }) {
    const dataUrl = renderer.toDataURL();
    return $38bb4a85553a6bfc$var$dataURLToShareData(dataUrl, 'String Art Studio - ' + pattern.name, pattern.name + '.jpg', (0, $2509ceef6c629a64$export$87dcc7060093bbda)(pattern, {
        renderer: renderer instanceof (0, $0649237e9259f2a7$export$2e2bcd8739ae039) ? 'svg' : 'canvas',
        patternAsTemplate: true
    }));
}


const $718de5d870731526$var$swFilename = 'service-worker.js';
async function $718de5d870731526$export$d594efb518b3cec4() {
    if (!navigator.serviceWorker || document.location.hostname === '127.0.0.1') return;
    try {
        const registration = await navigator.serviceWorker.register($718de5d870731526$var$swFilename);
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                    else console.log('Content is cached for offline use.');
                }
            };
        };
    } catch (error) {
        console.error('Error during service worker registration:', error);
    }
}






var $2deec1a9c1aeca88$exports = {};
$2deec1a9c1aeca88$exports = ".hidden{display:none}fieldset{border:none;margin:0 0 1.3em;padding:0}section:not(:last-child){margin-bottom:1em}fieldset:last-child{margin-bottom:0}fieldset>section{margin-top:.3em}.dialog-input{border:solid 1px var(--color-input);color:#fff;box-sizing:border-box;background:0 0;border-radius:4px;outline:none;height:32px!important;padding:4px 8px!important}.dialog-input-small{width:50px}.dialog-input-tall{width:100%;font-size:1.1em;height:50px!important}.dialog-input::selection{color:#000;background:#fff}.dialog-input:hover,.dialog-input:active,.dialog-input:focus-visible{border-color:var(--color-input-active)}.dialog-input:active,.dialog-input:focus-visible{background:#ffffff1a}.dialog-input option{color:#000;background-color:#fff}.row{flex-direction:row;align-items:center;display:flex}.dialog-lesser-select{color:#fffc;cursor:pointer;background:0 0;border:none;border-bottom:1px dotted #ffffff80;height:32px!important;padding:0!important}.dialog-lesser-select option{color:#000}.radio-list{border:solid 1px var(--color-input);box-sizing:border-box;border-radius:4px;align-items:center;width:fit-content;height:32px;padding:4px 8px;display:flex}.radio-list input[type=radio]{margin:0 4px 0 0}input[type=radio]+label{margin-bottom:0;display:inline-block}input[type=radio]+label:not(:last-child){margin-inline-end:1.5em}#inputs,#readonly{white-space:nowrap}#readonly{font-size:14px}input{width:70px}#connector.linked{display:inline-block;transform:rotate(45deg)}";


const $f0492547ffa27fa1$var$sheet = new CSSStyleSheet();
$f0492547ffa27fa1$var$sheet.replaceSync(String($2deec1a9c1aeca88$exports));
const $f0492547ffa27fa1$var$DIMENSIONS = [
    'width',
    'height'
];
class $f0492547ffa27fa1$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    #dimensions;
    #inputsElement;
    #readonlyElement;
    #aspectRatio;
    #isReadonly = false;
    floatingPoints;
    #connectorElement;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        shadow.adoptedStyleSheets = [
            $f0492547ffa27fa1$var$sheet
        ];
        this.shadowRoot.innerHTML = `
      <span id="inputs">
        <input
          type="number"
          id="width"
          maxlength="3"
          min="1"
          class="dialog-input size-input"
          name="width"
        />
        <span id="connector">&times;</span>
        <input
          type="number"
          id="height"
          maxlength="3"
          min="1"
          class="dialog-input size-input"
          name="height"
        />
      </span>
      <span id="readonly" hidden></span>
    `;
        this.#dimensions = {
            width: {
                element: shadow.querySelector('#width'),
                value: 0,
                max: null,
                defaultValue: null
            },
            height: {
                element: shadow.querySelector('#height'),
                value: 0,
                max: null,
                defaultValue: null
            }
        };
        this.#connectorElement = shadow.querySelector('#connector');
        this.#inputsElement = shadow.querySelector('#inputs');
        this.#readonlyElement = shadow.querySelector('#readonly');
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'width',
            'height',
            'aspect-ratio',
            'max-width',
            'max-height',
            'readonly',
            'default-width',
            'default-height',
            'floating-points'
        ];
    }
    get inputs() {
        return [
            this.#dimensions.width.element,
            this.#dimensions.height.element
        ];
    }
    get width() {
        return this.#dimensions.width.value;
    }
    set width(value) {
        this.setDimensionValue('width', value, {
            updateOtherDimensionOnce: true
        });
    }
    get height() {
        return this.#dimensions.height.value;
    }
    set height(value) {
        this.setDimensionValue('height', value, {
            updateOtherDimensionOnce: true
        });
    }
    get value() {
        return [
            this.width,
            this.height
        ];
    }
    set value(value) {
        if (typeof value === 'string') {
            const match = value.match(/^(\d+(?:\.\d+)?),\s?(\d+(?:\.\d+)?)$/);
            if (match) {
                this.width = Number(match[1]);
                this.height = Number(match[2]);
            }
        } else {
            this.width = value[0];
            this.height = value[1];
        }
    }
    get maxWidth() {
        return this.#dimensions.width.max;
    }
    get maxHeight() {
        return this.#dimensions.height.max;
    }
    set maxWidth(value) {
        this.setMaxDimensionValue('width', value);
    }
    set maxHeight(value) {
        this.setMaxDimensionValue('height', value);
    }
    get isReadonly() {
        return this.#isReadonly;
    }
    set isReadonly(value) {
        if (this.#isReadonly = value && value !== 'false') {
            (0, $8d5cef8e7fea78a8$export$fe8985bb6374093c)(this.#inputsElement);
            (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(this.#readonlyElement);
        } else {
            (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(this.#inputsElement);
            (0, $8d5cef8e7fea78a8$export$fe8985bb6374093c)(this.#readonlyElement);
        }
    }
    #setReadonlyText() {
        this.#readonlyElement.innerHTML = `${this.width} &times; ${this.height}`;
    }
    applyAspectRatio(targetDimension, value) {
        if (!this.#aspectRatio) return value;
        return targetDimension === 'width' ? value * this.#aspectRatio : value / this.#aspectRatio;
    }
    getOtherDimension(dimension) {
        return dimension === 'width' ? 'height' : 'width';
    }
    get aspectRatio() {
        return this.#aspectRatio;
    }
    set aspectRatio(value) {
        this.#aspectRatio = value ? Number(value) : null;
        if (isNaN(this.#aspectRatio)) this.#aspectRatio = null;
        if (this.#aspectRatio) {
            if (!this.#connectorElement.classList.contains('linked')) this.#connectorElement.classList.add('linked');
            this.#connectorElement.innerHTML = "\uD83D\uDD17";
        } else {
            this.#connectorElement.classList.remove('linked');
            this.#connectorElement.innerHTML = '&times;';
        }
    }
    setMaxDimensionValue(dimension, value, updateOtherDimension = true) {
        const props = this.#dimensions[dimension];
        value = Number(value);
        let normalizedValue = value;
        if (this.floatingPoints != null) normalizedValue = value.toFixedPrecision(this.floatingPoints);
        if (normalizedValue === props.max) return;
        props.max = isNaN(normalizedValue) ? null : normalizedValue;
        if (props.max) {
            if (props.value && props.value > normalizedValue) this[dimension] = normalizedValue;
            props.element.setAttribute('max', String(props.max));
        } else props.element.removeAttribute('max');
        if (updateOtherDimension && this.#aspectRatio) {
            const otherDimension = this.getOtherDimension(dimension);
            const otherDimensionMaxValue = this.applyAspectRatio(otherDimension, value);
            if (!this.#dimensions[otherDimension].max || otherDimensionMaxValue < this.#dimensions[otherDimension].max) this.setMaxDimensionValue(otherDimension, otherDimensionMaxValue, false);
        }
    }
    setMaxDimensions(dimensions) {
        this.setMaxDimensionValue('width', dimensions[0], false);
        this.setMaxDimensionValue('height', dimensions[1], false);
    }
    setDimensionValue(dimension, value, { updateOtherDimension: updateOtherDimension = true, updateOtherDimensionOnce: updateOtherDimensionOnce = false } = {}) {
        const props = this.#dimensions[dimension];
        let normalizedValue = value;
        if (this.floatingPoints != null) normalizedValue = value.toFixedPrecision(this.floatingPoints);
        if (normalizedValue === this[dimension]) return;
        if (isNaN(normalizedValue)) console.warn('Attempting to set a NaN value to DimensionsInput width.');
        else {
            if (props.max) normalizedValue = Math.min(normalizedValue, props.max);
            props.value = normalizedValue;
            props.element.value = String(this.floatingPoints != null ? normalizedValue.toFixedPrecision(this.floatingPoints) : normalizedValue);
            if (updateOtherDimension && this.#aspectRatio) {
                const otherDimension = this.getOtherDimension(dimension);
                this.setDimensionValue(otherDimension, this.applyAspectRatio(otherDimension, normalizedValue), {
                    updateOtherDimension: updateOtherDimensionOnce
                });
            }
            this.#setReadonlyText();
        }
        this.#updateFormValue();
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'aspect-ratio') this.aspectRatio = newVal;
        else if (name === 'max-width') this.maxWidth = newVal;
        else if (name === 'max-height') this.maxHeight = newVal;
        else if (name === 'floating-points') this.setFloatingPoints(Number(newVal));
        else if (name === 'readonly') this.isReadonly = newVal;
    }
    connectedCallback() {
        this.shadowRoot.addEventListener('input', (e)=>this.#handleInput(e));
        this.shadowRoot.addEventListener('focusin', (e)=>{
            if (e.target instanceof HTMLInputElement) e.target.select();
        });
        this.#syncAttributes();
    }
    #handleInput(e) {
        if (e.target instanceof HTMLInputElement) {
            const value = Number(e.target.value);
            for (const dimension of $f0492547ffa27fa1$var$DIMENSIONS)if (e.target === this.#dimensions[dimension].element) {
                this[dimension] = value;
                this.dispatchEvent(new CustomEvent('dimensionchange', {
                    detail: {
                        value: this.value,
                        dimension: dimension,
                        width: this.width,
                        height: this.height
                    }
                }));
                break;
            }
            this.#updateFormValue();
        }
    }
    #updateFormValue() {
        this.internals.setFormValue(String(this.value.join(',')));
    }
    #syncAttributes() {
        for (const dimension of $f0492547ffa27fa1$var$DIMENSIONS){
            const props = this.#dimensions[dimension];
            if (this.hasAttribute('default-' + dimension)) {
                const value = Number(this.getAttribute('default-' + dimension));
                props.defaultValue = isNaN(value) ? 0 : value;
                props.element.placeholder = String(value);
            }
            this.setMaxDimensionValue(dimension, this.getAttribute('max-' + dimension));
            if (this.hasAttribute(dimension)) {
                const value = Number(this.getAttribute(dimension));
                this[dimension] = isNaN(value) ? props.defaultValue : value;
            }
        }
        this.aspectRatio = this.getAttribute('aspect-ratio');
        this.isReadonly = this.getAttribute('readonly');
        if (this.hasAttribute('floating-points')) {
            const value = Number(this.getAttribute('floating-points'));
            this.setFloatingPoints(isNaN(value) ? null : value);
        }
    }
    setFloatingPoints(value) {
        if (value != null && !isNaN(value)) {
            this.floatingPoints = value;
            this.inputs.forEach((input)=>input.setAttribute('step', String(1 / 10 ** this.floatingPoints)));
            $f0492547ffa27fa1$var$DIMENSIONS.forEach((dimension)=>{
                if (this[dimension]) this[dimension] = this[dimension].toFixedPrecision(value);
            });
        } else {
            this.floatingPoints = null;
            this.inputs.forEach((input)=>input.removeAttribute('step'));
        }
    }
}
customElements.define('dimensions-input', $f0492547ffa27fa1$export$2e2bcd8739ae039);



class $f4729f31dd8a035c$export$e44a253a59704894 extends HTMLElement {
    button;
    #buttonStyle;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
          position: relative;
        }

        button {
          display: block;
          padding: 10px 15px;
          background: transparent;
          color: white;
          border: none;
          cursor: pointer;
          font: inherit;
        }

        button:hover {
          background: #444;
        }

        button:focus {
          background: rgba(255,255,255,.2)
        }
        ul {
          display: none;
          position: absolute;
          top: 100%;
          right: 0;
          min-width: 120px;
          background: var(--color-dialog-background);
          border: var(--border-dialog);
          margin: 0;
          padding: 0;
          list-style: none;
          z-index: 1000;
          box-shadow: 1px 1px 10px rgba(0,0,0,.7)
        }

        :host(.open) ul {
          display: block;
        }
      </style>

      <button aria-haspopup="true" aria-expanded="false">
        <slot name="label">Menu</slot>
      </button>
      <ul role="menu">
        <slot></slot>
      </ul>
    `;
    }
    connectedCallback() {
        this.button = this.shadowRoot.querySelector('button');
        this.button.addEventListener('click', ()=>this.toggle());
        if (this.#buttonStyle) this.button.style = this.#buttonStyle;
        document.addEventListener('click', (e)=>{
            if (!this.contains(e.target) && !this.shadowRoot.contains(e.target)) this.close();
        });
        this.button.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') {
                this.close();
                this.button.focus();
            }
        });
        // Listen for selection from child items
        this.addEventListener('item-selected', (e)=>{
            const customEvent = e;
            this.dispatchEvent(new CustomEvent('select', {
                detail: {
                    value: customEvent.detail.value
                },
                bubbles: true,
                composed: true
            }));
            this.close();
        });
    }
    static get observedAttributes() {
        return [
            'button-style'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'button-style') {
            if (this.button) this.button.style = newVal;
            else this.#buttonStyle = newVal;
        }
    }
    toggle() {
        const isOpen = this.classList.toggle('open');
        this.button.setAttribute('aria-expanded', String(isOpen));
    }
    close() {
        this.classList.remove('open');
        this.button.setAttribute('aria-expanded', 'false');
    }
}
customElements.define('dropdown-menu', $f4729f31dd8a035c$export$e44a253a59704894);


class $0096ec60fce19dcf$var$DropdownMenuItem extends HTMLElement {
    static get observedAttributes() {
        return [
            'value',
            'selected'
        ];
    }
    value = '';
    #listItem;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.innerHTML = `
      <style>
        li {
          list-style: none;
          padding: 12px 40px 12px 20px;
          color: White;
          text-decoration: none;
          white-space: nowrap;
          background: transparent;
          cursor: pointer;
        }
        li:hover {
          background: rgba(255,255,255,.1);
        }

        li.selected {
          color: var( --color-accent);
          pointer-events: none;
        }

        span:not(:empty) {
          float: left; 
          margin-right: .5em;
          position: relative;
          left: -4px;
          top: 1px;
        }
      </style>
      <li role="menuitem" ${this.hasAttribute('selected') ? 'class="selected"' : ''}>
        <span id="icon"><slot name="icon"></span>
        <slot></slot>
      </li>
    `;
        this.#listItem = this.shadowRoot.querySelector('li');
    }
    connectedCallback() {
        const item = this.shadowRoot.querySelector('li');
        item.addEventListener('click', (e)=>{
            e.preventDefault();
            this.dispatchEvent(new CustomEvent('item-selected', {
                detail: {
                    value: this.value
                },
                bubbles: true,
                composed: true
            }));
        });
    }
    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'value') this.value = newValue;
        else if (name === 'selected') {
            if (newValue) this.#listItem.classList.add('selected');
            else this.#listItem.classList.remove('selected');
        }
    }
}
customElements.define('dropdown-menu-item', $0096ec60fce19dcf$var$DropdownMenuItem);


class $ebae7803240847c7$var$DropdownMenuSeparator extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
        this.shadowRoot.innerHTML = `
      <style>
        hr {
            margin: 8px 0;
            border: solid 1px rgba(255,255,255,.1);
        }
      </style>
      <hr />
    `;
    }
}
customElements.define('dropdown-menu-separator', $ebae7803240847c7$var$DropdownMenuSeparator);


var $eb971f7ae22dc5e1$exports = {};
$eb971f7ae22dc5e1$exports = ".hidden{display:none}fieldset{border:none;margin:0 0 1.3em;padding:0}section:not(:last-child){margin-bottom:1em}fieldset:last-child{margin-bottom:0}fieldset>section{margin-top:.3em}.dialog-input{border:solid 1px var(--color-input);color:#fff;box-sizing:border-box;background:0 0;border-radius:4px;outline:none;height:32px!important;padding:4px 8px!important}.dialog-input-small{width:50px}.dialog-input-tall{width:100%;font-size:1.1em;height:50px!important}.dialog-input::selection{color:#000;background:#fff}.dialog-input:hover,.dialog-input:active,.dialog-input:focus-visible{border-color:var(--color-input-active)}.dialog-input:active,.dialog-input:focus-visible{background:#ffffff1a}.dialog-input option{color:#000;background-color:#fff}.row{flex-direction:row;align-items:center;display:flex}.dialog-lesser-select{color:#fffc;cursor:pointer;background:0 0;border:none;border-bottom:1px dotted #ffffff80;height:32px!important;padding:0!important}.dialog-lesser-select option{color:#000}.radio-list{border:solid 1px var(--color-input);box-sizing:border-box;border-radius:4px;align-items:center;width:fit-content;height:32px;padding:4px 8px;display:flex}.radio-list input[type=radio]{margin:0 4px 0 0}input[type=radio]+label{margin-bottom:0;display:inline-block}input[type=radio]+label:not(:last-child){margin-inline-end:1.5em}@font-face{font-family:string_art_studio;src:url(string_art_studio.9cced145.ttf)format(\"truetype\"),url(string_art_studio.44d13d52.woff)format(\"woff\"),url(string_art_studio.ae7f2e94.svg#string_art_studio)format(\"svg\");font-weight:400;font-style:normal;font-display:block}i{speak:never;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:normal;font-weight:400;line-height:1;font-family:string_art_studio!important}.icon-text:before{content:\"\"}.icon-step_back:before{content:\"\"}.icon-step_forward:before{content:\"\"}.icon-thread:before{content:\"\"}.icon-rotate:before{content:\"\"}.icon-pencil:before{content:\"\"}.icon-plus:before{content:\"\"}.icon-trash:before{content:\"\"}.icon-diskette_b:before{content:\"\"}.icon-diskette:before{content:\"\"}.icon-menu:before{content:\"\"}.icon-arrow_left:before{content:\"\"}.icon-arrow_right:before{content:\"\"}.icon-caret_down:before{content:\"\"}.icon-download:before{content:\"\"}.icon-fullscreen:before{content:\"\"}.icon-hamburger:before{content:\"\"}.icon-options:before{content:\"\"}.icon-pause:before{content:\"\"}.icon-play:before{content:\"\"}.icon-refresh:before{content:\"\"}.icon-share:before{content:\"\"}.icon-thumbnails:before{content:\"\"}.icon-x:before{content:\"\"}[hidden]{display:none!important}dialog{background:var(--color-dialog-background);color:#fff;border:var(--border-dialog);box-sizing:border-box;width:400px;max-width:calc(100vw - 20px);margin:0;padding:0;position:fixed;top:100px;left:50%;transform:translate(-50%);box-shadow:0 0 10px #000c}dialog[open]{flex-direction:column;display:flex}#dialog_wrapper{box-sizing:border-box;width:100%;max-height:calc(100vh - 20px);padding:1em;overflow:auto}dialog.centered{top:50%;transform:translate(-50%)translateY(-50%)}dialog::backdrop{background:#000000b3}.dialog-title{color:var(--color-accent);text-shadow:1px 1px 1px #000;margin-top:0;font-size:1.4em;font-weight:400}dialog.error .dialog-title{color:var(--color-error)}.dialog-menu{text-align:end;flex-direction:row;justify-content:end;align-items:center;margin-bottom:0;display:flex}.dialog-menu button{color:#fff;cursor:pointer;background:0 0;border:none;border-radius:4px;margin-inline-start:.5em;padding:8px 16px;font-size:1em}.dialog-menu button.btn-submit{background:var(--color-input)}dialog.error .dialog-menu button.btn-submit{background:var(--color-error)}.dialog-menu button.btn-submit:hover{background:var(--color-input-active)}.dialog-menu .btn-cancel{opacity:.5}.dialog-menu .btn-cancel:hover,.dialog-menu .btn-cancel:focus{opacity:1}.dialog-menu button>i{vertical-align:middle;margin-inline-end:4px;display:inline-block;transform:translateY(-2px)}#dialog_contents{display:flex}#dialog_context_menu{z-index:2;position:absolute;top:0;right:0}";


const $34a1caf943752901$var$sheet = new CSSStyleSheet();
$34a1caf943752901$var$sheet.replaceSync(String($eb971f7ae22dc5e1$exports));
class $34a1caf943752901$export$2e2bcd8739ae039 extends HTMLElement {
    dialog;
    input;
    static get observedAttributes() {
        return [
            'dialog-title',
            'description',
            'value',
            'submit',
            'cancel',
            'type',
            'submit-icon'
        ];
    }
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $34a1caf943752901$var$sheet
        ];
        this.shadowRoot.innerHTML = `
      <confirm-dialog>
        <input
            type="text"
            class="dialog-input dialog-input-tall"
            name="patternName"
            required
          />
      </confirm-dialog>
    `;
        this.dialog = shadow.querySelector('confirm-dialog');
        this.input = shadow.querySelector('input');
        this.input.addEventListener('keypress', (e)=>{
            if (e.code === 'Enter') this.dialog.submit();
        });
    }
    connectedCallback() {
        this.syncAttributes();
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    syncAttributes() {
        $34a1caf943752901$export$2e2bcd8739ae039.observedAttributes.filter((attr)=>attr !== 'value').forEach((attr)=>{
            if (this.hasAttribute(attr)) this.dialog.setAttribute(attr, this.getAttribute(attr));
            else this.dialog.removeAttribute(attr);
        });
        if (this.hasAttribute('value')) this.input.value = this.getAttribute('value') || '';
    }
    /**
   * Opens the dialog, optionally with an initial value.
   */ show(initialValue) {
        if (initialValue !== undefined) this.input.value = initialValue;
        else if (this.hasAttribute('value')) this.input.value = this.getAttribute('value') || '';
        this.input.select();
        return this.dialog.show().then(()=>this.input.value);
    }
    close() {
        this.dialog.close();
    }
    /**
   * Gets the value entered by the user if submitted,
   * or null if canceled.
   */ getValue() {
        return this.input.value;
    }
}
customElements.define('input-dialog', $34a1caf943752901$export$2e2bcd8739ae039);


var $7a37a3caedf4d681$exports = {};
$7a37a3caedf4d681$exports = ".hidden{display:none}fieldset{border:none;margin:0 0 1.3em;padding:0}section:not(:last-child){margin-bottom:1em}fieldset:last-child{margin-bottom:0}fieldset>section{margin-top:.3em}.dialog-input{border:solid 1px var(--color-input);color:#fff;box-sizing:border-box;background:0 0;border-radius:4px;outline:none;height:32px!important;padding:4px 8px!important}.dialog-input-small{width:50px}.dialog-input-tall{width:100%;font-size:1.1em;height:50px!important}.dialog-input::selection{color:#000;background:#fff}.dialog-input:hover,.dialog-input:active,.dialog-input:focus-visible{border-color:var(--color-input-active)}.dialog-input:active,.dialog-input:focus-visible{background:#ffffff1a}.dialog-input option{color:#000;background-color:#fff}.row{flex-direction:row;align-items:center;display:flex}.dialog-lesser-select{color:#fffc;cursor:pointer;background:0 0;border:none;border-bottom:1px dotted #ffffff80;height:32px!important;padding:0!important}.dialog-lesser-select option{color:#000}.radio-list{border:solid 1px var(--color-input);box-sizing:border-box;border-radius:4px;align-items:center;width:fit-content;height:32px;padding:4px 8px;display:flex}.radio-list input[type=radio]{margin:0 4px 0 0}input[type=radio]+label{margin-bottom:0;display:inline-block}input[type=radio]+label:not(:last-child){margin-inline-end:1.5em}@font-face{font-family:string_art_studio;src:url(string_art_studio.9cced145.ttf)format(\"truetype\"),url(string_art_studio.44d13d52.woff)format(\"woff\"),url(string_art_studio.ae7f2e94.svg#string_art_studio)format(\"svg\");font-weight:400;font-style:normal;font-display:block}i{speak:never;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:normal;font-weight:400;line-height:1;font-family:string_art_studio!important}.icon-text:before{content:\"\"}.icon-step_back:before{content:\"\"}.icon-step_forward:before{content:\"\"}.icon-thread:before{content:\"\"}.icon-rotate:before{content:\"\"}.icon-pencil:before{content:\"\"}.icon-plus:before{content:\"\"}.icon-trash:before{content:\"\"}.icon-diskette_b:before{content:\"\"}.icon-diskette:before{content:\"\"}.icon-menu:before{content:\"\"}.icon-arrow_left:before{content:\"\"}.icon-arrow_right:before{content:\"\"}.icon-caret_down:before{content:\"\"}.icon-download:before{content:\"\"}.icon-fullscreen:before{content:\"\"}.icon-hamburger:before{content:\"\"}.icon-options:before{content:\"\"}.icon-pause:before{content:\"\"}.icon-play:before{content:\"\"}.icon-refresh:before{content:\"\"}.icon-share:before{content:\"\"}.icon-thumbnails:before{content:\"\"}.icon-x:before{content:\"\"}[hidden]{display:none!important}dialog{background:var(--color-dialog-background);color:#fff;border:var(--border-dialog);box-sizing:border-box;width:400px;max-width:calc(100vw - 20px);margin:0;padding:0;position:fixed;top:100px;left:50%;transform:translate(-50%);box-shadow:0 0 10px #000c}dialog[open]{flex-direction:column;display:flex}#dialog_wrapper{box-sizing:border-box;width:100%;max-height:calc(100vh - 20px);padding:1em;overflow:auto}dialog.centered{top:50%;transform:translate(-50%)translateY(-50%)}dialog::backdrop{background:#000000b3}.dialog-title{color:var(--color-accent);text-shadow:1px 1px 1px #000;margin-top:0;font-size:1.4em;font-weight:400}dialog.error .dialog-title{color:var(--color-error)}.dialog-menu{text-align:end;flex-direction:row;justify-content:end;align-items:center;margin-bottom:0;display:flex}.dialog-menu button{color:#fff;cursor:pointer;background:0 0;border:none;border-radius:4px;margin-inline-start:.5em;padding:8px 16px;font-size:1em}.dialog-menu button.btn-submit{background:var(--color-input)}dialog.error .dialog-menu button.btn-submit{background:var(--color-error)}.dialog-menu button.btn-submit:hover{background:var(--color-input-active)}.dialog-menu .btn-cancel{opacity:.5}.dialog-menu .btn-cancel:hover,.dialog-menu .btn-cancel:focus{opacity:1}.dialog-menu button>i{vertical-align:middle;margin-inline-end:4px;display:inline-block;transform:translateY(-2px)}#dialog_contents{display:flex}#dialog_context_menu{z-index:2;position:absolute;top:0;right:0}";


var $08ec3d656de31381$exports = {};
$08ec3d656de31381$exports = "<dialog>\n  <div id=dialog_wrapper>\n    <div id=dialog_context_menu>\n      <slot name=context-menu></slot>\n    </div>\n    <form method=dialog>\n      <h2 class=dialog-title></h2>\n      <p class=dialog-desc></p>\n      <div id=dialog_contents>\n        <slot></slot>\n      </div>\n      <menu class=dialog-menu>\n        <button type=button class=btn-cancel>Cancel</button>\n        <button value=confirm class=btn-submit>\n          <i id=submit_icon class=icon hidden></i>\n          <span id=submit_text></span>\n        </button>\n      </menu>\n    </form>\n  </div>\n</dialog>\n";



const $1b7158181746ebe4$var$sheet = new CSSStyleSheet();
$1b7158181746ebe4$var$sheet.replaceSync(String($7a37a3caedf4d681$exports));
class $1b7158181746ebe4$export$2e2bcd8739ae039 extends HTMLElement {
    dialog;
    cancelBtn;
    submitBtn;
    titleEl;
    descEl;
    submitText;
    submitIcon;
    static get observedAttributes() {
        return [
            'dialog-title',
            'description',
            'submit',
            'cancel',
            'type',
            'centered',
            'submit-icon',
            'width'
        ];
    }
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $1b7158181746ebe4$var$sheet
        ];
        this.shadowRoot.innerHTML = String($08ec3d656de31381$exports);
        this.dialog = shadow.querySelector('dialog');
        this.cancelBtn = shadow.querySelector('.btn-cancel');
        this.submitBtn = shadow.querySelector('.btn-submit');
        this.titleEl = shadow.querySelector('.dialog-title');
        this.descEl = shadow.querySelector('.dialog-desc');
        this.submitText = shadow.querySelector('#submit_text');
        this.submitIcon = shadow.querySelector('#submit_icon');
    }
    connectedCallback() {
        this.cancelBtn.addEventListener('click', ()=>{
            this.dialog.returnValue = '';
            this.dialog.close();
        });
        // Initialize attributes on first connect
        this.syncAttributes();
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    syncAttributes() {
        if (this.hasAttribute('dialog-title')) this.titleEl.textContent = this.getAttribute('dialog-title');
        if (this.hasAttribute('description')) this.descEl.textContent = this.getAttribute('description');
        this.submitText.textContent = this.getAttribute('submit') || 'Submit';
        this.cancelBtn.textContent = this.getAttribute('cancel') || 'Cancel';
        if (this.hasAttribute('type') && this.getAttribute('type') === 'error') this.dialog.classList.add('error');
        else this.dialog.classList.remove('error');
        if (this.hasAttribute('centered') && this.getAttribute('centered') !== 'false') this.dialog.classList.add('centered');
        else this.dialog.classList.remove('centered');
        if (this.hasAttribute('submit-icon')) {
            this.submitIcon.className = 'icon-' + this.getAttribute('submit-icon');
            (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(this.submitIcon);
        } else (0, $8d5cef8e7fea78a8$export$fe8985bb6374093c)(this.submitIcon);
        if (this.hasAttribute('width')) {
            const value = this.getAttribute('width');
            const isPx = /^\d+$/.test(value);
            this.dialog.style.setProperty('width', isPx ? `${value}px` : value);
        } else this.dialog.style.removeProperty('width');
    }
    /**
   * Opens the dialog, optionally with an initial value.
   */ show(onShow) {
        this.dialog.showModal();
        onShow?.();
        return new Promise((resolve, reject)=>{
            const handleClose = ()=>{
                this.dialog.removeEventListener('close', handleClose);
                if (this.dialog.returnValue === 'confirm') resolve();
                else reject();
            };
            this.dialog.addEventListener('close', handleClose);
        });
    }
    /**
   * Closes the dialog
   */ close() {
        this.dialog.close();
    }
    submit() {
        this.submitBtn.click();
    }
}
customElements.define('confirm-dialog', $1b7158181746ebe4$export$2e2bcd8739ae039);


var $0346d3bbf80d0cab$exports = {};
$0346d3bbf80d0cab$exports = ".hidden{display:none}fieldset{border:none;margin:0 0 1.3em;padding:0}section:not(:last-child){margin-bottom:1em}fieldset:last-child{margin-bottom:0}fieldset>section{margin-top:.3em}.dialog-input{border:solid 1px var(--color-input);color:#fff;box-sizing:border-box;background:0 0;border-radius:4px;outline:none;height:32px!important;padding:4px 8px!important}.dialog-input-small{width:50px}.dialog-input-tall{width:100%;font-size:1.1em;height:50px!important}.dialog-input::selection{color:#000;background:#fff}.dialog-input:hover,.dialog-input:active,.dialog-input:focus-visible{border-color:var(--color-input-active)}.dialog-input:active,.dialog-input:focus-visible{background:#ffffff1a}.dialog-input option{color:#000;background-color:#fff}.row{flex-direction:row;align-items:center;display:flex}.dialog-lesser-select{color:#fffc;cursor:pointer;background:0 0;border:none;border-bottom:1px dotted #ffffff80;height:32px!important;padding:0!important}.dialog-lesser-select option{color:#000}.radio-list{border:solid 1px var(--color-input);box-sizing:border-box;border-radius:4px;align-items:center;width:fit-content;height:32px;padding:4px 8px;display:flex}.radio-list input[type=radio]{margin:0 4px 0 0}input[type=radio]+label{margin-bottom:0;display:inline-block}input[type=radio]+label:not(:last-child){margin-inline-end:1.5em}@font-face{font-family:string_art_studio;src:url(string_art_studio.9cced145.ttf)format(\"truetype\"),url(string_art_studio.44d13d52.woff)format(\"woff\"),url(string_art_studio.ae7f2e94.svg#string_art_studio)format(\"svg\");font-weight:400;font-style:normal;font-display:block}i{speak:never;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:normal;font-weight:400;line-height:1;font-family:string_art_studio!important}.icon-text:before{content:\"\"}.icon-step_back:before{content:\"\"}.icon-step_forward:before{content:\"\"}.icon-thread:before{content:\"\"}.icon-rotate:before{content:\"\"}.icon-pencil:before{content:\"\"}.icon-plus:before{content:\"\"}.icon-trash:before{content:\"\"}.icon-diskette_b:before{content:\"\"}.icon-diskette:before{content:\"\"}.icon-menu:before{content:\"\"}.icon-arrow_left:before{content:\"\"}.icon-arrow_right:before{content:\"\"}.icon-caret_down:before{content:\"\"}.icon-download:before{content:\"\"}.icon-fullscreen:before{content:\"\"}.icon-hamburger:before{content:\"\"}.icon-options:before{content:\"\"}.icon-pause:before{content:\"\"}.icon-play:before{content:\"\"}.icon-refresh:before{content:\"\"}.icon-share:before{content:\"\"}.icon-thumbnails:before{content:\"\"}.icon-x:before{content:\"\"}#buttons{grid-area:\"controls\";border-right:var(--border-light);background:var(--color-header);z-index:3;padding:0 var(--horizontal-padding);justify-content:space-evenly;align-items:center;display:flex;position:relative;box-shadow:0 -2px 6px #0000004d}#buttons .btn{margin:0}.btn{color:#fff;cursor:pointer;background:#0375fb;border:none;border-radius:15px;width:100%;height:30px;margin-bottom:8px}.btn:hover{background:#3592ff}.btn_subdued{color:#000;background:#c5c5c5}.btn_subdued:hover{color:#000;background:#efefef}.circular_btn{width:var(--controls-height);height:var(--controls-height);cursor:pointer;color:var(--color-text);background:0 0;border:none;justify-content:center;align-items:center;font-size:28px;display:flex}.circular_btn:hover{color:var(--color-text);background:#0000004d}.circular_btn img{width:18px;height:18px}.circular_btn.active{background:radial-gradient(circle at 50% 100%,#5205e7,#220c1b);padding:0;box-shadow:inset 0 4px 6px #0009}.circular_btn.active i{transform:scale(.95)}#buttons_dialogs{z-index:2;height:calc(100vh - var(--controls-height) - var(--select-height));width:100%;position:absolute;bottom:100%;overflow:hidden}.buttons_dialog{--buttons-dialog-border-radius:10px;bottom:var(--controls-height);z-index:1;background:var(--color-buttons-dialog);width:var(--sidebar-width);padding:var(--vertical-padding)var(--horizontal-padding);padding-top:calc(2*var(--buttons-dialog-border-radius));border-top:var(--border-light);transition:transform .2s ease-out;position:fixed;transform:translateY(100%);box-shadow:0 -2px 7px #000000b3}.buttons_dialog.open{transform:translateY(0)}.btn-icon{color:#fff;cursor:pointer;background:0 0;border:none;align-items:center;font-size:22px;display:flex}.menu_btn{background:var(--color-accent);height:48px;color:var(--color-text);border-radius:24px;align-items:center;padding:0 32px 0 24px;font-weight:500;text-decoration:none;display:inline-flex;font-size:1.1em!important}@media only screen and (width<=800px){.menu_btn{justify-content:center;width:auto;display:flex}}.menu_btn:hover{background:var(--color-accent-hover);color:var(--color-text);text-decoration:none}.menu_btn img{margin-inline-end:8px}.icon_btn{color:#fffc;cursor:pointer;background:0 0;border:none;border-radius:4px;padding:4px 6px;font-size:14px}.icon_btn:hover{color:#fff}.icon_btn>i{position:relative;top:1px}#wrapper{width:100%;display:block}form{grid-area:form;overflow:auto}#preview{margin-top:1em}#canvas{--checkers1:#fff;--checkers2:#bbb;box-sizing:border-box;background:conic-gradient(var(--checkers2)25%,var(--checkers1)0 50%,var(--checkers2)0 75%,var(--checkers1)0);background-size:40px 40px;outline:1px solid #666;width:100%;height:300px;margin-top:4px;position:relative;box-shadow:inset 0 1px 5px #0000}canvas{width:100%;height:100%;position:absolute;top:0;left:0}@media only screen and (width<=800px){#canvas{max-height:250px}}@media only screen and (width>=801px){#wrapper{grid-template:\"preview form\"1fr/200px 1fr;gap:1em;display:grid}#preview{grid-area:preview;margin-top:0}}section{margin-bottom:1px}label:not(.icon_btn){margin-bottom:4px;display:block}input[type=checkbox]:checked+.icon_btn{color:#fff;background:#ffffff1a}";


var $7daf604df182e360$exports = {};
$7daf604df182e360$exports = "<confirm-dialog dialog-title=\"Download image\" submit=Download submit-icon=download centered width=640>\n  <div id=wrapper>\n    <form>\n      <fieldset>\n        <label for=type>Type</label>\n        <div class=radio-list>\n          <input type=radio name=type id=type_all value=all checked>\n          <label for=type_all>Image</label>\n          <input type=radio name=type id=type_nails_map value=nails_map>\n          <label for=type_nails_map>Nails map 🔨</label>\n        </div>\n      </fieldset>\n      <label for=size>Image size</label>\n      <section>\n        <div style=flex:0>\n          <select id=size class=dialog-input style=width:auto name=size></select>\n        </div>\n        <div style=white-space:nowrap;flex:1;margin-top:.5em>\n          <div id=width_and_height>\n            <dimensions-input id=image_dimensions name=image_dimensions></dimensions-input>\n            <select class=\"dialog-lesser-select unit-select\" name=unit>\n              <option value=cm>cm</option>\n              <option value=inch>inch</option>\n              <option value=px>px</option>\n            </select>\n            <input type=checkbox id=rotate_image name=rotate_image hidden>\n            <label id=rotate_btn class=icon_btn title=Rotate type=button for=rotate_image>\n              <i class=icon-rotate></i>\n            </label>\n          </div>\n        </div>\n      </section>\n      <section>\n        <label for=pattern_size>Pattern size</label>\n        <dimensions-input id=pattern_size name=pattern_dimensions></dimensions-input>\n        <select class=\"dialog-lesser-select unit-select\" name=unit>\n          <option value=cm>cm</option>\n          <option value=inch>inch</option>\n          <option value=px>px</option>\n        </select>\n      </section>\n      <section>\n        <label for=margin>Margin</label>\n        <input type=number id=margin value=0 style=width:70px min=0 step=1 class=\"dialog-input size-input\" name=margin>\n        <select class=\"dialog-lesser-select unit-select\" name=unit>\n          <option value=cm>cm</option>\n          <option value=inch>inch</option>\n          <option value=px>px</option>\n        </select>\n      </section>\n      <div style=margin-top:1.5em>\n        <expandable-panel legend=\"More options\" minimized>\n          <fieldset class=dialog-checkbox hidden id=render_numbers_block>\n            <string-art-checkbox id=render_numbers label=\"Show nail numbers\" name=render_numbers data-updates-preview>\n          </string-art-checkbox></fieldset>\n\n          <fieldset id=dpi_block>\n            <label for=dpi>Print resolution</label>\n            <select id=dpi value=300 class=dialog-input style=width:80px name=dpi>\n              <option value=72>72</option>\n              <option value=150>150</option>\n              <option value=200>200</option>\n              <option value=300 selected>300</option>\n              <option value=360>360</option>\n              <option value=600>600</option>\n              <option value=720>720</option>\n              <option value=1200>1200</option>\n              <option value=2400>2400</option>\n              <option value=2880>2880</option>\n            </select>\n            <label for=dpi style=display:inline>DPI</label>\n          </fieldset>\n          <fieldset>\n            <section>\n              <label for=format>Image type</label>\n              <select id=format class=dialog-input name=format data-updates-preview>\n                <option value=png>PNG</option>\n                <option value=jpeg>JPEG</option>\n                <option value=webp>WEBP</option>\n                <option value=svg>SVG</option>\n              </select>\n            </section>\n            <section id=transparent_background_block>\n              <string-art-checkbox id=transparent_background label=\"Transparent background\" name=transparent_background data-updates-preview>\n            </string-art-checkbox></section>\n          </fieldset>\n        </expandable-panel>\n      </div>\n    </form>\n    <div id=preview>\n      Preview\n      <article id=canvas></article>\n    </div>\n  </div>\n</confirm-dialog>\n";




const $37ffe584ad149ed5$var$UNITS_LOCALSTORAGE_KEY = 'units';
class $37ffe584ad149ed5$var$Preferences extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    #userPreferredUnits;
    getUserPreferredUnits() {
        if (!this.#userPreferredUnits) this.#userPreferredUnits = localStorage.getItem($37ffe584ad149ed5$var$UNITS_LOCALSTORAGE_KEY) === 'inch' ? 'inch' : 'cm';
        return this.#userPreferredUnits;
    }
    setUserPreferredUnits(units) {
        if (this.#userPreferredUnits !== units) {
            this.#userPreferredUnits = units;
            localStorage.setItem($37ffe584ad149ed5$var$UNITS_LOCALSTORAGE_KEY, units);
            this.emit('unitsChange', units);
        }
    }
}
const $37ffe584ad149ed5$var$preferences = new $37ffe584ad149ed5$var$Preferences();
var $37ffe584ad149ed5$export$2e2bcd8739ae039 = $37ffe584ad149ed5$var$preferences;





const $9ecbf20527c60613$var$DEFAULT_DIMENSIONS = [
    10,
    10
];
const $9ecbf20527c60613$export$1ddaf6ceff5ce8d6 = [
    {
        id: 'fit',
        name: 'Fit pattern',
        dimensions: ({ customDimensions: customDimensions, patternAspectRatio: patternAspectRatio })=>{
            let dimensions = customDimensions;
            if (!dimensions) {
                const SMALL_SCREEN_DIMENSION = Math.min(screen.width, screen.height);
                const dpr = window.devicePixelRatio ?? 1;
                dimensions = (0, $b683a3137b30eaa9$export$c566af9defc62c6)([
                    SMALL_SCREEN_DIMENSION,
                    SMALL_SCREEN_DIMENSION
                ], (v)=>v * dpr);
            }
            const customDimensionsFitPattern = [
                dimensions[0],
                dimensions[0] / patternAspectRatio
            ];
            return (0, $b683a3137b30eaa9$export$18c295d7a6a8189d)(customDimensionsFitPattern, dimensions);
        },
        units: [
            'px',
            'cm',
            'inch'
        ],
        defaultUnits: 'px',
        defaultMargin: 20,
        allowSizeEdit: true,
        aspectRatio: ({ patternAspectRatio: patternAspectRatio })=>patternAspectRatio
    },
    {
        id: 'screen',
        name: 'Screen size',
        dimensions: ()=>{
            const dpr = window.devicePixelRatio ?? 1;
            return [
                window.screen.width,
                window.screen.height
            ].map((v)=>Math.floor(v * dpr));
        },
        units: [
            'px'
        ],
        defaultMargin: 10,
        allowRotate: true
    },
    ...(0, $b683a3137b30eaa9$export$e8dd885a22676074).map((size)=>({
            ...size,
            units: [
                'cm',
                'inch'
            ],
            inUnits: 'cm',
            defaultMargin: 1,
            allowRotate: true
        })),
    {
        id: 'custom',
        name: "Custom size\u2026",
        units: [
            'px',
            'cm',
            'inch'
        ],
        dimensions: ({ customDimensions: customDimensions, currentDimensions: currentDimensions })=>currentDimensions ?? customDimensions ?? $9ecbf20527c60613$var$DEFAULT_DIMENSIONS,
        allowSizeEdit: true,
        allowRotate: true
    }
];
function $9ecbf20527c60613$export$1c29b97c038fa375(id) {
    return $9ecbf20527c60613$export$1ddaf6ceff5ce8d6.find(({ id: sizeId })=>sizeId === id);
}




var $e444d6404c095fa5$var$t = "undefined" != typeof window ? window : void 0, $e444d6404c095fa5$var$i = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$t, $e444d6404c095fa5$var$e = Array.prototype, $e444d6404c095fa5$var$r = $e444d6404c095fa5$var$e.forEach, $e444d6404c095fa5$var$s = $e444d6404c095fa5$var$e.indexOf, $e444d6404c095fa5$var$n = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.navigator, $e444d6404c095fa5$var$o = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.document, $e444d6404c095fa5$var$a = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.location, $e444d6404c095fa5$var$l = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.fetch, $e444d6404c095fa5$var$u = null != $e444d6404c095fa5$var$i && $e444d6404c095fa5$var$i.XMLHttpRequest && "withCredentials" in new $e444d6404c095fa5$var$i.XMLHttpRequest ? $e444d6404c095fa5$var$i.XMLHttpRequest : void 0, $e444d6404c095fa5$var$h = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.AbortController, $e444d6404c095fa5$var$d = null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.userAgent, $e444d6404c095fa5$var$v = null != $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t : {}, $e444d6404c095fa5$var$c = {
    DEBUG: !1,
    LIB_VERSION: "1.284.0"
};
function $e444d6404c095fa5$var$f(t, i, e, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void e(t);
    }
    a.done ? i(l) : Promise.resolve(l).then(r, s);
}
function $e444d6404c095fa5$var$p(t) {
    return function() {
        var i = this, e = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(i, e);
            function o(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $e444d6404c095fa5$var$g() {
    return $e444d6404c095fa5$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var e = arguments[i];
            for(var r in e)({}).hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $e444d6404c095fa5$var$g.apply(null, arguments);
}
function $e444d6404c095fa5$var$_(t, i) {
    if (null == t) return {};
    var e = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== i.indexOf(r)) continue;
        e[r] = t[r];
    }
    return e;
}
var $e444d6404c095fa5$var$m = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $e444d6404c095fa5$var$y = function(t, i) {
    if (void 0 === i && (i = []), !t) return !1;
    var e = t.toLowerCase();
    return $e444d6404c095fa5$var$m.concat(i).some((t)=>{
        var i = t.toLowerCase();
        return -1 !== e.indexOf(i);
    });
}, $e444d6404c095fa5$var$b = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
function $e444d6404c095fa5$var$w(t, i) {
    return -1 !== t.indexOf(i);
}
var $e444d6404c095fa5$var$x = function(t) {
    return t.trim();
}, $e444d6404c095fa5$var$S = function(t) {
    return t.replace(/^\$/, "");
};
var $e444d6404c095fa5$var$E = Array.isArray, $e444d6404c095fa5$var$k = Object.prototype, $e444d6404c095fa5$var$P = $e444d6404c095fa5$var$k.hasOwnProperty, $e444d6404c095fa5$var$T = $e444d6404c095fa5$var$k.toString, $e444d6404c095fa5$var$R = $e444d6404c095fa5$var$E || function(t) {
    return "[object Array]" === $e444d6404c095fa5$var$T.call(t);
}, $e444d6404c095fa5$var$I = (t)=>"function" == typeof t, $e444d6404c095fa5$var$C = (t)=>t === Object(t) && !$e444d6404c095fa5$var$R(t), $e444d6404c095fa5$var$O = (t)=>{
    if ($e444d6404c095fa5$var$C(t)) {
        for(var i in t)if ($e444d6404c095fa5$var$P.call(t, i)) return !1;
        return !0;
    }
    return !1;
}, $e444d6404c095fa5$var$F = (t)=>void 0 === t, $e444d6404c095fa5$var$M = (t)=>"[object String]" == $e444d6404c095fa5$var$T.call(t), $e444d6404c095fa5$var$A = (t)=>$e444d6404c095fa5$var$M(t) && 0 === t.trim().length, $e444d6404c095fa5$var$D = (t)=>null === t, $e444d6404c095fa5$var$j = (t)=>$e444d6404c095fa5$var$F(t) || $e444d6404c095fa5$var$D(t), $e444d6404c095fa5$var$L = (t)=>"[object Number]" == $e444d6404c095fa5$var$T.call(t), $e444d6404c095fa5$var$N = (t)=>"[object Boolean]" === $e444d6404c095fa5$var$T.call(t), $e444d6404c095fa5$var$U = (t)=>t instanceof FormData, $e444d6404c095fa5$var$z = (t)=>$e444d6404c095fa5$var$w($e444d6404c095fa5$var$b, t);
function $e444d6404c095fa5$var$H(t) {
    return null === t || "object" != typeof t;
}
function $e444d6404c095fa5$var$B(t, i) {
    return Object.prototype.toString.call(t) === "[object " + i + "]";
}
function $e444d6404c095fa5$var$q(t) {
    return !$e444d6404c095fa5$var$F(Event) && function(t, i) {
        try {
            return t instanceof i;
        } catch (t) {
            return !1;
        }
    }(t, Event);
}
var $e444d6404c095fa5$var$W = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $e444d6404c095fa5$var$G = (t)=>$e444d6404c095fa5$var$w($e444d6404c095fa5$var$W, t), $e444d6404c095fa5$var$V = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $e444d6404c095fa5$var$J(t, i, e, r, s) {
    return i > e && (r.warn("min cannot be greater than max."), i = e), $e444d6404c095fa5$var$L(t) ? t > e ? (r.warn(" cannot be  greater than max: " + e + ". Using max value instead."), e) : t < i ? (r.warn(" cannot be less than min: " + i + ". Using min value instead."), i) : t : (r.warn(" must be a number. using max or fallback. max: " + e + ", fallback: " + s), $e444d6404c095fa5$var$J(s || e, i, e, r));
}
class $e444d6404c095fa5$var$K {
    constructor(t){
        this.t = {}, this.i = t.i, this.o = $e444d6404c095fa5$var$J(t.bucketSize, 0, 100, t.h), this.m = $e444d6404c095fa5$var$J(t.refillRate, 0, this.o, t.h), this.S = $e444d6404c095fa5$var$J(t.refillInterval, 0, 864e5, t.h);
    }
    $(t, i) {
        var e = i - t.lastAccess, r = Math.floor(e / this.S);
        if (r > 0) {
            var s = r * this.m;
            t.tokens = Math.min(t.tokens + s, this.o), t.lastAccess = t.lastAccess + r * this.S;
        }
    }
    consumeRateLimit(t) {
        var i, e = Date.now(), r = String(t), s = this.t[r];
        return s ? this.$(s, e) : (s = {
            tokens: this.o,
            lastAccess: e
        }, this.t[r] = s), 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (i = this.i) || i.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.t = {};
    }
}
var $e444d6404c095fa5$var$Y, $e444d6404c095fa5$var$X, $e444d6404c095fa5$var$Q, $e444d6404c095fa5$var$Z = (t)=>t instanceof Error;
function $e444d6404c095fa5$var$tt(t) {
    var i = globalThis._posthogChunkIds;
    if (i) {
        var e = Object.keys(i);
        return $e444d6404c095fa5$var$Q && e.length === $e444d6404c095fa5$var$X || ($e444d6404c095fa5$var$X = e.length, $e444d6404c095fa5$var$Q = e.reduce((e, r)=>{
            $e444d6404c095fa5$var$Y || ($e444d6404c095fa5$var$Y = {});
            var s = $e444d6404c095fa5$var$Y[r];
            if (s) e[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = i[r];
                if (l && u) {
                    e[l] = u, $e444d6404c095fa5$var$Y[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return e;
        }, {})), $e444d6404c095fa5$var$Q;
    }
}
var $e444d6404c095fa5$var$it = "?";
function $e444d6404c095fa5$var$et(t, i, e, r) {
    var s = {
        platform: "web:javascript",
        filename: t,
        function: "<anonymous>" === i ? $e444d6404c095fa5$var$it : i,
        in_app: !0
    };
    return $e444d6404c095fa5$var$F(e) || (s.lineno = e), $e444d6404c095fa5$var$F(r) || (s.colno = r), s;
}
var $e444d6404c095fa5$var$rt = (t, i)=>{
    var e = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return e || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $e444d6404c095fa5$var$it,
        e ? "safari-extension:" + i : "safari-web-extension:" + i
    ] : [
        t,
        i
    ];
}, $e444d6404c095fa5$var$st = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $e444d6404c095fa5$var$nt = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $e444d6404c095fa5$var$ot = /\((\S*)(?::(\d+))(?::(\d+))\)/, $e444d6404c095fa5$var$at = (t)=>{
    var i = $e444d6404c095fa5$var$st.exec(t);
    if (i) {
        var [, e, r, s] = i;
        return $e444d6404c095fa5$var$et(e, $e444d6404c095fa5$var$it, +r, +s);
    }
    var n = $e444d6404c095fa5$var$nt.exec(t);
    if (n) {
        if (n[2] && 0 === n[2].indexOf("eval")) {
            var o = $e444d6404c095fa5$var$ot.exec(n[2]);
            o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
        }
        var [a, l] = $e444d6404c095fa5$var$rt(n[1] || $e444d6404c095fa5$var$it, n[2]);
        return $e444d6404c095fa5$var$et(l, a, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
    }
}, $e444d6404c095fa5$var$lt = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $e444d6404c095fa5$var$ut = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $e444d6404c095fa5$var$ht = (t)=>{
    var i = $e444d6404c095fa5$var$lt.exec(t);
    if (i) {
        if (i[3] && i[3].indexOf(" > eval") > -1) {
            var e = $e444d6404c095fa5$var$ut.exec(i[3]);
            e && (i[1] = i[1] || "eval", i[3] = e[1], i[4] = e[2], i[5] = "");
        }
        var r = i[3], s = i[1] || $e444d6404c095fa5$var$it;
        return [s, r] = $e444d6404c095fa5$var$rt(s, r), $e444d6404c095fa5$var$et(r, s, i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
    }
}, $e444d6404c095fa5$var$dt = /\(error: (.*)\)/, $e444d6404c095fa5$var$vt = 50;
function $e444d6404c095fa5$var$ct() {
    for(var t = arguments.length, i = new Array(t), e = 0; e < t; e++)i[e] = arguments[e];
    return function(t, e) {
        void 0 === e && (e = 0);
        for(var r = [], s = t.split("\n"), n = e; n < s.length; n++){
            var o = s[n];
            if (!(o.length > 1024)) {
                var a = $e444d6404c095fa5$var$dt.test(o) ? o.replace($e444d6404c095fa5$var$dt, "$1") : o;
                if (!a.match(/\S*Error: /)) {
                    for (var l of i){
                        var u = l(a);
                        if (u) {
                            r.push(u);
                            break;
                        }
                    }
                    if (r.length >= $e444d6404c095fa5$var$vt) break;
                }
            }
        }
        return function(t) {
            if (!t.length) return [];
            var i = Array.from(t);
            return i.reverse(), i.slice(0, $e444d6404c095fa5$var$vt).map((t)=>{
                var e;
                return $e444d6404c095fa5$var$g({}, t, {
                    filename: t.filename || (e = i, e[e.length - 1] || {}).filename,
                    function: t.function || $e444d6404c095fa5$var$it
                });
            });
        }(r);
    };
}
class $e444d6404c095fa5$var$ft {
    constructor(t, i, e){
        void 0 === t && (t = []), void 0 === i && (i = []), void 0 === e && (e = []), this.coercers = t, this.modifiers = e, this.stackParser = $e444d6404c095fa5$var$ct(...i);
    }
    buildFromUnknown(t, i) {
        void 0 === i && (i = {});
        var e = i && i.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(e, i, 0).apply(t), s = this.buildParsingContext(), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, e),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var i = this;
        return $e444d6404c095fa5$var$p(function*() {
            for (var e of t)e.stacktrace && e.stacktrace.frames && $e444d6404c095fa5$var$R(e.stacktrace.frames) && (e.stacktrace.frames = yield i.applyModifiers(e.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var i;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (i = t.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, i) {
        var e, r;
        return null != t.cause && (e = this.parseStacktrace(t.cause, i)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? 1 : 0), i.chunkIdMap)), $e444d6404c095fa5$var$g({}, t, {
            cause: e,
            stack: r
        });
    }
    applyChunkIds(t, i) {
        return t.map((t)=>(t.filename && i && (t.chunk_id = i[t.filename]), t));
    }
    applyCoercers(t, i) {
        for (var e of this.coercers)if (e.match(t)) return e.coerce(t, i);
        return this.coerceFallback(i);
    }
    applyModifiers(t) {
        var i = this;
        return $e444d6404c095fa5$var$p(function*() {
            var e = t;
            for (var r of i.modifiers)e = yield r(e);
            return e;
        })();
    }
    convertToExceptionList(t, i) {
        var e, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (e = i.type) && void 0 !== e ? e : "generic",
                handled: null === (r = i.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $e444d6404c095fa5$var$g({}, i, {
            handled: !0
        }))), o;
    }
    buildParsingContext() {
        return {
            chunkIdMap: $e444d6404c095fa5$var$tt(this.stackParser)
        };
    }
    buildCoercingContext(t, i, e) {
        void 0 === e && (e = 0);
        var r = (e, r)=>{
            if (r <= 4) {
                var s = this.buildCoercingContext(t, i, r);
                return this.applyCoercers(e, s);
            }
        };
        return $e444d6404c095fa5$var$g({}, i, {
            syntheticException: 0 == e ? i.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, e),
            next: (t)=>r(t, e + 1)
        });
    }
}
class $e444d6404c095fa5$var$pt {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, i) {
        var e = $e444d6404c095fa5$var$M(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: e ? t.stack : void 0,
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var i = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? i + ": " + t.message : i;
    }
    isDOMException(t) {
        return $e444d6404c095fa5$var$B(t, "DOMException");
    }
    isDOMError(t) {
        return $e444d6404c095fa5$var$B(t, "DOMError");
    }
}
class $e444d6404c095fa5$var$gt {
    match(t) {
        return ((t)=>t instanceof Error)(t);
    }
    coerce(t, i) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, i),
            stack: this.getStack(t),
            cause: t.cause ? i.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, i) {
        var e = t.message;
        return e.error && "string" == typeof e.error.message ? String(e.error.message) : String(e);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $e444d6404c095fa5$var$_t {
    constructor(){}
    match(t) {
        return $e444d6404c095fa5$var$B(t, "ErrorEvent") && null != t.error;
    }
    coerce(t, i) {
        var e, r = i.apply(t.error);
        return r || {
            type: "ErrorEvent",
            value: t.message,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
var $e444d6404c095fa5$var$mt = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $e444d6404c095fa5$var$yt {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, i) {
        var e, [r, s] = this.getInfos(t);
        return {
            type: null != r ? r : "Error",
            value: null != s ? s : t,
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var i = "Error", e = t, r = t.match($e444d6404c095fa5$var$mt);
        return r && (i = r[1], e = r[2]), [
            i,
            e
        ];
    }
}
var $e444d6404c095fa5$var$bt = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $e444d6404c095fa5$var$wt(t, i) {
    void 0 === i && (i = 40);
    var e = Object.keys(t);
    if (e.sort(), !e.length) return "[object has no keys]";
    for(var r = e.length; r > 0; r--){
        var s = e.slice(0, r).join(", ");
        if (!(s.length > i)) return r === e.length || s.length <= i ? s : s.slice(0, i) + "...";
    }
    return "";
}
class $e444d6404c095fa5$var$xt {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, i) {
        var e, r = this.getErrorPropertyFromObject(t);
        return r ? i.apply(r) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $e444d6404c095fa5$var$q(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var i = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (i += " with message: '" + t.message + "'"), i;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var e = this.getObjectClassName(t);
        return (e && "Object" !== e ? "'" + e + "'" : "Object") + " captured as exception with keys: " + $e444d6404c095fa5$var$wt(t);
    }
    isSeverityLevel(t) {
        return $e444d6404c095fa5$var$M(t) && !$e444d6404c095fa5$var$A(t) && $e444d6404c095fa5$var$bt.indexOf(t) >= 0;
    }
    getErrorPropertyFromObject(t) {
        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i)) {
            var e = t[i];
            if ($e444d6404c095fa5$var$Z(e)) return e;
        }
    }
    getObjectClassName(t) {
        try {
            var i = Object.getPrototypeOf(t);
            return i ? i.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $e444d6404c095fa5$var$St {
    match(t) {
        return $e444d6404c095fa5$var$q(t);
    }
    coerce(t, i) {
        var e, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $e444d6404c095fa5$var$wt(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$Et {
    match(t) {
        return $e444d6404c095fa5$var$H(t);
    }
    coerce(t, i) {
        var e;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$$t {
    match(t) {
        return $e444d6404c095fa5$var$B(t, "PromiseRejectionEvent");
    }
    coerce(t, i) {
        var e, r = this.getUnhandledRejectionReason(t);
        return $e444d6404c095fa5$var$H(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (e = i.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        } : i.apply(r);
    }
    getUnhandledRejectionReason(t) {
        if ($e444d6404c095fa5$var$H(t)) return t;
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $e444d6404c095fa5$var$kt = (i)=>{
    var e = {
        k: function(e) {
            if ($e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$c.DEBUG || $e444d6404c095fa5$var$v.POSTHOG_DEBUG) && !$e444d6404c095fa5$var$F($e444d6404c095fa5$var$t.console) && $e444d6404c095fa5$var$t.console) {
                for(var r = ("__rrweb_original__" in $e444d6404c095fa5$var$t.console[e]) ? $e444d6404c095fa5$var$t.console[e].__rrweb_original__ : $e444d6404c095fa5$var$t.console[e], s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), o = 1; o < s; o++)n[o - 1] = arguments[o];
                r(i, ...n);
            }
        },
        info: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.k("log", ...i);
        },
        warn: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.k("warn", ...i);
        },
        error: function() {
            for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
            e.k("error", ...i);
        },
        critical: function() {
            for(var t = arguments.length, e = new Array(t), r = 0; r < t; r++)e[r] = arguments[r];
            console.error(i, ...e);
        },
        uninitializedWarning: (t)=>{
            e.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t)=>$e444d6404c095fa5$var$kt(i + " " + t)
    };
    return e;
}, $e444d6404c095fa5$var$Pt = $e444d6404c095fa5$var$kt("[PostHog.js]"), $e444d6404c095fa5$var$Tt = $e444d6404c095fa5$var$Pt.createLogger, $e444d6404c095fa5$var$Rt = $e444d6404c095fa5$var$Tt("[ExternalScriptsLoader]"), $e444d6404c095fa5$var$It = (t, i, e)=>{
    if (t.config.disable_external_dependency_loading) return $e444d6404c095fa5$var$Rt.warn(i + " was requested but loading of external scripts is disabled."), e("Loading of external scripts is disabled");
    var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll("script");
    if (r) {
        for(var s, n = function() {
            if (r[a].src === i) {
                var t = r[a];
                return t.__posthog_loading_callback_fired ? {
                    v: e()
                } : (t.addEventListener("load", (i)=>{
                    t.__posthog_loading_callback_fired = !0, e(void 0, i);
                }), t.onerror = (t)=>e(t), {
                    v: void 0
                });
            }
        }, a = 0; a < r.length; a++)if (s = n()) return s.v;
    }
    var l = ()=>{
        if (!$e444d6404c095fa5$var$o) return e("document not found");
        var r = $e444d6404c095fa5$var$o.createElement("script");
        if (r.type = "text/javascript", r.crossOrigin = "anonymous", r.src = i, r.onload = (t)=>{
            r.__posthog_loading_callback_fired = !0, e(void 0, t);
        }, r.onerror = (t)=>e(t), t.config.prepare_external_dependency_script && (r = t.config.prepare_external_dependency_script(r)), !r) return e("prepare_external_dependency_script returned null");
        var s, n = $e444d6404c095fa5$var$o.querySelectorAll("body > script");
        n.length > 0 ? null == (s = n[0].parentNode) || s.insertBefore(r, n[0]) : $e444d6404c095fa5$var$o.body.appendChild(r);
    };
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.body ? l() : null == $e444d6404c095fa5$var$o || $e444d6404c095fa5$var$o.addEventListener("DOMContentLoaded", l);
};
$e444d6404c095fa5$var$v.__PosthogExtensions__ = $e444d6404c095fa5$var$v.__PosthogExtensions__ || {}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadExternalDependency = (t, i, e)=>{
    var r = "/static/" + i + ".js?v=" + t.version;
    if ("remote-config" === i && (r = "/array/" + t.config.token + "/config.js"), "toolbar" === i) {
        var s = 3e5;
        r = r + "&t=" + Math.floor(Date.now() / s) * s;
    }
    var n = t.requestRouter.endpointFor("assets", r);
    $e444d6404c095fa5$var$It(t, n, e);
}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadSiteApp = (t, i, e)=>{
    var r = t.requestRouter.endpointFor("api", i);
    $e444d6404c095fa5$var$It(t, r, e);
};
var $e444d6404c095fa5$var$Ct = {};
function $e444d6404c095fa5$var$Ot(t, i, e) {
    if ($e444d6404c095fa5$var$R(t)) {
        if ($e444d6404c095fa5$var$r && t.forEach === $e444d6404c095fa5$var$r) t.forEach(i, e);
        else if ("length" in t && t.length === +t.length) {
            for(var s = 0, n = t.length; s < n; s++)if (s in t && i.call(e, t[s], s) === $e444d6404c095fa5$var$Ct) return;
        }
    }
}
function $e444d6404c095fa5$var$Ft(t, i, e) {
    if (!$e444d6404c095fa5$var$j(t)) {
        if ($e444d6404c095fa5$var$R(t)) return $e444d6404c095fa5$var$Ot(t, i, e);
        if ($e444d6404c095fa5$var$U(t)) {
            for (var r of t.entries())if (i.call(e, r[1], r[0]) === $e444d6404c095fa5$var$Ct) return;
        } else for(var s in t)if ($e444d6404c095fa5$var$P.call(t, s) && i.call(e, t[s], s) === $e444d6404c095fa5$var$Ct) return;
    }
}
var $e444d6404c095fa5$var$Mt = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Ot(e, function(i) {
        for(var e in i)void 0 !== i[e] && (t[e] = i[e]);
    }), t;
}, $e444d6404c095fa5$var$At = function(t) {
    for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
    return $e444d6404c095fa5$var$Ot(e, function(i) {
        $e444d6404c095fa5$var$Ot(i, function(i) {
            t.push(i);
        });
    }), t;
};
function $e444d6404c095fa5$var$Dt(t) {
    for(var i = Object.keys(t), e = i.length, r = new Array(e); e--;)r[e] = [
        i[e],
        t[i[e]]
    ];
    return r;
}
var $e444d6404c095fa5$var$jt = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $e444d6404c095fa5$var$Lt = function(t) {
    return function() {
        try {
            for(var i = arguments.length, e = new Array(i), r = 0; r < i; r++)e[r] = arguments[r];
            return t.apply(this, e);
        } catch (t) {
            $e444d6404c095fa5$var$Pt.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $e444d6404c095fa5$var$Pt.critical(t);
        }
    };
}, $e444d6404c095fa5$var$Nt = function(t) {
    var i = {};
    return $e444d6404c095fa5$var$Ft(t, function(t, e) {
        ($e444d6404c095fa5$var$M(t) && t.length > 0 || $e444d6404c095fa5$var$L(t)) && (i[e] = t);
    }), i;
};
function $e444d6404c095fa5$var$Ut(t, i) {
    var e, r, s;
    return e = t, r = (t)=>$e444d6404c095fa5$var$M(t) && !$e444d6404c095fa5$var$D(i) ? t.slice(0, i) : t, s = new Set, function t(i, e) {
        var n;
        return i !== Object(i) ? r ? r(i, e) : i : s.has(i) ? void 0 : (s.add(i), $e444d6404c095fa5$var$R(i) ? (n = [], $e444d6404c095fa5$var$Ot(i, (i)=>{
            n.push(t(i));
        })) : (n = {}, $e444d6404c095fa5$var$Ft(i, (i, e)=>{
            s.has(i) || (n[e] = t(i, e));
        })), n);
    }(e);
}
var $e444d6404c095fa5$var$zt = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $e444d6404c095fa5$var$Ht(t) {
    var i = null == t ? void 0 : t.hostname;
    if (!$e444d6404c095fa5$var$M(i)) return !1;
    var e = i.split(".").slice(-2).join(".");
    for (var r of $e444d6404c095fa5$var$zt)if (e === r) return !1;
    return !0;
}
function $e444d6404c095fa5$var$Bt(t, i) {
    for(var e = 0; e < t.length; e++)if (i(t[e])) return t[e];
}
function $e444d6404c095fa5$var$qt(t, i, e, r) {
    var { capture: s = !1, passive: n = !0 } = null != r ? r : {};
    null == t || t.addEventListener(i, e, {
        capture: s,
        passive: n
    });
}
var $e444d6404c095fa5$var$Wt = "$people_distinct_id", $e444d6404c095fa5$var$Gt = "__alias", $e444d6404c095fa5$var$Vt = "__timers", $e444d6404c095fa5$var$Jt = "$autocapture_disabled_server_side", $e444d6404c095fa5$var$Kt = "$heatmaps_enabled_server_side", $e444d6404c095fa5$var$Yt = "$exception_capture_enabled_server_side", $e444d6404c095fa5$var$Xt = "$error_tracking_suppression_rules", $e444d6404c095fa5$var$Qt = "$error_tracking_capture_extension_exceptions", $e444d6404c095fa5$var$Zt = "$web_vitals_enabled_server_side", $e444d6404c095fa5$var$ti = "$dead_clicks_enabled_server_side", $e444d6404c095fa5$var$ii = "$web_vitals_allowed_metrics", $e444d6404c095fa5$var$ei = "$session_recording_remote_config", $e444d6404c095fa5$var$ri = "$sesid", $e444d6404c095fa5$var$si = "$session_is_sampled", $e444d6404c095fa5$var$ni = "$enabled_feature_flags", $e444d6404c095fa5$var$oi = "$early_access_features", $e444d6404c095fa5$var$ai = "$feature_flag_details", $e444d6404c095fa5$var$li = "$stored_person_properties", $e444d6404c095fa5$var$ui = "$stored_group_properties", $e444d6404c095fa5$var$hi = "$surveys", $e444d6404c095fa5$var$di = "$surveys_activated", $e444d6404c095fa5$var$vi = "$flag_call_reported", $e444d6404c095fa5$var$ci = "$user_state", $e444d6404c095fa5$var$fi = "$client_session_props", $e444d6404c095fa5$var$pi = "$capture_rate_limit", $e444d6404c095fa5$var$gi = "$initial_campaign_params", $e444d6404c095fa5$var$_i = "$initial_referrer_info", $e444d6404c095fa5$var$mi = "$initial_person_info", $e444d6404c095fa5$var$yi = "$epp", $e444d6404c095fa5$var$bi = "__POSTHOG_TOOLBAR__", $e444d6404c095fa5$var$wi = "$posthog_cookieless", $e444d6404c095fa5$var$xi = [
    $e444d6404c095fa5$var$Wt,
    $e444d6404c095fa5$var$Gt,
    "__cmpns",
    $e444d6404c095fa5$var$Vt,
    "$session_recording_enabled_server_side",
    $e444d6404c095fa5$var$Kt,
    $e444d6404c095fa5$var$ri,
    $e444d6404c095fa5$var$ni,
    $e444d6404c095fa5$var$Xt,
    $e444d6404c095fa5$var$ci,
    $e444d6404c095fa5$var$oi,
    $e444d6404c095fa5$var$ai,
    $e444d6404c095fa5$var$ui,
    $e444d6404c095fa5$var$li,
    $e444d6404c095fa5$var$hi,
    $e444d6404c095fa5$var$vi,
    $e444d6404c095fa5$var$fi,
    $e444d6404c095fa5$var$pi,
    $e444d6404c095fa5$var$gi,
    $e444d6404c095fa5$var$_i,
    $e444d6404c095fa5$var$yi,
    $e444d6404c095fa5$var$mi
];
function $e444d6404c095fa5$var$Si(t) {
    return t instanceof Element && (t.id === $e444d6404c095fa5$var$bi || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $e444d6404c095fa5$var$Ei(t) {
    return !!t && 1 === t.nodeType;
}
function $e444d6404c095fa5$var$$i(t, i) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === i.toLowerCase();
}
function $e444d6404c095fa5$var$ki(t) {
    return !!t && 3 === t.nodeType;
}
function $e444d6404c095fa5$var$Pi(t) {
    return !!t && 11 === t.nodeType;
}
function $e444d6404c095fa5$var$Ti(t) {
    return t ? $e444d6404c095fa5$var$x(t).split(/\s+/) : [];
}
function $e444d6404c095fa5$var$Ri(i) {
    var e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.href;
    return !!(e && i && i.some((t)=>e.match(t)));
}
function $e444d6404c095fa5$var$Ii(t) {
    var i = "";
    switch(typeof t.className){
        case "string":
            i = t.className;
            break;
        case "object":
            i = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            i = "";
    }
    return $e444d6404c095fa5$var$Ti(i);
}
function $e444d6404c095fa5$var$Ci(t) {
    return $e444d6404c095fa5$var$j(t) ? null : $e444d6404c095fa5$var$x(t).split(/(\s+)/).filter((t)=>$e444d6404c095fa5$var$Ki(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $e444d6404c095fa5$var$Oi(t) {
    var i = "";
    return $e444d6404c095fa5$var$zi(t) && !$e444d6404c095fa5$var$Hi(t) && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ft(t.childNodes, function(t) {
        var e;
        $e444d6404c095fa5$var$ki(t) && t.textContent && (i += null !== (e = $e444d6404c095fa5$var$Ci(t.textContent)) && void 0 !== e ? e : "");
    }), $e444d6404c095fa5$var$x(i);
}
function $e444d6404c095fa5$var$Fi(t) {
    var i;
    return $e444d6404c095fa5$var$F(t.target) ? t.srcElement || null : null != (i = t.target) && i.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $e444d6404c095fa5$var$Mi = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $e444d6404c095fa5$var$Ai(t, i) {
    if ($e444d6404c095fa5$var$F(i)) return !0;
    var e, r = function(t) {
        if (i.some((i)=>t.matches(i))) return {
            v: !0
        };
    };
    for (var s of t)if (e = r(s)) return e.v;
    return !1;
}
function $e444d6404c095fa5$var$Di(t) {
    var i = t.parentNode;
    return !(!i || !$e444d6404c095fa5$var$Ei(i)) && i;
}
var $e444d6404c095fa5$var$ji = [
    ".ph-no-rageclick",
    ".ph-no-capture"
];
var $e444d6404c095fa5$var$Li = (t)=>!t || $e444d6404c095fa5$var$$i(t, "html") || !$e444d6404c095fa5$var$Ei(t), $e444d6404c095fa5$var$Ni = (i, e)=>{
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Li(i)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        i
    ], n = i; n.parentNode && !$e444d6404c095fa5$var$$i(n, "body");)if ($e444d6404c095fa5$var$Pi(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $e444d6404c095fa5$var$Di(n);
        if (!o) break;
        if (e || $e444d6404c095fa5$var$Mi.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else {
            var a = $e444d6404c095fa5$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        }
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $e444d6404c095fa5$var$Ui(i, e, r, s, n) {
    var o, a, l, u;
    if (void 0 === r && (r = void 0), !$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Li(i)) return !1;
    if (null != (o = r) && o.url_allowlist && !$e444d6404c095fa5$var$Ri(r.url_allowlist)) return !1;
    if (null != (a = r) && a.url_ignorelist && $e444d6404c095fa5$var$Ri(r.url_ignorelist)) return !1;
    if (null != (l = r) && l.dom_event_allowlist) {
        var h = r.dom_event_allowlist;
        if (h && !h.some((t)=>e.type === t)) return !1;
    }
    var { parentIsUsefulElement: d, targetElementList: v } = $e444d6404c095fa5$var$Ni(i, s);
    if (!function(t, i) {
        var e = null == i ? void 0 : i.element_allowlist;
        if ($e444d6404c095fa5$var$F(e)) return !0;
        var r, s = function(t) {
            if (e.some((i)=>t.tagName.toLowerCase() === i)) return {
                v: !0
            };
        };
        for (var n of t)if (r = s(n)) return r.v;
        return !1;
    }(v, r)) return !1;
    if (!$e444d6404c095fa5$var$Ai(v, null == (u = r) ? void 0 : u.css_selector_allowlist)) return !1;
    var c = $e444d6404c095fa5$var$t.getComputedStyle(i);
    if (c && "pointer" === c.getPropertyValue("cursor") && "click" === e.type) return !0;
    var f = i.tagName.toLowerCase();
    switch(f){
        case "html":
            return !1;
        case "form":
            return (n || [
                "submit"
            ]).indexOf(e.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (n || [
                "change",
                "click"
            ]).indexOf(e.type) >= 0;
        default:
            return d ? (n || [
                "click"
            ]).indexOf(e.type) >= 0 : (n || [
                "click"
            ]).indexOf(e.type) >= 0 && ($e444d6404c095fa5$var$Mi.indexOf(f) > -1 || "true" === i.getAttribute("contenteditable"));
    }
}
function $e444d6404c095fa5$var$zi(t) {
    for(var i = t; i.parentNode && !$e444d6404c095fa5$var$$i(i, "body"); i = i.parentNode){
        var e = $e444d6404c095fa5$var$Ii(i);
        if ($e444d6404c095fa5$var$w(e, "ph-sensitive") || $e444d6404c095fa5$var$w(e, "ph-no-capture")) return !1;
    }
    if ($e444d6404c095fa5$var$w($e444d6404c095fa5$var$Ii(t), "ph-include")) return !0;
    var r = t.type || "";
    if ($e444d6404c095fa5$var$M(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var s = t.name || t.id || "";
    if ($e444d6404c095fa5$var$M(s)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(s.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Hi(t) {
    return !!($e444d6404c095fa5$var$$i(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $e444d6404c095fa5$var$$i(t, "select") || $e444d6404c095fa5$var$$i(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $e444d6404c095fa5$var$Bi = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", $e444d6404c095fa5$var$qi = new RegExp("^(?:" + $e444d6404c095fa5$var$Bi + ")$"), $e444d6404c095fa5$var$Wi = new RegExp($e444d6404c095fa5$var$Bi), $e444d6404c095fa5$var$Gi = "\\d{3}-?\\d{2}-?\\d{4}", $e444d6404c095fa5$var$Vi = new RegExp("^(" + $e444d6404c095fa5$var$Gi + ")$"), $e444d6404c095fa5$var$Ji = new RegExp("(" + $e444d6404c095fa5$var$Gi + ")");
function $e444d6404c095fa5$var$Ki(t, i) {
    if (void 0 === i && (i = !0), $e444d6404c095fa5$var$j(t)) return !1;
    if ($e444d6404c095fa5$var$M(t)) {
        if (t = $e444d6404c095fa5$var$x(t), (i ? $e444d6404c095fa5$var$qi : $e444d6404c095fa5$var$Wi).test((t || "").replace(/[- ]/g, ""))) return !1;
        if ((i ? $e444d6404c095fa5$var$Vi : $e444d6404c095fa5$var$Ji).test(t)) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Yi(t) {
    var i = $e444d6404c095fa5$var$Oi(t);
    return $e444d6404c095fa5$var$Ki(i = (i + " " + $e444d6404c095fa5$var$Xi(t)).trim()) ? i : "";
}
function $e444d6404c095fa5$var$Xi(t) {
    var i = "";
    return t && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Ft(t.childNodes, function(t) {
        var e;
        if (t && "span" === (null == (e = t.tagName) ? void 0 : e.toLowerCase())) try {
            var r = $e444d6404c095fa5$var$Oi(t);
            i = (i + " " + r).trim(), t.childNodes && t.childNodes.length && (i = (i + " " + $e444d6404c095fa5$var$Xi(t)).trim());
        } catch (t) {
            $e444d6404c095fa5$var$Pt.error("[AutoCapture]", t);
        }
    }), i;
}
function $e444d6404c095fa5$var$Qi(t) {
    return function(t) {
        var i = t.map((t)=>{
            var i, e, r = "";
            if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
            var n = $e444d6404c095fa5$var$g({}, t.text ? {
                text: t.text
            } : {}, {
                "nth-child": null !== (i = t.nth_child) && void 0 !== i ? i : 0,
                "nth-of-type": null !== (e = t.nth_of_type) && void 0 !== e ? e : 0
            }, t.href ? {
                href: t.href
            } : {}, t.attr_id ? {
                attr_id: t.attr_id
            } : {}, t.attributes), o = {};
            return $e444d6404c095fa5$var$Dt(n).sort((t, i)=>{
                var [e] = t, [r] = i;
                return e.localeCompare(r);
            }).forEach((t)=>{
                var [i, e] = t;
                return o[$e444d6404c095fa5$var$Zi(i.toString())] = $e444d6404c095fa5$var$Zi(e.toString());
            }), r += ":", r += $e444d6404c095fa5$var$Dt(o).map((t)=>{
                var [i, e] = t;
                return i + '="' + e + '"';
            }).join("");
        });
        return i.join(";");
    }(function(t) {
        return t.map((t)=>{
            var i, e, r = {
                text: null == (i = t.$el_text) ? void 0 : i.slice(0, 400),
                tag_name: t.tag_name,
                href: null == (e = t.attr__href) ? void 0 : e.slice(0, 2048),
                attr_class: $e444d6404c095fa5$var$te(t),
                attr_id: t.attr__id,
                nth_child: t.nth_child,
                nth_of_type: t.nth_of_type,
                attributes: {}
            };
            return $e444d6404c095fa5$var$Dt(t).filter((t)=>{
                var [i] = t;
                return 0 === i.indexOf("attr__");
            }).forEach((t)=>{
                var [i, e] = t;
                return r.attributes[i] = e;
            }), r;
        });
    }(t));
}
function $e444d6404c095fa5$var$Zi(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $e444d6404c095fa5$var$te(t) {
    var i = t.attr__class;
    return i ? $e444d6404c095fa5$var$R(i) ? i : $e444d6404c095fa5$var$Ti(i) : void 0;
}
class $e444d6404c095fa5$var$ie {
    constructor(){
        this.clicks = [];
    }
    isRageClick(t, i, e) {
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(i - r.y) < 30 && e - r.timestamp < 1e3) {
            if (this.clicks.push({
                x: t,
                y: i,
                timestamp: e
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: t,
                y: i,
                timestamp: e
            }
        ];
        return !1;
    }
}
var $e444d6404c095fa5$export$7bea938663611d9 = "$copy_autocapture", $e444d6404c095fa5$export$6a00d17b5aff0af = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $e444d6404c095fa5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $e444d6404c095fa5$var$ne = (t)=>{
    var i = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.createElement("a");
    return $e444d6404c095fa5$var$F(i) ? null : (i.href = t, i);
}, $e444d6404c095fa5$var$oe = function(t, i) {
    var e, r;
    void 0 === i && (i = "&");
    var s = [];
    return $e444d6404c095fa5$var$Ft(t, function(t, i) {
        $e444d6404c095fa5$var$F(t) || $e444d6404c095fa5$var$F(i) || "undefined" === i || (e = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(i), s[s.length] = r + "=" + e);
    }), s.join(i);
}, $e444d6404c095fa5$var$ae = function(t, i) {
    for(var e, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; s < r.length; s++){
        var n = r[s].split("=");
        if (n[0] === i) {
            e = n;
            break;
        }
    }
    if (!$e444d6404c095fa5$var$R(e) || e.length < 2) return "";
    var o = e[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $e444d6404c095fa5$var$Pt.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $e444d6404c095fa5$var$le = function(t, i, e) {
    if (!t || !i || !i.length) return t;
    for(var r = t.split("#"), s = r[0] || "", n = r[1], o = s.split("?"), a = o[1], l = o[0], u = (a || "").split("&"), h = [], d = 0; d < u.length; d++){
        var v = u[d].split("=");
        $e444d6404c095fa5$var$R(v) && (i.includes(v[0]) ? h.push(v[0] + "=" + e) : h.push(u[d]));
    }
    var c = l;
    return null != a && (c += "?" + h.join("&")), null != n && (c += "#" + n), c;
}, $e444d6404c095fa5$var$ue = function(t, i) {
    var e = t.match(new RegExp(i + "=([^&]*)"));
    return e ? e[1] : null;
}, $e444d6404c095fa5$var$he = $e444d6404c095fa5$var$Tt("[AutoCapture]");
function $e444d6404c095fa5$var$de(t, i) {
    return i.length > t ? i.slice(0, t) + "..." : i;
}
function $e444d6404c095fa5$var$ve(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var i = t;
    do i = i.previousSibling;
    while (i && !$e444d6404c095fa5$var$Ei(i));
    return i;
}
function $e444d6404c095fa5$var$ce(t, i, e, r) {
    var s = t.tagName.toLowerCase(), n = {
        tag_name: s
    };
    $e444d6404c095fa5$var$Mi.indexOf(s) > -1 && !e && ("a" === s.toLowerCase() || "button" === s.toLowerCase() ? n.$el_text = $e444d6404c095fa5$var$de(1024, $e444d6404c095fa5$var$Yi(t)) : n.$el_text = $e444d6404c095fa5$var$de(1024, $e444d6404c095fa5$var$Oi(t)));
    var o = $e444d6404c095fa5$var$Ii(t);
    o.length > 0 && (n.classes = o.filter(function(t) {
        return "" !== t;
    })), $e444d6404c095fa5$var$Ft(t.attributes, function(e) {
        var s;
        if ((!$e444d6404c095fa5$var$Hi(t) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(e.name)) && (null == r || !r.includes(e.name)) && !i && $e444d6404c095fa5$var$Ki(e.value) && (s = e.name, !$e444d6404c095fa5$var$M(s) || "_ngcontent" !== s.substring(0, 10) && "_nghost" !== s.substring(0, 7))) {
            var o = e.value;
            "class" === e.name && (o = $e444d6404c095fa5$var$Ti(o).join(" ")), n["attr__" + e.name] = $e444d6404c095fa5$var$de(1024, o);
        }
    });
    for(var a = 1, l = 1, u = t; u = $e444d6404c095fa5$var$ve(u);)a++, u.tagName === t.tagName && l++;
    return n.nth_child = a, n.nth_of_type = l, n;
}
function $e444d6404c095fa5$var$fe(i, e) {
    for(var r, s, { e: n, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = e, h = [
        i
    ], d = i; d.parentNode && !$e444d6404c095fa5$var$$i(d, "body");)$e444d6404c095fa5$var$Pi(d.parentNode) ? (h.push(d.parentNode.host), d = d.parentNode.host) : (h.push(d.parentNode), d = d.parentNode);
    var v, c = [], f = {}, p = !1, g = !1;
    if ($e444d6404c095fa5$var$Ft(h, (t)=>{
        var i = $e444d6404c095fa5$var$zi(t);
        "a" === t.tagName.toLowerCase() && (p = t.getAttribute("href"), p = i && p && $e444d6404c095fa5$var$Ki(p) && p), $e444d6404c095fa5$var$w($e444d6404c095fa5$var$Ii(t), "ph-no-capture") && (g = !0), c.push($e444d6404c095fa5$var$ce(t, o, a, l));
        var e = function(t) {
            if (!$e444d6404c095fa5$var$zi(t)) return {};
            var i = {};
            return $e444d6404c095fa5$var$Ft(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var e = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    e && r && $e444d6404c095fa5$var$Ki(r) && (i[e] = r);
                }
            }), i;
        }(t);
        $e444d6404c095fa5$var$Mt(f, e);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === i.tagName.toLowerCase() || "button" === i.tagName.toLowerCase() ? c[0].$el_text = $e444d6404c095fa5$var$Yi(i) : c[0].$el_text = $e444d6404c095fa5$var$Oi(i)), p) {
        var _, m;
        c[0].attr__href = p;
        var y = null == (_ = $e444d6404c095fa5$var$ne(p)) ? void 0 : _.host, b = null == $e444d6404c095fa5$var$t || null == (m = $e444d6404c095fa5$var$t.location) ? void 0 : m.host;
        y && b && y !== b && (v = p);
    }
    return {
        props: $e444d6404c095fa5$var$Mt({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: c
        }, {
            $elements_chain: $e444d6404c095fa5$var$Qi(c)
        }, null != (r = c[0]) && r.$el_text ? {
            $el_text: null == (s = c[0]) ? void 0 : s.$el_text
        } : {}, v && "click" === n.type ? {
            $external_click_url: v
        } : {}, f)
    };
}
class $e444d6404c095fa5$var$pe {
    constructor(t){
        this.P = !1, this.T = null, this.rageclicks = new $e444d6404c095fa5$var$ie, this.R = !1, this.instance = t, this.I = null;
    }
    get C() {
        var t, i, e = $e444d6404c095fa5$var$C(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return e.url_allowlist = null == (t = e.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), e.url_ignorelist = null == (i = e.url_ignorelist) ? void 0 : i.map((t)=>new RegExp(t)), e;
    }
    O() {
        if (this.isBrowserSupported()) {
            if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o) {
                var i = (i)=>{
                    i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event);
                    try {
                        this.F(i);
                    } catch (t) {
                        $e444d6404c095fa5$var$he.error("Failed to capture event", t);
                    }
                };
                if ($e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "submit", i, {
                    capture: !0
                }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "change", i, {
                    capture: !0
                }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "click", i, {
                    capture: !0
                }), this.C.capture_copied_text) {
                    var e = (i)=>{
                        i = i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event), this.F(i, $e444d6404c095fa5$export$7bea938663611d9);
                    };
                    $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "copy", e, {
                        capture: !0
                    }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "cut", e, {
                        capture: !0
                    });
                }
            }
        } else $e444d6404c095fa5$var$he.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this.P && (this.O(), this.P = !0);
    }
    onRemoteConfig(t) {
        t.elementsChainAsString && (this.R = t.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Jt]: !!t.autocapture_opt_out
        }), this.T = !!t.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(t) {
        this.I = t;
    }
    getElementSelectors(t) {
        var i, e = [];
        return null == (i = this.I) || i.forEach((i)=>{
            var r = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll(i);
            null == r || r.forEach((r)=>{
                t === r && e.push(i);
            });
        }), e;
    }
    get isEnabled() {
        var t, i, e = null == (t = this.instance.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$Jt], r = this.T;
        if ($e444d6404c095fa5$var$D(r) && !$e444d6404c095fa5$var$N(e) && !this.instance.M()) return !1;
        var s = null !== (i = this.T) && void 0 !== i ? i : !!e;
        return !!this.instance.config.autocapture && !s;
    }
    F(i, e) {
        if (void 0 === e && (e = "$autocapture"), this.isEnabled) {
            var r, s = $e444d6404c095fa5$var$Fi(i);
            if ($e444d6404c095fa5$var$ki(s) && (s = s.parentNode || null), "$autocapture" === e && "click" === i.type && i instanceof MouseEvent) this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(i.clientX, i.clientY, (new Date).getTime()) && function(i, e) {
                if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Li(i)) return !1;
                var r, s;
                if (!1 === (r = $e444d6404c095fa5$var$N(e) ? !!e && $e444d6404c095fa5$var$ji : null !== (s = null == e ? void 0 : e.css_selector_ignorelist) && void 0 !== s ? s : $e444d6404c095fa5$var$ji)) return !1;
                var { targetElementList: n } = $e444d6404c095fa5$var$Ni(i, !1);
                return !$e444d6404c095fa5$var$Ai(n, r);
            }(s, this.instance.config.rageclick) && this.F(i, "$rageclick");
            var n = e === $e444d6404c095fa5$export$7bea938663611d9;
            if (s && $e444d6404c095fa5$var$Ui(s, i, this.C, n, n ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = $e444d6404c095fa5$var$fe(s, {
                    e: i,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.C.element_attribute_ignorelist,
                    elementsChainAsString: this.R
                });
                if (a) return !1;
                var l = this.getElementSelectors(s);
                if (l && l.length > 0 && (o.$element_selectors = l), e === $e444d6404c095fa5$export$7bea938663611d9) {
                    var u, h = $e444d6404c095fa5$var$Ci(null == $e444d6404c095fa5$var$t || null == (u = $e444d6404c095fa5$var$t.getSelection()) ? void 0 : u.toString()), d = i.type || "clipboard";
                    if (!h) return !1;
                    o.$selected_content = h, o.$copy_type = d;
                }
                return this.instance.capture(e, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return $e444d6404c095fa5$var$I(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelectorAll);
    }
}
Math.trunc || (Math.trunc = function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $e444d6404c095fa5$var$L(t) && isFinite(t) && Math.floor(t) === t;
});
var $e444d6404c095fa5$var$ge = "0123456789abcdef";
class $e444d6404c095fa5$var$_e {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, i, e, r) {
        if (!Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(e) || !Number.isInteger(r) || t < 0 || i < 0 || e < 0 || r < 0 || t > 0xffffffffffff || i > 4095 || e > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / Math.pow(2, 8), s[5] = t, s[6] = 112 | i >>> 8, s[7] = i, s[8] = 128 | e >>> 24, s[9] = e >>> 16, s[10] = e >>> 8, s[11] = e, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $e444d6404c095fa5$var$_e(s);
    }
    toString() {
        for(var t = "", i = 0; i < this.bytes.length; i++)t = t + $e444d6404c095fa5$var$ge.charAt(this.bytes[i] >>> 4) + $e444d6404c095fa5$var$ge.charAt(15 & this.bytes[i]), 3 !== i && 5 !== i && 7 !== i && 9 !== i || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $e444d6404c095fa5$var$_e(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var i = 0; i < 16; i++){
            var e = this.bytes[i] - t.bytes[i];
            if (0 !== e) return Math.sign(e);
        }
        return 0;
    }
}
class $e444d6404c095fa5$var$me {
    constructor(){
        this.A = 0, this.D = 0, this.j = new $e444d6404c095fa5$var$we;
    }
    generate() {
        var t = this.generateOrAbort();
        if ($e444d6404c095fa5$var$F(t)) {
            this.A = 0;
            var i = this.generateOrAbort();
            if ($e444d6404c095fa5$var$F(i)) throw new Error("Could not generate UUID after timestamp reset");
            return i;
        }
        return t;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.A) this.A = t, this.L();
        else {
            if (!(t + 1e4 > this.A)) return;
            this.D++, this.D > 4398046511103 && (this.A++, this.L());
        }
        return $e444d6404c095fa5$var$_e.fromFieldsV7(this.A, Math.trunc(this.D / Math.pow(2, 30)), this.D & Math.pow(2, 30) - 1, this.j.nextUint32());
    }
    L() {
        this.D = 1024 * this.j.nextUint32() + (1023 & this.j.nextUint32());
    }
}
var $e444d6404c095fa5$var$ye, $e444d6404c095fa5$var$be = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var i = 0; i < t.length; i++)t[i] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$F($e444d6404c095fa5$var$t.crypto) && crypto.getRandomValues && ($e444d6404c095fa5$var$be = (t)=>crypto.getRandomValues(t));
class $e444d6404c095fa5$var$we {
    constructor(){
        this.N = new Uint32Array(8), this.U = 1 / 0;
    }
    nextUint32() {
        return this.U >= this.N.length && ($e444d6404c095fa5$var$be(this.N), this.U = 0), this.N[this.U++];
    }
}
var $e444d6404c095fa5$var$xe = ()=>$e444d6404c095fa5$var$Se().toString(), $e444d6404c095fa5$var$Se = ()=>($e444d6404c095fa5$var$ye || ($e444d6404c095fa5$var$ye = new $e444d6404c095fa5$var$me)).generate(), $e444d6404c095fa5$var$Ee = "";
var $e444d6404c095fa5$var$$e = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function $e444d6404c095fa5$var$ke(t, i) {
    if (i) {
        var e = function(t, i) {
            if (void 0 === i && (i = $e444d6404c095fa5$var$o), $e444d6404c095fa5$var$Ee) return $e444d6404c095fa5$var$Ee;
            if (!i) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(t)) return "";
            for(var e = t.split("."), r = Math.min(e.length, 8), s = "dmn_chk_" + $e444d6404c095fa5$var$xe(); !$e444d6404c095fa5$var$Ee && r--;){
                var n = e.slice(r).join("."), a = s + "=1;domain=." + n + ";path=/";
                i.cookie = a + ";max-age=3", i.cookie.includes(s) && (i.cookie = a + ";max-age=0", $e444d6404c095fa5$var$Ee = n);
            }
            return $e444d6404c095fa5$var$Ee;
        }(t);
        if (!e) {
            var r = ((t)=>{
                var i = t.match($e444d6404c095fa5$var$$e);
                return i ? i[0] : "";
            })(t);
            r !== e && $e444d6404c095fa5$var$Pt.info("Warning: cookie subdomain discovery mismatch", r, e), e = r;
        }
        return e ? "; domain=." + e : "";
    }
    return "";
}
var $e444d6404c095fa5$var$Pe = {
    H: ()=>!!$e444d6404c095fa5$var$o,
    B: function(t) {
        $e444d6404c095fa5$var$Pt.error("cookieStore error: " + t);
    },
    q: function(t) {
        if ($e444d6404c095fa5$var$o) {
            try {
                for(var i = t + "=", e = $e444d6404c095fa5$var$o.cookie.split(";").filter((t)=>t.length), r = 0; r < e.length; r++){
                    for(var s = e[r]; " " == s.charAt(0);)s = s.substring(1, s.length);
                    if (0 === s.indexOf(i)) return decodeURIComponent(s.substring(i.length, s.length));
                }
            } catch (t) {}
            return null;
        }
    },
    W: function(t) {
        var i;
        try {
            i = JSON.parse($e444d6404c095fa5$var$Pe.q(t)) || {};
        } catch (t) {}
        return i;
    },
    G: function(t, i, e, r, s) {
        if ($e444d6404c095fa5$var$o) try {
            var n = "", a = "", l = $e444d6404c095fa5$var$ke($e444d6404c095fa5$var$o.location.hostname, r);
            if (e) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * e * 3600000), n = "; expires=" + u.toUTCString();
            }
            s && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(i)) + n + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $e444d6404c095fa5$var$Pt.warn("cookieStore warning: large cookie, len=" + h.length), $e444d6404c095fa5$var$o.cookie = h, h;
        } catch (t) {
            return;
        }
    },
    V: function(t, i) {
        if (null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.cookie) try {
            $e444d6404c095fa5$var$Pe.G(t, "", -1, i);
        } catch (t) {
            return;
        }
    }
}, $e444d6404c095fa5$var$Te = null, $e444d6404c095fa5$var$Re = {
    H: function() {
        if (!$e444d6404c095fa5$var$D($e444d6404c095fa5$var$Te)) return $e444d6404c095fa5$var$Te;
        var i = !0;
        if ($e444d6404c095fa5$var$F($e444d6404c095fa5$var$t)) i = !1;
        else try {
            var e = "__mplssupport__";
            $e444d6404c095fa5$var$Re.G(e, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$Re.q(e) && (i = !1), $e444d6404c095fa5$var$Re.V(e);
        } catch (t) {
            i = !1;
        }
        return i || $e444d6404c095fa5$var$Pt.error("localStorage unsupported; falling back to cookie store"), $e444d6404c095fa5$var$Te = i, i;
    },
    B: function(t) {
        $e444d6404c095fa5$var$Pt.error("localStorage error: " + t);
    },
    q: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Re.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$Re.q(t)) || {};
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$Re.B(t);
        }
    },
    V: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Re.B(t);
        }
    }
}, $e444d6404c095fa5$var$Ie = [
    "distinct_id",
    $e444d6404c095fa5$var$ri,
    $e444d6404c095fa5$var$si,
    $e444d6404c095fa5$var$yi,
    $e444d6404c095fa5$var$mi
], $e444d6404c095fa5$var$Ce = $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$Re, {
    W: function(t) {
        try {
            var i = {};
            try {
                i = $e444d6404c095fa5$var$Pe.W(t) || {};
            } catch (t) {}
            var e = $e444d6404c095fa5$var$Mt(i, JSON.parse($e444d6404c095fa5$var$Re.q(t) || "{}"));
            return $e444d6404c095fa5$var$Re.G(t, e), e;
        } catch (t) {}
        return null;
    },
    G: function(t, i, e, r, s, n) {
        try {
            $e444d6404c095fa5$var$Re.G(t, i, void 0, void 0, n);
            var o = {};
            $e444d6404c095fa5$var$Ie.forEach((t)=>{
                i[t] && (o[t] = i[t]);
            }), Object.keys(o).length && $e444d6404c095fa5$var$Pe.G(t, o, e, r, s, n);
        } catch (t) {
            $e444d6404c095fa5$var$Re.B(t);
        }
    },
    V: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(i), $e444d6404c095fa5$var$Pe.V(i, e);
        } catch (t) {
            $e444d6404c095fa5$var$Re.B(t);
        }
    }
}), $e444d6404c095fa5$var$Oe = {}, $e444d6404c095fa5$var$Fe = {
    H: function() {
        return !0;
    },
    B: function(t) {
        $e444d6404c095fa5$var$Pt.error("memoryStorage error: " + t);
    },
    q: function(t) {
        return $e444d6404c095fa5$var$Oe[t] || null;
    },
    W: function(t) {
        return $e444d6404c095fa5$var$Oe[t] || null;
    },
    G: function(t, i) {
        $e444d6404c095fa5$var$Oe[t] = i;
    },
    V: function(t) {
        delete $e444d6404c095fa5$var$Oe[t];
    }
}, $e444d6404c095fa5$var$Me = null, $e444d6404c095fa5$var$Ae = {
    H: function() {
        if (!$e444d6404c095fa5$var$D($e444d6404c095fa5$var$Me)) return $e444d6404c095fa5$var$Me;
        if ($e444d6404c095fa5$var$Me = !0, $e444d6404c095fa5$var$F($e444d6404c095fa5$var$t)) $e444d6404c095fa5$var$Me = !1;
        else try {
            var i = "__support__";
            $e444d6404c095fa5$var$Ae.G(i, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$Ae.q(i) && ($e444d6404c095fa5$var$Me = !1), $e444d6404c095fa5$var$Ae.V(i);
        } catch (t) {
            $e444d6404c095fa5$var$Me = !1;
        }
        return $e444d6404c095fa5$var$Me;
    },
    B: function(t) {
        $e444d6404c095fa5$var$Pt.error("sessionStorage error: ", t);
    },
    q: function(i) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.sessionStorage.getItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Ae.B(t);
        }
        return null;
    },
    W: function(t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$Ae.q(t)) || null;
        } catch (t) {}
        return null;
    },
    G: function(i, e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.setItem(i, JSON.stringify(e));
        } catch (t) {
            $e444d6404c095fa5$var$Ae.B(t);
        }
    },
    V: function(i) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.removeItem(i);
        } catch (t) {
            $e444d6404c095fa5$var$Ae.B(t);
        }
    }
}, $e444d6404c095fa5$var$De = function(t) {
    return t[t.PENDING = -1] = "PENDING", t[t.DENIED = 0] = "DENIED", t[t.GRANTED = 1] = "GRANTED", t;
}({});
class $e444d6404c095fa5$var$je {
    constructor(t){
        this._instance = t;
    }
    get C() {
        return this._instance.config;
    }
    get consent() {
        return this.J() ? $e444d6404c095fa5$var$De.DENIED : this.K;
    }
    isOptedOut() {
        return "always" === this.C.cookieless_mode || this.consent === $e444d6404c095fa5$var$De.DENIED || this.consent === $e444d6404c095fa5$var$De.PENDING && (this.C.opt_out_capturing_by_default || "on_reject" === this.C.cookieless_mode);
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return this.consent === $e444d6404c095fa5$var$De.DENIED;
    }
    optInOut(t) {
        this.Y.G(this.X, t ? 1 : 0, this.C.cookie_expiration, this.C.cross_subdomain_cookie, this.C.secure_cookie);
    }
    reset() {
        this.Y.V(this.X, this.C.cross_subdomain_cookie);
    }
    get X() {
        var { token: t, opt_out_capturing_cookie_prefix: i, consent_persistence_name: e } = this._instance.config;
        return e || (i ? i + t : "__ph_opt_in_out_" + t);
    }
    get K() {
        var t = this.Y.q(this.X);
        return $e444d6404c095fa5$var$G(t) ? $e444d6404c095fa5$var$De.GRANTED : $e444d6404c095fa5$var$w($e444d6404c095fa5$var$V, t) ? $e444d6404c095fa5$var$De.DENIED : $e444d6404c095fa5$var$De.PENDING;
    }
    get Y() {
        if (!this.Z) {
            var t = this.C.opt_out_capturing_persistence_type;
            this.Z = "localStorage" === t ? $e444d6404c095fa5$var$Re : $e444d6404c095fa5$var$Pe;
            var i = "localStorage" === t ? $e444d6404c095fa5$var$Pe : $e444d6404c095fa5$var$Re;
            i.q(this.X) && (this.Z.q(this.X) || this.optInOut($e444d6404c095fa5$var$G(i.q(this.X))), i.V(this.X, this.C.cross_subdomain_cookie));
        }
        return this.Z;
    }
    J() {
        return !!this.C.respect_dnt && !!$e444d6404c095fa5$var$Bt([
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.doNotTrack,
            null == $e444d6404c095fa5$var$n ? void 0 : $e444d6404c095fa5$var$n.msDoNotTrack,
            $e444d6404c095fa5$var$v.doNotTrack
        ], (t)=>$e444d6404c095fa5$var$G(t));
    }
}
var $e444d6404c095fa5$var$Le = $e444d6404c095fa5$var$Tt("[Dead Clicks]"), $e444d6404c095fa5$var$Ne = ()=>!0, $e444d6404c095fa5$var$Ue = (t)=>{
    var i, e = !(null == (i = t.instance.persistence) || !i.get_property($e444d6404c095fa5$var$ti)), r = t.instance.config.capture_dead_clicks;
    return $e444d6404c095fa5$var$N(r) ? r : e;
};
class $e444d6404c095fa5$var$ze {
    get lazyLoadedDeadClicksAutocapture() {
        return this.tt;
    }
    constructor(t, i, e){
        this.instance = t, this.isEnabled = i, this.onCapture = e, this.startIfEnabled();
    }
    onRemoteConfig(t) {
        this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$ti]: null == t ? void 0 : t.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.it(()=>{
            this.et();
        });
    }
    it(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.initDeadClicksAutocapture && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this.instance, "dead-clicks-autocapture", (i)=>{
            i ? $e444d6404c095fa5$var$Le.error("failed to load script", i) : t();
        });
    }
    et() {
        var t;
        if ($e444d6404c095fa5$var$o) {
            if (!this.tt && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var i = $e444d6404c095fa5$var$C(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                i.__onCapture = this.onCapture, this.tt = $e444d6404c095fa5$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, i), this.tt.start($e444d6404c095fa5$var$o), $e444d6404c095fa5$var$Le.info("starting...");
            }
        } else $e444d6404c095fa5$var$Le.error("`document` not found. Cannot start.");
    }
    stop() {
        this.tt && (this.tt.stop(), this.tt = void 0, $e444d6404c095fa5$var$Le.info("stopping..."));
    }
}
var $e444d6404c095fa5$var$He = $e444d6404c095fa5$var$Tt("[ExceptionAutocapture]");
class $e444d6404c095fa5$var$Be {
    constructor(i){
        var e, r, s;
        this.rt = ()=>{
            var i;
            if ($e444d6404c095fa5$var$t && this.isEnabled && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions) {
                var e = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                try {
                    !this.st && this.C.capture_unhandled_errors && (this.st = e(this.captureException.bind(this))), !this.nt && this.C.capture_unhandled_rejections && (this.nt = r(this.captureException.bind(this))), !this.ot && this.C.capture_console_errors && (this.ot = s(this.captureException.bind(this)));
                } catch (t) {
                    $e444d6404c095fa5$var$He.error("failed to start", t), this.lt();
                }
            }
        }, this._instance = i, this.ut = !(null == (e = this._instance.persistence) || !e.props[$e444d6404c095fa5$var$Yt]), this.C = this.ht(), this.dt = new $e444d6404c095fa5$var$K({
            refillRate: null !== (r = this._instance.config.error_tracking.__exceptionRateLimiterRefillRate) && void 0 !== r ? r : 1,
            bucketSize: null !== (s = this._instance.config.error_tracking.__exceptionRateLimiterBucketSize) && void 0 !== s ? s : 10,
            refillInterval: 1e4,
            h: $e444d6404c095fa5$var$He
        }), this.startIfEnabled();
    }
    ht() {
        var t = this._instance.config.capture_exceptions, i = {
            capture_unhandled_errors: !1,
            capture_unhandled_rejections: !1,
            capture_console_errors: !1
        };
        return $e444d6404c095fa5$var$C(t) ? i = $e444d6404c095fa5$var$g({}, i, t) : ($e444d6404c095fa5$var$F(t) ? this.ut : t) && (i = $e444d6404c095fa5$var$g({}, i, {
            capture_unhandled_errors: !0,
            capture_unhandled_rejections: !0
        })), i;
    }
    get isEnabled() {
        return this.C.capture_console_errors || this.C.capture_unhandled_errors || this.C.capture_unhandled_rejections;
    }
    startIfEnabled() {
        this.isEnabled && ($e444d6404c095fa5$var$He.info("enabled"), this.it(this.rt));
    }
    it(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.errorWrappingFunctions && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "exception-autocapture", (i)=>{
            if (i) return $e444d6404c095fa5$var$He.error("failed to load script", i);
            t();
        });
    }
    lt() {
        var t, i, e;
        null == (t = this.st) || t.call(this), this.st = void 0, null == (i = this.nt) || i.call(this), this.nt = void 0, null == (e = this.ot) || e.call(this), this.ot = void 0;
    }
    onRemoteConfig(t) {
        var i = t.autocaptureExceptions;
        this.ut = !!i || !1, this.C = this.ht(), this._instance.persistence && this._instance.persistence.register({
            [$e444d6404c095fa5$var$Yt]: this.ut
        }), this.startIfEnabled();
    }
    captureException(t) {
        var i, e, r = null !== (i = null == t || null == (e = t.$exception_list) || null == (e = e[0]) ? void 0 : e.type) && void 0 !== i ? i : "Exception";
        this.dt.consumeRateLimit(r) ? $e444d6404c095fa5$var$He.info("Skipping exception capture because of client rate limiting.", {
            exception: r
        }) : this._instance.exceptions.sendExceptionEvent(t);
    }
}
function $e444d6404c095fa5$var$qe(t, i, e) {
    try {
        if (!(i in t)) return ()=>{};
        var r = t[i], s = e(r);
        return $e444d6404c095fa5$var$I(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
            __posthog_wrapped__: {
                enumerable: !1,
                value: !0
            }
        })), t[i] = s, ()=>{
            t[i] = r;
        };
    } catch (t) {
        return ()=>{};
    }
}
class $e444d6404c095fa5$var$We {
    constructor(i){
        var e;
        this._instance = i, this.vt = (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname) || "";
    }
    get isEnabled() {
        return "history_change" === this._instance.config.capture_pageview;
    }
    startIfEnabled() {
        this.isEnabled && ($e444d6404c095fa5$var$Pt.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
    }
    stop() {
        this.ct && this.ct(), this.ct = void 0, $e444d6404c095fa5$var$Pt.info("History API monitoring stopped");
    }
    monitorHistoryChanges() {
        var i, e;
        if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.history) {
            var r = this;
            null != (i = $e444d6404c095fa5$var$t.history.pushState) && i.__posthog_wrapped__ || $e444d6404c095fa5$var$qe($e444d6404c095fa5$var$t.history, "pushState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.ft("pushState");
                }), null != (e = $e444d6404c095fa5$var$t.history.replaceState) && e.__posthog_wrapped__ || $e444d6404c095fa5$var$qe($e444d6404c095fa5$var$t.history, "replaceState", (t)=>function(i, e, s) {
                    t.call(this, i, e, s), r.ft("replaceState");
                }), this.gt();
        }
    }
    ft(i) {
        try {
            var e, r = null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.pathname;
            if (!r) return;
            r !== this.vt && this.isEnabled && this._instance.capture("$pageview", {
                navigation_type: i
            }), this.vt = r;
        } catch (t) {
            $e444d6404c095fa5$var$Pt.error("Error capturing " + i + " pageview", t);
        }
    }
    gt() {
        if (!this.ct) {
            var i = ()=>{
                this.ft("popstate");
            };
            $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "popstate", i), this.ct = ()=>{
                $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.removeEventListener("popstate", i);
            };
        }
    }
}
var $e444d6404c095fa5$var$Ge = $e444d6404c095fa5$var$Tt("[SegmentIntegration]");
function $e444d6404c095fa5$var$Ve(t, i) {
    var e = t.config.segment;
    if (!e) return i();
    !function(t, i) {
        var e = t.config.segment;
        if (!e) return i();
        var r = (e)=>{
            var r = ()=>e.anonymousId() || $e444d6404c095fa5$var$xe();
            t.config.get_device_id = r, e.id() && (t.register({
                distinct_id: e.id(),
                $device_id: r()
            }), t.persistence.set_property($e444d6404c095fa5$var$ci, "identified")), i();
        }, s = e.user();
        "then" in s && $e444d6404c095fa5$var$I(s.then) ? s.then((t)=>r(t)) : r(s);
    }(t, ()=>{
        e.register(((t)=>{
            Promise && Promise.resolve || $e444d6404c095fa5$var$Ge.warn("This browser does not have Promise support, and can not use the segment integration");
            var i = (i, e)=>{
                if (!e) return i;
                i.event.userId || i.event.anonymousId === t.get_distinct_id() || ($e444d6404c095fa5$var$Ge.info("No userId set, resetting PostHog"), t.reset()), i.event.userId && i.event.userId !== t.get_distinct_id() && ($e444d6404c095fa5$var$Ge.info("UserId set, identifying with PostHog"), t.identify(i.event.userId));
                var r = t.calculateEventProperties(e, i.event.properties);
                return i.event.properties = Object.assign({}, r, i.event.properties), i;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (t)=>i(t, t.event.event),
                page: (t)=>i(t, "$pageview"),
                identify: (t)=>i(t, "$identify"),
                screen: (t)=>i(t, "$screen")
            };
        })(t)).then(()=>{
            i();
        });
    });
}
var $e444d6404c095fa5$var$Je = "posthog-js";
function $e444d6404c095fa5$var$Ke(t, i) {
    var { organization: e, projectId: r, prefix: s, severityAllowList: n = [
        "error"
    ], sendExceptionsToPostHog: o = !0 } = void 0 === i ? {} : i;
    return (i)=>{
        var a, l, u, h, d;
        if (!("*" === n || n.includes(i.level)) || !t.__loaded) return i;
        i.tags || (i.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        i.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (i.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c = (null == (a = i.exception) ? void 0 : a.values) || [], f = c.map((t)=>$e444d6404c095fa5$var$g({}, t, {
                stacktrace: t.stacktrace ? $e444d6404c095fa5$var$g({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$e444d6404c095fa5$var$g({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), p = {
            $exception_message: (null == (l = c[0]) ? void 0 : l.value) || i.message,
            $exception_type: null == (u = c[0]) ? void 0 : u.type,
            $exception_level: i.level,
            $exception_list: f,
            $sentry_event_id: i.event_id,
            $sentry_exception: i.exception,
            $sentry_exception_message: (null == (h = c[0]) ? void 0 : h.value) || i.message,
            $sentry_exception_type: null == (d = c[0]) ? void 0 : d.type,
            $sentry_tags: i.tags
        };
        return e && r && (p.$sentry_url = (s || "https://sentry.io/organizations/") + e + "/issues/?project=" + r + "&query=" + i.event_id), o && t.exceptions.sendExceptionEvent(p), i;
    };
}
class $e444d6404c095fa5$var$Ye {
    constructor(t, i, e, r, s, n){
        this.name = $e444d6404c095fa5$var$Je, this.setupOnce = function(o) {
            o($e444d6404c095fa5$var$Ke(t, {
                organization: i,
                projectId: e,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
var $e444d6404c095fa5$var$Xe = null != $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.location ? $e444d6404c095fa5$var$ue($e444d6404c095fa5$var$t.location.hash, "__posthog") || $e444d6404c095fa5$var$ue(location.hash, "state") : null, $e444d6404c095fa5$var$Qe = "_postHogToolbarParams", $e444d6404c095fa5$var$Ze = $e444d6404c095fa5$var$Tt("[Toolbar]"), $e444d6404c095fa5$var$tr = function(t) {
    return t[t.UNINITIALIZED = 0] = "UNINITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.LOADED = 2] = "LOADED", t;
}($e444d6404c095fa5$var$tr || {});
class $e444d6404c095fa5$var$ir {
    constructor(t){
        this.instance = t;
    }
    _t(t) {
        $e444d6404c095fa5$var$v.ph_toolbar_state = t;
    }
    yt() {
        var t;
        return null !== (t = $e444d6404c095fa5$var$v.ph_toolbar_state) && void 0 !== t ? t : $e444d6404c095fa5$var$tr.UNINITIALIZED;
    }
    maybeLoadToolbar(i, e, r) {
        if (void 0 === i && (i = void 0), void 0 === e && (e = void 0), void 0 === r && (r = void 0), !$e444d6404c095fa5$var$t || !$e444d6404c095fa5$var$o) return !1;
        i = null != i ? i : $e444d6404c095fa5$var$t.location, r = null != r ? r : $e444d6404c095fa5$var$t.history;
        try {
            if (!e) {
                try {
                    $e444d6404c095fa5$var$t.localStorage.setItem("test", "test"), $e444d6404c095fa5$var$t.localStorage.removeItem("test");
                } catch (t) {
                    return !1;
                }
                e = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage;
            }
            var s, n = $e444d6404c095fa5$var$Xe || $e444d6404c095fa5$var$ue(i.hash, "__posthog") || $e444d6404c095fa5$var$ue(i.hash, "state"), a = n ? $e444d6404c095fa5$var$jt(()=>JSON.parse(atob(decodeURIComponent(n)))) || $e444d6404c095fa5$var$jt(()=>JSON.parse(decodeURIComponent(n))) : null;
            return a && "ph_authorize" === a.action ? ((s = a).source = "url", s && Object.keys(s).length > 0 && (a.desiredHash ? i.hash = a.desiredHash : r ? r.replaceState(r.state, "", i.pathname + i.search) : i.hash = "")) : ((s = JSON.parse(e.getItem($e444d6404c095fa5$var$Qe) || "{}")).source = "localstorage", delete s.userIntent), !(!s.token || this.instance.config.token !== s.token) && (this.loadToolbar(s), !0);
        } catch (t) {
            return !1;
        }
    }
    bt(t) {
        var i = $e444d6404c095fa5$var$v.ph_load_toolbar || $e444d6404c095fa5$var$v.ph_load_editor;
        !$e444d6404c095fa5$var$j(i) && $e444d6404c095fa5$var$I(i) ? i(t, this.instance) : $e444d6404c095fa5$var$Ze.warn("No toolbar load function found");
    }
    loadToolbar(i) {
        var e = !(null == $e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.getElementById($e444d6404c095fa5$var$bi));
        if (!$e444d6404c095fa5$var$t || e) return !1;
        var r = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, s = $e444d6404c095fa5$var$g({
            token: this.instance.config.token
        }, i, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, r ? {
            instrument: !1
        } : {});
        if ($e444d6404c095fa5$var$t.localStorage.setItem($e444d6404c095fa5$var$Qe, JSON.stringify($e444d6404c095fa5$var$g({}, s, {
            source: void 0
        }))), this.yt() === $e444d6404c095fa5$var$tr.LOADED) this.bt(s);
        else if (this.yt() === $e444d6404c095fa5$var$tr.UNINITIALIZED) {
            var n;
            this._t($e444d6404c095fa5$var$tr.LOADING), null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == n.loadExternalDependency || n.loadExternalDependency(this.instance, "toolbar", (t)=>{
                if (t) return $e444d6404c095fa5$var$Ze.error("[Toolbar] Failed to load", t), void this._t($e444d6404c095fa5$var$tr.UNINITIALIZED);
                this._t($e444d6404c095fa5$var$tr.LOADED), this.bt(s);
            }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "turbolinks:load", ()=>{
                this._t($e444d6404c095fa5$var$tr.UNINITIALIZED), this.loadToolbar(s);
            });
        }
        return !0;
    }
    wt(t) {
        return this.loadToolbar(t);
    }
    maybeLoadEditor(t, i, e) {
        return void 0 === t && (t = void 0), void 0 === i && (i = void 0), void 0 === e && (e = void 0), this.maybeLoadToolbar(t, i, e);
    }
}
var $e444d6404c095fa5$var$er = $e444d6404c095fa5$var$Tt("[TracingHeaders]");
class $e444d6404c095fa5$var$rr {
    constructor(t){
        this.xt = void 0, this.St = void 0, this.rt = ()=>{
            var t, i;
            $e444d6404c095fa5$var$F(this.xt) && (null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) || t._patchXHR(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
            $e444d6404c095fa5$var$F(this.St) && (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (i = i.tracingHeadersPatchFns) || i._patchFetch(this._instance.config.__add_tracing_headers || [], this._instance.get_distinct_id(), this._instance.sessionManager));
        }, this._instance = t;
    }
    it(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.tracingHeadersPatchFns && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "tracing-headers", (i)=>{
            if (i) return $e444d6404c095fa5$var$er.error("failed to load script", i);
            t();
        });
    }
    startIfEnabledOrStop() {
        var t, i;
        this._instance.config.__add_tracing_headers ? this.it(this.rt) : (null == (t = this.xt) || t.call(this), null == (i = this.St) || i.call(this), this.xt = void 0, this.St = void 0);
    }
}
var $e444d6404c095fa5$var$sr = "Mobile", $e444d6404c095fa5$var$nr = "iOS", $e444d6404c095fa5$var$or = "Android", $e444d6404c095fa5$var$ar = "Tablet", $e444d6404c095fa5$var$lr = $e444d6404c095fa5$var$or + " " + $e444d6404c095fa5$var$ar, $e444d6404c095fa5$var$ur = "iPad", $e444d6404c095fa5$var$hr = "Apple", $e444d6404c095fa5$var$dr = $e444d6404c095fa5$var$hr + " Watch", $e444d6404c095fa5$var$vr = "Safari", $e444d6404c095fa5$var$cr = "BlackBerry", $e444d6404c095fa5$var$fr = "Samsung", $e444d6404c095fa5$var$pr = $e444d6404c095fa5$var$fr + "Browser", $e444d6404c095fa5$var$gr = $e444d6404c095fa5$var$fr + " Internet", $e444d6404c095fa5$var$_r = "Chrome", $e444d6404c095fa5$var$mr = $e444d6404c095fa5$var$_r + " OS", $e444d6404c095fa5$var$yr = $e444d6404c095fa5$var$_r + " " + $e444d6404c095fa5$var$nr, $e444d6404c095fa5$var$br = "Internet Explorer", $e444d6404c095fa5$var$wr = $e444d6404c095fa5$var$br + " " + $e444d6404c095fa5$var$sr, $e444d6404c095fa5$var$xr = "Opera", $e444d6404c095fa5$var$Sr = $e444d6404c095fa5$var$xr + " Mini", $e444d6404c095fa5$var$Er = "Edge", $e444d6404c095fa5$var$$r = "Microsoft " + $e444d6404c095fa5$var$Er, $e444d6404c095fa5$var$kr = "Firefox", $e444d6404c095fa5$var$Pr = $e444d6404c095fa5$var$kr + " " + $e444d6404c095fa5$var$nr, $e444d6404c095fa5$var$Tr = "Nintendo", $e444d6404c095fa5$var$Rr = "PlayStation", $e444d6404c095fa5$var$Ir = "Xbox", $e444d6404c095fa5$var$Cr = $e444d6404c095fa5$var$or + " " + $e444d6404c095fa5$var$sr, $e444d6404c095fa5$var$Or = $e444d6404c095fa5$var$sr + " " + $e444d6404c095fa5$var$vr, $e444d6404c095fa5$var$Fr = "Windows", $e444d6404c095fa5$var$Mr = $e444d6404c095fa5$var$Fr + " Phone", $e444d6404c095fa5$var$Ar = "Nokia", $e444d6404c095fa5$var$Dr = "Ouya", $e444d6404c095fa5$var$jr = "Generic", $e444d6404c095fa5$var$Lr = $e444d6404c095fa5$var$jr + " " + $e444d6404c095fa5$var$sr.toLowerCase(), $e444d6404c095fa5$var$Nr = $e444d6404c095fa5$var$jr + " " + $e444d6404c095fa5$var$ar.toLowerCase(), $e444d6404c095fa5$var$Ur = "Konqueror", $e444d6404c095fa5$var$zr = "(\\d+(\\.\\d+)?)", $e444d6404c095fa5$var$Hr = new RegExp("Version/" + $e444d6404c095fa5$var$zr), $e444d6404c095fa5$var$Br = new RegExp($e444d6404c095fa5$var$Ir, "i"), $e444d6404c095fa5$var$qr = new RegExp($e444d6404c095fa5$var$Rr + " \\w+", "i"), $e444d6404c095fa5$var$Wr = new RegExp($e444d6404c095fa5$var$Tr + " \\w+", "i"), $e444d6404c095fa5$var$Gr = new RegExp($e444d6404c095fa5$var$cr + "|PlayBook|BB10", "i"), $e444d6404c095fa5$var$Vr = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var $e444d6404c095fa5$var$Jr = (t, i)=>i && $e444d6404c095fa5$var$w(i, $e444d6404c095fa5$var$hr) || function(t) {
        return $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$vr) && !$e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$_r) && !$e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$or);
    }(t), $e444d6404c095fa5$var$Kr = function(t, i) {
    return i = i || "", $e444d6404c095fa5$var$w(t, " OPR/") && $e444d6404c095fa5$var$w(t, "Mini") ? $e444d6404c095fa5$var$Sr : $e444d6404c095fa5$var$w(t, " OPR/") ? $e444d6404c095fa5$var$xr : $e444d6404c095fa5$var$Gr.test(t) ? $e444d6404c095fa5$var$cr : $e444d6404c095fa5$var$w(t, "IE" + $e444d6404c095fa5$var$sr) || $e444d6404c095fa5$var$w(t, "WPDesktop") ? $e444d6404c095fa5$var$wr : $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$pr) ? $e444d6404c095fa5$var$gr : $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$Er) || $e444d6404c095fa5$var$w(t, "Edg/") ? $e444d6404c095fa5$var$$r : $e444d6404c095fa5$var$w(t, "FBIOS") ? "Facebook " + $e444d6404c095fa5$var$sr : $e444d6404c095fa5$var$w(t, "UCWEB") || $e444d6404c095fa5$var$w(t, "UCBrowser") ? "UC Browser" : $e444d6404c095fa5$var$w(t, "CriOS") ? $e444d6404c095fa5$var$yr : $e444d6404c095fa5$var$w(t, "CrMo") || $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$_r) ? $e444d6404c095fa5$var$_r : $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$or) && $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$vr) ? $e444d6404c095fa5$var$Cr : $e444d6404c095fa5$var$w(t, "FxiOS") ? $e444d6404c095fa5$var$Pr : $e444d6404c095fa5$var$w(t.toLowerCase(), $e444d6404c095fa5$var$Ur.toLowerCase()) ? $e444d6404c095fa5$var$Ur : $e444d6404c095fa5$var$Jr(t, i) ? $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$sr) ? $e444d6404c095fa5$var$Or : $e444d6404c095fa5$var$vr : $e444d6404c095fa5$var$w(t, $e444d6404c095fa5$var$kr) ? $e444d6404c095fa5$var$kr : $e444d6404c095fa5$var$w(t, "MSIE") || $e444d6404c095fa5$var$w(t, "Trident/") ? $e444d6404c095fa5$var$br : $e444d6404c095fa5$var$w(t, "Gecko") ? $e444d6404c095fa5$var$kr : "";
}, $e444d6404c095fa5$var$Yr = {
    [$e444d6404c095fa5$var$wr]: [
        new RegExp("rv:" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$$r]: [
        new RegExp($e444d6404c095fa5$var$Er + "?\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$_r]: [
        new RegExp("(" + $e444d6404c095fa5$var$_r + "|CrMo)\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$yr]: [
        new RegExp("CriOS\\/" + $e444d6404c095fa5$var$zr)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$vr]: [
        $e444d6404c095fa5$var$Hr
    ],
    [$e444d6404c095fa5$var$Or]: [
        $e444d6404c095fa5$var$Hr
    ],
    [$e444d6404c095fa5$var$xr]: [
        new RegExp("(Opera|OPR)\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$kr]: [
        new RegExp($e444d6404c095fa5$var$kr + "\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$Pr]: [
        new RegExp("FxiOS\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$Ur]: [
        new RegExp("Konqueror[:/]?" + $e444d6404c095fa5$var$zr, "i")
    ],
    [$e444d6404c095fa5$var$cr]: [
        new RegExp($e444d6404c095fa5$var$cr + " " + $e444d6404c095fa5$var$zr),
        $e444d6404c095fa5$var$Hr
    ],
    [$e444d6404c095fa5$var$Cr]: [
        new RegExp("android\\s" + $e444d6404c095fa5$var$zr, "i")
    ],
    [$e444d6404c095fa5$var$gr]: [
        new RegExp($e444d6404c095fa5$var$pr + "\\/" + $e444d6404c095fa5$var$zr)
    ],
    [$e444d6404c095fa5$var$br]: [
        new RegExp("(rv:|MSIE )" + $e444d6404c095fa5$var$zr)
    ],
    Mozilla: [
        new RegExp("rv:" + $e444d6404c095fa5$var$zr)
    ]
}, $e444d6404c095fa5$var$Xr = function(t, i) {
    var e = $e444d6404c095fa5$var$Kr(t, i), r = $e444d6404c095fa5$var$Yr[e];
    if ($e444d6404c095fa5$var$F(r)) return null;
    for(var s = 0; s < r.length; s++){
        var n = r[s], o = t.match(n);
        if (o) return parseFloat(o[o.length - 2]);
    }
    return null;
}, $e444d6404c095fa5$var$Qr = [
    [
        new RegExp($e444d6404c095fa5$var$Ir + "; " + $e444d6404c095fa5$var$Ir + " (.*?)[);]", "i"),
        (t)=>[
                $e444d6404c095fa5$var$Ir,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Tr, "i"),
        [
            $e444d6404c095fa5$var$Tr,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Rr, "i"),
        [
            $e444d6404c095fa5$var$Rr,
            ""
        ]
    ],
    [
        $e444d6404c095fa5$var$Gr,
        [
            $e444d6404c095fa5$var$cr,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Fr, "i"),
        (t, i)=>{
            if (/Phone/.test(i) || /WPDesktop/.test(i)) return [
                $e444d6404c095fa5$var$Mr,
                ""
            ];
            if (new RegExp($e444d6404c095fa5$var$sr).test(i) && !/IEMobile\b/.test(i)) return [
                $e444d6404c095fa5$var$Fr + " " + $e444d6404c095fa5$var$sr,
                ""
            ];
            var e = /Windows NT ([0-9.]+)/i.exec(i);
            if (e && e[1]) {
                var r = e[1], s = $e444d6404c095fa5$var$Vr[r] || "";
                return /arm/i.test(i) && (s = "RT"), [
                    $e444d6404c095fa5$var$Fr,
                    s
                ];
            }
            return [
                $e444d6404c095fa5$var$Fr,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>{
            if (t && t[3]) {
                var i = [
                    t[3],
                    t[4],
                    t[5] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$nr,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$nr,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var i = "";
            return t && t.length >= 3 && (i = $e444d6404c095fa5$var$F(t[2]) ? t[3] : t[2]), [
                "watchOS",
                i
            ];
        }
    ],
    [
        new RegExp("(" + $e444d6404c095fa5$var$or + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e444d6404c095fa5$var$or + ")", "i"),
        (t)=>{
            if (t && t[2]) {
                var i = [
                    t[2],
                    t[3],
                    t[4] || "0"
                ];
                return [
                    $e444d6404c095fa5$var$or,
                    i.join(".")
                ];
            }
            return [
                $e444d6404c095fa5$var$or,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var i = [
                "Mac OS X",
                ""
            ];
            if (t && t[1]) {
                var e = [
                    t[1],
                    t[2],
                    t[3] || "0"
                ];
                i[1] = e.join(".");
            }
            return i;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $e444d6404c095fa5$var$mr,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $e444d6404c095fa5$var$Zr = function(t) {
    return $e444d6404c095fa5$var$Wr.test(t) ? $e444d6404c095fa5$var$Tr : $e444d6404c095fa5$var$qr.test(t) ? $e444d6404c095fa5$var$Rr : $e444d6404c095fa5$var$Br.test(t) ? $e444d6404c095fa5$var$Ir : new RegExp($e444d6404c095fa5$var$Dr, "i").test(t) ? $e444d6404c095fa5$var$Dr : new RegExp("(" + $e444d6404c095fa5$var$Mr + "|WPDesktop)", "i").test(t) ? $e444d6404c095fa5$var$Mr : /iPad/.test(t) ? $e444d6404c095fa5$var$ur : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $e444d6404c095fa5$var$dr : $e444d6404c095fa5$var$Gr.test(t) ? $e444d6404c095fa5$var$cr : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($e444d6404c095fa5$var$Ar, "i").test(t) ? $e444d6404c095fa5$var$Ar : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? !new RegExp($e444d6404c095fa5$var$sr).test(t) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) ? /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $e444d6404c095fa5$var$or : $e444d6404c095fa5$var$lr : $e444d6404c095fa5$var$or : new RegExp("(pda|" + $e444d6404c095fa5$var$sr + ")", "i").test(t) ? $e444d6404c095fa5$var$Lr : new RegExp($e444d6404c095fa5$var$ar, "i").test(t) && !new RegExp($e444d6404c095fa5$var$ar + " pc", "i").test(t) ? $e444d6404c095fa5$var$Nr : "";
}, $e444d6404c095fa5$var$ts = "https?://(.*)", $e444d6404c095fa5$var$is = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $e444d6404c095fa5$var$es = $e444d6404c095fa5$var$At([
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid"
], $e444d6404c095fa5$var$is), $e444d6404c095fa5$var$rs = "<masked>", $e444d6404c095fa5$var$ss = [
    "li_fat_id"
];
function $e444d6404c095fa5$var$ns(t, i, e) {
    if (!$e444d6404c095fa5$var$o) return {};
    var r, s = i ? $e444d6404c095fa5$var$At([], $e444d6404c095fa5$var$is, e || []) : [], n = $e444d6404c095fa5$var$os($e444d6404c095fa5$var$le($e444d6404c095fa5$var$o.URL, s, $e444d6404c095fa5$var$rs), t), a = (r = {}, $e444d6404c095fa5$var$Ft($e444d6404c095fa5$var$ss, function(t) {
        var i = $e444d6404c095fa5$var$Pe.q(t);
        r[t] = i || null;
    }), r);
    return $e444d6404c095fa5$var$Mt(a, n);
}
function $e444d6404c095fa5$var$os(t, i) {
    var e = $e444d6404c095fa5$var$es.concat(i || []), r = {};
    return $e444d6404c095fa5$var$Ft(e, function(i) {
        var e = $e444d6404c095fa5$var$ae(t, i);
        r[i] = e || null;
    }), r;
}
function $e444d6404c095fa5$var$as(t) {
    var i = function(t) {
        return t ? 0 === t.search($e444d6404c095fa5$var$ts + "google.([^/?]*)") ? "google" : 0 === t.search($e444d6404c095fa5$var$ts + "bing.com") ? "bing" : 0 === t.search($e444d6404c095fa5$var$ts + "yahoo.com") ? "yahoo" : 0 === t.search($e444d6404c095fa5$var$ts + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), e = "yahoo" != i ? "q" : "p", r = {};
    if (!$e444d6404c095fa5$var$D(i)) {
        r.$search_engine = i;
        var s = $e444d6404c095fa5$var$o ? $e444d6404c095fa5$var$ae($e444d6404c095fa5$var$o.referrer, e) : "";
        s.length && (r.ph_keyword = s);
    }
    return r;
}
function $e444d6404c095fa5$var$ls() {
    return navigator.language || navigator.userLanguage;
}
function $e444d6404c095fa5$var$us() {
    return (null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) || "$direct";
}
function $e444d6404c095fa5$var$hs(t, i) {
    var e = t ? $e444d6404c095fa5$var$At([], $e444d6404c095fa5$var$is, i || []) : [], r = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href.substring(0, 1e3);
    return {
        r: $e444d6404c095fa5$var$us().substring(0, 1e3),
        u: r ? $e444d6404c095fa5$var$le(r, e, $e444d6404c095fa5$var$rs) : void 0
    };
}
function $e444d6404c095fa5$var$ds(t) {
    var i, { r: e, u: r } = t, s = {
        $referrer: e,
        $referring_domain: null == e ? void 0 : "$direct" == e ? "$direct" : null == (i = $e444d6404c095fa5$var$ne(e)) ? void 0 : i.host
    };
    if (r) {
        s.$current_url = r;
        var n = $e444d6404c095fa5$var$ne(r);
        s.$host = null == n ? void 0 : n.host, s.$pathname = null == n ? void 0 : n.pathname;
        var o = $e444d6404c095fa5$var$os(r);
        $e444d6404c095fa5$var$Mt(s, o);
    }
    if (e) {
        var a = $e444d6404c095fa5$var$as(e);
        $e444d6404c095fa5$var$Mt(s, a);
    }
    return s;
}
function $e444d6404c095fa5$var$vs() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$cs() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$fs(i, e) {
    if (!$e444d6404c095fa5$var$d) return {};
    var r, s, n, o = i ? $e444d6404c095fa5$var$At([], $e444d6404c095fa5$var$is, e || []) : [], [l, u] = function(t) {
        for(var i = 0; i < $e444d6404c095fa5$var$Qr.length; i++){
            var [e, r] = $e444d6404c095fa5$var$Qr[i], s = e.exec(t), n = s && ($e444d6404c095fa5$var$I(r) ? r(s, t) : r);
            if (n) return n;
        }
        return [
            "",
            ""
        ];
    }($e444d6404c095fa5$var$d);
    return $e444d6404c095fa5$var$Mt($e444d6404c095fa5$var$Nt({
        $os: l,
        $os_version: u,
        $browser: $e444d6404c095fa5$var$Kr($e444d6404c095fa5$var$d, navigator.vendor),
        $device: $e444d6404c095fa5$var$Zr($e444d6404c095fa5$var$d),
        $device_type: (s = $e444d6404c095fa5$var$d, n = $e444d6404c095fa5$var$Zr(s), n === $e444d6404c095fa5$var$ur || n === $e444d6404c095fa5$var$lr || "Kobo" === n || "Kindle Fire" === n || n === $e444d6404c095fa5$var$Nr ? $e444d6404c095fa5$var$ar : n === $e444d6404c095fa5$var$Tr || n === $e444d6404c095fa5$var$Ir || n === $e444d6404c095fa5$var$Rr || n === $e444d6404c095fa5$var$Dr ? "Console" : n === $e444d6404c095fa5$var$dr ? "Wearable" : n ? $e444d6404c095fa5$var$sr : "Desktop"),
        $timezone: $e444d6404c095fa5$var$vs(),
        $timezone_offset: $e444d6404c095fa5$var$cs()
    }), {
        $current_url: $e444d6404c095fa5$var$le(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.href, o, $e444d6404c095fa5$var$rs),
        $host: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.host,
        $pathname: null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.pathname,
        $raw_user_agent: $e444d6404c095fa5$var$d.length > 1e3 ? $e444d6404c095fa5$var$d.substring(0, 997) + "..." : $e444d6404c095fa5$var$d,
        $browser_version: $e444d6404c095fa5$var$Xr($e444d6404c095fa5$var$d, navigator.vendor),
        $browser_language: $e444d6404c095fa5$var$ls(),
        $browser_language_prefix: (r = $e444d6404c095fa5$var$ls(), "string" == typeof r ? r.split("-")[0] : void 0),
        $screen_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.height,
        $screen_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.width,
        $viewport_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerHeight,
        $viewport_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerWidth,
        $lib: "web",
        $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION,
        $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
        $time: Date.now() / 1e3
    });
}
var $e444d6404c095fa5$var$ps = $e444d6404c095fa5$var$Tt("[Web Vitals]"), $e444d6404c095fa5$var$gs = 9e5;
class $e444d6404c095fa5$var$_s {
    constructor(t){
        var i;
        this.Et = !1, this.P = !1, this.N = {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }, this.$t = ()=>{
            clearTimeout(this.kt), 0 !== this.N.metrics.length && (this._instance.capture("$web_vitals", this.N.metrics.reduce((t, i)=>$e444d6404c095fa5$var$g({}, t, {
                    ["$web_vitals_" + i.name + "_event"]: $e444d6404c095fa5$var$g({}, i),
                    ["$web_vitals_" + i.name + "_value"]: i.value
                }), {})), this.N = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }, this.Pt = (t)=>{
            var i, e = null == (i = this._instance.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0);
            if ($e444d6404c095fa5$var$F(e)) $e444d6404c095fa5$var$ps.error("Could not read session ID. Dropping metrics!");
            else {
                this.N = this.N || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var r = this.Tt();
                if (!$e444d6404c095fa5$var$F(r)) {
                    if ($e444d6404c095fa5$var$j(null == t ? void 0 : t.name) || $e444d6404c095fa5$var$j(null == t ? void 0 : t.value)) $e444d6404c095fa5$var$ps.error("Invalid metric received", t);
                    else if (this.Rt && t.value >= this.Rt) $e444d6404c095fa5$var$ps.error("Ignoring metric with value >= " + this.Rt, t);
                    else this.N.url !== r && (this.$t(), this.kt = setTimeout(this.$t, this.flushToCaptureTimeoutMs)), $e444d6404c095fa5$var$F(this.N.url) && (this.N.url = r), this.N.firstMetricTimestamp = $e444d6404c095fa5$var$F(this.N.firstMetricTimestamp) ? Date.now() : this.N.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0), this.N.metrics.push($e444d6404c095fa5$var$g({}, t, {
                        $current_url: r,
                        $session_id: e.sessionId,
                        $window_id: e.windowId,
                        timestamp: Date.now()
                    })), this.N.metrics.length === this.allowedMetrics.length && this.$t();
                }
            }
        }, this.rt = ()=>{
            var t, i, e, r, s = $e444d6404c095fa5$var$v.__PosthogExtensions__;
            $e444d6404c095fa5$var$F(s) || $e444d6404c095fa5$var$F(s.postHogWebVitalsCallbacks) || ({ onLCP: t, onCLS: i, onFCP: e, onINP: r } = s.postHogWebVitalsCallbacks), t && i && e && r ? (this.allowedMetrics.indexOf("LCP") > -1 && t(this.Pt.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && i(this.Pt.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && e(this.Pt.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && r(this.Pt.bind(this)), this.P = !0) : $e444d6404c095fa5$var$ps.error("web vitals callbacks not loaded - not starting");
        }, this._instance = t, this.Et = !(null == (i = this._instance.persistence) || !i.props[$e444d6404c095fa5$var$Zt]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var t, i, e = $e444d6404c095fa5$var$C(this._instance.config.capture_performance) ? null == (t = this._instance.config.capture_performance) ? void 0 : t.web_vitals_allowed_metrics : void 0;
        return $e444d6404c095fa5$var$F(e) ? (null == (i = this._instance.persistence) ? void 0 : i.props[$e444d6404c095fa5$var$ii]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : e;
    }
    get flushToCaptureTimeoutMs() {
        return ($e444d6404c095fa5$var$C(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get Rt() {
        var t = $e444d6404c095fa5$var$C(this._instance.config.capture_performance) && $e444d6404c095fa5$var$L(this._instance.config.capture_performance.__web_vitals_max_value) ? this._instance.config.capture_performance.__web_vitals_max_value : $e444d6404c095fa5$var$gs;
        return 0 < t && t <= 6e4 ? $e444d6404c095fa5$var$gs : t;
    }
    get isEnabled() {
        var t = null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.protocol;
        if ("http:" !== t && "https:" !== t) return $e444d6404c095fa5$var$ps.info("Web Vitals are disabled on non-http/https protocols"), !1;
        var i = $e444d6404c095fa5$var$C(this._instance.config.capture_performance) ? this._instance.config.capture_performance.web_vitals : $e444d6404c095fa5$var$N(this._instance.config.capture_performance) ? this._instance.config.capture_performance : void 0;
        return $e444d6404c095fa5$var$N(i) ? i : this.Et;
    }
    startIfEnabled() {
        this.isEnabled && !this.P && ($e444d6404c095fa5$var$ps.info("enabled, starting..."), this.it(this.rt));
    }
    onRemoteConfig(t) {
        var i = $e444d6404c095fa5$var$C(t.capturePerformance) && !!t.capturePerformance.web_vitals, e = $e444d6404c095fa5$var$C(t.capturePerformance) ? t.capturePerformance.web_vitals_allowed_metrics : void 0;
        this._instance.persistence && (this._instance.persistence.register({
            [$e444d6404c095fa5$var$Zt]: i
        }), this._instance.persistence.register({
            [$e444d6404c095fa5$var$ii]: e
        })), this.Et = i, this.startIfEnabled();
    }
    it(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.postHogWebVitalsCallbacks && t(), null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "web-vitals", (i)=>{
            i ? $e444d6404c095fa5$var$ps.error("failed to load script", i) : t();
        });
    }
    Tt() {
        var i = $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t.location.href : void 0;
        if (i) {
            var e = this._instance.config.mask_personal_data_properties, r = this._instance.config.custom_personal_data_properties, s = e ? $e444d6404c095fa5$var$At([], $e444d6404c095fa5$var$is, r || []) : [];
            return $e444d6404c095fa5$var$le(i, s, $e444d6404c095fa5$var$rs);
        }
        $e444d6404c095fa5$var$ps.error("Could not determine current URL");
    }
}
var $e444d6404c095fa5$var$ms = $e444d6404c095fa5$var$Tt("[Heatmaps]");
function $e444d6404c095fa5$var$ys(t) {
    return $e444d6404c095fa5$var$C(t) && "clientX" in t && "clientY" in t && $e444d6404c095fa5$var$L(t.clientX) && $e444d6404c095fa5$var$L(t.clientY);
}
class $e444d6404c095fa5$var$bs {
    constructor(t){
        var i;
        this.rageclicks = new $e444d6404c095fa5$var$ie, this.Et = !1, this.P = !1, this.It = null, this.instance = t, this.Et = !(null == (i = this.instance.persistence) || !i.props[$e444d6404c095fa5$var$Kt]);
    }
    get flushIntervalMilliseconds() {
        var t = 5e3;
        return $e444d6404c095fa5$var$C(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (t = this.instance.config.capture_heatmaps.flush_interval_milliseconds), t;
    }
    get isEnabled() {
        return $e444d6404c095fa5$var$F(this.instance.config.capture_heatmaps) ? $e444d6404c095fa5$var$F(this.instance.config.enable_heatmaps) ? this.Et : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this.P) return;
            $e444d6404c095fa5$var$ms.info("starting..."), this.Ct(), this.Ot();
        } else {
            var t;
            clearInterval(null !== (t = this.It) && void 0 !== t ? t : void 0), this.Ft(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(t) {
        var i = !!t.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [$e444d6404c095fa5$var$Kt]: i
        }), this.Et = i, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var t = this.N;
        return this.N = void 0, t;
    }
    Mt(t) {
        this.At(t.originalEvent, "deadclick");
    }
    Ot() {
        this.It && clearInterval(this.It), this.It = function(t) {
            return "visible" === (null == t ? void 0 : t.visibilityState);
        }($e444d6404c095fa5$var$o) ? setInterval(this.Dt.bind(this), this.flushIntervalMilliseconds) : null;
    }
    Ct() {
        $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o && (this.jt = this.Dt.bind(this), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "beforeunload", this.jt), this.Lt = (i)=>this.At(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "click", this.Lt, {
            capture: !0
        }), this.Nt = (i)=>this.Ut(i || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "mousemove", this.Nt, {
            capture: !0
        }), this.zt = new $e444d6404c095fa5$var$ze(this.instance, $e444d6404c095fa5$var$Ne, this.Mt.bind(this)), this.zt.startIfEnabled(), this.Ht = this.Ot.bind(this), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "visibilitychange", this.Ht), this.P = !0);
    }
    Ft() {
        var i;
        $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$o && (this.jt && $e444d6404c095fa5$var$t.removeEventListener("beforeunload", this.jt), this.Lt && $e444d6404c095fa5$var$o.removeEventListener("click", this.Lt, {
            capture: !0
        }), this.Nt && $e444d6404c095fa5$var$o.removeEventListener("mousemove", this.Nt, {
            capture: !0
        }), this.Ht && $e444d6404c095fa5$var$o.removeEventListener("visibilitychange", this.Ht), clearTimeout(this.Bt), null == (i = this.zt) || i.stop(), this.P = !1);
    }
    qt(i, e) {
        var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(i, e, r) {
            for(var s = i; s && $e444d6404c095fa5$var$Ei(s) && !$e444d6404c095fa5$var$$i(s, "body");){
                if (s === r) return !1;
                if ($e444d6404c095fa5$var$w(e, null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.getComputedStyle(s).position)) return !0;
                s = $e444d6404c095fa5$var$Di(s);
            }
            return !1;
        }($e444d6404c095fa5$var$Fi(i), [
            "fixed",
            "sticky"
        ], n);
        return {
            x: i.clientX + (o ? 0 : s),
            y: i.clientY + (o ? 0 : r),
            target_fixed: o,
            type: e
        };
    }
    At(t, i) {
        var e;
        if (void 0 === i && (i = "click"), !$e444d6404c095fa5$var$Si(t.target) && $e444d6404c095fa5$var$ys(t)) {
            var r = this.qt(t, i);
            null != (e = this.rageclicks) && e.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && this.Wt($e444d6404c095fa5$var$g({}, r, {
                type: "rageclick"
            })), this.Wt(r);
        }
    }
    Ut(t) {
        !$e444d6404c095fa5$var$Si(t.target) && $e444d6404c095fa5$var$ys(t) && (clearTimeout(this.Bt), this.Bt = setTimeout(()=>{
            this.Wt(this.qt(t, "mousemove"));
        }, 500));
    }
    Wt(i) {
        if ($e444d6404c095fa5$var$t) {
            var e = $e444d6404c095fa5$var$t.location.href, r = this.instance.config.mask_personal_data_properties, s = this.instance.config.custom_personal_data_properties, n = r ? $e444d6404c095fa5$var$At([], $e444d6404c095fa5$var$is, s || []) : [], o = $e444d6404c095fa5$var$le(e, n, $e444d6404c095fa5$var$rs);
            this.N = this.N || {}, this.N[o] || (this.N[o] = []), this.N[o].push(i);
        }
    }
    Dt() {
        this.N && !$e444d6404c095fa5$var$O(this.N) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class $e444d6404c095fa5$var$ws {
    constructor(t){
        this._instance = t;
    }
    doPageView(i, e) {
        var r, s = this.Gt(i, e);
        return this.Vt = {
            pathname: null !== (r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: e,
            timestamp: i
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var i;
        return this.Gt(t, null == (i = this.Vt) ? void 0 : i.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.Vt) ? void 0 : t.pageViewId
        };
    }
    Gt(t, i) {
        var e = this.Vt;
        if (!e) return {
            $pageview_id: i
        };
        var r = {
            $pageview_id: i,
            $prev_pageview_id: e.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: n, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: h } = s;
            if (!($e444d6404c095fa5$var$F(n) || $e444d6404c095fa5$var$F(o) || $e444d6404c095fa5$var$F(a) || $e444d6404c095fa5$var$F(l) || $e444d6404c095fa5$var$F(u) || $e444d6404c095fa5$var$F(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n <= 1 ? 1 : $e444d6404c095fa5$var$J(o / n, 0, 1, $e444d6404c095fa5$var$Pt), v = n <= 1 ? 1 : $e444d6404c095fa5$var$J(a / n, 0, 1, $e444d6404c095fa5$var$Pt), c = l <= 1 ? 1 : $e444d6404c095fa5$var$J(u / l, 0, 1, $e444d6404c095fa5$var$Pt), f = l <= 1 ? 1 : $e444d6404c095fa5$var$J(h / l, 0, 1, $e444d6404c095fa5$var$Pt);
                r = $e444d6404c095fa5$var$Mt(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return e.pathname && (r.$prev_pageview_pathname = e.pathname), e.timestamp && (r.$prev_pageview_duration = (t.getTime() - e.timestamp.getTime()) / 1e3), r;
    }
}
var $e444d6404c095fa5$var$xs = Uint8Array, $e444d6404c095fa5$var$Ss = Uint16Array, $e444d6404c095fa5$var$Es = Uint32Array, $e444d6404c095fa5$var$$s = new $e444d6404c095fa5$var$xs([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $e444d6404c095fa5$var$ks = new $e444d6404c095fa5$var$xs([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $e444d6404c095fa5$var$Ps = new $e444d6404c095fa5$var$xs([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $e444d6404c095fa5$var$Ts = function(t, i) {
    for(var e = new $e444d6404c095fa5$var$Ss(31), r = 0; r < 31; ++r)e[r] = i += 1 << t[r - 1];
    var s = new $e444d6404c095fa5$var$Es(e[30]);
    for(r = 1; r < 30; ++r)for(var n = e[r]; n < e[r + 1]; ++n)s[n] = n - e[r] << 5 | r;
    return [
        e,
        s
    ];
}, $e444d6404c095fa5$var$Rs = $e444d6404c095fa5$var$Ts($e444d6404c095fa5$var$$s, 2), $e444d6404c095fa5$var$Is = $e444d6404c095fa5$var$Rs[0], $e444d6404c095fa5$var$Cs = $e444d6404c095fa5$var$Rs[1];
$e444d6404c095fa5$var$Is[28] = 258, $e444d6404c095fa5$var$Cs[258] = 28;
for(var $e444d6404c095fa5$var$Os = $e444d6404c095fa5$var$Ts($e444d6404c095fa5$var$ks, 0)[1], $e444d6404c095fa5$var$Fs = new $e444d6404c095fa5$var$Ss(32768), $e444d6404c095fa5$var$Ms = 0; $e444d6404c095fa5$var$Ms < 32768; ++$e444d6404c095fa5$var$Ms){
    var $e444d6404c095fa5$var$As = (43690 & $e444d6404c095fa5$var$Ms) >>> 1 | (21845 & $e444d6404c095fa5$var$Ms) << 1;
    $e444d6404c095fa5$var$As = (61680 & ($e444d6404c095fa5$var$As = (52428 & $e444d6404c095fa5$var$As) >>> 2 | (13107 & $e444d6404c095fa5$var$As) << 2)) >>> 4 | (3855 & $e444d6404c095fa5$var$As) << 4, $e444d6404c095fa5$var$Fs[$e444d6404c095fa5$var$Ms] = ((65280 & $e444d6404c095fa5$var$As) >>> 8 | (255 & $e444d6404c095fa5$var$As) << 8) >>> 1;
}
var $e444d6404c095fa5$var$Ds = function(t, i, e) {
    for(var r = t.length, s = 0, n = new $e444d6404c095fa5$var$Ss(i); s < r; ++s)++n[t[s] - 1];
    var o, a = new $e444d6404c095fa5$var$Ss(i);
    for(s = 0; s < i; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (e) {
        o = new $e444d6404c095fa5$var$Ss(1 << i);
        var l = 15 - i;
        for(s = 0; s < r; ++s)if (t[s]) for(var u = s << 4 | t[s], h = i - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; d <= v; ++d)o[$e444d6404c095fa5$var$Fs[d] >>> l] = u;
    } else for(o = new $e444d6404c095fa5$var$Ss(r), s = 0; s < r; ++s)o[s] = $e444d6404c095fa5$var$Fs[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $e444d6404c095fa5$var$js = new $e444d6404c095fa5$var$xs(288);
for($e444d6404c095fa5$var$Ms = 0; $e444d6404c095fa5$var$Ms < 144; ++$e444d6404c095fa5$var$Ms)$e444d6404c095fa5$var$js[$e444d6404c095fa5$var$Ms] = 8;
for($e444d6404c095fa5$var$Ms = 144; $e444d6404c095fa5$var$Ms < 256; ++$e444d6404c095fa5$var$Ms)$e444d6404c095fa5$var$js[$e444d6404c095fa5$var$Ms] = 9;
for($e444d6404c095fa5$var$Ms = 256; $e444d6404c095fa5$var$Ms < 280; ++$e444d6404c095fa5$var$Ms)$e444d6404c095fa5$var$js[$e444d6404c095fa5$var$Ms] = 7;
for($e444d6404c095fa5$var$Ms = 280; $e444d6404c095fa5$var$Ms < 288; ++$e444d6404c095fa5$var$Ms)$e444d6404c095fa5$var$js[$e444d6404c095fa5$var$Ms] = 8;
var $e444d6404c095fa5$var$Ls = new $e444d6404c095fa5$var$xs(32);
for($e444d6404c095fa5$var$Ms = 0; $e444d6404c095fa5$var$Ms < 32; ++$e444d6404c095fa5$var$Ms)$e444d6404c095fa5$var$Ls[$e444d6404c095fa5$var$Ms] = 5;
var $e444d6404c095fa5$var$Ns = $e444d6404c095fa5$var$Ds($e444d6404c095fa5$var$js, 9, 0), $e444d6404c095fa5$var$Us = $e444d6404c095fa5$var$Ds($e444d6404c095fa5$var$Ls, 5, 0), $e444d6404c095fa5$var$zs = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $e444d6404c095fa5$var$Hs = function(t, i, e) {
    (null == e || e > t.length) && (e = t.length);
    var r = new (t instanceof $e444d6404c095fa5$var$Ss ? $e444d6404c095fa5$var$Ss : t instanceof $e444d6404c095fa5$var$Es ? $e444d6404c095fa5$var$Es : $e444d6404c095fa5$var$xs)(e - i);
    return r.set(t.subarray(i, e)), r;
}, $e444d6404c095fa5$var$Bs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8;
}, $e444d6404c095fa5$var$qs = function(t, i, e) {
    e <<= 7 & i;
    var r = i / 8 >> 0;
    t[r] |= e, t[r + 1] |= e >>> 8, t[r + 2] |= e >>> 16;
}, $e444d6404c095fa5$var$Ws = function(t, i) {
    for(var e = [], r = 0; r < t.length; ++r)t[r] && e.push({
        s: r,
        f: t[r]
    });
    var s = e.length, n = e.slice();
    if (!s) return [
        new $e444d6404c095fa5$var$xs(0),
        0
    ];
    if (1 == s) {
        var o = new $e444d6404c095fa5$var$xs(e[0].s + 1);
        return o[e[0].s] = 1, [
            o,
            1
        ];
    }
    e.sort(function(t, i) {
        return t.f - i.f;
    }), e.push({
        s: -1,
        f: 25001
    });
    var a = e[0], l = e[1], u = 0, h = 1, d = 2;
    for(e[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = e[e[u].f < e[d].f ? u++ : d++], l = e[u != h && e[u].f < e[d].f ? u++ : d++], e[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; r < s; ++r)n[r].s > v && (v = n[r].s);
    var c = new $e444d6404c095fa5$var$Ss(v + 1), f = $e444d6404c095fa5$var$Gs(e[h - 1], c, 0);
    if (f > i) {
        r = 0;
        var p = 0, g = f - i, _ = 1 << g;
        for(n.sort(function(t, i) {
            return c[i.s] - c[t.s] || t.f - i.f;
        }); r < s; ++r){
            var m = n[r].s;
            if (!(c[m] > i)) break;
            p += _ - (1 << f - c[m]), c[m] = i;
        }
        for(p >>>= g; p > 0;){
            var y = n[r].s;
            c[y] < i ? p -= 1 << i - c[y]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var b = n[r].s;
            c[b] == i && (--c[b], ++p);
        }
        f = i;
    }
    return [
        new $e444d6404c095fa5$var$xs(c),
        f
    ];
}, $e444d6404c095fa5$var$Gs = function(t, i, e) {
    return -1 == t.s ? Math.max($e444d6404c095fa5$var$Gs(t.l, i, e + 1), $e444d6404c095fa5$var$Gs(t.r, i, e + 1)) : i[t.s] = e;
}, $e444d6404c095fa5$var$Vs = function(t) {
    for(var i = t.length; i && !t[--i];);
    for(var e = new $e444d6404c095fa5$var$Ss(++i), r = 0, s = t[0], n = 1, o = function(t) {
        e[r++] = t;
    }, a = 1; a <= i; ++a)if (t[a] == s && a != i) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        e.subarray(0, r),
        i
    ];
}, $e444d6404c095fa5$var$Js = function(t, i) {
    for(var e = 0, r = 0; r < i.length; ++r)e += t[r] * i[r];
    return e;
}, $e444d6404c095fa5$var$Ks = function(t, i, e) {
    var r = e.length, s = $e444d6404c095fa5$var$zs(i + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; n < r; ++n)t[s + n + 4] = e[n];
    return 8 * (s + 4 + r);
}, $e444d6404c095fa5$var$Ys = function(t, i, e, r, s, n, o, a, l, u, h) {
    $e444d6404c095fa5$var$Bs(i, h++, e), ++s[256];
    for(var d = $e444d6404c095fa5$var$Ws(s, 15), v = d[0], c = d[1], f = $e444d6404c095fa5$var$Ws(n, 15), p = f[0], g = f[1], _ = $e444d6404c095fa5$var$Vs(v), m = _[0], y = _[1], b = $e444d6404c095fa5$var$Vs(p), w = b[0], x = b[1], S = new $e444d6404c095fa5$var$Ss(19), E = 0; E < m.length; ++E)S[31 & m[E]]++;
    for(E = 0; E < w.length; ++E)S[31 & w[E]]++;
    for(var k = $e444d6404c095fa5$var$Ws(S, 7), P = k[0], T = k[1], R = 19; R > 4 && !P[$e444d6404c095fa5$var$Ps[R - 1]]; --R);
    var I, C, O, F, M = u + 5 << 3, A = $e444d6404c095fa5$var$Js(s, $e444d6404c095fa5$var$js) + $e444d6404c095fa5$var$Js(n, $e444d6404c095fa5$var$Ls) + o, D = $e444d6404c095fa5$var$Js(s, v) + $e444d6404c095fa5$var$Js(n, p) + o + 14 + 3 * R + $e444d6404c095fa5$var$Js(S, P) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (M <= A && M <= D) return $e444d6404c095fa5$var$Ks(i, h, t.subarray(l, l + u));
    if ($e444d6404c095fa5$var$Bs(i, h, 1 + (D < A)), h += 2, D < A) {
        I = $e444d6404c095fa5$var$Ds(v, c, 0), C = v, O = $e444d6404c095fa5$var$Ds(p, g, 0), F = p;
        var j = $e444d6404c095fa5$var$Ds(P, T, 0);
        $e444d6404c095fa5$var$Bs(i, h, y - 257), $e444d6404c095fa5$var$Bs(i, h + 5, x - 1), $e444d6404c095fa5$var$Bs(i, h + 10, R - 4), h += 14;
        for(E = 0; E < R; ++E)$e444d6404c095fa5$var$Bs(i, h + 3 * E, P[$e444d6404c095fa5$var$Ps[E]]);
        h += 3 * R;
        for(var L = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var U = L[N];
            for(E = 0; E < U.length; ++E){
                var z = 31 & U[E];
                $e444d6404c095fa5$var$Bs(i, h, j[z]), h += P[z], z > 15 && ($e444d6404c095fa5$var$Bs(i, h, U[E] >>> 5 & 127), h += U[E] >>> 12);
            }
        }
    } else I = $e444d6404c095fa5$var$Ns, C = $e444d6404c095fa5$var$js, O = $e444d6404c095fa5$var$Us, F = $e444d6404c095fa5$var$Ls;
    for(E = 0; E < a; ++E)if (r[E] > 255) {
        z = r[E] >>> 18 & 31;
        $e444d6404c095fa5$var$qs(i, h, I[z + 257]), h += C[z + 257], z > 7 && ($e444d6404c095fa5$var$Bs(i, h, r[E] >>> 23 & 31), h += $e444d6404c095fa5$var$$s[z]);
        var H = 31 & r[E];
        $e444d6404c095fa5$var$qs(i, h, O[H]), h += F[H], H > 3 && ($e444d6404c095fa5$var$qs(i, h, r[E] >>> 5 & 8191), h += $e444d6404c095fa5$var$ks[H]);
    } else $e444d6404c095fa5$var$qs(i, h, I[r[E]]), h += C[r[E]];
    return $e444d6404c095fa5$var$qs(i, h, I[256]), h + C[256];
}, $e444d6404c095fa5$var$Xs = new $e444d6404c095fa5$var$Es([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $e444d6404c095fa5$var$Qs = function() {
    for(var t = new $e444d6404c095fa5$var$Es(256), i = 0; i < 256; ++i){
        for(var e = i, r = 9; --r;)e = (1 & e && 3988292384) ^ e >>> 1;
        t[i] = e;
    }
    return t;
}(), $e444d6404c095fa5$var$Zs = function(t, i, e, r, s) {
    return function(t, i, e, r, s, n) {
        var o = t.length, a = new $e444d6404c095fa5$var$xs(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!i || o < 8) for(var h = 0; h <= o; h += 65535){
            var d = h + 65535;
            d < o ? u = $e444d6404c095fa5$var$Ks(l, u, t.subarray(h, d)) : (l[h] = n, u = $e444d6404c095fa5$var$Ks(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $e444d6404c095fa5$var$Xs[i - 1], c = v >>> 13, f = 8191 & v, p = (1 << e) - 1, g = new $e444d6404c095fa5$var$Ss(32768), _ = new $e444d6404c095fa5$var$Ss(p + 1), m = Math.ceil(e / 3), y = 2 * m, b = function(i) {
                return (t[i] ^ t[i + 1] << m ^ t[i + 2] << y) & p;
            }, w = new $e444d6404c095fa5$var$Es(25e3), x = new $e444d6404c095fa5$var$Ss(288), S = new $e444d6404c095fa5$var$Ss(32), E = 0, k = 0, P = (h = 0, 0), T = 0, R = 0; h < o; ++h){
                var I = b(h), C = 32767 & h, O = _[I];
                if (g[C] = O, _[I] = C, T <= h) {
                    var F = o - h;
                    if ((E > 7e3 || P > 24576) && F > 423) {
                        u = $e444d6404c095fa5$var$Ys(t, l, 0, w, x, S, k, P, R, h - R, u), P = E = k = 0, R = h;
                        for(var M = 0; M < 286; ++M)x[M] = 0;
                        for(M = 0; M < 30; ++M)S[M] = 0;
                    }
                    var A = 2, D = 0, j = f, L = C - O & 32767;
                    if (F > 2 && I == b(h - L)) for(var N = Math.min(c, F) - 1, U = Math.min(32767, h), z = Math.min(258, F); L <= U && --j && C != O;){
                        if (t[h + A] == t[h + A - L]) {
                            for(var H = 0; H < z && t[h + H] == t[h + H - L]; ++H);
                            if (H > A) {
                                if (A = H, D = L, H > N) break;
                                var B = Math.min(L, H - 2), q = 0;
                                for(M = 0; M < B; ++M){
                                    var W = h - L + M + 32768 & 32767, G = W - g[W] + 32768 & 32767;
                                    G > q && (q = G, O = W);
                                }
                            }
                        }
                        L += (C = O) - (O = g[C]) + 32768 & 32767;
                    }
                    if (D) {
                        w[P++] = 268435456 | $e444d6404c095fa5$var$Cs[A] << 18 | $e444d6404c095fa5$var$Os[D];
                        var V = 31 & $e444d6404c095fa5$var$Cs[A], J = 31 & $e444d6404c095fa5$var$Os[D];
                        k += $e444d6404c095fa5$var$$s[V] + $e444d6404c095fa5$var$ks[J], ++x[257 + V], ++S[J], T = h + A, ++E;
                    } else w[P++] = t[h], ++x[t[h]];
                }
            }
            u = $e444d6404c095fa5$var$Ys(t, l, n, w, x, S, k, P, R, h - R, u);
        }
        return $e444d6404c095fa5$var$Hs(a, 0, r + $e444d6404c095fa5$var$zs(u) + s);
    }(t, null == i.level ? 6 : i.level, null == i.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(t.length)))) : 12 + i.mem, e, r, !0);
}, $e444d6404c095fa5$var$tn = function(t, i, e) {
    for(; e; ++i)t[i] = e, e >>>= 8;
};
function $e444d6404c095fa5$var$en(t, i) {
    void 0 === i && (i = {});
    var e = function() {
        var t = 4294967295;
        return {
            p: function(i) {
                for(var e = t, r = 0; r < i.length; ++r)e = $e444d6404c095fa5$var$Qs[255 & e ^ i[r]] ^ e >>> 8;
                t = e;
            },
            d: function() {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    e.p(t);
    var s, n = $e444d6404c095fa5$var$Zs(t, i, 10 + ((s = i).filename && s.filename.length + 1 || 0), 8), o = n.length;
    return function(t, i) {
        var e = i.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = i.level < 2 ? 4 : 9 == i.level ? 2 : 0, t[9] = 3, 0 != i.mtime && $e444d6404c095fa5$var$tn(t, 4, Math.floor(new Date(i.mtime || Date.now()) / 1e3)), e) {
            t[3] = 8;
            for(var r = 0; r <= e.length; ++r)t[r + 10] = e.charCodeAt(r);
        }
    }(n, i), $e444d6404c095fa5$var$tn(n, o - 8, e.d()), $e444d6404c095fa5$var$tn(n, o - 4, r), n;
}
var $e444d6404c095fa5$var$rn = function(t) {
    var i, e, r, s, n = "";
    for(i = e = 0, r = (t = (t + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, s = 0; s < r; s++){
        var o = t.charCodeAt(s), a = null;
        o < 128 ? e++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $e444d6404c095fa5$var$D(a) || (e > i && (n += t.substring(i, e)), n += a, i = e = s + 1);
    }
    return e > i && (n += t.substring(i, t.length)), n;
}, $e444d6404c095fa5$var$sn = !!$e444d6404c095fa5$var$u || !!$e444d6404c095fa5$var$l, $e444d6404c095fa5$var$nn = "text/plain", $e444d6404c095fa5$var$on = function(t, i, e) {
    var r;
    void 0 === e && (e = !0);
    var [s, n] = t.split("?"), o = $e444d6404c095fa5$var$g({}, i), a = null !== (r = null == n ? void 0 : n.split("&").map((t)=>{
        var i, [r, s] = t.split("="), n = e && null !== (i = o[r]) && void 0 !== i ? i : s;
        return delete o[r], r + "=" + n;
    })) && void 0 !== r ? r : [], l = $e444d6404c095fa5$var$oe(o);
    return l && a.push(l), s + "?" + a.join("&");
}, $e444d6404c095fa5$var$an = (t, i)=>JSON.stringify(t, (t, i)=>"bigint" == typeof i ? i.toString() : i, i), $e444d6404c095fa5$var$ln = (t)=>{
    var { data: i, compression: e } = t;
    if (i) {
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) {
            var r = $e444d6404c095fa5$var$en(function(t, i) {
                var e = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $e444d6404c095fa5$var$xs(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; o < e; ++o){
                    if (s + 5 > r.length) {
                        var a = new $e444d6404c095fa5$var$xs(s + 8 + (e - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    l < 128 || i ? n(l) : l < 2048 ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && l < 57344 ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $e444d6404c095fa5$var$Hs(r, 0, s);
            }($e444d6404c095fa5$var$an(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: $e444d6404c095fa5$var$nn
            });
            return {
                contentType: $e444d6404c095fa5$var$nn,
                body: s,
                estimatedSize: s.size
            };
        }
        if (e === $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) {
            var n = function(t) {
                var i, e, r, s, n, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", h = [];
                if (!t) return t;
                t = $e444d6404c095fa5$var$rn(t);
                do i = (n = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, e = n >> 12 & 63, r = n >> 6 & 63, s = 63 & n, h[l++] = o.charAt(i) + o.charAt(e) + o.charAt(r) + o.charAt(s);
                while (a < t.length);
                switch(u = h.join(""), t.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }($e444d6404c095fa5$var$an(i)), o = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $e444d6404c095fa5$var$an(t)))(n);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: o,
                estimatedSize: new Blob([
                    o
                ]).size
            };
        }
        var a = $e444d6404c095fa5$var$an(i);
        return {
            contentType: "application/json",
            body: a,
            estimatedSize: new Blob([
                a
            ]).size
        };
    }
}, $e444d6404c095fa5$var$un = [];
$e444d6404c095fa5$var$l && $e444d6404c095fa5$var$un.push({
    transport: "fetch",
    method: (t)=>{
        var i, e, { contentType: r, body: s, estimatedSize: n } = null !== (i = $e444d6404c095fa5$var$ln(t)) && void 0 !== i ? i : {}, o = new Headers;
        $e444d6404c095fa5$var$Ft(t.headers, function(t, i) {
            o.append(i, t);
        }), r && o.append("Content-Type", r);
        var a = t.url, u = null;
        if ($e444d6404c095fa5$var$h) {
            var d = new $e444d6404c095fa5$var$h;
            u = {
                signal: d.signal,
                timeout: setTimeout(()=>d.abort(), t.timeout)
            };
        }
        $e444d6404c095fa5$var$l(a, $e444d6404c095fa5$var$g({
            method: (null == t ? void 0 : t.method) || "GET",
            headers: o,
            keepalive: "POST" === t.method && (n || 0) < 52428.8,
            body: s,
            signal: null == (e = u) ? void 0 : e.signal
        }, t.fetchOptions)).then((i)=>i.text().then((e)=>{
                var r = {
                    statusCode: i.status,
                    text: e
                };
                if (200 === i.status) try {
                    r.json = JSON.parse(e);
                } catch (t) {
                    $e444d6404c095fa5$var$Pt.error(t);
                }
                null == t.callback || t.callback(r);
            })).catch((i)=>{
            $e444d6404c095fa5$var$Pt.error(i), null == t.callback || t.callback({
                statusCode: 0,
                text: i
            });
        }).finally(()=>u ? clearTimeout(u.timeout) : null);
    }
}), $e444d6404c095fa5$var$u && $e444d6404c095fa5$var$un.push({
    transport: "XHR",
    method: (t)=>{
        var i, e = new $e444d6404c095fa5$var$u;
        e.open(t.method || "GET", t.url, !0);
        var { contentType: r, body: s } = null !== (i = $e444d6404c095fa5$var$ln(t)) && void 0 !== i ? i : {};
        $e444d6404c095fa5$var$Ft(t.headers, function(t, i) {
            e.setRequestHeader(i, t);
        }), r && e.setRequestHeader("Content-Type", r), t.timeout && (e.timeout = t.timeout), t.disableXHRCredentials || (e.withCredentials = !0), e.onreadystatechange = ()=>{
            if (4 === e.readyState) {
                var i = {
                    statusCode: e.status,
                    text: e.responseText
                };
                if (200 === e.status) try {
                    i.json = JSON.parse(e.responseText);
                } catch (t) {}
                null == t.callback || t.callback(i);
            }
        }, e.send(s);
    }
}), null != $e444d6404c095fa5$var$n && $e444d6404c095fa5$var$n.sendBeacon && $e444d6404c095fa5$var$un.push({
    transport: "sendBeacon",
    method: (t)=>{
        var i = $e444d6404c095fa5$var$on(t.url, {
            beacon: "1"
        });
        try {
            var e, { contentType: r, body: s } = null !== (e = $e444d6404c095fa5$var$ln(t)) && void 0 !== e ? e : {}, o = "string" == typeof s ? new Blob([
                s
            ], {
                type: r
            }) : s;
            $e444d6404c095fa5$var$n.sendBeacon(i, o);
        } catch (t) {}
    }
});
var $e444d6404c095fa5$var$hn = function(t, i) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(i)) return !1;
    try {
        return new RegExp(i).test(t);
    } catch (t) {
        return !1;
    }
};
function $e444d6404c095fa5$var$dn(t, i, e) {
    return $e444d6404c095fa5$var$an({
        distinct_id: t,
        userPropertiesToSet: i,
        userPropertiesToSetOnce: e
    });
}
var $e444d6404c095fa5$var$vn = {
    exact: (t, i)=>i.some((i)=>t.some((t)=>i === t)),
    is_not: (t, i)=>i.every((i)=>t.every((t)=>i !== t)),
    regex: (t, i)=>i.some((i)=>t.some((t)=>$e444d6404c095fa5$var$hn(i, t))),
    not_regex: (t, i)=>i.every((i)=>t.every((t)=>!$e444d6404c095fa5$var$hn(i, t))),
    icontains: (t, i)=>i.map($e444d6404c095fa5$var$cn).some((i)=>t.map($e444d6404c095fa5$var$cn).some((t)=>i.includes(t))),
    not_icontains: (t, i)=>i.map($e444d6404c095fa5$var$cn).every((i)=>t.map($e444d6404c095fa5$var$cn).every((t)=>!i.includes(t)))
}, $e444d6404c095fa5$var$cn = (t)=>t.toLowerCase(), $e444d6404c095fa5$var$fn = $e444d6404c095fa5$var$Tt("[Error tracking]");
class $e444d6404c095fa5$var$pn {
    constructor(t){
        var i, e;
        this.Jt = [], this.Kt = new $e444d6404c095fa5$var$ft([
            new $e444d6404c095fa5$var$pt,
            new $e444d6404c095fa5$var$$t,
            new $e444d6404c095fa5$var$_t,
            new $e444d6404c095fa5$var$gt,
            new $e444d6404c095fa5$var$St,
            new $e444d6404c095fa5$var$xt,
            new $e444d6404c095fa5$var$yt,
            new $e444d6404c095fa5$var$Et
        ], [
            $e444d6404c095fa5$var$at,
            $e444d6404c095fa5$var$ht
        ]), this._instance = t, this.Jt = null !== (i = null == (e = this._instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$Xt)) && void 0 !== i ? i : [];
    }
    onRemoteConfig(t) {
        var i, e, r, s = null !== (i = null == (e = t.errorTracking) ? void 0 : e.suppressionRules) && void 0 !== i ? i : [], n = null == (r = t.errorTracking) ? void 0 : r.captureExtensionExceptions;
        this.Jt = s, this._instance.persistence && this._instance.persistence.register({
            [$e444d6404c095fa5$var$Xt]: this.Jt,
            [$e444d6404c095fa5$var$Qt]: n
        });
    }
    get Yt() {
        var t, i = !!this._instance.get_property($e444d6404c095fa5$var$Qt), e = this._instance.config.error_tracking.captureExtensionExceptions;
        return null !== (t = null != e ? e : i) && void 0 !== t && t;
    }
    buildProperties(t, i) {
        return this.Kt.buildFromUnknown(t, {
            syntheticException: null == i ? void 0 : i.syntheticException,
            mechanism: {
                handled: null == i ? void 0 : i.handled
            }
        });
    }
    sendExceptionEvent(t) {
        var i = t.$exception_list;
        if (this.Xt(i)) {
            if (this.Qt(i)) return void $e444d6404c095fa5$var$fn.info("Skipping exception capture because a suppression rule matched");
            if (!this.Yt && this.Zt(i)) return void $e444d6404c095fa5$var$fn.info("Skipping exception capture because it was thrown by an extension");
            if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ti(i)) return void $e444d6404c095fa5$var$fn.info("Skipping exception capture because it was thrown by the PostHog SDK");
        }
        return this._instance.capture("$exception", t, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
    Qt(t) {
        if (0 === t.length) return !1;
        var i = t.reduce((t, i)=>{
            var { type: e, value: r } = i;
            return $e444d6404c095fa5$var$M(e) && e.length > 0 && t.$exception_types.push(e), $e444d6404c095fa5$var$M(r) && r.length > 0 && t.$exception_values.push(r), t;
        }, {
            $exception_types: [],
            $exception_values: []
        });
        return this.Jt.some((t)=>{
            var e = t.values.map((t)=>{
                var e, r = $e444d6404c095fa5$var$vn[t.operator], s = $e444d6404c095fa5$var$R(t.value) ? t.value : [
                    t.value
                ], n = null !== (e = i[t.key]) && void 0 !== e ? e : [];
                return s.length > 0 && r(s, n);
            });
            return "OR" === t.type ? e.some(Boolean) : e.every(Boolean);
        });
    }
    Zt(t) {
        return t.flatMap((t)=>{
            var i, e;
            return null !== (i = null == (e = t.stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [];
        }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
    }
    ti(t) {
        if (t.length > 0) {
            var i, e, r, s, n = null !== (i = null == (e = t[0].stacktrace) ? void 0 : e.frames) && void 0 !== i ? i : [], o = n[n.length - 1];
            return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
        }
        return !1;
    }
    Xt(t) {
        return !$e444d6404c095fa5$var$j(t) && $e444d6404c095fa5$var$R(t);
    }
}
var $e444d6404c095fa5$var$gn = $e444d6404c095fa5$var$Tt("[FeatureFlags]"), $e444d6404c095fa5$var$_n = "$active_feature_flags", $e444d6404c095fa5$var$mn = "$override_feature_flags", $e444d6404c095fa5$var$yn = "$feature_flag_payloads", $e444d6404c095fa5$var$bn = "$override_feature_flag_payloads", $e444d6404c095fa5$var$wn = "$feature_flag_request_id", $e444d6404c095fa5$var$xn = (t)=>{
    var i = {};
    for (var [e, r] of $e444d6404c095fa5$var$Dt(t || {}))r && (i[e] = r);
    return i;
}, $e444d6404c095fa5$var$Sn = (t)=>{
    var i = t.flags;
    return i ? (t.featureFlags = Object.fromEntries(Object.keys(i).map((t)=>{
        var e;
        return [
            t,
            null !== (e = i[t].variant) && void 0 !== e ? e : i[t].enabled
        ];
    })), t.featureFlagPayloads = Object.fromEntries(Object.keys(i).filter((t)=>i[t].enabled).filter((t)=>{
        var e;
        return null == (e = i[t].metadata) ? void 0 : e.payload;
    }).map((t)=>{
        var e;
        return [
            t,
            null == (e = i[t].metadata) ? void 0 : e.payload
        ];
    }))) : $e444d6404c095fa5$var$gn.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
}, $e444d6404c095fa5$var$En = function(t) {
    return t.FeatureFlags = "feature_flags", t.Recordings = "recordings", t;
}({});
class $e444d6404c095fa5$var$$n {
    constructor(t){
        this.ii = !1, this.ei = !1, this.ri = !1, this.si = !1, this.ni = !1, this.oi = !1, this.ai = !1, this._instance = t, this.featureFlagEventHandlers = [];
    }
    li() {
        var t = this._instance.config.evaluation_environments;
        return null != t && t.length ? t.filter((t)=>{
            var i = t && "string" == typeof t && t.trim().length > 0;
            return i || $e444d6404c095fa5$var$gn.error("Invalid evaluation environment found:", t, "Expected non-empty string"), i;
        }) : [];
    }
    ui() {
        return this.li().length > 0;
    }
    flags() {
        if (this._instance.config.__preview_remote_config) this.oi = !0;
        else {
            var t = !this.hi && (this._instance.config.advanced_disable_feature_flags || this._instance.config.advanced_disable_feature_flags_on_first_load);
            this.di({
                disableFlags: t
            });
        }
    }
    get hasLoadedFlags() {
        return this.ei;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagsWithDetails() {
        var t = this._instance.get_property($e444d6404c095fa5$var$ai), i = this._instance.get_property($e444d6404c095fa5$var$mn), e = this._instance.get_property($e444d6404c095fa5$var$bn);
        if (!e && !i) return t || {};
        var r = $e444d6404c095fa5$var$Mt({}, t || {}), s = [
            ...new Set([
                ...Object.keys(e || {}),
                ...Object.keys(i || {})
            ])
        ];
        for (var n of s){
            var o, a, l = r[n], u = null == i ? void 0 : i[n], h = $e444d6404c095fa5$var$F(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $e444d6404c095fa5$var$F(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == e ? void 0 : e[n], c = $e444d6404c095fa5$var$g({}, l, {
                enabled: h,
                variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
            });
            if (h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v) c.metadata = $e444d6404c095fa5$var$g({}, null == l ? void 0 : l.metadata, {
                payload: v,
                original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
            });
            r[n] = c;
        }
        return this.ii || ($e444d6404c095fa5$var$gn.warn(" Overriding feature flag details!", {
            flagDetails: t,
            overriddenPayloads: e,
            finalDetails: r
        }), this.ii = !0), r;
    }
    getFlagVariants() {
        var t = this._instance.get_property($e444d6404c095fa5$var$ni), i = this._instance.get_property($e444d6404c095fa5$var$mn);
        if (!i) return t || {};
        for(var e = $e444d6404c095fa5$var$Mt({}, t), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ii || ($e444d6404c095fa5$var$gn.warn(" Overriding feature flags!", {
            enabledFlags: t,
            overriddenFlags: i,
            finalFlags: e
        }), this.ii = !0), e;
    }
    getFlagPayloads() {
        var t = this._instance.get_property($e444d6404c095fa5$var$yn), i = this._instance.get_property($e444d6404c095fa5$var$bn);
        if (!i) return t || {};
        for(var e = $e444d6404c095fa5$var$Mt({}, t || {}), r = Object.keys(i), s = 0; s < r.length; s++)e[r[s]] = i[r[s]];
        return this.ii || ($e444d6404c095fa5$var$gn.warn(" Overriding feature flag payloads!", {
            flagPayloads: t,
            overriddenPayloads: i,
            finalPayloads: e
        }), this.ii = !0), e;
    }
    reloadFeatureFlags() {
        this.si || this._instance.config.advanced_disable_feature_flags || this.hi || (this.hi = setTimeout(()=>{
            this.di();
        }, 5));
    }
    vi() {
        clearTimeout(this.hi), this.hi = void 0;
    }
    ensureFlagsLoaded() {
        this.ei || this.ri || this.hi || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(t) {
        this.$anon_distinct_id = t;
    }
    setReloadingPaused(t) {
        this.si = t;
    }
    di(t) {
        var i;
        if (this.vi(), !this._instance.M()) {
            if (this.ri) this.ni = !0;
            else {
                var e = {
                    token: this._instance.config.token,
                    distinct_id: this._instance.get_distinct_id(),
                    groups: this._instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: $e444d6404c095fa5$var$g({}, (null == (i = this._instance.persistence) ? void 0 : i.get_initial_props()) || {}, this._instance.get_property($e444d6404c095fa5$var$li) || {}),
                    group_properties: this._instance.get_property($e444d6404c095fa5$var$ui)
                };
                (null != t && t.disableFlags || this._instance.config.advanced_disable_feature_flags) && (e.disable_flags = !0), this.ui() && (e.evaluation_environments = this.li());
                var r = this._instance.config.__preview_remote_config, s = r ? "/flags/?v=2" : "/flags/?v=2&config=true", n = this._instance.config.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : "", o = this._instance.requestRouter.endpointFor("api", s + n);
                r && (e.timezone = $e444d6404c095fa5$var$vs()), this.ri = !0, this._instance.ci({
                    method: "POST",
                    url: o,
                    data: e,
                    compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                    timeout: this._instance.config.feature_flag_request_timeout_ms,
                    callback: (t)=>{
                        var i, r, s = !0;
                        (200 === t.statusCode && (this.ni || (this.$anon_distinct_id = void 0), s = !1), this.ri = !1, this.oi) || (this.oi = !0, this._instance.fi(null !== (r = t.json) && void 0 !== r ? r : {}));
                        if (!e.disable_flags || this.ni) {
                            if (this.ai = !s, t.json && null != (i = t.json.quotaLimited) && i.includes($e444d6404c095fa5$var$En.FeatureFlags)) $e444d6404c095fa5$var$gn.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                            else {
                                var n;
                                if (!e.disable_flags) this.receivedFeatureFlags(null !== (n = t.json) && void 0 !== n ? n : {}, s);
                                this.ni && (this.ni = !1, this.di());
                            }
                        }
                    }
                });
            }
        }
    }
    getFeatureFlag(t, i) {
        if (void 0 === i && (i = {}), this.ei || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFlagVariants()[t], r = "" + e, s = this._instance.get_property($e444d6404c095fa5$var$wn) || void 0, n = this._instance.get_property($e444d6404c095fa5$var$vi) || {};
            if ((i.send_event || !("send_event" in i)) && (!(t in n) || !n[t].includes(r))) {
                var o, a, l, u, h, d, v, c, f;
                $e444d6404c095fa5$var$R(n[t]) ? n[t].push(r) : n[t] = [
                    r
                ], null == (o = this._instance.persistence) || o.register({
                    [$e444d6404c095fa5$var$vi]: n
                });
                var p = this.getFeatureFlagDetails(t), g = {
                    $feature_flag: t,
                    $feature_flag_response: e,
                    $feature_flag_payload: this.getFeatureFlagPayload(t) || null,
                    $feature_flag_request_id: s,
                    $feature_flag_bootstrapped_response: (null == (a = this._instance.config.bootstrap) || null == (a = a.featureFlags) ? void 0 : a[t]) || null,
                    $feature_flag_bootstrapped_payload: (null == (l = this._instance.config.bootstrap) || null == (l = l.featureFlagPayloads) ? void 0 : l[t]) || null,
                    $used_bootstrap_value: !this.ai
                };
                $e444d6404c095fa5$var$F(null == p || null == (u = p.metadata) ? void 0 : u.version) || (g.$feature_flag_version = p.metadata.version);
                var _, m = null !== (h = null == p || null == (d = p.reason) ? void 0 : d.description) && void 0 !== h ? h : null == p || null == (v = p.reason) ? void 0 : v.code;
                if (m && (g.$feature_flag_reason = m), null != p && null != (c = p.metadata) && c.id && (g.$feature_flag_id = p.metadata.id), $e444d6404c095fa5$var$F(null == p ? void 0 : p.original_variant) && $e444d6404c095fa5$var$F(null == p ? void 0 : p.original_enabled) || (g.$feature_flag_original_response = $e444d6404c095fa5$var$F(p.original_variant) ? p.original_enabled : p.original_variant), null != p && null != (f = p.metadata) && f.original_payload) g.$feature_flag_original_payload = null == p || null == (_ = p.metadata) ? void 0 : _.original_payload;
                this._instance.capture("$feature_flag_called", g);
            }
            return e;
        }
        $e444d6404c095fa5$var$gn.warn('getFeatureFlag for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagDetails(t) {
        return this.getFlagsWithDetails()[t];
    }
    getFeatureFlagPayload(t) {
        return this.getFlagPayloads()[t];
    }
    getRemoteConfigPayload(t, i) {
        var e = this._instance.config.token, r = {
            distinct_id: this._instance.get_distinct_id(),
            token: e
        };
        this.ui() && (r.evaluation_environments = this.li()), this._instance.ci({
            method: "POST",
            url: this._instance.requestRouter.endpointFor("api", "/flags/?v=2&config=true"),
            data: r,
            compression: this._instance.config.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
            timeout: this._instance.config.feature_flag_request_timeout_ms,
            callback: (e)=>{
                var r, s = null == (r = e.json) ? void 0 : r.featureFlagPayloads;
                i((null == s ? void 0 : s[t]) || void 0);
            }
        });
    }
    isFeatureEnabled(t, i) {
        if (void 0 === i && (i = {}), this.ei || this.getFlags() && this.getFlags().length > 0) {
            var e = this.getFeatureFlag(t, i);
            return $e444d6404c095fa5$var$F(e) ? void 0 : !!e;
        }
        $e444d6404c095fa5$var$gn.warn('isFeatureEnabled for key "' + t + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers.push(t);
    }
    removeFeatureFlagsHandler(t) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((i)=>i !== t);
    }
    receivedFeatureFlags(t, i) {
        if (this._instance.persistence) {
            this.ei = !0;
            var e = this.getFlagVariants(), r = this.getFlagPayloads(), s = this.getFlagsWithDetails();
            !function(t, i, e, r, s) {
                void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                var n = $e444d6404c095fa5$var$Sn(t), o = n.flags, a = n.featureFlags, l = n.featureFlagPayloads;
                if (a) {
                    var u = t.requestId;
                    if ($e444d6404c095fa5$var$R(a)) {
                        $e444d6404c095fa5$var$gn.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                        var h = {};
                        if (a) for(var d = 0; d < a.length; d++)h[a[d]] = !0;
                        i && i.register({
                            [$e444d6404c095fa5$var$_n]: a,
                            [$e444d6404c095fa5$var$ni]: h
                        });
                    } else {
                        var v = a, c = l, f = o;
                        t.errorsWhileComputingFlags && (v = $e444d6404c095fa5$var$g({}, e, v), c = $e444d6404c095fa5$var$g({}, r, c), f = $e444d6404c095fa5$var$g({}, s, f)), i && i.register($e444d6404c095fa5$var$g({
                            [$e444d6404c095fa5$var$_n]: Object.keys($e444d6404c095fa5$var$xn(v)),
                            [$e444d6404c095fa5$var$ni]: v || {},
                            [$e444d6404c095fa5$var$yn]: c || {},
                            [$e444d6404c095fa5$var$ai]: f || {}
                        }, u ? {
                            [$e444d6404c095fa5$var$wn]: u
                        } : {}));
                    }
                }
            }(t, this._instance.persistence, e, r, s), this.pi(i);
        }
    }
    override(t, i) {
        void 0 === i && (i = !1), $e444d6404c095fa5$var$gn.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
            flags: t,
            suppressWarning: i
        });
    }
    overrideFeatureFlags(t) {
        if (!this._instance.__loaded || !this._instance.persistence) return $e444d6404c095fa5$var$gn.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
        if (!1 === t) return this._instance.persistence.unregister($e444d6404c095fa5$var$mn), this._instance.persistence.unregister($e444d6404c095fa5$var$bn), void this.pi();
        if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
            var i, e = t;
            if (this.ii = Boolean(null !== (i = e.suppressWarning) && void 0 !== i && i), "flags" in e) {
                if (!1 === e.flags) this._instance.persistence.unregister($e444d6404c095fa5$var$mn);
                else if (e.flags) {
                    if ($e444d6404c095fa5$var$R(e.flags)) {
                        for(var r = {}, s = 0; s < e.flags.length; s++)r[e.flags[s]] = !0;
                        this._instance.persistence.register({
                            [$e444d6404c095fa5$var$mn]: r
                        });
                    } else this._instance.persistence.register({
                        [$e444d6404c095fa5$var$mn]: e.flags
                    });
                }
            }
            return "payloads" in e && (!1 === e.payloads ? this._instance.persistence.unregister($e444d6404c095fa5$var$bn) : e.payloads && this._instance.persistence.register({
                [$e444d6404c095fa5$var$bn]: e.payloads
            })), void this.pi();
        }
        this.pi();
    }
    onFeatureFlags(t) {
        if (this.addFeatureFlagsHandler(t), this.ei) {
            var { flags: i, flagVariants: e } = this.gi();
            t(i, e);
        }
        return ()=>this.removeFeatureFlagsHandler(t);
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        var r, s = (this._instance.get_property($e444d6404c095fa5$var$oi) || []).find((i)=>i.flagKey === t), n = {
            ["$feature_enrollment/" + t]: i
        }, o = {
            $feature_flag: t,
            $feature_enrollment: i,
            $set: n
        };
        s && (o.$early_access_feature_name = s.name), e && (o.$feature_enrollment_stage = e), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
        var a = $e444d6404c095fa5$var$g({}, this.getFlagVariants(), {
            [t]: i
        });
        null == (r = this._instance.persistence) || r.register({
            [$e444d6404c095fa5$var$_n]: Object.keys($e444d6404c095fa5$var$xn(a)),
            [$e444d6404c095fa5$var$ni]: a
        }), this.pi();
    }
    getEarlyAccessFeatures(t, i, e) {
        void 0 === i && (i = !1);
        var r = this._instance.get_property($e444d6404c095fa5$var$oi), s = e ? "&" + e.map((t)=>"stage=" + t).join("&") : "";
        if (r && !i) return t(r);
        this._instance.ci({
            url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this._instance.config.token + s),
            method: "GET",
            callback: (i)=>{
                var e, r;
                if (i.json) {
                    var s = i.json.earlyAccessFeatures;
                    return null == (e = this._instance.persistence) || e.unregister($e444d6404c095fa5$var$oi), null == (r = this._instance.persistence) || r.register({
                        [$e444d6404c095fa5$var$oi]: s
                    }), t(s);
                }
            }
        });
    }
    gi() {
        var t = this.getFlags(), i = this.getFlagVariants();
        return {
            flags: t.filter((t)=>i[t]),
            flagVariants: Object.keys(i).filter((t)=>i[t]).reduce((t, e)=>(t[e] = i[e], t), {})
        };
    }
    pi(t) {
        var { flags: i, flagVariants: e } = this.gi();
        this.featureFlagEventHandlers.forEach((r)=>r(i, e, {
                errorsLoading: t
            }));
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($e444d6404c095fa5$var$li) || {};
        this._instance.register({
            [$e444d6404c095fa5$var$li]: $e444d6404c095fa5$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this._instance.unregister($e444d6404c095fa5$var$li);
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0);
        var e = this._instance.get_property($e444d6404c095fa5$var$ui) || {};
        0 !== Object.keys(e).length && Object.keys(e).forEach((i)=>{
            e[i] = $e444d6404c095fa5$var$g({}, e[i], t[i]), delete t[i];
        }), this._instance.register({
            [$e444d6404c095fa5$var$ui]: $e444d6404c095fa5$var$g({}, e, t)
        }), i && this._instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(t) {
        if (t) {
            var i = this._instance.get_property($e444d6404c095fa5$var$ui) || {};
            this._instance.register({
                [$e444d6404c095fa5$var$ui]: $e444d6404c095fa5$var$g({}, i, {
                    [t]: {}
                })
            });
        } else this._instance.unregister($e444d6404c095fa5$var$ui);
    }
    reset() {
        this.ei = !1, this.ri = !1, this.si = !1, this.ni = !1, this.oi = !1, this.ai = !1, this.$anon_distinct_id = void 0, this.vi(), this.ii = !1;
    }
}
var $e444d6404c095fa5$var$kn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class $e444d6404c095fa5$var$Pn {
    constructor(t, i){
        this.C = t, this.props = {}, this.mi = !1, this.yi = ((t)=>{
            var i = "";
            return t.token && (i = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + i + "_posthog";
        })(t), this.Y = this.bi(t), this.load(), t.debug && $e444d6404c095fa5$var$Pt.info("Persistence loaded", t.persistence, $e444d6404c095fa5$var$g({}, this.props)), this.update_config(t, t, i), this.save();
    }
    isDisabled() {
        return !!this.wi;
    }
    bi(t) {
        -1 === $e444d6404c095fa5$var$kn.indexOf(t.persistence.toLowerCase()) && ($e444d6404c095fa5$var$Pt.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        return "localstorage" === i && $e444d6404c095fa5$var$Re.H() ? $e444d6404c095fa5$var$Re : "localstorage+cookie" === i && $e444d6404c095fa5$var$Ce.H() ? $e444d6404c095fa5$var$Ce : "sessionstorage" === i && $e444d6404c095fa5$var$Ae.H() ? $e444d6404c095fa5$var$Ae : "memory" === i ? $e444d6404c095fa5$var$Fe : "cookie" === i ? $e444d6404c095fa5$var$Pe : $e444d6404c095fa5$var$Ce.H() ? $e444d6404c095fa5$var$Ce : $e444d6404c095fa5$var$Pe;
    }
    properties() {
        var t = {};
        return $e444d6404c095fa5$var$Ft(this.props, function(i, e) {
            if (e === $e444d6404c095fa5$var$ni && $e444d6404c095fa5$var$C(i)) for(var r = Object.keys(i), n = 0; n < r.length; n++)t["$feature/" + r[n]] = i[r[n]];
            else a = e, l = !1, ($e444d6404c095fa5$var$D(o = $e444d6404c095fa5$var$xi) ? l : $e444d6404c095fa5$var$s && o.indexOf === $e444d6404c095fa5$var$s ? -1 != o.indexOf(a) : ($e444d6404c095fa5$var$Ft(o, function(t) {
                if (l || (l = t === a)) return $e444d6404c095fa5$var$Ct;
            }), l)) || (t[e] = i);
            var o, a, l;
        }), t;
    }
    load() {
        if (!this.wi) {
            var t = this.Y.W(this.yi);
            t && (this.props = $e444d6404c095fa5$var$Mt({}, t));
        }
    }
    save() {
        this.wi || this.Y.G(this.yi, this.props, this.xi, this.Si, this.Ei, this.C.debug);
    }
    remove() {
        this.Y.V(this.yi, !1), this.Y.V(this.yi, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, i, e) {
        if ($e444d6404c095fa5$var$C(t)) {
            $e444d6404c095fa5$var$F(i) && (i = "None"), this.xi = $e444d6404c095fa5$var$F(e) ? this.$i : e;
            var r = !1;
            if ($e444d6404c095fa5$var$Ft(t, (t, e)=>{
                this.props.hasOwnProperty(e) && this.props[e] !== i || (this.props[e] = t, r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, i) {
        if ($e444d6404c095fa5$var$C(t)) {
            this.xi = $e444d6404c095fa5$var$F(i) ? this.$i : i;
            var e = !1;
            if ($e444d6404c095fa5$var$Ft(t, (i, r)=>{
                t.hasOwnProperty(r) && this.props[r] !== i && (this.props[r] = i, e = !0);
            }), e) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (delete this.props[t], this.save());
    }
    update_campaign_params() {
        if (!this.mi) {
            var t = $e444d6404c095fa5$var$ns(this.C.custom_campaign_params, this.C.mask_personal_data_properties, this.C.custom_personal_data_properties);
            $e444d6404c095fa5$var$O($e444d6404c095fa5$var$Nt(t)) || this.register(t), this.mi = !0;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.referrer) ? $e444d6404c095fa5$var$as(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $e444d6404c095fa5$var$us(),
            $referring_domain: null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.referrer && (null == (t = $e444d6404c095fa5$var$ne($e444d6404c095fa5$var$o.referrer)) ? void 0 : t.host) || "$direct"
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$e444d6404c095fa5$var$gi] || this.props[$e444d6404c095fa5$var$_i] || this.register_once({
            [$e444d6404c095fa5$var$mi]: $e444d6404c095fa5$var$hs(this.C.mask_personal_data_properties, this.C.custom_personal_data_properties)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $e444d6404c095fa5$var$Ft([
            $e444d6404c095fa5$var$_i,
            $e444d6404c095fa5$var$gi
        ], (i)=>{
            var e = this.props[i];
            e && $e444d6404c095fa5$var$Ft(e, function(i, e) {
                t["$initial_" + $e444d6404c095fa5$var$S(e)] = i;
            });
        });
        var i, e, r = this.props[$e444d6404c095fa5$var$mi];
        if (r) {
            var s = (i = $e444d6404c095fa5$var$ds(r), e = {}, $e444d6404c095fa5$var$Ft(i, function(t, i) {
                e["$initial_" + $e444d6404c095fa5$var$S(i)] = t;
            }), e);
            $e444d6404c095fa5$var$Mt(t, s);
        }
        return t;
    }
    safe_merge(t) {
        return $e444d6404c095fa5$var$Ft(this.props, function(i, e) {
            e in t || (t[e] = i);
        }), t;
    }
    update_config(t, i, e) {
        if (this.$i = this.xi = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!e), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), t.persistence !== i.persistence) {
            var r = this.bi(t), s = this.props;
            this.clear(), this.Y = r, this.props = s, this.save();
        }
    }
    set_disabled(t) {
        this.wi = t, this.wi ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.Si && (this.Si = t, this.remove(), this.save());
    }
    set_secure(t) {
        t !== this.Ei && (this.Ei = t, this.remove(), this.save());
    }
    set_event_timer(t, i) {
        var e = this.props[$e444d6404c095fa5$var$Vt] || {};
        e[t] = i, this.props[$e444d6404c095fa5$var$Vt] = e, this.save();
    }
    remove_event_timer(t) {
        var i = (this.props[$e444d6404c095fa5$var$Vt] || {})[t];
        return $e444d6404c095fa5$var$F(i) || (delete this.props[$e444d6404c095fa5$var$Vt][t], this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, i) {
        this.props[t] = i, this.save();
    }
}
var $e444d6404c095fa5$export$87f1e68f1b904cbb = function(t) {
    return t.Button = "button", t.Tab = "tab", t.Selector = "selector", t;
}({}), $e444d6404c095fa5$export$8c0ce98316e43193 = function(t) {
    return t.TopLeft = "top_left", t.TopRight = "top_right", t.TopCenter = "top_center", t.MiddleLeft = "middle_left", t.MiddleRight = "middle_right", t.MiddleCenter = "middle_center", t.Left = "left", t.Center = "center", t.Right = "right", t.NextToTrigger = "next_to_trigger", t;
}({}), $e444d6404c095fa5$export$22779822dd24228f = function(t) {
    return t.Popover = "popover", t.API = "api", t.Widget = "widget", t.ExternalSurvey = "external_survey", t;
}({}), $e444d6404c095fa5$export$9c2ac61661d417f8 = function(t) {
    return t.Open = "open", t.MultipleChoice = "multiple_choice", t.SingleChoice = "single_choice", t.Rating = "rating", t.Link = "link", t;
}({}), $e444d6404c095fa5$export$bbed2da3bd3bb001 = function(t) {
    return t.NextQuestion = "next_question", t.End = "end", t.ResponseBased = "response_based", t.SpecificQuestion = "specific_question", t;
}({}), $e444d6404c095fa5$export$407ee791fe918359 = function(t) {
    return t.Once = "once", t.Recurring = "recurring", t.Always = "always", t;
}({}), $e444d6404c095fa5$export$9d7ec1793ca1658e = function(t) {
    return t.SHOWN = "survey shown", t.DISMISSED = "survey dismissed", t.SENT = "survey sent", t;
}({}), $e444d6404c095fa5$export$fe4c9af525341543 = function(t) {
    return t.SURVEY_ID = "$survey_id", t.SURVEY_NAME = "$survey_name", t.SURVEY_RESPONSE = "$survey_response", t.SURVEY_ITERATION = "$survey_iteration", t.SURVEY_ITERATION_START_DATE = "$survey_iteration_start_date", t.SURVEY_PARTIALLY_COMPLETED = "$survey_partially_completed", t.SURVEY_SUBMISSION_ID = "$survey_submission_id", t.SURVEY_QUESTIONS = "$survey_questions", t.SURVEY_COMPLETED = "$survey_completed", t;
}({}), $e444d6404c095fa5$export$a8a66d9d1b857494 = function(t) {
    return t.Popover = "popover", t.Inline = "inline", t;
}({});
class $e444d6404c095fa5$var$jn {
    constructor(){
        this.ki = {}, this.ki = {};
    }
    on(t, i) {
        return this.ki[t] || (this.ki[t] = []), this.ki[t].push(i), ()=>{
            this.ki[t] = this.ki[t].filter((t)=>t !== i);
        };
    }
    emit(t, i) {
        for (var e of this.ki[t] || [])e(i);
        for (var r of this.ki["*"] || [])r(t, i);
    }
}
class $e444d6404c095fa5$var$Ln {
    constructor(t){
        this.Pi = new $e444d6404c095fa5$var$jn, this.Ti = (t, i)=>this.Ri(t, i) && this.Ii(t, i) && this.Ci(t, i), this.Ri = (t, i)=>null == i || !i.event || (null == t ? void 0 : t.event) === (null == i ? void 0 : i.event), this._instance = t, this.Oi = new Set, this.Fi = new Set;
    }
    init() {
        var t;
        if (!$e444d6404c095fa5$var$F(null == (t = this._instance) ? void 0 : t.Mi)) {
            var i;
            null == (i = this._instance) || i.Mi((t, i)=>{
                this.on(t, i);
            });
        }
    }
    register(t) {
        var i, e;
        if (!$e444d6404c095fa5$var$F(null == (i = this._instance) ? void 0 : i.Mi) && (t.forEach((t)=>{
            var i, e;
            null == (i = this.Fi) || i.add(t), null == (e = t.steps) || e.forEach((t)=>{
                var i;
                null == (i = this.Oi) || i.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (e = this._instance) && e.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var i;
                null == (i = t.steps) || i.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, i) {
        var e;
        null != i && 0 != t.length && (this.Oi.has(t) || this.Oi.has(null == i ? void 0 : i.event)) && this.Fi && (null == (e = this.Fi) ? void 0 : e.size) > 0 && this.Fi.forEach((t)=>{
            this.Ai(i, t) && this.Pi.emit("actionCaptured", t.name);
        });
    }
    Di(t) {
        this.onAction("actionCaptured", (i)=>t(i));
    }
    Ai(t, i) {
        if (null == (null == i ? void 0 : i.steps)) return !1;
        for (var e of i.steps)if (this.Ti(t, e)) return !0;
        return !1;
    }
    onAction(t, i) {
        return this.Pi.on(t, i);
    }
    Ii(t, i) {
        if (null != i && i.url) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$e444d6404c095fa5$var$Ln.ji(r, null == i ? void 0 : i.url, (null == i ? void 0 : i.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static ji(i, e, r) {
        switch(r){
            case "regex":
                return !!$e444d6404c095fa5$var$t && $e444d6404c095fa5$var$hn(i, e);
            case "exact":
                return e === i;
            case "contains":
                var s = $e444d6404c095fa5$var$Ln.Li(e).replace(/_/g, ".").replace(/%/g, ".*");
                return $e444d6404c095fa5$var$hn(i, s);
            default:
                return !1;
        }
    }
    static Li(t) {
        return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    Ci(t, i) {
        if ((null != i && i.href || null != i && i.tag_name || null != i && i.text) && !this.Ni(t).some((t)=>!(null != i && i.href && !$e444d6404c095fa5$var$Ln.ji(t.href || "", null == i ? void 0 : i.href, (null == i ? void 0 : i.href_matching) || "exact")) && (null == i || !i.tag_name || t.tag_name === (null == i ? void 0 : i.tag_name)) && !(null != i && i.text && !$e444d6404c095fa5$var$Ln.ji(t.text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact") && !$e444d6404c095fa5$var$Ln.ji(t.$el_text || "", null == i ? void 0 : i.text, (null == i ? void 0 : i.text_matching) || "exact")))) return !1;
        if (null != i && i.selector) {
            var e, r = null == t || null == (e = t.properties) ? void 0 : e.$element_selectors;
            if (!r) return !1;
            if (!r.includes(null == i ? void 0 : i.selector)) return !1;
        }
        return !0;
    }
    Ni(t) {
        return null == (null == t ? void 0 : t.properties.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
}
var $e444d6404c095fa5$var$Nn = $e444d6404c095fa5$var$Tt("[Surveys]");
var $e444d6404c095fa5$var$Un = "seenSurvey_", $e444d6404c095fa5$var$zn = (t, i)=>{
    var e = "$survey_" + i + "/" + t.id;
    return t.current_iteration && t.current_iteration > 0 && (e = "$survey_" + i + "/" + t.id + "/" + t.current_iteration), e;
}, $e444d6404c095fa5$var$Hn = (t)=>{
    var i = "" + $e444d6404c095fa5$var$Un + t.id;
    return t.current_iteration && t.current_iteration > 0 && (i = "" + $e444d6404c095fa5$var$Un + t.id + "_" + t.current_iteration), i;
}, $e444d6404c095fa5$var$Bn = [
    $e444d6404c095fa5$export$22779822dd24228f.Popover,
    $e444d6404c095fa5$export$22779822dd24228f.Widget,
    $e444d6404c095fa5$export$22779822dd24228f.API
], $e444d6404c095fa5$var$qn = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $e444d6404c095fa5$export$a8a66d9d1b857494.Popover
};
class $e444d6404c095fa5$var$Wn {
    constructor(t){
        this._instance = t, this.Ui = new Map, this.zi = new Map;
    }
    register(t) {
        var i;
        $e444d6404c095fa5$var$F(null == (i = this._instance) ? void 0 : i.Mi) || (this.Hi(t), this.Bi(t));
    }
    Bi(t) {
        var i = t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.actions) && (null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) ? void 0 : e.length) > 0;
        });
        if (0 !== i.length) {
            if (null == this.qi) {
                this.qi = new $e444d6404c095fa5$var$Ln(this._instance), this.qi.init();
                this.qi.Di((t)=>{
                    this.onAction(t);
                });
            }
            i.forEach((t)=>{
                var i, e, r, s, n;
                t.conditions && null != (i = t.conditions) && i.actions && null != (e = t.conditions) && null != (e = e.actions) && e.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.qi) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((i)=>{
                    if (i && i.name) {
                        var e = this.zi.get(i.name);
                        e && e.push(t.id), this.zi.set(i.name, e || [
                            t.id
                        ]);
                    }
                }));
            });
        }
    }
    Hi(t) {
        var i;
        if (0 !== t.filter((t)=>{
            var i, e;
            return (null == (i = t.conditions) ? void 0 : i.events) && (null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) ? void 0 : e.length) > 0;
        }).length) null == (i = this._instance) || i.Mi((t, i)=>{
            this.onEvent(t, i);
        }), t.forEach((t)=>{
            var i;
            null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || i.forEach((i)=>{
                if (i && i.name) {
                    var e = this.Ui.get(i.name);
                    e && e.push(t.id), this.Ui.set(i.name, e || [
                        t.id
                    ]);
                }
            });
        });
    }
    onEvent(t, i) {
        var e, r, s = (null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[$e444d6404c095fa5$var$di]) || [];
        if ($e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN === t && i && s.length > 0) {
            var n;
            $e444d6404c095fa5$var$Nn.info("survey event matched, removing survey from activated surveys", {
                event: t,
                eventPayload: i,
                existingActivatedSurveys: s
            });
            var o = null == i || null == (n = i.properties) ? void 0 : n.$survey_id;
            if (o) {
                var a = s.indexOf(o);
                a >= 0 && (s.splice(a, 1), this.Wi(s));
            }
        } else if (this.Ui.has(t)) {
            $e444d6404c095fa5$var$Nn.info("survey event name matched", {
                event: t,
                eventPayload: i,
                surveys: this.Ui.get(t)
            });
            var l = [];
            null == (r = this._instance) || r.getSurveys((i)=>{
                l = i.filter((i)=>{
                    var e;
                    return null == (e = this.Ui.get(t)) ? void 0 : e.includes(i.id);
                });
            });
            var u = l.filter((e)=>{
                var r, s = null == (r = e.conditions) || null == (r = r.events) || null == (r = r.values) ? void 0 : r.find((i)=>i.name === t);
                return !!s && (!s.propertyFilters || Object.entries(s.propertyFilters).every((t)=>{
                    var e, [r, s] = t, n = null == i || null == (e = i.properties) ? void 0 : e[r];
                    if ($e444d6404c095fa5$var$F(n) || $e444d6404c095fa5$var$D(n)) return !1;
                    var o = [
                        String(n)
                    ], a = $e444d6404c095fa5$var$vn[s.operator];
                    return a ? a(s.values, o) : ($e444d6404c095fa5$var$Nn.warn("Unknown property comparison operator: " + s.operator), !1);
                }));
            });
            this.Wi(s.concat(u.map((t)=>t.id) || []));
        }
    }
    onAction(t) {
        var i, e = (null == (i = this._instance) || null == (i = i.persistence) ? void 0 : i.props[$e444d6404c095fa5$var$di]) || [];
        this.zi.has(t) && this.Wi(e.concat(this.zi.get(t) || []));
    }
    Wi(t) {
        var i;
        $e444d6404c095fa5$var$Nn.info("updating activated surveys", {
            activatedSurveys: t
        }), null == (i = this._instance) || null == (i = i.persistence) || i.register({
            [$e444d6404c095fa5$var$di]: [
                ...new Set(t)
            ]
        });
    }
    getSurveys() {
        var t, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$di];
        return i || [];
    }
    getEventToSurveys() {
        return this.Ui;
    }
    Gi() {
        return this.qi;
    }
}
class $e444d6404c095fa5$var$Gn {
    constructor(t){
        this.Vi = void 0, this._surveyManager = null, this.Ji = !1, this.Ki = !1, this.Yi = [], this._instance = t, this._surveyEventReceiver = null;
    }
    onRemoteConfig(t) {
        if (!this._instance.config.disable_surveys) {
            var i = t.surveys;
            if ($e444d6404c095fa5$var$j(i)) return $e444d6404c095fa5$var$Nn.warn("Flags not loaded yet. Not loading surveys.");
            var e = $e444d6404c095fa5$var$R(i);
            this.Vi = e ? i.length > 0 : i, $e444d6404c095fa5$var$Nn.info("flags response received, isSurveysEnabled: " + this.Vi), this.loadIfEnabled();
        }
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        for(var t = [], i = 0; i < localStorage.length; i++){
            var e = localStorage.key(i);
            (null != e && e.startsWith($e444d6404c095fa5$var$Un) || null != e && e.startsWith("inProgressSurvey_")) && t.push(e);
        }
        t.forEach((t)=>localStorage.removeItem(t));
    }
    loadIfEnabled() {
        if (!this._surveyManager) {
            if (this.Ki) $e444d6404c095fa5$var$Nn.info("Already initializing surveys, skipping...");
            else if (this._instance.config.disable_surveys) $e444d6404c095fa5$var$Nn.info("Disabled. Not loading surveys.");
            else if (this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) $e444d6404c095fa5$var$Nn.info("Not loading surveys in cookieless mode without consent.");
            else {
                var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (t) {
                    if (!$e444d6404c095fa5$var$F(this.Vi) || this._instance.config.advanced_enable_surveys) {
                        var i = this.Vi || this._instance.config.advanced_enable_surveys;
                        this.Ki = !0;
                        try {
                            var e = t.generateSurveys;
                            if (e) return void this.Xi(e, i);
                            var r = t.loadExternalDependency;
                            if (!r) return void this.Qi("PostHog loadExternalDependency extension not found.");
                            r(this._instance, "surveys", (e)=>{
                                e || !t.generateSurveys ? this.Qi("Could not load surveys script", e) : this.Xi(t.generateSurveys, i);
                            });
                        } catch (t) {
                            throw this.Qi("Error initializing surveys", t), t;
                        } finally{
                            this.Ki = !1;
                        }
                    }
                } else $e444d6404c095fa5$var$Nn.error("PostHog Extensions not found.");
            }
        }
    }
    Xi(t, i) {
        this._surveyManager = t(this._instance, i), this._surveyEventReceiver = new $e444d6404c095fa5$var$Wn(this._instance), $e444d6404c095fa5$var$Nn.info("Surveys loaded successfully"), this.Zi({
            isLoaded: !0
        });
    }
    Qi(t, i) {
        $e444d6404c095fa5$var$Nn.error(t, i), this.Zi({
            isLoaded: !1,
            error: t
        });
    }
    onSurveysLoaded(t) {
        return this.Yi.push(t), this._surveyManager && this.Zi({
            isLoaded: !0
        }), ()=>{
            this.Yi = this.Yi.filter((i)=>i !== t);
        };
    }
    getSurveys(t, i) {
        if (void 0 === i && (i = !1), this._instance.config.disable_surveys) return $e444d6404c095fa5$var$Nn.info("Disabled. Not loading surveys."), t([]);
        var e = this._instance.get_property($e444d6404c095fa5$var$hi);
        if (e && !i) return t(e, {
            isLoaded: !0
        });
        if (this.Ji) return t([], {
            isLoaded: !1,
            error: "Surveys are already being loaded"
        });
        try {
            this.Ji = !0, this._instance.ci({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this._instance.config.token),
                method: "GET",
                timeout: this._instance.config.surveys_request_timeout_ms,
                callback: (i)=>{
                    var e;
                    this.Ji = !1;
                    var r = i.statusCode;
                    if (200 !== r || !i.json) {
                        var s = "Surveys API could not be loaded, status: " + r;
                        return $e444d6404c095fa5$var$Nn.error(s), t([], {
                            isLoaded: !1,
                            error: s
                        });
                    }
                    var n, o = i.json.surveys || [], a = o.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && (function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) || !i.length);
                        }(t) || function(t) {
                            var i;
                            return !(null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) || !i.length);
                        }(t)));
                    a.length > 0 && (null == (n = this._surveyEventReceiver) || n.register(a));
                    return null == (e = this._instance.persistence) || e.register({
                        [$e444d6404c095fa5$var$hi]: o
                    }), t(o, {
                        isLoaded: !0
                    });
                }
            });
        } catch (t) {
            throw this.Ji = !1, t;
        }
    }
    Zi(t) {
        for (var i of this.Yi)try {
            if (!t.isLoaded) return i([], t);
            this.getSurveys(i);
        } catch (t) {
            $e444d6404c095fa5$var$Nn.error("Error in survey callback", t);
        }
    }
    getActiveMatchingSurveys(t, i) {
        if (void 0 === i && (i = !1), !$e444d6404c095fa5$var$j(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, i);
        $e444d6404c095fa5$var$Nn.warn("init was not called");
    }
    te(t) {
        var i = null;
        return this.getSurveys((e)=>{
            var r;
            i = null !== (r = e.find((i)=>i.id === t)) && void 0 !== r ? r : null;
        }), i;
    }
    ie(t) {
        if ($e444d6404c095fa5$var$j(this._surveyManager)) return {
            eligible: !1,
            reason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = "string" == typeof t ? this.te(t) : t;
        return i ? this._surveyManager.checkSurveyEligibility(i) : {
            eligible: !1,
            reason: "Survey not found"
        };
    }
    canRenderSurvey(t) {
        if ($e444d6404c095fa5$var$j(this._surveyManager)) return $e444d6404c095fa5$var$Nn.warn("init was not called"), {
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        };
        var i = this.ie(t);
        return {
            visible: i.eligible,
            disabledReason: i.reason
        };
    }
    canRenderSurveyAsync(t, i) {
        return $e444d6404c095fa5$var$j(this._surveyManager) ? ($e444d6404c095fa5$var$Nn.warn("init was not called"), Promise.resolve({
            visible: !1,
            disabledReason: "SDK is not enabled or survey functionality is not yet loaded"
        })) : new Promise((e)=>{
            this.getSurveys((i)=>{
                var r, s = null !== (r = i.find((i)=>i.id === t)) && void 0 !== r ? r : null;
                if (s) {
                    var n = this.ie(s);
                    e({
                        visible: n.eligible,
                        disabledReason: n.reason
                    });
                } else e({
                    visible: !1,
                    disabledReason: "Survey not found"
                });
            }, i);
        });
    }
    renderSurvey(t, i) {
        var e;
        if ($e444d6404c095fa5$var$j(this._surveyManager)) $e444d6404c095fa5$var$Nn.warn("init was not called");
        else {
            var r = "string" == typeof t ? this.te(t) : t;
            if (null != r && r.id) {
                if ($e444d6404c095fa5$var$Bn.includes(r.type)) {
                    var s = null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.querySelector(i);
                    if (s) return null != (e = r.appearance) && e.surveyPopupDelaySeconds ? ($e444d6404c095fa5$var$Nn.info("Rendering survey " + r.id + " with delay of " + r.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                        var t, i;
                        $e444d6404c095fa5$var$Nn.info("Rendering survey " + r.id + " with delay of " + (null == (t = r.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (i = this._surveyManager) || i.renderSurvey(r, s), $e444d6404c095fa5$var$Nn.info("Survey " + r.id + " rendered");
                    }, 1e3 * r.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(r, s);
                    $e444d6404c095fa5$var$Nn.warn("Survey element not found");
                } else $e444d6404c095fa5$var$Nn.warn("Surveys of type " + r.type + " cannot be rendered in the app");
            } else $e444d6404c095fa5$var$Nn.warn("Survey not found");
        }
    }
    displaySurvey(t, i) {
        var e;
        if ($e444d6404c095fa5$var$j(this._surveyManager)) $e444d6404c095fa5$var$Nn.warn("init was not called");
        else {
            var r = this.te(t);
            if (r) {
                var s = r;
                if (null != (e = r.appearance) && e.surveyPopupDelaySeconds && i.ignoreDelay && (s = $e444d6404c095fa5$var$g({}, r, {
                    appearance: $e444d6404c095fa5$var$g({}, r.appearance, {
                        surveyPopupDelaySeconds: 0
                    })
                })), !1 === i.ignoreConditions) {
                    var n = this.canRenderSurvey(r);
                    if (!n.visible) return void $e444d6404c095fa5$var$Nn.warn("Survey is not eligible to be displayed: ", n.disabledReason);
                }
                i.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s) : this.renderSurvey(s, i.selector);
            } else $e444d6404c095fa5$var$Nn.warn("Survey not found");
        }
    }
}
var $e444d6404c095fa5$var$Vn = $e444d6404c095fa5$var$Tt("[RateLimiter]");
class $e444d6404c095fa5$var$Jn {
    constructor(t){
        var i, e;
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var i = t.text;
            if (i && i.length) try {
                (JSON.parse(i).quota_limited || []).forEach((t)=>{
                    $e444d6404c095fa5$var$Vn.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $e444d6404c095fa5$var$Vn.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: i
                });
            }
        }, this.instance = t, this.captureEventsPerSecond = (null == (i = t.config.rate_limiting) ? void 0 : i.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null == (e = t.config.rate_limiting) ? void 0 : e.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext(t) {
        var i, e, r;
        void 0 === t && (t = !1);
        var s = (new Date).getTime(), n = null !== (i = null == (e = this.instance.persistence) ? void 0 : e.get_property($e444d6404c095fa5$var$pi)) && void 0 !== i ? i : {
            tokens: this.captureEventsBurstLimit,
            last: s
        };
        n.tokens += (s - n.last) / 1e3 * this.captureEventsPerSecond, n.last = s, n.tokens > this.captureEventsBurstLimit && (n.tokens = this.captureEventsBurstLimit);
        var o = n.tokens < 1;
        return o || t || (n.tokens = Math.max(0, n.tokens - 1)), !o || this.lastEventRateLimited || t || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to " + this.captureEventsPerSecond + " events per second and " + this.captureEventsBurstLimit + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null == (r = this.instance.persistence) || r.set_property($e444d6404c095fa5$var$pi, n), {
            isRateLimited: o,
            remainingTokens: n.tokens
        };
    }
    isServerRateLimited(t) {
        var i = this.serverLimits[t || "events"] || !1;
        return !1 !== i && (new Date).getTime() < i;
    }
}
var $e444d6404c095fa5$var$Kn = $e444d6404c095fa5$var$Tt("[RemoteConfig]");
class $e444d6404c095fa5$var$Yn {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    ee(t) {
        var i, e;
        null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.loadExternalDependency ? null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : ($e444d6404c095fa5$var$Kn.error("PostHog Extensions not found. Cannot load remote config."), t());
    }
    re(t) {
        this._instance.ci({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: (i)=>{
                t(i.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $e444d6404c095fa5$var$Kn.info("Using preloaded remote config", this.remoteConfig), void this.fi(this.remoteConfig);
            if (this._instance.M()) return void $e444d6404c095fa5$var$Kn.warn("Remote config is disabled. Falling back to local config.");
            this.ee((t)=>{
                if (!t) return $e444d6404c095fa5$var$Kn.info("No config found after loading remote JS config. Falling back to JSON."), void this.re((t)=>{
                    this.fi(t);
                });
                this.fi(t);
            });
        } catch (t) {
            $e444d6404c095fa5$var$Kn.error("Error loading remote config", t);
        }
    }
    fi(t) {
        t ? this._instance.config.__preview_remote_config ? (this._instance.fi(t), !1 !== t.hasFeatureFlags && this._instance.featureFlags.ensureFlagsLoaded()) : $e444d6404c095fa5$var$Kn.info("__preview_remote_config is disabled. Logging config instead", t) : $e444d6404c095fa5$var$Kn.error("Failed to fetch remote config from PostHog.");
    }
}
var $e444d6404c095fa5$var$Xn = 3e3;
class $e444d6404c095fa5$var$Qn {
    constructor(t, i){
        this.se = !0, this.ne = [], this.oe = $e444d6404c095fa5$var$J((null == i ? void 0 : i.flush_interval_ms) || $e444d6404c095fa5$var$Xn, 250, 5e3, $e444d6404c095fa5$var$Pt.createLogger("flush interval"), $e444d6404c095fa5$var$Xn), this.ae = t;
    }
    enqueue(t) {
        this.ne.push(t), this.le || this.ue();
    }
    unload() {
        this.he();
        var t = this.ne.length > 0 ? this.de() : {}, i = Object.values(t);
        [
            ...i.filter((t)=>0 === t.url.indexOf("/e")),
            ...i.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.ae($e444d6404c095fa5$var$g({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.se = !1, this.ue();
    }
    ue() {
        var t = this;
        this.se || (this.le = setTimeout(()=>{
            if (this.he(), this.ne.length > 0) {
                var i = this.de(), e = function() {
                    var e = i[r], s = (new Date).getTime();
                    e.data && $e444d6404c095fa5$var$R(e.data) && $e444d6404c095fa5$var$Ft(e.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.ae(e);
                };
                for(var r in i)e();
            }
        }, this.oe));
    }
    he() {
        clearTimeout(this.le), this.le = void 0;
    }
    de() {
        var t = {};
        return $e444d6404c095fa5$var$Ft(this.ne, (i)=>{
            var e, r = i, s = (r ? r.batchKey : null) || r.url;
            $e444d6404c095fa5$var$F(t[s]) && (t[s] = $e444d6404c095fa5$var$g({}, r, {
                data: []
            })), null == (e = t[s].data) || e.push(r.data);
        }), this.ne = [], t;
    }
}
var $e444d6404c095fa5$var$Zn = [
    "retriesPerformedSoFar"
];
class $e444d6404c095fa5$var$to {
    constructor(i){
        this.ve = !1, this.ce = 3e3, this.ne = [], this._instance = i, this.ne = [], this.fe = !0, !$e444d6404c095fa5$var$F($e444d6404c095fa5$var$t) && "onLine" in $e444d6404c095fa5$var$t.navigator && (this.fe = $e444d6404c095fa5$var$t.navigator.onLine, this.pe = ()=>{
            this.fe = !0, this.Dt();
        }, this.ge = ()=>{
            this.fe = !1;
        }, $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "online", this.pe), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "offline", this.ge));
    }
    get length() {
        return this.ne.length;
    }
    retriableRequest(t) {
        var { retriesPerformedSoFar: i } = t, e = $e444d6404c095fa5$var$_(t, $e444d6404c095fa5$var$Zn);
        $e444d6404c095fa5$var$L(i) && i > 0 && (e.url = $e444d6404c095fa5$var$on(e.url, {
            retry_count: i
        })), this._instance.ci($e444d6404c095fa5$var$g({}, e, {
            callback: (t)=>{
                200 !== t.statusCode && (t.statusCode < 400 || t.statusCode >= 500) && (null != i ? i : 0) < 10 ? this._e($e444d6404c095fa5$var$g({
                    retriesPerformedSoFar: i
                }, e)) : null == e.callback || e.callback(t);
            }
        }));
    }
    _e(t) {
        var i = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = i + 1;
        var e = function(t) {
            var i = 3e3 * Math.pow(2, t), e = i / 2, r = Math.min(18e5, i), s = (Math.random() - .5) * (r - e);
            return Math.ceil(r + s);
        }(i), r = Date.now() + e;
        this.ne.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + e;
        navigator.onLine || (s += " (Browser is offline)"), $e444d6404c095fa5$var$Pt.warn(s), this.ve || (this.ve = !0, this.me());
    }
    me() {
        if (this.ye && clearTimeout(this.ye), 0 === this.ne.length) return this.ve = !1, void (this.ye = void 0);
        this.ye = setTimeout(()=>{
            this.fe && this.ne.length > 0 && this.Dt(), this.me();
        }, this.ce);
    }
    Dt() {
        var t = Date.now(), i = [], e = this.ne.filter((e)=>e.retryAt < t || (i.push(e), !1));
        if (this.ne = i, e.length > 0) for (var { requestOptions: r } of e)this.retriableRequest(r);
    }
    unload() {
        for (var { requestOptions: i } of (this.ye && (clearTimeout(this.ye), this.ye = void 0), this.ve = !1, $e444d6404c095fa5$var$F($e444d6404c095fa5$var$t) || (this.pe && ($e444d6404c095fa5$var$t.removeEventListener("online", this.pe), this.pe = void 0), this.ge && ($e444d6404c095fa5$var$t.removeEventListener("offline", this.ge), this.ge = void 0)), this.ne))try {
            this._instance.ci($e444d6404c095fa5$var$g({}, i, {
                transport: "sendBeacon"
            }));
        } catch (t) {
            $e444d6404c095fa5$var$Pt.error(t);
        }
        this.ne = [];
    }
}
class $e444d6404c095fa5$var$io {
    constructor(t){
        this.be = ()=>{
            var t, i, e, r;
            this.we || (this.we = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this.we.lastScrollY = Math.ceil(n), this.we.maxScrollY = Math.max(n, null !== (t = this.we.maxScrollY) && void 0 !== t ? t : 0), this.we.maxScrollHeight = Math.max(o, null !== (i = this.we.maxScrollHeight) && void 0 !== i ? i : 0), this.we.lastContentY = a, this.we.maxContentY = Math.max(a, null !== (e = this.we.maxContentY) && void 0 !== e ? e : 0), this.we.maxContentHeight = Math.max(l, null !== (r = this.we.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    getContext() {
        return this.we;
    }
    resetContext() {
        var t = this.we;
        return setTimeout(this.be, 0), t;
    }
    startMeasuringScrollPosition() {
        $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "scroll", this.be, {
            capture: !0
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "scrollend", this.be, {
            capture: !0
        }), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "resize", this.be);
    }
    scrollElement() {
        if (!this._instance.config.scroll_root_selector) return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.documentElement;
        var i = $e444d6404c095fa5$var$R(this._instance.config.scroll_root_selector) ? this._instance.config.scroll_root_selector : [
            this._instance.config.scroll_root_selector
        ];
        for (var e of i){
            var r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.querySelector(e);
            if (r) return r;
        }
    }
    scrollY() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollTop || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollY || $e444d6404c095fa5$var$t.pageYOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this._instance.config.scroll_root_selector) {
            var i = this.scrollElement();
            return i && i.scrollLeft || 0;
        }
        return $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.scrollX || $e444d6404c095fa5$var$t.pageXOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollLeft) || 0;
    }
}
var $e444d6404c095fa5$var$eo = (t)=>$e444d6404c095fa5$var$hs(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties);
class $e444d6404c095fa5$var$ro {
    constructor(t, i, e, r){
        this.xe = (t)=>{
            var i = this.Se();
            if (!i || i.sessionId !== t) {
                var e = {
                    sessionId: t,
                    props: this.Ee(this._instance)
                };
                this.$e.register({
                    [$e444d6404c095fa5$var$fi]: e
                });
            }
        }, this._instance = t, this.ke = i, this.$e = e, this.Ee = r || $e444d6404c095fa5$var$eo, this.ke.onSessionId(this.xe);
    }
    Se() {
        return this.$e.props[$e444d6404c095fa5$var$fi];
    }
    getSetOnceProps() {
        var t, i = null == (t = this.Se()) ? void 0 : t.props;
        return i ? "r" in i ? $e444d6404c095fa5$var$ds(i) : {
            $referring_domain: i.referringDomain,
            $pathname: i.initialPathName,
            utm_source: i.utm_source,
            utm_campaign: i.utm_campaign,
            utm_medium: i.utm_medium,
            utm_content: i.utm_content,
            utm_term: i.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $e444d6404c095fa5$var$Ft($e444d6404c095fa5$var$Nt(this.getSetOnceProps()), (i, e)=>{
            "$current_url" === e && (e = "url"), t["$session_entry_" + $e444d6404c095fa5$var$S(e)] = i;
        }), t;
    }
}
var $e444d6404c095fa5$var$so = $e444d6404c095fa5$var$Tt("[SessionId]");
class $e444d6404c095fa5$var$no {
    on(t, i) {
        return this.Pe.on(t, i);
    }
    constructor(t, i, e){
        var r;
        if (this.Te = [], this.Re = void 0, this.Pe = new $e444d6404c095fa5$var$jn, this.Ie = (t, i)=>Math.abs(t - i) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if ("always" === t.config.cookieless_mode) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.C = t.config, this.$e = t.persistence, this.Ce = void 0, this.Oe = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Fe = i || $e444d6404c095fa5$var$xe, this.Me = e || $e444d6404c095fa5$var$xe;
        var s = this.C.persistence_name || this.C.token, n = this.C.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * $e444d6404c095fa5$var$J(n, 60, 36e3, $e444d6404c095fa5$var$so.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.Ae(), this.De = "ph_" + s + "_window_id", this.je = "ph_" + s + "_primary_window_exists", this.Le()) {
            var o = $e444d6404c095fa5$var$Ae.W(this.De), a = $e444d6404c095fa5$var$Ae.W(this.je);
            o && !a ? this.Ce = o : $e444d6404c095fa5$var$Ae.V(this.De), $e444d6404c095fa5$var$Ae.G(this.je, !0);
        }
        if (null != (r = this.C.bootstrap) && r.sessionID) try {
            var l = ((t)=>{
                var i = t.replace(/-/g, "");
                if (32 !== i.length) throw new Error("Not a valid UUID");
                if ("7" !== i[12]) throw new Error("Not a UUIDv7");
                return parseInt(i.substring(0, 12), 16);
            })(this.C.bootstrap.sessionID);
            this.Ne(this.C.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (t) {
            $e444d6404c095fa5$var$so.error("Invalid sessionID in bootstrap", t);
        }
        this.Ue();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $e444d6404c095fa5$var$F(this.Te) && (this.Te = []), this.Te.push(t), this.Oe && t(this.Oe, this.Ce), ()=>{
            this.Te = this.Te.filter((i)=>i !== t);
        };
    }
    Le() {
        return "memory" !== this.C.persistence && !this.$e.wi && $e444d6404c095fa5$var$Ae.H();
    }
    ze(t) {
        t !== this.Ce && (this.Ce = t, this.Le() && $e444d6404c095fa5$var$Ae.G(this.De, t));
    }
    He() {
        return this.Ce ? this.Ce : this.Le() ? $e444d6404c095fa5$var$Ae.W(this.De) : null;
    }
    Ne(t, i, e) {
        t === this.Oe && i === this._sessionActivityTimestamp && e === this._sessionStartTimestamp || (this._sessionStartTimestamp = e, this._sessionActivityTimestamp = i, this.Oe = t, this.$e.register({
            [$e444d6404c095fa5$var$ri]: [
                i,
                t,
                e
            ]
        }));
    }
    Be() {
        if (this.Oe && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this.Oe,
            this._sessionStartTimestamp
        ];
        var t = this.$e.props[$e444d6404c095fa5$var$ri];
        return $e444d6404c095fa5$var$R(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Ne(null, null, null);
    }
    destroy() {
        clearTimeout(this.qe), this.qe = void 0, this.Re && $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.removeEventListener("beforeunload", this.Re, {
            capture: !1
        }), this.Re = void 0), this.Te = [];
    }
    Ue() {
        this.Re = ()=>{
            this.Le() && $e444d6404c095fa5$var$Ae.V(this.je);
        }, $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "beforeunload", this.Re, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, i) {
        if (void 0 === t && (t = !1), void 0 === i && (i = null), "always" === this.C.cookieless_mode) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var e = i || (new Date).getTime(), [r, s, n] = this.Be(), o = this.He(), a = $e444d6404c095fa5$var$L(n) && n > 0 && Math.abs(e - n) > 864e5, l = !1, u = !s, h = !t && this.Ie(e, r);
        u || h || a ? (s = this.Fe(), o = this.Me(), $e444d6404c095fa5$var$so.info("new session ID generated", {
            sessionId: s,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            }
        }), n = e, l = !0) : o || (o = this.Me(), l = !0);
        var d = 0 === r || !t || a ? e : r, v = 0 === n ? (new Date).getTime() : n;
        return this.ze(o), this.Ne(s, d, v), t || this.Ae(), l && this.Te.forEach((t)=>t(s, o, l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: s,
            windowId: o,
            sessionStartTimestamp: v,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: h,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: r
        };
    }
    Ae() {
        clearTimeout(this.qe), this.qe = setTimeout(()=>{
            var [t] = this.Be();
            if (this.Ie((new Date).getTime(), t)) {
                var i = this.Oe;
                this.resetSessionId(), this.Pe.emit("forcedIdleReset", {
                    idleSessionId: i
                });
            }
        }, 1.1 * this.sessionTimeoutMs);
    }
}
var $e444d6404c095fa5$var$oo = [
    "$set_once",
    "$set"
], $e444d6404c095fa5$var$ao = $e444d6404c095fa5$var$Tt("[SiteApps]");
class $e444d6404c095fa5$var$lo {
    constructor(t){
        this._instance = t, this.We = [], this.apps = {};
    }
    get isEnabled() {
        return !!this._instance.config.opt_in_site_apps;
    }
    Ge(t, i) {
        if (i) {
            var e = this.globalsForEvent(i);
            this.We.push(e), this.We.length > 1e3 && (this.We = this.We.slice(10));
        }
    }
    get siteAppLoaders() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var t = this._instance.Mi(this.Ge.bind(this));
            this.Ve = ()=>{
                t(), this.We = [], this.Ve = void 0;
            };
        }
    }
    globalsForEvent(t) {
        var i, e, r, s, n, o, a;
        if (!t) throw new Error("Event payload is required");
        var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
        for (var [d, v] of Object.entries(h))l[d] = {
            id: u[d],
            type: d,
            properties: v
        };
        var { $set_once: c, $set: f } = t;
        return {
            event: $e444d6404c095fa5$var$g({}, $e444d6404c095fa5$var$_(t, $e444d6404c095fa5$var$oo), {
                properties: $e444d6404c095fa5$var$g({}, t.properties, f ? {
                    $set: $e444d6404c095fa5$var$g({}, null !== (i = null == (e = t.properties) ? void 0 : e.$set) && void 0 !== i ? i : {}, f)
                } : {}, c ? {
                    $set_once: $e444d6404c095fa5$var$g({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                } : {}),
                elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
            }),
            person: {
                properties: this._instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(t) {
        var i = this.apps[t.id], e = ()=>{
            var e;
            (!i.errored && this.We.length && ($e444d6404c095fa5$var$ao.info("Processing " + this.We.length + " events for site app with id " + t.id), this.We.forEach((t)=>null == i.processEvent ? void 0 : i.processEvent(t)), i.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored)) && (null == (e = this.Ve) || e.call(this));
        }, r = !1, s = (s)=>{
            i.errored = !s, i.loaded = !0, $e444d6404c095fa5$var$ao.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && e();
        };
        try {
            var { processEvent: n } = t.init({
                posthog: this._instance,
                callback: (t)=>{
                    s(t);
                }
            });
            n && (i.processEvent = n), r = !0;
        } catch (i) {
            $e444d6404c095fa5$var$ao.error("Error while initializing PostHog app with config id " + t.id, i), s(!1);
        }
        if (r && i.loaded) try {
            e();
        } catch (e) {
            $e444d6404c095fa5$var$ao.error("Error while processing buffered events PostHog app with config id " + t.id, e), i.errored = !0;
        }
    }
    Je() {
        var t = this.siteAppLoaders || [];
        for (var i of t)this.apps[i.id] = {
            id: i.id,
            loaded: !1,
            errored: !1,
            processedBuffer: !1
        };
        for (var e of t)this.setupSiteApp(e);
    }
    Ke(t) {
        if (0 !== Object.keys(this.apps).length) {
            var i = this.globalsForEvent(t);
            for (var e of Object.values(this.apps))try {
                null == e.processEvent || e.processEvent(i);
            } catch (i) {
                $e444d6404c095fa5$var$ao.error("Error while processing event " + t.event + " for site app " + e.id, i);
            }
        }
    }
    onRemoteConfig(t) {
        var i, e, r, s = this;
        if (null != (i = this.siteAppLoaders) && i.length) return this.isEnabled ? (this.Je(), void this._instance.on("eventCaptured", (t)=>this.Ke(t))) : void $e444d6404c095fa5$var$ao.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        if (null == (e = this.Ve) || e.call(this), null != (r = t.siteApps) && r.length) {
            if (this.isEnabled) {
                var n = function(t) {
                    var i;
                    $e444d6404c095fa5$var$v["__$$ph_site_app_" + t] = s._instance, null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadSiteApp || i.loadSiteApp(s._instance, a, (i)=>{
                        if (i) return $e444d6404c095fa5$var$ao.error("Error while initializing PostHog app with config id " + t, i);
                    });
                };
                for (var { id: o, url: a } of t.siteApps)n(o);
            } else $e444d6404c095fa5$var$ao.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var $e444d6404c095fa5$var$uo = function(t, i) {
    if (!t) return !1;
    var e = t.userAgent;
    if (e && $e444d6404c095fa5$var$y(e, i)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$e444d6404c095fa5$var$y(null == t ? void 0 : t.brand, i))) return !0;
    } catch (t) {}
    return !!t.webdriver;
}, $e444d6404c095fa5$var$ho = function(t) {
    return t.US = "us", t.EU = "eu", t.CUSTOM = "custom", t;
}({}), $e444d6404c095fa5$var$vo = "i.posthog.com";
class $e444d6404c095fa5$var$co {
    constructor(t){
        this.Ye = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get uiHost() {
        var t, i = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return i || (i = this.apiHost.replace("." + $e444d6404c095fa5$var$vo, ".posthog.com")), "https://app.posthog.com" === i ? "https://us.posthog.com" : i;
    }
    get region() {
        return this.Ye[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Ye[this.apiHost] = $e444d6404c095fa5$var$ho.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this.Ye[this.apiHost] = $e444d6404c095fa5$var$ho.EU : this.Ye[this.apiHost] = $e444d6404c095fa5$var$ho.CUSTOM), this.Ye[this.apiHost];
    }
    endpointFor(t, i) {
        if (void 0 === i && (i = ""), i && (i = "/" === i[0] ? i : "/" + i), "ui" === t) return this.uiHost + i;
        if (this.region === $e444d6404c095fa5$var$ho.CUSTOM) return this.apiHost + i;
        var e = $e444d6404c095fa5$var$vo + i;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + e;
            case "api":
                return "https://" + this.region + "." + e;
        }
    }
}
var $e444d6404c095fa5$var$fo = {
    icontains: (i, e)=>!!$e444d6404c095fa5$var$t && e.href.toLowerCase().indexOf(i.toLowerCase()) > -1,
    not_icontains: (i, e)=>!!$e444d6404c095fa5$var$t && -1 === e.href.toLowerCase().indexOf(i.toLowerCase()),
    regex: (i, e)=>!!$e444d6404c095fa5$var$t && $e444d6404c095fa5$var$hn(e.href, i),
    not_regex: (i, e)=>!!$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$hn(e.href, i),
    exact: (t, i)=>i.href === t,
    is_not: (t, i)=>i.href !== t
};
class $e444d6404c095fa5$var$po {
    constructor(t){
        var i = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), i.getWebExperiments((t)=>{
                $e444d6404c095fa5$var$po.Xe("retrieved web experiments from the server"), i.Qe = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var e;
                        if (i.Qe) $e444d6404c095fa5$var$po.Xe("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (e = i.Qe) || e.set(t.feature_flag_key, t);
                        var r = i._instance.getFeatureFlag(t.feature_flag_key);
                        $e444d6404c095fa5$var$M(r) && t.variants[r] && i.Ze(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $e444d6404c095fa5$var$po.tr(n) && i.Ze(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    onFeatureFlags(t) {
        if (this._is_bot()) $e444d6404c095fa5$var$po.Xe("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this._instance.config.disable_web_experiments) {
            if ($e444d6404c095fa5$var$j(this.Qe)) return this.Qe = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $e444d6404c095fa5$var$po.Xe("applying feature flags", t), t.forEach((t)=>{
                var i;
                if (this.Qe && null != (i = this.Qe) && i.has(t)) {
                    var e, r = this._instance.getFeatureFlag(t), s = null == (e = this.Qe) ? void 0 : e.get(t);
                    r && null != s && s.variants[r] && this.Ze(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $e444d6404c095fa5$var$po.getWindowLocation();
        if (null != t && t.search) {
            var i = $e444d6404c095fa5$var$ae(null == t ? void 0 : t.search, "__experiment_id"), e = $e444d6404c095fa5$var$ae(null == t ? void 0 : t.search, "__experiment_variant");
            i && e && ($e444d6404c095fa5$var$po.Xe("previewing web experiments " + i + " && " + e), this.getWebExperiments((t)=>{
                this.ir(parseInt(i), e, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this._instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, i, e) {
        if (this._instance.config.disable_web_experiments && !e) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !i) return t(r);
        this._instance.ci({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this._instance.config.token),
            method: "GET",
            callback: (i)=>{
                if (200 !== i.statusCode || !i.json) return t([]);
                var e = i.json.experiments || [];
                return t(e);
            }
        });
    }
    ir(t, i, e) {
        var r = e.filter((i)=>i.id === t);
        r && r.length > 0 && ($e444d6404c095fa5$var$po.Xe("Previewing web experiment [" + r[0].name + "] with variant [" + i + "]"), this.Ze(r[0].name, i, r[0].variants[i].transforms));
    }
    static tr(t) {
        return !$e444d6404c095fa5$var$j(t.conditions) && $e444d6404c095fa5$var$po.er(t) && $e444d6404c095fa5$var$po.rr(t);
    }
    static er(t) {
        var i;
        if ($e444d6404c095fa5$var$j(t.conditions) || $e444d6404c095fa5$var$j(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var e, r, s, n = $e444d6404c095fa5$var$po.getWindowLocation();
        return !!n && (null == (e = t.conditions) || !e.url || $e444d6404c095fa5$var$fo[null !== (r = null == (s = t.conditions) ? void 0 : s.urlMatchType) && void 0 !== r ? r : "icontains"](t.conditions.url, n));
    }
    static getWindowLocation() {
        return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location;
    }
    static rr(t) {
        var i;
        if ($e444d6404c095fa5$var$j(t.conditions) || $e444d6404c095fa5$var$j(null == (i = t.conditions) ? void 0 : i.utm)) return !0;
        var e = $e444d6404c095fa5$var$ns();
        if (e.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == e.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == e.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == e.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == e.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static Xe(t) {
        for(var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)e[r - 1] = arguments[r];
        $e444d6404c095fa5$var$Pt.info("[WebExperiments] " + t, e);
    }
    Ze(t, i, e) {
        this._is_bot() ? $e444d6404c095fa5$var$po.Xe("Refusing to render web experiment since the viewer is a likely bot") : "control" !== i ? e.forEach((e)=>{
            if (e.selector) {
                var r;
                $e444d6404c095fa5$var$po.Xe("applying transform of variant " + i + " for experiment " + t + " ", e);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(e.selector);
                null == s || s.forEach((t)=>{
                    var i = t;
                    e.html && (i.innerHTML = e.html), e.css && i.setAttribute("style", e.css);
                });
            }
        }) : $e444d6404c095fa5$var$po.Xe("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n && this._instance ? $e444d6404c095fa5$var$uo($e444d6404c095fa5$var$n, this._instance.config.custom_blocked_useragents) : void 0;
    }
}
var $e444d6404c095fa5$var$go = $e444d6404c095fa5$var$Tt("[PostHog ExternalIntegrations]"), $e444d6404c095fa5$var$_o = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $e444d6404c095fa5$var$mo {
    constructor(t){
        this._instance = t;
    }
    it(t, i) {
        var e;
        null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $e444d6404c095fa5$var$go.error("failed to load script", t);
            i();
        });
    }
    startIfEnabledOrStop() {
        var t = this, i = function(i) {
            var e, s, n;
            (!r || null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[i] || t.it($e444d6404c095fa5$var$_o[i], ()=>{
                var e;
                null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[i]) || e.start(t._instance);
            }), !r && null != (s = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (s = s.integrations) && s[i]) && (null == (n = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (n = n.integrations) || null == (n = n[i]) || n.stop());
        };
        for (var [e, r] of Object.entries(null !== (s = this._instance.config.integrations) && void 0 !== s ? s : {})){
            var s;
            i(e);
        }
    }
}
var $e444d6404c095fa5$var$yo = "[SessionRecording]", $e444d6404c095fa5$var$bo = $e444d6404c095fa5$var$Tt($e444d6404c095fa5$var$yo);
class $e444d6404c095fa5$var$wo {
    get started() {
        var t;
        return !(null == (t = this.sr) || !t.isStarted);
    }
    get status() {
        return this.sr ? this.sr.status : this.nr && !this.ar ? "disabled" : "lazy_loading";
    }
    constructor(t){
        if (this._forceAllowLocalhostNetworkCapture = !1, this.nr = !1, this.lr = void 0, this._instance = t, !this._instance.sessionManager) throw $e444d6404c095fa5$var$bo.error("started without valid sessionManager"), new Error($e444d6404c095fa5$var$yo + " started without valid sessionManager. This is a bug.");
        if ("always" === this._instance.config.cookieless_mode) throw new Error($e444d6404c095fa5$var$yo + ' cannot be used with cookieless_mode="always"');
    }
    get ar() {
        var i, e = !(null == (i = this._instance.get_property($e444d6404c095fa5$var$ei)) || !i.enabled), r = !this._instance.config.disable_session_recording, s = this._instance.config.disable_session_recording || this._instance.consent.isOptedOut();
        return $e444d6404c095fa5$var$t && e && r && !s;
    }
    startIfEnabledOrStop(t) {
        var i;
        if (!this.ar || null == (i = this.sr) || !i.isStarted) {
            var e = !$e444d6404c095fa5$var$F(Object.assign) && !$e444d6404c095fa5$var$F(Array.from);
            this.ar && e ? (this.ur(t), $e444d6404c095fa5$var$bo.info("starting")) : this.stopRecording();
        }
    }
    ur(t) {
        var i, e, r;
        this.ar && (null != $e444d6404c095fa5$var$v && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (i = i.rrweb) && i.record && null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.initSessionRecording ? this.hr(t) : null == (r = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.dr, (i)=>{
            if (i) return $e444d6404c095fa5$var$bo.error("could not load recorder", i);
            this.hr(t);
        }));
    }
    stopRecording() {
        var t, i;
        null == (t = this.lr) || t.call(this), this.lr = void 0, null == (i = this.sr) || i.stop();
    }
    vr() {
        var t;
        null == (t = this._instance.persistence) || t.unregister($e444d6404c095fa5$var$si);
    }
    cr(t) {
        if (this._instance.persistence) {
            var i, e, r = this._instance.persistence, s = ()=>{
                var i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, e = null == i ? void 0 : i.sampleRate, s = $e444d6404c095fa5$var$j(e) ? null : parseFloat(e);
                $e444d6404c095fa5$var$j(s) && this.vr();
                var n = null == i ? void 0 : i.minimumDurationMilliseconds;
                r.register({
                    [$e444d6404c095fa5$var$ei]: $e444d6404c095fa5$var$g({
                        enabled: !!i
                    }, i, {
                        networkPayloadCapture: $e444d6404c095fa5$var$g({
                            capturePerformance: t.capturePerformance
                        }, null == i ? void 0 : i.networkPayloadCapture),
                        canvasRecording: {
                            enabled: null == i ? void 0 : i.recordCanvas,
                            fps: null == i ? void 0 : i.canvasFps,
                            quality: null == i ? void 0 : i.canvasQuality
                        },
                        sampleRate: s,
                        minimumDurationMilliseconds: $e444d6404c095fa5$var$F(n) ? null : n,
                        endpoint: null == i ? void 0 : i.endpoint,
                        triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                        masking: null == i ? void 0 : i.masking,
                        urlTriggers: null == i ? void 0 : i.urlTriggers
                    })
                });
            };
            s(), null == (i = this.lr) || i.call(this), this.lr = null == (e = this._instance.sessionManager) ? void 0 : e.onSessionId(s);
        }
    }
    onRemoteConfig(t) {
        "sessionRecording" in t ? !1 !== t.sessionRecording ? (this.cr(t), this.nr = !0, this.startIfEnabledOrStop()) : this.nr = !0 : $e444d6404c095fa5$var$bo.info("skipping remote config with no sessionRecording", t);
    }
    log(t, i) {
        var e;
        void 0 === i && (i = "log"), null != (e = this.sr) && e.log ? this.sr.log(t, i) : $e444d6404c095fa5$var$bo.warn("log called before recorder was ready");
    }
    get dr() {
        var t, i, e = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$ei);
        return (null == e || null == (i = e.scriptConfig) ? void 0 : i.script) || "lazy-recorder";
    }
    hr(t) {
        var i, e;
        if (null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || !i.initSessionRecording) throw Error("Called on script loaded before session recording is available");
        this.sr || (this.sr = null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) ? void 0 : e.initSessionRecording(this._instance), this.sr._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture);
        this.sr.start(t);
    }
    onRRwebEmit(t) {
        var i;
        null == (i = this.sr) || null == i.onRRwebEmit || i.onRRwebEmit(t);
    }
    overrideLinkedFlag() {
        var t;
        null == (t = this.sr) || t.overrideLinkedFlag();
    }
    overrideSampling() {
        var t;
        null == (t = this.sr) || t.overrideSampling();
    }
    overrideTrigger(t) {
        var i;
        null == (i = this.sr) || i.overrideTrigger(t);
    }
    get sdkDebugProperties() {
        var t;
        return (null == (t = this.sr) ? void 0 : t.sdkDebugProperties) || {
            $recording_status: this.status
        };
    }
    tryAddCustomEvent(t, i) {
        var e;
        return !(null == (e = this.sr) || !e.tryAddCustomEvent(t, i));
    }
}
var $e444d6404c095fa5$var$xo = {}, $e444d6404c095fa5$var$So = ()=>{}, $e444d6404c095fa5$var$Eo = "posthog", $e444d6404c095fa5$var$$o = !$e444d6404c095fa5$var$sn && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("MSIE")) && -1 === (null == $e444d6404c095fa5$var$d ? void 0 : $e444d6404c095fa5$var$d.indexOf("Mozilla")), $e444d6404c095fa5$var$ko = (i)=>{
    var e;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: $e444d6404c095fa5$var$Ht(null == $e444d6404c095fa5$var$o ? void 0 : $e444d6404c095fa5$var$o.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: $e444d6404c095fa5$var$So,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: "2025-05-24" !== i || "history_change",
        capture_pageleave: "if_capture_pageview",
        defaults: null != i ? i : "unset",
        debug: $e444d6404c095fa5$var$a && $e444d6404c095fa5$var$M(null == $e444d6404c095fa5$var$a ? void 0 : $e444d6404c095fa5$var$a.search) && -1 !== $e444d6404c095fa5$var$a.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_external_dependency_loading: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.location) ? void 0 : e.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error: (t)=>{
            var i = "Bad HTTP status: " + t.statusCode + " " + t.text;
            $e444d6404c095fa5$var$Pt.error(i);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        before_send: void 0,
        request_queue_config: {
            flush_interval_ms: $e444d6404c095fa5$var$Xn
        },
        error_tracking: {},
        _onCapture: $e444d6404c095fa5$var$So,
        __preview_eager_load_replay: !1
    };
}, $e444d6404c095fa5$var$Po = (t)=>{
    var i = {};
    $e444d6404c095fa5$var$F(t.process_person) || (i.person_profiles = t.process_person), $e444d6404c095fa5$var$F(t.xhr_headers) || (i.request_headers = t.xhr_headers), $e444d6404c095fa5$var$F(t.cookie_name) || (i.persistence_name = t.cookie_name), $e444d6404c095fa5$var$F(t.disable_cookie) || (i.disable_persistence = t.disable_cookie), $e444d6404c095fa5$var$F(t.store_google) || (i.save_campaign_params = t.store_google), $e444d6404c095fa5$var$F(t.verbose) || (i.debug = t.verbose);
    var e = $e444d6404c095fa5$var$Mt({}, i, t);
    return $e444d6404c095fa5$var$R(t.property_blacklist) && ($e444d6404c095fa5$var$F(t.property_denylist) ? e.property_denylist = t.property_blacklist : $e444d6404c095fa5$var$R(t.property_denylist) ? e.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $e444d6404c095fa5$var$Pt.error("Invalid value for property_denylist config: " + t.property_denylist)), e;
};
class $e444d6404c095fa5$var$To {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get pr() {
        return this.__forceAllowLocalhost;
    }
    set pr(t) {
        $e444d6404c095fa5$var$Pt.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $e444d6404c095fa5$export$a9d6b9cbf49b8241 {
    get decideEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, i;
        return null !== (t = null == (i = this.featureFlags) ? void 0 : i.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        this.webPerformance = new $e444d6404c095fa5$var$To, this.gr = !1, this.version = $e444d6404c095fa5$var$c.LIB_VERSION, this._r = new $e444d6404c095fa5$var$jn, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $e444d6404c095fa5$var$ko(), this.SentryIntegration = $e444d6404c095fa5$var$Ye, this.sentryIntegration = (t)=>(function(t, i) {
                var e = $e444d6404c095fa5$var$Ke(t, i);
                return {
                    name: $e444d6404c095fa5$var$Je,
                    processEvent: (t)=>e(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.mr = !1, this.yr = null, this.br = null, this.wr = null, this.featureFlags = new $e444d6404c095fa5$var$$n(this), this.toolbar = new $e444d6404c095fa5$var$ir(this), this.scrollManager = new $e444d6404c095fa5$var$io(this), this.pageViewManager = new $e444d6404c095fa5$var$ws(this), this.surveys = new $e444d6404c095fa5$var$Gn(this), this.experiments = new $e444d6404c095fa5$var$po(this), this.exceptions = new $e444d6404c095fa5$var$pn(this), this.rateLimiter = new $e444d6404c095fa5$var$Jn(this), this.requestRouter = new $e444d6404c095fa5$var$co(this), this.consent = new $e444d6404c095fa5$var$je(this), this.externalIntegrations = new $e444d6404c095fa5$var$mo(this), this.people = {
            set: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(r), null == e || e({});
            },
            set_once: (t, i, e)=>{
                var r = $e444d6404c095fa5$var$M(t) ? {
                    [t]: i
                } : t;
                this.setPersonProperties(void 0, r), null == e || e({});
            }
        }, this.on("eventCaptured", (t)=>$e444d6404c095fa5$var$Pt.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, i, e) {
        if (e && e !== $e444d6404c095fa5$var$Eo) {
            var r, s = null !== (r = $e444d6404c095fa5$var$xo[e]) && void 0 !== r ? r : new $e444d6404c095fa5$export$a9d6b9cbf49b8241;
            return s._init(t, i, e), $e444d6404c095fa5$var$xo[e] = s, $e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$Eo][e] = s, s;
        }
        return this._init(t, i, e);
    }
    _init(i, e, r) {
        var s, n;
        if (void 0 === e && (e = {}), $e444d6404c095fa5$var$F(i) || $e444d6404c095fa5$var$A(i)) return $e444d6404c095fa5$var$Pt.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, e.debug = this.Sr(e.debug), this.Er = e, this.$r = [], e.person_profiles && (this.br = e.person_profiles), this.set_config($e444d6404c095fa5$var$Mt({}, $e444d6404c095fa5$var$ko(e.defaults), $e444d6404c095fa5$var$Po(e), {
            name: r,
            token: i
        })), this.config.on_xhr_error && $e444d6404c095fa5$var$Pt.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = e.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS;
        var o = this.kr();
        this.persistence = new $e444d6404c095fa5$var$Pn(this.config, o), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Pn($e444d6404c095fa5$var$g({}, this.config, {
            persistence: "sessionStorage"
        }), o);
        var a = $e444d6404c095fa5$var$g({}, this.persistence.props), l = $e444d6404c095fa5$var$g({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.Pr = new $e444d6404c095fa5$var$Qn((t)=>this.Tr(t), this.config.request_queue_config), this.Rr = new $e444d6404c095fa5$var$to(this), this.__request_queue = [];
        var u = "always" === this.config.cookieless_mode || "on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut();
        if (u || (this.sessionManager = new $e444d6404c095fa5$var$no(this), this.sessionPropsManager = new $e444d6404c095fa5$var$ro(this, this.sessionManager, this.persistence)), new $e444d6404c095fa5$var$rr(this).startIfEnabledOrStop(), this.siteApps = new $e444d6404c095fa5$var$lo(this), null == (s = this.siteApps) || s.init(), u || (this.sessionRecording = new $e444d6404c095fa5$var$wo(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new $e444d6404c095fa5$var$pe(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new $e444d6404c095fa5$var$bs(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new $e444d6404c095fa5$var$_s(this), this.exceptionObserver = new $e444d6404c095fa5$var$Be(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $e444d6404c095fa5$var$ze(this, $e444d6404c095fa5$var$Ue), this.deadClicksAutocapture.startIfEnabled(), this.historyAutocapture = new $e444d6404c095fa5$var$We(this), this.historyAutocapture.startIfEnabled(), $e444d6404c095fa5$var$c.DEBUG = $e444d6404c095fa5$var$c.DEBUG || this.config.debug, $e444d6404c095fa5$var$c.DEBUG && $e444d6404c095fa5$var$Pt.info("Starting in debug mode", {
            this: this,
            config: e,
            thisC: $e444d6404c095fa5$var$g({}, this.config),
            p: a,
            s: l
        }), void 0 !== (null == (n = e.bootstrap) ? void 0 : n.distinctID)) {
            var h, d, v = this.config.get_device_id($e444d6404c095fa5$var$xe()), f = null != (h = e.bootstrap) && h.isIdentifiedID ? v : e.bootstrap.distinctID;
            this.persistence.set_property($e444d6404c095fa5$var$ci, null != (d = e.bootstrap) && d.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: e.bootstrap.distinctID,
                $device_id: f
            });
        }
        if (this.Ir()) {
            var p, _, m = Object.keys((null == (p = e.bootstrap) ? void 0 : p.featureFlags) || {}).filter((t)=>{
                var i;
                return !(null == (i = e.bootstrap) || null == (i = i.featureFlags) || !i[t]);
            }).reduce((t, i)=>{
                var r;
                return t[i] = (null == (r = e.bootstrap) || null == (r = r.featureFlags) ? void 0 : r[i]) || !1, t;
            }, {}), y = Object.keys((null == (_ = e.bootstrap) ? void 0 : _.featureFlagPayloads) || {}).filter((t)=>m[t]).reduce((t, i)=>{
                var r, s;
                null != (r = e.bootstrap) && null != (r = r.featureFlagPayloads) && r[i] && (t[i] = null == (s = e.bootstrap) || null == (s = s.featureFlagPayloads) ? void 0 : s[i]);
                return t;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: m,
                featureFlagPayloads: y
            });
        }
        if (u) this.register_once({
            distinct_id: $e444d6404c095fa5$var$wi,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id($e444d6404c095fa5$var$xe());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property($e444d6404c095fa5$var$ci, "anonymous");
        }
        return $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), this.toolbar.maybeLoadToolbar(), e.segment ? $e444d6404c095fa5$var$Ve(this, ()=>this.Cr()) : this.Cr(), $e444d6404c095fa5$var$I(this.config._onCapture) && this.config._onCapture !== $e444d6404c095fa5$var$So && ($e444d6404c095fa5$var$Pt.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $e444d6404c095fa5$var$Pt.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this;
    }
    fi(t) {
        var i, e, r, s, n, a, l, u;
        if (!$e444d6404c095fa5$var$o || !$e444d6404c095fa5$var$o.body) return $e444d6404c095fa5$var$Pt.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.fi(t);
        }, 500);
        this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = $e444d6404c095fa5$var$w(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) ? $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS : $e444d6404c095fa5$var$w(t.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) ? $e444d6404c095fa5$export$6a00d17b5aff0af.Base64 : void 0), null != (i = t.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this.br ? this.br : "identified_only"
        }), null == (e = this.siteApps) || e.onRemoteConfig(t), null == (r = this.sessionRecording) || r.onRemoteConfig(t), null == (s = this.autocapture) || s.onRemoteConfig(t), null == (n = this.heatmaps) || n.onRemoteConfig(t), this.surveys.onRemoteConfig(t), null == (a = this.webVitalsAutocapture) || a.onRemoteConfig(t), null == (l = this.exceptionObserver) || l.onRemoteConfig(t), this.exceptions.onRemoteConfig(t), null == (u = this.deadClicksAutocapture) || u.onRemoteConfig(t);
    }
    Cr() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $e444d6404c095fa5$var$Pt.critical("`loaded` function failed", t);
        }
        this.Or(), this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || "always" === this.config.cookieless_mode) && this.Fr();
        }, 1), new $e444d6404c095fa5$var$Yn(this).load(), this.featureFlags.flags();
    }
    Or() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.Pr) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $e444d6404c095fa5$var$Ot(this.__request_queue, (t)=>this.Tr(t)), this.__request_queue = [], this.Or();
    }
    _handle_unload() {
        var t, i;
        this.config.request_batching ? (this.Mr() && this.capture("$pageleave"), null == (t = this.Pr) || t.unload(), null == (i = this.Rr) || i.unload()) : this.Mr() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    ci(t) {
        this.__loaded && ($e444d6404c095fa5$var$$o ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) || (t.transport = t.transport || this.config.api_transport, t.url = $e444d6404c095fa5$var$on(t.url, {
            ip: this.config.ip ? 1 : 0
        }), t.headers = $e444d6404c095fa5$var$g({}, this.config.request_headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, t.disableXHRCredentials = this.config.__preview_disable_xhr_credentials, this.config.__preview_disable_beacon && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var i, e, r, s = $e444d6404c095fa5$var$g({}, t);
            s.timeout = s.timeout || 6e4, s.url = $e444d6404c095fa5$var$on(s.url, {
                _: (new Date).getTime().toString(),
                ver: $e444d6404c095fa5$var$c.LIB_VERSION,
                compression: s.compression
            });
            var n = null !== (i = s.transport) && void 0 !== i ? i : "fetch", o = $e444d6404c095fa5$var$un.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), a = null !== (e = null == (r = $e444d6404c095fa5$var$Bt(o, (t)=>t.transport === n)) ? void 0 : r.method) && void 0 !== e ? e : o[0].method;
            if (!a) throw new Error("No available transport method");
            a(s);
        })($e444d6404c095fa5$var$g({}, t, {
            callback: (i)=>{
                var e, r;
                (this.rateLimiter.checkForLimiting(i), i.statusCode >= 400) && (null == (e = (r = this.config).on_request_error) || e.call(r, i));
                null == t.callback || t.callback(i);
            }
        }))));
    }
    Tr(t) {
        this.Rr ? this.Rr.retriableRequest(t) : this.ci(t);
    }
    _execute_array(t) {
        var i, e = [], r = [], s = [];
        $e444d6404c095fa5$var$Ot(t, (t)=>{
            t && (i = t[0], $e444d6404c095fa5$var$R(i) ? s.push(t) : $e444d6404c095fa5$var$I(t) ? t.call(this) : $e444d6404c095fa5$var$R(t) && "alias" === i ? e.push(t) : $e444d6404c095fa5$var$R(t) && -1 !== i.indexOf("capture") && $e444d6404c095fa5$var$I(this[i]) ? s.push(t) : r.push(t));
        });
        var n = function(t, i) {
            $e444d6404c095fa5$var$Ot(t, function(t) {
                if ($e444d6404c095fa5$var$R(t[0])) {
                    var e = i;
                    $e444d6404c095fa5$var$Ft(t, function(t) {
                        e = e[t[0]].apply(e, t.slice(1));
                    });
                } else this[t[0]].apply(this, t.slice(1));
            }, i);
        };
        n(e, this), n(r, this), n(s, this);
    }
    Ir() {
        var t, i;
        return (null == (t = this.config.bootstrap) ? void 0 : t.featureFlags) && Object.keys(null == (i = this.config.bootstrap) ? void 0 : i.featureFlags).length > 0 || !1;
    }
    push(t) {
        this._execute_array([
            t
        ]);
    }
    capture(t, i, e) {
        var r;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.Pr) {
            if (this.is_capturing()) {
                if (!$e444d6404c095fa5$var$F(t) && $e444d6404c095fa5$var$M(t)) {
                    var s = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!(s && !this.config.__preview_capture_bot_pageviews)) {
                        var n = null != e && e.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == n || !n.isRateLimited) {
                            null != i && i.$current_url && !$e444d6404c095fa5$var$M(null == i ? void 0 : i.$current_url) && ($e444d6404c095fa5$var$Pt.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == i || delete i.$current_url), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var o = new Date, a = (null == e ? void 0 : e.timestamp) || o, l = $e444d6404c095fa5$var$xe(), u = {
                                uuid: l,
                                event: t,
                                properties: this.calculateEventProperties(t, i || {}, a, l)
                            };
                            "$pageview" === t && this.config.__preview_capture_bot_pageviews && s && (u.event = "$bot_pageview", u.properties.$browser_type = "bot"), n && (u.properties.$lib_rate_limit_remaining_tokens = n.remainingTokens), (null == e ? void 0 : e.$set) && (u.$set = null == e ? void 0 : e.$set);
                            var h, d = this.Ar(null == e ? void 0 : e.$set_once);
                            if (d && (u.$set_once = d), (u = $e444d6404c095fa5$var$Ut(u, null != e && e._noTruncate ? null : this.config.properties_string_max_length)).timestamp = a, $e444d6404c095fa5$var$F(null == e ? void 0 : e.timestamp) || (u.properties.$event_time_override_provided = !0, u.properties.$event_time_override_system_time = o), t === $e444d6404c095fa5$export$9d7ec1793ca1658e.DISMISSED || t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT) {
                                var v = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ID], c = null == i ? void 0 : i[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ITERATION];
                                h = {
                                    id: v,
                                    current_iteration: c
                                }, localStorage.getItem($e444d6404c095fa5$var$Hn(h)) || localStorage.setItem($e444d6404c095fa5$var$Hn(h), "true"), u.$set = $e444d6404c095fa5$var$g({}, u.$set, {
                                    [$e444d6404c095fa5$var$zn({
                                        id: v,
                                        current_iteration: c
                                    }, t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed")]: !0
                                });
                            }
                            var f = $e444d6404c095fa5$var$g({}, u.properties.$set, u.$set);
                            if ($e444d6404c095fa5$var$O(f) || this.setPersonPropertiesForFlags(f), !$e444d6404c095fa5$var$j(this.config.before_send)) {
                                var p = this.Dr(u);
                                if (!p) return;
                                u = p;
                            }
                            this._r.emit("eventCaptured", u);
                            var _ = {
                                method: "POST",
                                url: null !== (r = null == e ? void 0 : e._url) && void 0 !== r ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: u,
                                compression: "best-available",
                                batchKey: null == e ? void 0 : e._batchKey
                            };
                            return !this.config.request_batching || e && (null == e || !e._batchKey) || null != e && e.send_instantly ? this.Tr(_) : this.Pr.enqueue(_), u;
                        }
                        $e444d6404c095fa5$var$Pt.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $e444d6404c095fa5$var$Pt.error("No event name provided to posthog.capture");
            }
        } else $e444d6404c095fa5$var$Pt.uninitializedWarning("posthog.capture");
    }
    Mi(t) {
        return this.on("eventCaptured", (i)=>t(i.event, i));
    }
    calculateEventProperties(t, i, e, r, s) {
        if (e = e || new Date, !this.persistence || !this.sessionPersistence) return i;
        var n = s ? void 0 : this.persistence.remove_event_timer(t), a = $e444d6404c095fa5$var$g({}, i);
        if (a.token = this.config.token, a.$config_defaults = this.config.defaults, ("always" == this.config.cookieless_mode || "on_reject" == this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) && (a.$cookieless_mode = !0), "$snapshot" === t) {
            var l = $e444d6404c095fa5$var$g({}, this.persistence.properties(), this.sessionPersistence.properties());
            return a.distinct_id = l.distinct_id, (!$e444d6404c095fa5$var$M(a.distinct_id) && !$e444d6404c095fa5$var$L(a.distinct_id) || $e444d6404c095fa5$var$A(a.distinct_id)) && $e444d6404c095fa5$var$Pt.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
        }
        var u, h = $e444d6404c095fa5$var$fs(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties);
        if (this.sessionManager) {
            var { sessionId: v, windowId: c } = this.sessionManager.checkAndGetSessionAndWindowId(s, e.getTime());
            a.$session_id = v, a.$window_id = c;
        }
        this.sessionPropsManager && $e444d6404c095fa5$var$Mt(a, this.sessionPropsManager.getSessionProps());
        try {
            var f;
            this.sessionRecording && $e444d6404c095fa5$var$Mt(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = null == (f = this.Rr) ? void 0 : f.length;
        } catch (t) {
            a.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $e444d6404c095fa5$var$ho.CUSTOM && (a.$lib_custom_api_host = this.config.api_host), u = "$pageview" !== t || s ? "$pageleave" !== t || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(e) : this.pageViewManager.doPageView(e, r), a = $e444d6404c095fa5$var$Mt(a, u), "$pageview" === t && $e444d6404c095fa5$var$o && (a.title = $e444d6404c095fa5$var$o.title), !$e444d6404c095fa5$var$F(n)) {
            var p = e.getTime() - n;
            a.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        $e444d6404c095fa5$var$d && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser"), (a = $e444d6404c095fa5$var$Mt({}, h, this.persistence.properties(), this.sessionPersistence.properties(), a)).$is_identified = this._isIdentified(), $e444d6404c095fa5$var$R(this.config.property_denylist) ? $e444d6404c095fa5$var$Ft(this.config.property_denylist, function(t) {
            delete a[t];
        }) : $e444d6404c095fa5$var$Pt.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var _ = this.config.sanitize_properties;
        _ && ($e444d6404c095fa5$var$Pt.error("sanitize_properties is deprecated. Use before_send instead"), a = _(a, t));
        var m = this.jr();
        return a.$process_person_profile = m, m && !s && this.Lr("_calculate_event_properties"), a;
    }
    Ar(t) {
        var i;
        if (!this.persistence || !this.jr()) return t;
        if (this.gr) return t;
        var e = this.persistence.get_initial_props(), r = null == (i = this.sessionPropsManager) ? void 0 : i.getSetOnceProps(), s = $e444d6404c095fa5$var$Mt({}, e, r || {}, t || {}), n = this.config.sanitize_properties;
        return n && ($e444d6404c095fa5$var$Pt.error("sanitize_properties is deprecated. Use before_send instead"), s = n(s, "$set_once")), this.gr = !0, $e444d6404c095fa5$var$O(s) ? void 0 : s;
    }
    register(t, i) {
        var e;
        null == (e = this.persistence) || e.register(t, i);
    }
    register_once(t, i, e) {
        var r;
        null == (r = this.persistence) || r.register_once(t, i, e);
    }
    register_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.register(t);
    }
    unregister(t) {
        var i;
        null == (i = this.persistence) || i.unregister(t);
    }
    unregister_for_session(t) {
        var i;
        null == (i = this.sessionPersistence) || i.unregister(t);
    }
    Nr(t, i) {
        this.register({
            [t]: i
        });
    }
    getFeatureFlag(t, i) {
        return this.featureFlags.getFeatureFlag(t, i);
    }
    getFeatureFlagPayload(t) {
        var i = this.featureFlags.getFeatureFlagPayload(t);
        try {
            return JSON.parse(i);
        } catch (t) {
            return i;
        }
    }
    isFeatureEnabled(t, i) {
        return this.featureFlags.isFeatureEnabled(t, i);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(t, i, e) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(t, i, e);
    }
    getEarlyAccessFeatures(t, i, e) {
        return void 0 === i && (i = !1), this.featureFlags.getEarlyAccessFeatures(t, i, e);
    }
    on(t, i) {
        return this._r.on(t, i);
    }
    onFeatureFlags(t) {
        return this.featureFlags.onFeatureFlags(t);
    }
    onSurveysLoaded(t) {
        return this.surveys.onSurveysLoaded(t);
    }
    onSessionId(t) {
        var i, e;
        return null !== (i = null == (e = this.sessionManager) ? void 0 : e.onSessionId(t)) && void 0 !== i ? i : ()=>{};
    }
    getSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getSurveys(t, i);
    }
    getActiveMatchingSurveys(t, i) {
        void 0 === i && (i = !1), this.surveys.getActiveMatchingSurveys(t, i);
    }
    renderSurvey(t, i) {
        this.surveys.renderSurvey(t, i);
    }
    displaySurvey(t, i) {
        void 0 === i && (i = $e444d6404c095fa5$var$qn), this.surveys.displaySurvey(t, i);
    }
    canRenderSurvey(t) {
        return this.surveys.canRenderSurvey(t);
    }
    canRenderSurveyAsync(t, i) {
        return void 0 === i && (i = !1), this.surveys.canRenderSurveyAsync(t, i);
    }
    identify(t, i, e) {
        if (!this.__loaded || !this.persistence) return $e444d6404c095fa5$var$Pt.uninitializedWarning("posthog.identify");
        if ($e444d6404c095fa5$var$L(t) && (t = t.toString(), $e444d6404c095fa5$var$Pt.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), t) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(t.toLowerCase())) $e444d6404c095fa5$var$Pt.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.');
            else if (t !== $e444d6404c095fa5$var$wi) {
                if (this.Lr("posthog.identify")) {
                    var r = this.get_distinct_id();
                    if (this.register({
                        $user_id: t
                    }), !this.get_property("$device_id")) {
                        var s = r;
                        this.register_once({
                            $had_persisted_distinct_id: !0,
                            $device_id: s
                        }, "");
                    }
                    t !== r && t !== this.get_property($e444d6404c095fa5$var$Gt) && (this.unregister($e444d6404c095fa5$var$Gt), this.register({
                        distinct_id: t
                    }));
                    var n = "anonymous" === (this.persistence.get_property($e444d6404c095fa5$var$ci) || "anonymous");
                    t !== r && n ? (this.persistence.set_property($e444d6404c095fa5$var$ci, "identified"), this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, e || {}, i || {}), !1), this.capture("$identify", {
                        distinct_id: t,
                        $anon_distinct_id: r
                    }, {
                        $set: i || {},
                        $set_once: e || {}
                    }), this.wr = $e444d6404c095fa5$var$dn(t, i, e), this.featureFlags.setAnonymousDistinctId(r)) : (i || e) && this.setPersonProperties(i, e), t !== r && (this.reloadFeatureFlags(), this.unregister($e444d6404c095fa5$var$vi));
                }
            } else $e444d6404c095fa5$var$Pt.critical('The string "' + $e444d6404c095fa5$var$wi + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.');
        } else $e444d6404c095fa5$var$Pt.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(t, i) {
        if ((t || i) && this.Lr("posthog.setPersonProperties")) {
            var e = $e444d6404c095fa5$var$dn(this.get_distinct_id(), t, i);
            this.wr !== e ? (this.setPersonPropertiesForFlags($e444d6404c095fa5$var$g({}, i || {}, t || {})), this.capture("$set", {
                $set: t || {},
                $set_once: i || {}
            }), this.wr = e) : $e444d6404c095fa5$var$Pt.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    group(t, i, e) {
        if (t && i) {
            if (this.Lr("posthog.group")) {
                var r = this.getGroups();
                r[t] !== i && this.resetGroupPropertiesForFlags(t), this.register({
                    $groups: $e444d6404c095fa5$var$g({}, r, {
                        [t]: i
                    })
                }), e && (this.capture("$groupidentify", {
                    $group_type: t,
                    $group_key: i,
                    $group_set: e
                }), this.setGroupPropertiesForFlags({
                    [t]: e
                })), r[t] === i || e || this.reloadFeatureFlags();
            }
        } else $e444d6404c095fa5$var$Pt.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.featureFlags.setPersonPropertiesForFlags(t, i);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(t, i) {
        void 0 === i && (i = !0), this.Lr("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(t, i);
    }
    resetGroupPropertiesForFlags(t) {
        this.featureFlags.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        var i, e, r, s;
        if ($e444d6404c095fa5$var$Pt.info("reset"), !this.__loaded) return $e444d6404c095fa5$var$Pt.uninitializedWarning("posthog.reset");
        var n = this.get_property("$device_id");
        if (this.consent.reset(), null == (i = this.persistence) || i.clear(), null == (e = this.sessionPersistence) || e.clear(), this.surveys.reset(), this.featureFlags.reset(), null == (r = this.persistence) || r.set_property($e444d6404c095fa5$var$ci, "anonymous"), null == (s = this.sessionManager) || s.resetSessionId(), this.wr = null, "always" === this.config.cookieless_mode) this.register_once({
            distinct_id: $e444d6404c095fa5$var$wi,
            $device_id: null
        }, "");
        else {
            var o = this.config.get_device_id($e444d6404c095fa5$var$xe());
            this.register_once({
                distinct_id: o,
                $device_id: t ? o : n
            }, "");
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1);
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, i;
        return null !== (t = null == (i = this.sessionManager) ? void 0 : i.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var { sessionId: i, sessionStartTimestamp: e } = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + i);
        if (null != t && t.withTimestamp && e) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!e) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - e) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, i) {
        return t === this.get_property($e444d6404c095fa5$var$Wt) ? ($e444d6404c095fa5$var$Pt.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Lr("posthog.alias") ? ($e444d6404c095fa5$var$F(i) && (i = this.get_distinct_id()), t !== i ? (this.Nr($e444d6404c095fa5$var$Gt, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: i
        })) : ($e444d6404c095fa5$var$Pt.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var i = $e444d6404c095fa5$var$g({}, this.config);
        if ($e444d6404c095fa5$var$C(t)) {
            var e, r, s, n, o;
            $e444d6404c095fa5$var$Mt(this.config, $e444d6404c095fa5$var$Po(t));
            var a = this.kr();
            null == (e = this.persistence) || e.update_config(this.config, i, a), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Pn($e444d6404c095fa5$var$g({}, this.config, {
                persistence: "sessionStorage"
            }), a);
            var l = this.Sr(this.config.debug);
            $e444d6404c095fa5$var$N(l) && (this.config.debug = l), $e444d6404c095fa5$var$N(this.config.debug) && (this.config.debug ? ($e444d6404c095fa5$var$c.DEBUG = !0, $e444d6404c095fa5$var$Re.H() && $e444d6404c095fa5$var$Re.G("ph_debug", "true"), $e444d6404c095fa5$var$Pt.info("set_config", {
                config: t,
                oldConfig: i,
                newConfig: $e444d6404c095fa5$var$g({}, this.config)
            })) : ($e444d6404c095fa5$var$c.DEBUG = !1, $e444d6404c095fa5$var$Re.H() && $e444d6404c095fa5$var$Re.V("ph_debug"))), null == (r = this.sessionRecording) || r.startIfEnabledOrStop(), null == (s = this.autocapture) || s.startIfEnabled(), null == (n = this.heatmaps) || n.startIfEnabled(), this.surveys.loadIfEnabled(), this.Ur(), null == (o = this.externalIntegrations) || o.startIfEnabledOrStop();
        }
    }
    startSessionRecording(t) {
        var i = !0 === t, e = {
            sampling: i || !(null == t || !t.sampling),
            linked_flag: i || !(null == t || !t.linked_flag),
            url_trigger: i || !(null == t || !t.url_trigger),
            event_trigger: i || !(null == t || !t.event_trigger)
        };
        if (Object.values(e).some(Boolean)) {
            var r, s, n, o, a;
            if (null == (r = this.sessionManager) || r.checkAndGetSessionAndWindowId(), e.sampling) null == (s = this.sessionRecording) || s.overrideSampling();
            if (e.linked_flag) null == (n = this.sessionRecording) || n.overrideLinkedFlag();
            if (e.url_trigger) null == (o = this.sessionRecording) || o.overrideTrigger("url");
            if (e.event_trigger) null == (a = this.sessionRecording) || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, i) {
        var e = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
            handled: !0,
            syntheticException: e
        });
        return this.exceptions.sendExceptionEvent($e444d6404c095fa5$var$g({}, r, i));
    }
    loadToolbar(t) {
        return this.toolbar.loadToolbar(t);
    }
    get_property(t) {
        var i;
        return null == (i = this.persistence) ? void 0 : i.props[t];
    }
    getSessionProperty(t) {
        var i;
        return null == (i = this.sessionPersistence) ? void 0 : i.props[t];
    }
    toString() {
        var t, i = null !== (t = this.config.name) && void 0 !== t ? t : $e444d6404c095fa5$var$Eo;
        return i !== $e444d6404c095fa5$var$Eo && (i = $e444d6404c095fa5$var$Eo + "." + i), i;
    }
    _isIdentified() {
        var t, i;
        return "identified" === (null == (t = this.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$ci)) || "identified" === (null == (i = this.sessionPersistence) ? void 0 : i.get_property($e444d6404c095fa5$var$ci));
    }
    jr() {
        var t, i;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && $e444d6404c095fa5$var$O(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$e444d6404c095fa5$var$Gt]) && (null == (i = this.persistence) || null == (i = i.props) || !i[$e444d6404c095fa5$var$yi]));
    }
    Mr() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.jr() || this.Lr("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    Lr(t) {
        return "never" === this.config.person_profiles ? ($e444d6404c095fa5$var$Pt.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Nr($e444d6404c095fa5$var$yi, !0), !0);
    }
    kr() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut(), i = this.config.opt_out_persistence_by_default || "on_reject" === this.config.cookieless_mode;
        return this.config.disable_persistence || t && !!i;
    }
    Ur() {
        var t, i, e, r, s = this.kr();
        (null == (t = this.persistence) ? void 0 : t.wi) !== s && (null == (e = this.persistence) || e.set_disabled(s));
        (null == (i = this.sessionPersistence) ? void 0 : i.wi) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s));
        return s;
    }
    opt_in_capturing(t) {
        if ("always" !== this.config.cookieless_mode) {
            var i, e;
            if ("on_reject" === this.config.cookieless_mode && this.consent.isExplicitlyOptedOut()) this.reset(!0), null == (i = this.sessionManager) || i.destroy(), this.sessionManager = new $e444d6404c095fa5$var$no(this), this.persistence && (this.sessionPropsManager = new $e444d6404c095fa5$var$ro(this, this.sessionManager, this.persistence)), this.sessionRecording = new $e444d6404c095fa5$var$wo(this), this.sessionRecording.startIfEnabledOrStop();
            if (this.consent.optInOut(!0), this.Ur(), this.Or(), "on_reject" == this.config.cookieless_mode && this.surveys.loadIfEnabled(), $e444d6404c095fa5$var$F(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) this.capture(null !== (e = null == t ? void 0 : t.captureEventName) && void 0 !== e ? e : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            });
            this.config.capture_pageview && this.Fr();
        } else $e444d6404c095fa5$var$Pt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    opt_out_capturing() {
        var t, i;
        "always" !== this.config.cookieless_mode ? ("on_reject" === this.config.cookieless_mode && this.consent.isOptedIn() && this.reset(!0), this.consent.optInOut(!1), this.Ur(), "on_reject" === this.config.cookieless_mode && (this.register({
            distinct_id: $e444d6404c095fa5$var$wi,
            $device_id: null
        }), null == (t = this.sessionManager) || t.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, null == (i = this.sessionRecording) || i.stopRecording(), this.sessionRecording = void 0, this.Fr())) : $e444d6404c095fa5$var$Pt.warn('Consent opt in/out is not valid with cookieless_mode="always" and will be ignored');
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return t === $e444d6404c095fa5$var$De.GRANTED ? "granted" : t === $e444d6404c095fa5$var$De.DENIED ? "denied" : "pending";
    }
    is_capturing() {
        return "always" === this.config.cookieless_mode || ("on_reject" === this.config.cookieless_mode ? this.consent.isExplicitlyOptedOut() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.Ur();
    }
    _is_bot() {
        return $e444d6404c095fa5$var$n ? $e444d6404c095fa5$var$uo($e444d6404c095fa5$var$n, this.config.custom_blocked_useragents) : void 0;
    }
    Fr() {
        $e444d6404c095fa5$var$o && ("visible" === $e444d6404c095fa5$var$o.visibilityState ? this.mr || (this.mr = !0, this.capture("$pageview", {
            title: $e444d6404c095fa5$var$o.title
        }, {
            send_instantly: !0
        }), this.yr && ($e444d6404c095fa5$var$o.removeEventListener("visibilitychange", this.yr), this.yr = null)) : this.yr || (this.yr = this.Fr.bind(this), $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "visibilitychange", this.yr)));
    }
    debug(i) {
        !1 === i ? (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    M() {
        var t, i, e, r, s, n, o, a = this.Er || {};
        return "advanced_disable_flags" in a ? !!a.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($e444d6404c095fa5$var$Pt.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (e = "advanced_disable_decide", r = !1, s = $e444d6404c095fa5$var$Pt, n = (i = "advanced_disable_flags") in (t = a) && !$e444d6404c095fa5$var$F(t[i]), o = e in t && !$e444d6404c095fa5$var$F(t[e]), n ? t[i] : o ? (s && s.warn("Config field '" + e + "' is deprecated. Please use '" + i + "' instead. The old field will be removed in a future major version."), t[e]) : r);
    }
    Dr(t) {
        if ($e444d6404c095fa5$var$j(this.config.before_send)) return t;
        var i = $e444d6404c095fa5$var$R(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], e = t;
        for (var r of i){
            if (e = r(e), $e444d6404c095fa5$var$j(e)) {
                var s = "Event '" + t.event + "' was rejected in beforeSend function";
                return $e444d6404c095fa5$var$z(t.event) ? $e444d6404c095fa5$var$Pt.warn(s + ". This can cause unexpected behavior.") : $e444d6404c095fa5$var$Pt.info(s), null;
            }
            e.properties && !$e444d6404c095fa5$var$O(e.properties) || $e444d6404c095fa5$var$Pt.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        return e;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.Vt) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, i) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: i
        });
    }
    captureTraceMetric(t, i, e) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: i,
            $ai_metric_value: String(e)
        });
    }
    Sr(t) {
        var i = $e444d6404c095fa5$var$N(t) && !t, e = $e444d6404c095fa5$var$Re.H() && "true" === $e444d6404c095fa5$var$Re.q("ph_debug");
        return !i && (!!e || t);
    }
}
!function(t, i) {
    for(var e = 0; e < i.length; e++)t.prototype[i[e]] = $e444d6404c095fa5$var$Lt(t.prototype[i[e]]);
}($e444d6404c095fa5$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $e444d6404c095fa5$var$Io, $e444d6404c095fa5$export$2e2bcd8739ae039 = ($e444d6404c095fa5$var$Io = $e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$Eo] = new $e444d6404c095fa5$export$a9d6b9cbf49b8241, function() {
    function i() {
        i.done || (i.done = !0, $e444d6404c095fa5$var$$o = !1, $e444d6404c095fa5$var$Ft($e444d6404c095fa5$var$xo, function(t) {
            t._dom_loaded();
        }));
    }
    null != $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$o.addEventListener ? "complete" === $e444d6404c095fa5$var$o.readyState ? i() : $e444d6404c095fa5$var$qt($e444d6404c095fa5$var$o, "DOMContentLoaded", i, {
        capture: !1
    }) : $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$Pt.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
}(), $e444d6404c095fa5$var$Io);


const $00eb9133a5a9a95d$var$sheet = new CSSStyleSheet();
$00eb9133a5a9a95d$var$sheet.replaceSync(String($0346d3bbf80d0cab$exports));
const $00eb9133a5a9a95d$var$DEFAULT_DPI = 300;
const $00eb9133a5a9a95d$var$IMAGE_TYPES_WITH_TRANSPARENT_BACKGROUND = [
    'png',
    'svg',
    'webp'
];
class $00eb9133a5a9a95d$export$2e2bcd8739ae039 extends HTMLElement {
    dialog;
    elements;
    units;
    customDimensions;
    dimensions;
    margin;
    patternAspectRatio = 1;
    currentSize;
    currentPattern;
    unitFloatingPointsPrecision = 0;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $00eb9133a5a9a95d$var$sheet
        ];
        this.shadowRoot.innerHTML = String($7daf604df182e360$exports);
        this.dialog = shadow.querySelector('confirm-dialog');
        this.elements = {
            size: shadow.querySelector('#size'),
            form: shadow.querySelector('form'),
            unitSelect: shadow.querySelectorAll('.unit-select'),
            dpi: shadow.querySelector('#dpi'),
            dpiBlock: shadow.querySelector('#dpi_block'),
            renderNumbersBlock: shadow.querySelector('#render_numbers_block'),
            patternDimensions: shadow.querySelector('#pattern_size'),
            imageDimensions: shadow.querySelector('#image_dimensions'),
            margin: shadow.querySelector('#margin'),
            canvas: shadow.querySelector('#canvas'),
            transparentBackground: shadow.querySelector('#transparent_background'),
            rotateBtn: shadow.querySelector('#rotate_btn')
        };
        this.#setSizes();
        this.setSize((0, $9ecbf20527c60613$export$1ddaf6ceff5ce8d6)[0].id);
        (0, $37ffe584ad149ed5$export$2e2bcd8739ae039).addEventListener('unitsChange', (units)=>{
            if (this.units !== 'px') this.setUnits(units);
        });
        shadow.addEventListener('focusin', (e)=>{
            if (e.target instanceof HTMLInputElement && (e.target.type === 'text' || e.target.type === 'number')) e.target.select();
        });
        shadow.addEventListener('change', (e)=>{
            if (e.target instanceof HTMLSelectElement && e.target.classList.contains('unit-select')) this.setUnits(e.target.value);
            if (e.target === this.elements.size) this.setSize(this.elements.size.value);
            if (e.target instanceof HTMLInputElement && e.target.type === 'radio' && e.target.name === 'type') {
                const selectedType = this.elements.form.querySelector('input[name="type"]:checked')?.value;
                this.setType(selectedType);
            }
            if (e.target instanceof HTMLElement && e.target.dataset.updatesPreview != null) this.updatePreview();
            if (e.target instanceof HTMLSelectElement && e.target.id === 'format') this.setImageType(e.target.value);
        });
        this.elements.margin.addEventListener('input', (e)=>{
            const value = Number(e.target.value);
            this.setMargin(isNaN(value) ? 0 : value);
        });
        this.elements.imageDimensions.addEventListener('dimensionchange', ({ detail: { dimension: dimension, value: dimensions, ...size } })=>{
            const value = size[dimension];
            if (this.customDimensions) {
                this.customDimensions = dimensions;
                this.setDimensions(dimensions);
                this.elements.patternDimensions.setMaxDimensions(dimensions);
                this.elements.patternDimensions[dimension] = value - this.margin * 2;
            }
            this.updatePreview();
        });
        this.elements.patternDimensions.addEventListener('dimensionchange', ({ detail: { dimension: dimension, value: dimensions, ...size } })=>{
            const value = size[dimension];
            if (this.dimensions) this.setMargin(this.dimensions[dimension === 'width' ? 0 : 1] - value, {
                updatePatternDimensions: false
            });
        });
        this.elements.rotateBtn.addEventListener('click', ()=>this.rotateImage());
    }
    setType(type, updatePreview = true) {
        this.shadowRoot.querySelector(`#type_${type}`).checked = true;
        this.#toggleNailNumbers(type === 'nails_map');
        if (updatePreview) this.updatePreview();
    }
    setImageType(imageType) {
        this.shadowRoot.querySelector('#format').value = imageType;
        (0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(this.elements.transparentBackground, !$00eb9133a5a9a95d$var$IMAGE_TYPES_WITH_TRANSPARENT_BACKGROUND.includes(imageType));
    }
    getFormValues() {
        const data = new FormData(this.elements.form);
        return Object.fromEntries(data.entries());
    }
    get isTransparentBackground() {
        const formValues = this.getFormValues();
        return $00eb9133a5a9a95d$var$IMAGE_TYPES_WITH_TRANSPARENT_BACKGROUND.includes(String(formValues.format)) && formValues.transparent_background === 'on';
    }
    #setSizes() {
        this.elements.size.innerHTML = (0, $9ecbf20527c60613$export$1ddaf6ceff5ce8d6).map(({ id: id, name: name })=>`<option value="${id}">${name ?? id}</option>`).join('\n');
    }
    #toggleNailNumbers(show) {
        (0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(this.elements.renderNumbersBlock, !show);
    }
    get dpi() {
        return Number(this.elements.dpi.value ?? $00eb9133a5a9a95d$var$DEFAULT_DPI);
    }
    rotateImage() {
        this.setDimensions(this.#swapDimensions(this.dimensions));
    }
    setUnits(units, updatePreview = true) {
        if (units === this.units) return;
        const prevUnits = this.units;
        this.units = units;
        this.elements.unitSelect.forEach((unitSelect)=>{
            unitSelect.value = units;
        });
        this.unitFloatingPointsPrecision = units === 'px' ? 0 : 1;
        if (units === 'cm' || units === 'inch') {
            (0, $37ffe584ad149ed5$export$2e2bcd8739ae039).setUserPreferredUnits(units);
            (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(this.elements.dpiBlock);
        } else (0, $8d5cef8e7fea78a8$export$fe8985bb6374093c)(this.elements.dpiBlock);
        this.elements.patternDimensions.setFloatingPoints(this.unitFloatingPointsPrecision);
        this.elements.imageDimensions.setFloatingPoints(this.unitFloatingPointsPrecision);
        // If changing from length unit to px or vice-versa, need to convert dimensions
        if (prevUnits) {
            if (this.dimensions) this.dimensions = (0, $b683a3137b30eaa9$export$2e7f3602dd2acd76)(this.dimensions, prevUnits, units, this.dpi);
            if (this.margin) this.setMargin((0, $b683a3137b30eaa9$export$6625f4a88a935670)(this.margin, prevUnits, units, this.dpi));
        }
        if (this.dimensions) this.setDimensions(this.dimensions, updatePreview);
    }
    getMarginMax() {
        if (this.dimensions) return Math.min(this.dimensions[0] / 2.1, this.dimensions[1] / 2.1);
        return null;
    }
    setMargin(margin, { updatePatternDimensions: updatePatternDimensions = true, updatePreview: updatePreview = true } = {}) {
        margin = Math.max(margin, 0);
        if (this.dimensions) margin = Math.min(margin, this.getMarginMax());
        if (margin === this.margin) return;
        this.margin = margin ?? 0;
        this.elements.margin.value = String(margin.toFixedPrecision(this.unitFloatingPointsPrecision) ?? 0);
        if (updatePatternDimensions && this.dimensions) this.updatePatternDimensions();
        if (updatePreview) this.updatePreview();
    }
    setSize(id, updatePreview = true) {
        const size = (0, $9ecbf20527c60613$export$1c29b97c038fa375)(id);
        this.currentSize = size;
        const { units: units, dimensions: sizeDimensions, aspectRatio: aspectRatio, allowSizeEdit: allowSizeEdit, defaultUnits: defaultUnits, inUnits: inUnits, defaultMargin: defaultMargin = 0, allowRotate: allowRotate } = size;
        this.elements.imageDimensions.aspectRatio = aspectRatio instanceof Function ? aspectRatio({
            patternAspectRatio: this.patternAspectRatio
        }) : aspectRatio;
        let dimensions = sizeDimensions instanceof Function ? sizeDimensions({
            customDimensions: this.customDimensions,
            currentDimensions: this.dimensions,
            patternAspectRatio: this.patternAspectRatio
        }) : sizeDimensions;
        if (allowSizeEdit) {
            this.elements.imageDimensions.isReadonly = false;
            this.customDimensions = dimensions;
        } else this.elements.imageDimensions.isReadonly = true;
        (0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(this.elements.rotateBtn, !allowRotate);
        const isPixelsOnly = units && units.length === 1 && units[0] === 'px';
        this.togglePixels(!units || units.includes('px'));
        this.setPixelsOnly(isPixelsOnly);
        const newUnits = defaultUnits ?? (isPixelsOnly ? 'px' : units && !units.includes(this.units) ? (0, $37ffe584ad149ed5$export$2e2bcd8739ae039).getUserPreferredUnits() : this.units);
        this.setUnits(newUnits);
        if (inUnits && inUnits !== newUnits) dimensions = (0, $b683a3137b30eaa9$export$c566af9defc62c6)((0, $b683a3137b30eaa9$export$2e7f3602dd2acd76)(dimensions, inUnits, newUnits, this.dpi), (v)=>v.toFixedPrecision(1));
        if (defaultMargin) this.setMargin(defaultMargin);
        this.setDimensions(dimensions, updatePreview);
        if (updatePreview) this.updatePreview();
        this.elements.size.value = id;
    }
    togglePixels(showPixels) {
        this.elements.unitSelect.forEach((el)=>{
            const pixelsOption = el.querySelector('[value="px"]');
            (0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(pixelsOption, !showPixels);
        });
    }
    #getDimensionsBySizeId(id) {
        const { dimensions: dimensions } = (0, $9ecbf20527c60613$export$1c29b97c038fa375)(id);
        return dimensions instanceof Function ? dimensions({
            customDimensions: this.customDimensions,
            currentDimensions: this.dimensions,
            patternAspectRatio: this.patternAspectRatio
        }) : dimensions;
    }
    setPixelsOnly(isPixelsOnly) {
        if (isPixelsOnly) this.togglePixels(true);
        this.elements.unitSelect.forEach((el)=>{
            if (isPixelsOnly) el.setAttribute('disabled', 'disabled');
            else el.removeAttribute('disabled');
            const nonPixelOptions = el.querySelectorAll(':not([value="px"])');
            nonPixelOptions.forEach((option)=>(0, $8d5cef8e7fea78a8$export$1a3b688c8bc0de17)(option, isPixelsOnly));
        });
    }
    setDimensions(dimensions, updatePreview = true) {
        this.dimensions = dimensions;
        this.elements.imageDimensions.width = dimensions[0];
        this.elements.imageDimensions.height = dimensions[1];
        this.elements.canvas.style.removeProperty('width');
        this.elements.canvas.style.removeProperty('height');
        this.elements.margin.setAttribute('max', String(this.getMarginMax()));
        this.updatePatternDimensions();
        if (updatePreview) this.updatePreview();
    }
    updatePatternDimensions() {
        const patternDimensions = this.#getPatternDimensions();
        this.elements.patternDimensions.maxWidth = this.dimensions[0];
        this.elements.patternDimensions.maxHeight = this.dimensions[1];
        this.elements.patternDimensions.width = patternDimensions[0];
        this.elements.patternDimensions.height = patternDimensions[1];
    }
    #getPatternDimensions() {
        const width = this.dimensions[0] - this.margin * 2;
        const patternAvailableDimensions = (0, $b683a3137b30eaa9$export$c566af9defc62c6)(this.dimensions, (v)=>v - this.margin * 2);
        if (!this.patternAspectRatio || isNaN(this.patternAspectRatio)) return patternAvailableDimensions;
        const patternDimensions = [
            width,
            width / this.patternAspectRatio
        ];
        return (0, $b683a3137b30eaa9$export$18c295d7a6a8189d)(patternDimensions, (0, $b683a3137b30eaa9$export$c566af9defc62c6)(this.dimensions, (v)=>v - this.margin * 2));
    }
    #swapDimensions(dimensions) {
        return [
            dimensions[1],
            dimensions[0]
        ];
    }
    close() {
        this.dialog.close();
    }
    /**
   * Opens the dialog, optionally with an initial value.
   */ async show(pattern) {
        this.currentPattern = pattern;
        this.patternAspectRatio = pattern.getAspectRatio({
            size: this.dimensions
        });
        this.elements.patternDimensions.setAttribute('aspect-ratio', String(this.patternAspectRatio));
        this.setSize(this.currentSize.id);
        return this.dialog.show(()=>{
            const savedDownloadOptions = (0, $00643d12b3a54506$export$2e2bcd8739ae039).getPatternDownloadData(pattern.id);
            this.setDownloadOptionsToForm(savedDownloadOptions);
        }).then(async ()=>{
            const values = this.getFormValues();
            const downloadOptions = this.#formValuesToDownloadOptions(values, pattern);
            (0, $00643d12b3a54506$export$2e2bcd8739ae039).savePatternDownloadData(pattern.id, downloadOptions);
            await (0, $b7266296a7c0118e$export$ef63c67b3e1358f7)(pattern, downloadOptions);
            (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture('download', {
                pattern: pattern.type,
                isTemplate: pattern.isTemplate,
                ...downloadOptions
            });
        });
    }
    #formValuesToDownloadOptions(values, pattern) {
        const isNailsMap = values.type === 'nails_map';
        let dimensions = this.#getDimensionsBySizeId(values.size);
        if (values.rotate_image) dimensions = this.#swapDimensions(dimensions);
        const options = {
            size: dimensions,
            type: values.format === 'svg' ? 'svg' : 'canvas',
            imageType: values.format === 'svg' ? null : values.format,
            isNailsMap: isNailsMap,
            units: values.unit ?? 'px',
            dpi: Number(values.dpi),
            margin: Number(values.margin),
            includeNailNumbers: isNailsMap && values.render_numbers === 'on',
            filename: isNailsMap ? `${pattern.name} - nail map` : pattern.name,
            enableBackground: !this.isTransparentBackground,
            sizeId: String(values.size),
            isRotated: !!values.rotate_image
        };
        return options;
    }
    /**
   * Used when loading saved download options, to populate the form and internals
   * @param downloadOptions
   */ setDownloadOptionsToForm(downloadOptions) {
        if (!downloadOptions) {
            const size = (0, $9ecbf20527c60613$export$1ddaf6ceff5ce8d6)[0];
            downloadOptions = {
                size: size.dimensions instanceof Function ? size.dimensions({
                    patternAspectRatio: this.patternAspectRatio
                }) : size.dimensions,
                sizeId: size.id,
                margin: size.defaultMargin,
                units: size.defaultUnits,
                enableBackground: true
            };
        }
        this.setType(downloadOptions.isNailsMap ? 'nails_map' : 'all', false);
        this.#toggleNailNumbers(downloadOptions.isNailsMap);
        this.shadowRoot.querySelector('#render_numbers').value = downloadOptions.includeNailNumbers === true;
        const sizeId = downloadOptions.sizeId ?? 'custom';
        this.setSize(sizeId, false);
        const isRotated = downloadOptions.isRotated === true;
        this.shadowRoot.querySelector('#rotate_image').checked = isRotated;
        if (isRotated) this.rotateImage();
        if (downloadOptions.units != null) this.setUnits(downloadOptions.units, false);
        this.setMargin(downloadOptions.margin ?? 0, {
            updatePreview: false
        });
        // const { size } = downloadOptions;
        // if (getDownloadImageSizeById(sizeId).allowSizeEdit) {
        //   this.customDimensions = size;
        //   this.setDimensions(size, false);
        // }
        this.elements.dpi.value = String(downloadOptions.dpi ?? $00eb9133a5a9a95d$var$DEFAULT_DPI);
        this.setImageType(downloadOptions.imageType ?? 'png');
        this.shadowRoot.querySelector('#transparent_background').value = !downloadOptions.enableBackground;
        this.updatePreview();
    }
    updatePreview() {
        if (!this.currentPattern || !this.elements.canvas.clientWidth) return;
        this.elements.canvas.innerHTML = '';
        const dimensionsInPx = (0, $b683a3137b30eaa9$export$2e7f3602dd2acd76)(this.dimensions, this.units, 'px', this.dpi);
        if (this.elements.canvas.clientWidth) {
            const pxDimensions = (0, $b683a3137b30eaa9$export$18c295d7a6a8189d)(dimensionsInPx, [
                this.elements.canvas.clientWidth || 200,
                this.elements.canvas.clientHeight || 300
            ]);
            this.elements.canvas.style.width = pxDimensions[0] + 'px';
            this.elements.canvas.style.height = pxDimensions[1] + 'px';
        }
        const renderer = new (0, $2f2e0bbe9a3a6970$export$2e2bcd8739ae039)(this.elements.canvas, {
            updateOnResize: false
        });
        const previewSize = [
            this.elements.canvas.clientWidth || 200,
            this.elements.canvas.clientHeight || 300
        ];
        renderer.setFixedSize(previewSize);
        const previewPattern = this.currentPattern.copy();
        const values = this.getFormValues();
        previewPattern.assignConfig(values.type === 'nails_map' ? {
            darkMode: false,
            showNails: true,
            showNailNumbers: values.render_numbers === 'on',
            showStrings: false,
            nailsColor: '#000000',
            backgroundColor: '#ffffff',
            enableBackground: !this.isTransparentBackground
        } : {
            enableBackground: !this.isTransparentBackground,
            showNailNumbers: false,
            showStrings: true
        });
        const previewSizeRatio = previewSize[0] / dimensionsInPx[0];
        previewPattern.assignConfig({
            margin: Math.floor(this.margin * previewSizeRatio),
            nailRadius: Math.max(0.5, this.currentPattern.config.nailRadius * previewSizeRatio)
        });
        previewPattern.draw(renderer);
    }
}
customElements.define('download-dialog', $00eb9133a5a9a95d$export$2e2bcd8739ae039);


var $0159abe7f0ed534e$exports = {};
$0159abe7f0ed534e$exports = ".hidden{display:none}fieldset{border:none;margin:0 0 1.3em;padding:0}section:not(:last-child){margin-bottom:1em}fieldset:last-child{margin-bottom:0}fieldset>section{margin-top:.3em}.dialog-input{border:solid 1px var(--color-input);color:#fff;box-sizing:border-box;background:0 0;border-radius:4px;outline:none;height:32px!important;padding:4px 8px!important}.dialog-input-small{width:50px}.dialog-input-tall{width:100%;font-size:1.1em;height:50px!important}.dialog-input::selection{color:#000;background:#fff}.dialog-input:hover,.dialog-input:active,.dialog-input:focus-visible{border-color:var(--color-input-active)}.dialog-input:active,.dialog-input:focus-visible{background:#ffffff1a}.dialog-input option{color:#000;background-color:#fff}.row{flex-direction:row;align-items:center;display:flex}.dialog-lesser-select{color:#fffc;cursor:pointer;background:0 0;border:none;border-bottom:1px dotted #ffffff80;height:32px!important;padding:0!important}.dialog-lesser-select option{color:#000}.radio-list{border:solid 1px var(--color-input);box-sizing:border-box;border-radius:4px;align-items:center;width:fit-content;height:32px;padding:4px 8px;display:flex}.radio-list input[type=radio]{margin:0 4px 0 0}input[type=radio]+label{margin-bottom:0;display:inline-block}input[type=radio]+label:not(:last-child){margin-inline-end:1.5em}@font-face{font-family:string_art_studio;src:url(string_art_studio.9cced145.ttf)format(\"truetype\"),url(string_art_studio.44d13d52.woff)format(\"woff\"),url(string_art_studio.ae7f2e94.svg#string_art_studio)format(\"svg\");font-weight:400;font-style:normal;font-display:block}i{speak:never;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:normal;font-weight:400;line-height:1;font-family:string_art_studio!important}.icon-text:before{content:\"\"}.icon-step_back:before{content:\"\"}.icon-step_forward:before{content:\"\"}.icon-thread:before{content:\"\"}.icon-rotate:before{content:\"\"}.icon-pencil:before{content:\"\"}.icon-plus:before{content:\"\"}.icon-trash:before{content:\"\"}.icon-diskette_b:before{content:\"\"}.icon-diskette:before{content:\"\"}.icon-menu:before{content:\"\"}.icon-arrow_left:before{content:\"\"}.icon-arrow_right:before{content:\"\"}.icon-caret_down:before{content:\"\"}.icon-download:before{content:\"\"}.icon-fullscreen:before{content:\"\"}.icon-hamburger:before{content:\"\"}.icon-options:before{content:\"\"}.icon-pause:before{content:\"\"}.icon-play:before{content:\"\"}.icon-refresh:before{content:\"\"}.icon-share:before{content:\"\"}.icon-thumbnails:before{content:\"\"}.icon-x:before{content:\"\"}#buttons{grid-area:\"controls\";border-right:var(--border-light);background:var(--color-header);z-index:3;padding:0 var(--horizontal-padding);justify-content:space-evenly;align-items:center;display:flex;position:relative;box-shadow:0 -2px 6px #0000004d}#buttons .btn{margin:0}.btn{color:#fff;cursor:pointer;background:#0375fb;border:none;border-radius:15px;width:100%;height:30px;margin-bottom:8px}.btn:hover{background:#3592ff}.btn_subdued{color:#000;background:#c5c5c5}.btn_subdued:hover{color:#000;background:#efefef}.circular_btn{width:var(--controls-height);height:var(--controls-height);cursor:pointer;color:var(--color-text);background:0 0;border:none;justify-content:center;align-items:center;font-size:28px;display:flex}.circular_btn:hover{color:var(--color-text);background:#0000004d}.circular_btn img{width:18px;height:18px}.circular_btn.active{background:radial-gradient(circle at 50% 100%,#5205e7,#220c1b);padding:0;box-shadow:inset 0 4px 6px #0009}.circular_btn.active i{transform:scale(.95)}#buttons_dialogs{z-index:2;height:calc(100vh - var(--controls-height) - var(--select-height));width:100%;position:absolute;bottom:100%;overflow:hidden}.buttons_dialog{--buttons-dialog-border-radius:10px;bottom:var(--controls-height);z-index:1;background:var(--color-buttons-dialog);width:var(--sidebar-width);padding:var(--vertical-padding)var(--horizontal-padding);padding-top:calc(2*var(--buttons-dialog-border-radius));border-top:var(--border-light);transition:transform .2s ease-out;position:fixed;transform:translateY(100%);box-shadow:0 -2px 7px #000000b3}.buttons_dialog.open{transform:translateY(0)}.btn-icon{color:#fff;cursor:pointer;background:0 0;border:none;align-items:center;font-size:22px;display:flex}.menu_btn{background:var(--color-accent);height:48px;color:var(--color-text);border-radius:24px;align-items:center;padding:0 32px 0 24px;font-weight:500;text-decoration:none;display:inline-flex;font-size:1.1em!important}@media only screen and (width<=800px){.menu_btn{justify-content:center;width:auto;display:flex}}.menu_btn:hover{background:var(--color-accent-hover);color:var(--color-text);text-decoration:none}.menu_btn img{margin-inline-end:8px}.icon_btn{color:#fffc;cursor:pointer;background:0 0;border:none;border-radius:4px;padding:4px 6px;font-size:14px}.icon_btn:hover{color:#fff}.icon_btn>i{position:relative;top:1px}#wrapper{flex-direction:column;width:100%;height:90%;display:flex}form{flex:0}section{margin-bottom:1px}label:not(.icon_btn){margin-bottom:4px;display:block}input[type=checkbox]:checked+.icon_btn{color:#fff;background:#ffffff1a}h4{margin-bottom:0}hr{opacity:.2;position:relative;top:-.5em}#output{border:var(--border-light);background:var(--color-canvas-background);flex:1;max-height:30vh;padding:1em;overflow:auto}";


var $a7afb32b0b68a8ac$exports = {};
$a7afb32b0b68a8ac$exports = "<confirm-dialog dialog-title=\"Textual instructions\" submit=Download submit-icon=download centered description=\"The numbers are nail numbers, which can be printed with the nail positions. This output can also be used with other software, which is used to automatically create a string art project.\" width=640>\n  <div id=wrapper>\n    <form>\n      <hr>\n      <fieldset>\n        <label for=format>Output format</label>\n        <div class=radio-list>\n          <input type=radio name=format id=format_json value=json checked>\n          <label for=format_json>JSON</label>\n          <input type=radio name=format id=format_txt value=txt>\n          <label for=format_txt>Text</label>\n        </div>\n      </fieldset>\n\n      <fieldset>\n        <label for=color>Color format</label>\n        <div class=radio-list>\n          <input type=radio name=color id=color_rgb value=rgb checked>\n          <label for=color_rgb>RGB</label>\n          <input type=radio name=color id=color_hex value=hex>\n          <label for=color_hex>Hexadecimal</label>\n          <input type=radio name=color id=color_hsl value=hsl>\n          <label for=color_hsl>HSL</label>\n        </div>\n      </fieldset>\n      \n      \n    </form>\n    <h4>Ouput</h4>\n    <pre id=output></pre>\n  </div>\n</confirm-dialog>\n";






class $c4438e0c8b9ecc80$var$InstructionsController extends (0, $3c868d3c6cbc42ab$export$2e2bcd8739ae039) {
    pattern;
    layers;
    currentLayer;
    layerStart;
    constructor(renderer, pattern){
        super(renderer, new (0, $a2a2cf72b22d53bf$export$2e2bcd8739ae039)()), this.pattern = pattern, this.layers = [];
    }
    startLayer({ color: color }) {
        if (this.currentLayer?.color !== color) this.layers.push(this.currentLayer = {
            color: color,
            points: []
        });
        if (this.layerStart) {
            this.goto(...this.layerStart);
            this.layerStart = null;
        }
    }
    goto(nailKey, groupKey) {
        if (!this.currentLayer) {
            this.layerStart = [
                nailKey,
                groupKey
            ];
            return;
        }
        // If the current layer hasn't been started yet, there's no need to initialize the current layer
        if (this.currentLayer?.points.length) this.startLayer({
            color: this.currentLayer.color
        });
        this.currentLayer.points.push(this.pattern.getNailNumber(nailKey, groupKey));
    // const coordinates = this.nails.getNailCoordinates(nailKey, groupKey);
    //this.renderer.setStartingPoint(coordinates);
    }
    stringTo(nailKey, groupKey) {
        // this.renderer.lineTo(this.nails.getNailCoordinates(nailKey, groupKey));
        this.currentLayer.points.push(this.pattern.getNailNumber(nailKey, groupKey));
    }
}
const $c4438e0c8b9ecc80$var$DEFAULT_OPTIONS = {
    dimensions: [
        100,
        100
    ],
    includeNails: true
};
function $c4438e0c8b9ecc80$export$89b0fd24e5c904f9(pattern, options = {}) {
    const allOptions = Object.assign({}, $c4438e0c8b9ecc80$var$DEFAULT_OPTIONS, options);
    const renderer = new (0, $9ee6280c93a20bac$export$5d318302d9efabc7)(options.dimensions);
    const controller = new $c4438e0c8b9ecc80$var$InstructionsController(renderer, pattern);
    pattern.draw(renderer, {
        controller: controller
    });
    const instructions = {
        layers: controller.layers
    };
    if (allOptions.includeNails) instructions.nails = pattern.getNailsCoordinates();
    return instructions;
}


const $c9e1c460106a548b$var$hslRegExp = /^hsl\((\d{1,3}(?:\.\d+)?),\s?(\d{1,3}(?:\.\d+)?)%,\s?(\d{1,3}(?:\.\d+)?)%\)$/;
const $c9e1c460106a548b$var$rgbRegExp = /^rgb\((\d{1,3}),\s?(\d{1,3}),\s?(\d{1,3})\)$/;
const $c9e1c460106a548b$var$hexRegExp = /^#([0-9|a-f]{2})([0-9|a-f]{2})([0-9|a-f]{2})$/;
function $c9e1c460106a548b$export$abf11eb484a6bfbb(color, targetFormat) {
    const format = $c9e1c460106a548b$var$getColorFormat(color);
    if (format === targetFormat) return color;
    if (format === 'hsl') {
        const [_, h, s, l] = color.match($c9e1c460106a548b$var$hslRegExp);
        const rgb = $c9e1c460106a548b$var$hslToRgb(Number(h), Number(s), Number(l));
        return targetFormat === 'rgb' ? $c9e1c460106a548b$var$getRGBColorValue(rgb) : $c9e1c460106a548b$var$getHexColorValue(rgb);
    }
    const rgb = format === 'rgb' ? color.match($c9e1c460106a548b$var$rgbRegExp).splice(1).map((v)=>Number(v)) : color.match($c9e1c460106a548b$var$hexRegExp).slice(1).map((v)=>parseInt(v, 16));
    switch(targetFormat){
        case 'hsl':
            return $c9e1c460106a548b$var$getHSLColorValue($c9e1c460106a548b$var$rgbToHsl(rgb));
        case 'rgb':
            return $c9e1c460106a548b$var$getRGBColorValue(rgb);
        case 'hex':
            return $c9e1c460106a548b$var$getHexColorValue(rgb);
    }
}
function $c9e1c460106a548b$var$getRGBColorValue(rgb) {
    return `rgb(${rgb.join(', ')})`;
}
function $c9e1c460106a548b$var$getHSLColorValue([h, s, l]) {
    return `hsl(${h}, ${s}%, ${l}%)`;
}
function $c9e1c460106a548b$var$getHexColorValue(rgb) {
    return `#${rgb.map((v)=>v.toString(16).padStart(2, '0')).join('')}`;
}
function $c9e1c460106a548b$var$getColorFormat(color) {
    if ($c9e1c460106a548b$var$hslRegExp.test(color)) return 'hsl';
    if ($c9e1c460106a548b$var$rgbRegExp.test(color)) return 'rgb';
    if ($c9e1c460106a548b$var$hexRegExp.test(color)) return 'hex';
    throw new Error(`Unknown color format for "${color}"`);
}
function $c9e1c460106a548b$var$hslToRgb(h, s, l) {
    // normalize inputs
    h = (h % 360 + 360) % 360;
    s /= 100;
    l /= 100;
    if (s === 0) {
        // 0 saturation means grayscale, in which case just return the lightness
        const gray = Math.round(l * 255);
        return [
            gray,
            gray,
            gray
        ];
    }
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const hPrime = h / 60;
    const x = chroma * (1 - Math.abs(hPrime % 2 - 1));
    let r1 = 0, g1 = 0, b1 = 0;
    if (hPrime >= 0 && hPrime < 1) {
        r1 = chroma;
        g1 = x;
    } else if (hPrime < 2) {
        r1 = x;
        g1 = chroma;
    } else if (hPrime < 3) {
        g1 = chroma;
        b1 = x;
    } else if (hPrime < 4) {
        g1 = x;
        b1 = chroma;
    } else if (hPrime < 5) {
        r1 = x;
        b1 = chroma;
    } else {
        r1 = chroma;
        b1 = x;
    }
    const m = l - chroma / 2;
    return [
        Math.round((r1 + m) * 255),
        Math.round((g1 + m) * 255),
        Math.round((b1 + m) * 255)
    ];
}
function $c9e1c460106a548b$var$rgbToHsl([r, g, b]) {
    // normalize to [0,1]
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;
    let h = 0;
    let s = 0;
    const l = (max + min) / 2;
    if (delta !== 0) {
        // saturation
        s = delta / (1 - Math.abs(2 * l - 1));
        // hue
        switch(max){
            case r:
                h = (g - b) / delta % 6;
                break;
            case g:
                h = (b - r) / delta + 2;
                break;
            case b:
                h = (r - g) / delta + 4;
                break;
        }
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        Math.round(h),
        Math.round(s * 100),
        Math.round(l * 100)
    ];
}



const $e5347fe598f4e560$var$sheet = new CSSStyleSheet();
$e5347fe598f4e560$var$sheet.replaceSync(String($0159abe7f0ed534e$exports));
class $e5347fe598f4e560$export$2e2bcd8739ae039 extends HTMLElement {
    dialog;
    elements;
    currentPattern;
    formattedInstructions;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $e5347fe598f4e560$var$sheet
        ];
        this.shadowRoot.innerHTML = String($a7afb32b0b68a8ac$exports);
        this.dialog = shadow.querySelector('confirm-dialog');
        this.elements = {
            form: shadow.querySelector('form'),
            unitSelect: shadow.querySelectorAll('.unit-select'),
            output: shadow.querySelector('#output')
        };
        shadow.addEventListener('focusin', (e)=>{
            if (e.target instanceof HTMLInputElement && (e.target.type === 'text' || e.target.type === 'number')) e.target.select();
        });
        shadow.addEventListener('change', (e)=>{
            if (e.target instanceof HTMLElement) this.updatePreview();
        });
    }
    getFormValues() {
        const data = new FormData(this.elements.form);
        return Object.fromEntries(data.entries());
    }
    close() {
        this.dialog.close();
    }
    /**
   * Opens the dialog, optionally with an initial value.
   */ async show(pattern) {
        this.currentPattern = pattern;
        return this.dialog.show(()=>{
            const savedDownloadOptions = (0, $00643d12b3a54506$export$2e2bcd8739ae039).getPatternDownloadInstructionsData(pattern.id);
            this.setDownloadOptionsToForm(savedDownloadOptions);
            this.updatePreview();
        }).then(async ()=>{
            const values = this.getFormValues();
            const downloadOptions = this.#formValuesToDownloadOptions(values, pattern);
            (0, $00643d12b3a54506$export$2e2bcd8739ae039).savePatternDownloadInstructionsData(pattern.id, downloadOptions);
            (0, $b7266296a7c0118e$export$d7a1803f0e752f79)(this.formattedInstructions, `${pattern.name}.${downloadOptions.format === 'json' ? 'json' : 'txt'}`, downloadOptions.format === 'json' ? 'text/json' : 'text/plain');
        });
    }
    #formValuesToDownloadOptions(values, pattern) {
        const isNailsMap = values.type === 'nails_map';
        const options = {
            format: values.format === 'json' ? 'json' : 'txt',
            filename: isNailsMap ? `${pattern.name} - instructions` : pattern.name,
            includeNailPositions: true,
            includeInstructions: true,
            colorFormat: values.color
        };
        return options;
    }
    /**
   * Used when loading saved download options, to populate the form and internals
   * @param downloadOptions
   */ setDownloadOptionsToForm(downloadOptions) {
        if (!downloadOptions) downloadOptions = {
            format: 'json',
            includeNailPositions: true,
            includeInstructions: true,
            colorFormat: 'rgb'
        };
        this.setFormat(downloadOptions.format ?? 'json');
        this.setColorFormat(downloadOptions.colorFormat ?? 'rgb');
        this.updatePreview();
    }
    setFormat(format, updatePreview = true) {
        this.shadowRoot.querySelector(`#format_${format}`).checked = true;
        if (updatePreview) this.updatePreview();
    }
    setColorFormat(colorFormat, updatePreview = true) {
        this.shadowRoot.querySelector(`#color_${colorFormat}`).checked = true;
        if (updatePreview) this.updatePreview();
    }
    updatePreview() {
        const values = this.getFormValues();
        const downloadOptions = this.#formValuesToDownloadOptions(values, this.currentPattern);
        const instructions = (0, $c4438e0c8b9ecc80$export$89b0fd24e5c904f9)(this.currentPattern, {
            dimensions: [
                100,
                100
            ],
            includeNails: false
        });
        this.formattedInstructions = this.elements.output.innerHTML = this.formatInstructions(instructions, downloadOptions);
    }
    formatInstructions(instructions, options) {
        if (options.format === 'json') {
            const layers = instructions.layers.map((layer)=>({
                    color: (0, $c9e1c460106a548b$export$abf11eb484a6bfbb)(layer.color, options.colorFormat),
                    points: layer.points.join(', ')
                }));
            // const nails = instructions.nails.map(nail =>
            //   nail.map(v => roundNumber(v, 1)).join(', ')
            // );
            return JSON.stringify({
                layers: layers
            }, null, 2).replace(/\"points\": \"([\d\,\s]+)\"/g, `"points": [$1]`);
        } else return instructions.layers.map((layer)=>`${(0, $c9e1c460106a548b$export$abf11eb484a6bfbb)(layer.color, options.colorFormat)}\n${layer.points.join(', ')}`).join('\n\n');
    }
}
customElements.define('download-instructions-dialog', $e5347fe598f4e560$export$2e2bcd8739ae039);












class $1e47030bd2e0e155$export$2e2bcd8739ae039 extends (0, $00df09d341073864$export$2e2bcd8739ae039) {
    element;
    renderer;
    pattern;
    rendererType;
    cancelDraw;
    constructor(rendererType = 'canvas'){
        super();
        this.rendererType = rendererType;
        this.element = document.querySelector('#canvas_panel');
        this.element.addEventListener('wheel', ({ deltaY: deltaY })=>{
            const direction = -deltaY / Math.abs(deltaY); // Up is 1, down is -1
            this.emit('positionChange', {
                changeBy: direction
            });
        }, {
            passive: true
        });
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).addEventListener('showInstructionsChange', ({ showInstructions: showInstructions })=>{
            this.#withRenderer();
            if (showInstructions) this.renderer.showInstructions();
            else this.renderer.hideInstructions();
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('renderer', (rendererType)=>{
            this.rendererType = rendererType;
            this.renderer = null;
        });
    // Cancelling this for the moment, as it creates problems on mobile, when doing back with gestures:
    // this.#setTapEvents();
    }
    get position() {
        return this.pattern?.position ?? -1;
    }
    get size() {
        return [
            this.element.clientWidth,
            this.element.clientHeight
        ];
    }
    setSize(size) {
        this.#withRenderer();
        if (size) {
            if (!this.element.classList.contains('overflow')) this.element.classList.add('overflow');
            this.renderer.setFixedSize(size);
        } else {
            this.element.classList.remove('overflow');
            this.renderer.resetSize();
        }
    }
    getLastStringNailNumbers() {
        return this.pattern.getLastStringNailNumbers();
    }
    setRenderer(renderer) {
        this.renderer = renderer;
        renderer.addEventListener('sizeChange', ({ size: size })=>this.#updateOnSizeChange(size));
    }
    setPattern(pattern) {
        this.pattern = pattern;
        if (!pattern && this.renderer) this.renderer.clear();
    }
    #updateOnSizeChange(size) {
        if (size[0] && size[1]) this.pattern?.draw(this.renderer, {
            sizeChanged: true
        });
    }
    /**
   * Sets up click and touch events for the viewer
   */ #setTapEvents() {
        let timeout;
        this.element.addEventListener('pointerdown', ()=>{
            this.emit('click', null);
            const cancelTouch = ()=>{
                clearTimeout(timeout);
                this.element.removeEventListener('pointerup', cancelTouch);
            };
            timeout = setTimeout(()=>{
                this.element.removeEventListener('pointerup', cancelTouch);
                this.emit('touchStart', null);
                const end = ()=>{
                    this.emit('touchEnd', null);
                    this.element.removeEventListener('pointerup', end);
                };
                this.element.addEventListener('pointerup', end);
            }, 200);
            this.element.addEventListener('pointerup', cancelTouch);
        });
    }
    update(options) {
        (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions = false;
        this.#withRenderer();
        this.pattern?.draw(this.renderer, {
            ...options
        });
    }
    goto(position) {
        this.#withRenderer();
        this.pattern.goto(this.renderer, position, {
            showInstructions: (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions
        });
    }
    prev() {
        if (this.position === 0) return;
        this.pattern.goto(this.renderer, this.position - 1, {
            showInstructions: (0, $5082caf0e2beae35$export$2e2bcd8739ae039).showInstructions
        });
    }
    next() {
        return {
            done: this.pattern.drawNext().done
        };
    }
    getStepCount() {
        this.#withRenderer();
        return this.pattern.getStepCount({
            size: this.renderer.getSize()
        });
    }
    #withRenderer() {
        if (!this.renderer) {
            const RendererType = this.rendererType === 'svg' ? (0, $0649237e9259f2a7$export$2e2bcd8739ae039) : (0, $2f2e0bbe9a3a6970$export$2e2bcd8739ae039);
            this.setRenderer(new RendererType(this.element));
        }
    }
}







const $fc3e3d346052d3b6$var$DEFAULT_TARGET_SIZE_CM = [
    30,
    30
];
const $fc3e3d346052d3b6$var$DEFAULT_SIZES_CM = [
    20,
    30,
    40,
    50,
    60,
    70,
    80,
    90,
    100
];
let $fc3e3d346052d3b6$var$controller;
class $fc3e3d346052d3b6$var$Info {
    elements;
    targetSizeCm = $fc3e3d346052d3b6$var$DEFAULT_TARGET_SIZE_CM;
    pattern;
    lastSize;
    patternMargin;
    patternNailRadius;
    constructor(){
        this.elements = {
            infoPanel: document.querySelector('#info_panel'),
            nailsCount: document.querySelector('#nails_count'),
            threadsTotalLength: document.querySelector('#threads_total_length'),
            threadsPerColor: document.querySelector('#threads_per_color'),
            closestDistanceBetweenNails: document.querySelector('#closest_distance_between_nails'),
            dimensions: document.querySelector('#info_dimensions'),
            dimensionsSelect: document.querySelector('#info_dimensions_select')
        };
        this.elements.dimensions.addEventListener('dimensionchange', ({ detail: { value: dimensions } })=>{
            this.targetSizeCm = dimensions;
            if (this.pattern) this.update();
        });
        this.elements.dimensionsSelect.addEventListener('change', (e)=>{
            const value = Number(this.elements.dimensionsSelect.value);
            this.targetSizeCm = [
                value,
                value
            ];
            this.update();
        });
    }
    #setAvailableDimensions() {
        const aspectRatio = this.pattern.getAspectRatio({
            size: [
                100,
                100
            ]
        });
        const sizes = $fc3e3d346052d3b6$var$DEFAULT_SIZES_CM.map((v)=>aspectRatio >= 1 ? [
                v,
                Math.round(v / aspectRatio)
            ] : [
                Math.round(v * aspectRatio),
                v
            ]);
        this.elements.dimensionsSelect.innerHTML = sizes.map((size, i)=>`<option value="${$fc3e3d346052d3b6$var$DEFAULT_SIZES_CM[i]}">${size.join('x')} cm`).join('\n');
        this.elements.dimensionsSelect.value = this.targetSizeCm[0].toString();
    }
    setPattern(pattern, size) {
        this.pattern = pattern.copy();
        this.lastSize = size;
        this.patternMargin = pattern.config.margin;
        this.patternNailRadius = pattern.config.nailRadius;
        this.update();
        this.#setAvailableDimensions();
    }
    async update() {
        if (!this.pattern) throw new Error("Can't update info - no pattern.");
        $fc3e3d346052d3b6$var$controller?.abort();
        const fittedSize = (0, $b683a3137b30eaa9$export$18c295d7a6a8189d)(this.lastSize, this.targetSizeCm);
        const sizeRatio = Math.min(fittedSize[0] / this.lastSize[0], fittedSize[1] / this.lastSize[1]);
        this.pattern.assignConfig({
            margin: this.patternMargin * sizeRatio,
            nailRadius: this.patternNailRadius * sizeRatio
        });
        this.elements.dimensions.value = this.targetSizeCm;
        $fc3e3d346052d3b6$var$controller = new TaskController({
            priority: 'background'
        });
        const { nailsCount: nailsCount, threadsLength: threadsLength, closestDistanceBetweenNails: closestDistanceBetweenNails } = await scheduler.postTask(()=>this.getInfo(this.targetSizeCm), {
            signal: $fc3e3d346052d3b6$var$controller.signal
        });
        this.elements.nailsCount.textContent = nailsCount.toLocaleString();
        this.elements.threadsTotalLength.textContent = String(this.#threadLengthToDistance(threadsLength.total));
        this.elements.closestDistanceBetweenNails.textContent = String(this.#threadLengthToDistance(closestDistanceBetweenNails));
        this.elements.threadsPerColor.innerHTML = '';
        const maxColorLength = Math.max(...threadsLength.perColor.map(({ length: length })=>length));
        [
            ...threadsLength.perColor
        ].sort((a, b)=>b.length - a.length).forEach(({ color: color, length: length })=>{
            const colorEl = document.createElement('li');
            const colorValueEl = document.createElement('div');
            colorEl.appendChild(colorValueEl);
            colorValueEl.style.background = color;
            colorValueEl.className = 'info__thread_color_value';
            colorValueEl.style.width = `max(calc(${100 * length / maxColorLength}% - 70px), 6px)`;
            const colorValueDisplay = document.createElement('span');
            colorValueDisplay.innerText = this.#threadLengthToDistance(length);
            colorValueDisplay.className = 'info__thread_color_value_text';
            colorEl.appendChild(colorValueDisplay);
            this.elements.threadsPerColor.appendChild(colorEl);
        });
    }
    /**
   *
   * @param length Converts a pixel length unit to physical distance units
   */ #threadLengthToDistance(length, ratio = 1) {
        return (0, $b683a3137b30eaa9$export$deca72617c96d902)(length * ratio, 'cm');
    }
    getInfo(size) {
        const renderer = new (0, $fa5e071b86283164$export$f14c78f74247c3d)(size);
        this.pattern.draw(renderer, {
            sizeChanged: true,
            redrawStrings: true,
            redrawNails: true,
            precision: 100
        });
        return renderer.getInfo();
    }
}
const $fc3e3d346052d3b6$var$info = new $fc3e3d346052d3b6$var$Info();
var $fc3e3d346052d3b6$export$2e2bcd8739ae039 = $fc3e3d346052d3b6$var$info;


!function() {
    var t = [
        "user-blocking",
        "user-visible",
        "background"
    ];
    class i {
        constructor(){
            this.t = new MessageChannel, this.i = this.t.port2, this.l = {}, this.o = 1, this.t.port1.onmessage = (t)=>this.h(t);
        }
        u(t) {
            var i = this.o++;
            return this.l[i] = t, this.i.postMessage(i), i;
        }
        p(t) {
            delete this.l[t];
        }
        h(t) {
            var i = t.data;
            if (i in this.l) {
                var r = this.l[i];
                delete this.l[i], r();
            }
        }
    }
    function r() {
        return r.v || (r.v = new i), r.v;
    }
    class s {
        constructor(t, i, r){
            void 0 === r && (r = 0), this.k = t, this.T = null, this.C = null, this.m = !1, this._(i, r);
        }
        isIdleCallback() {
            return 0 === this.T;
        }
        I() {
            return 2 === this.T;
        }
        cancel() {
            if (!this.m) switch(this.m = !0, this.T){
                case 0:
                    cancelIdleCallback(this.C);
                    break;
                case 1:
                    clearTimeout(this.C);
                    break;
                case 2:
                    r().p(this.C);
                    break;
                default:
                    throw new TypeError("Unknown CallbackType");
            }
        }
        _(i, s) {
            if (s && s > 0) return this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            }, s));
            if (!t.includes(i)) throw new TypeError("Invalid task priority : " + i);
            return "background" === i && "function" == typeof requestIdleCallback ? (this.T = 0, void (this.C = requestIdleCallback(()=>{
                this.P();
            }))) : "function" == typeof MessageChannel ? (this.T = 2, void (this.C = r().u(()=>{
                this.P();
            }))) : (this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            })));
        }
        P() {
            this.m || this.k();
        }
    }
    var e = 0;
    class n {
        constructor(){
            this.j = null, this.M = null;
        }
        isEmpty() {
            return null == this.j;
        }
        push(t) {
            if ("object" != typeof t) throw new TypeError("Task must be an Object");
            t.A = e++, this.isEmpty() ? (t.N = null, this.j = t) : (t.N = this.M, this.M.O = t), t.O = null, this.M = t;
        }
        takeNextTask() {
            if (this.isEmpty()) return null;
            var t = this.j;
            return this.q(t), t;
        }
        merge(t, i) {
            if ("function" != typeof i) throw new TypeError("Must provide a selector function.");
            if (null == t) throw new Error("sourceQueue cannot be null");
            for(var r = this.j, s = null, e = t.j; e;){
                var n = e;
                if (e = e.O, i(n)) {
                    for(t.q(n); r && r.A < n.A;)s = r, r = r.O;
                    this.D(n, s), s = n;
                }
            }
        }
        D(t, i) {
            if (i != this.M) {
                var r = i ? i.O : this.j;
                t.O = r, r.N = t, t.N = i, null != i ? i.O = t : this.j = t;
            } else this.push(t);
        }
        q(t) {
            if (null == t) throw new Error("Expected task to be non-null");
            t === this.j && (this.j = t.O), t === this.M && (this.M = this.M.N), t.O && (t.O.N = t.N), t.N && (t.N.O = t.O);
        }
    }
    class l extends Event {
        constructor(i, r){
            if (!r || !t.includes(r.previousPriority)) throw new TypeError("Invalid task priority: '" + r.previousPriority + "'");
            super(i), this.previousPriority = r.previousPriority;
        }
    }
    class o extends AbortController {
        constructor(i){
            if (void 0 === i && (i = {}), super(), null == i && (i = {}), "object" != typeof i) throw new TypeError("'init' is not an object");
            var r, s, e = void 0 === i.priority ? "user-visible" : i.priority;
            if (!t.includes(e)) throw new TypeError("Invalid task priority: '" + e + "'");
            this.H = e, this.R = !1, s = (r = this).signal, Object.defineProperties(s, {
                priority: {
                    get: function() {
                        return r.H;
                    },
                    enumerable: !0
                },
                onprioritychange: {
                    value: null,
                    writable: !0,
                    enumerable: !0
                }
            }), s.addEventListener("prioritychange", (t)=>{
                s.onprioritychange && s.onprioritychange(t);
            });
        }
        setPriority(i) {
            if (!t.includes(i)) throw new TypeError("Invalid task priority: " + i);
            if (this.R) throw new DOMException("", "NotAllowedError");
            if (this.signal.priority !== i) {
                this.R = !0;
                var r = this.H;
                this.H = i;
                var s = new l("prioritychange", {
                    previousPriority: r
                });
                this.signal.dispatchEvent(s), this.R = !1;
            }
        }
    }
    void 0 === self.scheduler ? (self.scheduler = new class {
        constructor(){
            this.S = {}, t.forEach((t)=>{
                this.S[t] = [
                    new n,
                    new n
                ];
            }), this.U = null, this.W = new WeakMap;
        }
        yield() {
            return this.B(()=>{}, {
                priority: "user-visible"
            }, !0);
        }
        postTask(t, i) {
            return this.B(t, i, !1);
        }
        B(i, r, s) {
            if (void 0 !== (r = Object.assign({}, r)).signal) {
                if (null === r.signal || !("aborted" in r.signal) || "function" != typeof r.signal.addEventListener) return Promise.reject(new TypeError("'signal' is not a valid 'AbortSignal'"));
                if (r.signal && r.signal.priority && !t.includes(r.signal.priority)) return Promise.reject(new TypeError("Invalid task priority: '" + r.signal.priority + "'"));
            }
            if (void 0 !== r.priority && (null === r.priority || !t.includes(r.priority))) return Promise.reject(new TypeError("Invalid task priority: '" + r.priority + "'"));
            if (void 0 === r.delay && (r.delay = 0), r.delay = Number(r.delay), r.delay < 0) return Promise.reject(new TypeError("'delay' must be a positive number."));
            var e = {
                callback: i,
                options: r,
                resolve: null,
                reject: null,
                hostCallback: null,
                abortCallback: null,
                onTaskCompleted: function() {
                    this.options.signal && this.abortCallback && (this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null);
                },
                onTaskAborted: function() {
                    this.hostCallback && (this.hostCallback.cancel(), this.hostCallback = null), this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null, this.reject(this.options.signal.reason);
                },
                isAborted: function() {
                    return this.options.signal && this.options.signal.aborted;
                },
                isContinuation: s
            }, n = new Promise((t, i)=>{
                e.resolve = t, e.reject = i;
            });
            return this._(e), n;
        }
        _(t) {
            var i = t.options.signal;
            if (i) {
                if (i.aborted) return void t.reject(i.reason);
                t.abortCallback = ()=>{
                    t.onTaskAborted();
                }, i.addEventListener("abort", t.abortCallback);
            }
            t.options.delay > 0 ? t.hostCallback = new s(()=>{
                t.hostCallback = null, this.F(t);
            }, null, t.options.delay) : (this.G(t), this.J());
        }
        F(t) {
            this.G(t), this.U && (this.U.cancel(), this.U = null), this.K();
        }
        L(t) {
            var i = this.W.get(t);
            if (void 0 === i) throw new Error("Attempting to change priority on an unregistered signal");
            if (i !== t.priority) {
                for(var r = 0; r < 2; r++)this.S[t.priority][r].merge(this.S[i][r], (i)=>i.options.signal === t);
                this.W.set(t, t.priority);
            }
        }
        K() {
            this.U = null, this.V(), this.J();
        }
        J() {
            var { priority: t } = this.X();
            null != t && ("background" !== t && this.U && this.U.isIdleCallback() && (this.U.cancel(), this.U = null), this.U || (this.U = new s(()=>{
                this.K();
            }, t, 0)));
        }
        G(i) {
            var r;
            if (!t.includes(r = i.options.priority ? i.options.priority : i.options.signal && i.options.signal.priority ? i.options.signal.priority : "user-visible")) throw new TypeError("Invalid task priority: " + r);
            if (i.options.signal && i.options.signal.priority) {
                var s = i.options.signal;
                this.W.has(s) || (s.addEventListener("prioritychange", ()=>{
                    this.L(s);
                }), this.W.set(s, s.priority));
            }
            this.S[r][i.isContinuation ? 0 : 1].push(i);
        }
        V() {
            var t = null;
            do {
                var { priority: i, type: r } = this.X();
                if (null == i) return;
                t = this.S[i][r].takeNextTask();
            }while (t.isAborted());
            try {
                var s = t.callback();
                t.resolve(s);
            } catch (i) {
                t.reject(i);
            } finally{
                t.onTaskCompleted();
            }
        }
        X() {
            for(var i = 0; i < t.length; i++)for(var r = t[i], s = 0; s < 2; s++)if (!this.S[r][s].isEmpty()) return {
                priority: r,
                type: s
            };
            return {
                priority: null,
                type: 0
            };
        }
    }, self.TaskController = o, self.TaskPriorityChangeEvent = l) : self.scheduler.yield || (self.scheduler.yield = function() {
        return self.scheduler.postTask(()=>{}, {
            priority: "user-blocking"
        });
    });
}();




window.addEventListener('error', function(event) {
    alert('Error:\n' + event.message + '\n\nStack:\n' + event.error.stack);
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).captureException(event);
});
window.addEventListener('load', $1ccc8d3c866b7484$var$main);
async function $1ccc8d3c866b7484$var$main() {
    const elements = {
        main: document.querySelector('main'),
        resetBtn: document.querySelector('#controls_reset_btn'),
        buttons: document.querySelector('#buttons'),
        instructionsLink: document.querySelector('#pattern_select_dropdown_instructions')
    };
    (0, $e444d6404c095fa5$export$2e2bcd8739ae039).init('phc_hYSU225vNE9x5Xz1f9YBYf89Gzzqo0GAdXuMiu0NQII', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'always',
        persistence: 'localStorage'
    });
    const persistance = new (0, $00643d12b3a54506$export$2e2bcd8739ae039)();
    const thumbnails = new (0, $8a4d6517fbd25a59$export$45b50bca1da1e9b3)(persistance);
    let controls;
    let currentPattern;
    let showInfo = false;
    const viewer = window['viewer'] = new (0, $1e47030bd2e0e155$export$2e2bcd8739ae039)();
    const player = new (0, $f003126099aabc1e$export$2e2bcd8739ae039)(document.querySelector('#instructions'), viewer);
    await (0, $718de5d870731526$export$d594efb518b3cec4)();
    document.body.querySelectorAll('.pattern_only').forEach((0, $8d5cef8e7fea78a8$export$fe8985bb6374093c));
    const showShare = await (0, $38bb4a85553a6bfc$export$4fa6f570da04f7cc)();
    if (!showShare) document.querySelector('#share_menu_item').remove();
    const downloadDialog = document.querySelector('#download_dialog');
    const downloadInstructionsDialog = document.querySelector('#download_instructions_dialog');
    // TODO: Return true/false whether the action should be added to the URL.
    // When URL changes, close an open dialog
    const menuActions = {
        save_as: ()=>persistance.showSaveAsDialog(),
        delete: ()=>persistance.deletePattern(),
        save: ()=>persistance.saveCurrentPattern(),
        rename: ()=>persistance.renameCurrentPattern(),
        export: ()=>persistance.exportAllPatterns(),
        download: ()=>{
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToDialog('download');
        },
        instructions: ()=>showPanel('instructions'),
        design: ()=>showPanel('design'),
        info: ()=>showPanel('info'),
        share: ()=>sharePattern(),
        download_instructions: ()=>{
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToDialog('download_instructions');
        }
    };
    const dialogs = {
        download: ()=>{
            downloadDialog.show(viewer.pattern).finally(()=>(0, $a244379bf8b3b658$export$2e2bcd8739ae039).closeDialog());
        },
        download_instructions: ()=>{
            downloadInstructionsDialog.show(viewer.pattern).finally(()=>(0, $a244379bf8b3b658$export$2e2bcd8739ae039).closeDialog());
        }
    };
    (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('dialog', (dialogId)=>{
        if (dialogId in dialogs) dialogs[dialogId]();
        else if (dialogId in menuActions) menuActions[dialogId]();
    });
    (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('dialogClosed', ()=>{
        downloadDialog.close();
        downloadInstructionsDialog.close();
    });
    document.querySelector('#pattern_menu').addEventListener('select', (e)=>{
        const menuItemValue = e.detail.value;
        const itemElement = document.querySelector(`dropdown-menu-item[value="${menuItemValue}"]`);
        if (itemElement?.hasAttribute('selectable')) {
            document.querySelector('#pattern_menu [selected]')?.removeAttribute('selected');
            itemElement.setAttribute('selected', 'selected');
        }
        const action = menuActions[menuItemValue];
        if (action) {
            action();
            (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture('pattern_menu_select', {
                menu_item: menuItemValue
            });
        } else throw new Error(`No action available for menu item "${menuItemValue}".`);
    });
    document.body.addEventListener('click', (e)=>{
        const toggleBtn = e.target instanceof HTMLElement && e.target.closest('[data-toggle-for]');
        if (toggleBtn instanceof HTMLElement && toggleBtn) {
            const dialogId = toggleBtn.dataset.toggleFor;
            toggleBtn.classList.toggle('active');
            const toggledElement = document.querySelector('#' + dialogId);
            if (toggledElement) {
                toggledElement.classList.toggle('open');
                document.body.classList.toggle('dialog_' + dialogId);
            }
        }
    });
    elements.resetBtn.addEventListener('click', reset);
    async function sharePattern() {
        await (0, $38bb4a85553a6bfc$export$ed80d9de1d9df928)({
            renderer: viewer.renderer,
            pattern: viewer.pattern
        });
    }
    elements.instructionsLink.addEventListener('click', (e)=>{
        e.preventDefault();
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToMain();
    });
    thumbnails.addEventListener('select', ({ patternId: patternId })=>{
        const pattern = (0, $92270d8b7d92e411$export$ebb1a6b9e8c15cc2)(patternId);
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToPattern(pattern);
        (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture('thumbnail_select', {
            pattern: pattern.type,
            isTemplate: pattern.isTemplate
        });
    });
    const PANELS = [
        'info',
        'design',
        'instructions'
    ];
    function showPanel(panelId, navigateToFolder = true) {
        PANELS.forEach((panel)=>{
            if (panel !== panelId) {
                document.querySelector('#' + panel).classList.remove('open');
                document.querySelector(`dropdown-menu-item[value='${panel}']`)?.removeAttribute('selected');
                document.body.classList.remove('dialog_' + panel);
            }
        });
        document.querySelector(`dropdown-menu-item[value='${panelId}']`).setAttribute('selected', 'selected');
        const toggledElement = document.querySelector('#' + panelId);
        if (toggledElement && !toggledElement.classList.contains('open')) {
            toggledElement.classList.add('open');
            document.body.classList.add('dialog_' + panelId);
            currentPattern && viewer.update();
        }
        if (panelId === 'info') {
            showInfo = !showInfo;
            if (showInfo) (0, $fc3e3d346052d3b6$export$2e2bcd8739ae039).setPattern(currentPattern, viewer.size);
        }
        if (navigateToFolder) (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToFolder(panelId);
    }
    (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('folder', (folder)=>showPanel(folder, false));
    persistance.addEventListener('deletePattern', ({ pattern: pattern })=>{
        const templatePattern = (0, $92270d8b7d92e411$export$ebb1a6b9e8c15cc2)(pattern.type);
        if (templatePattern) {
            templatePattern.config = pattern.config;
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToPattern(templatePattern);
        }
    });
    persistance.addEventListener('save', ({ pattern: pattern })=>{
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToPattern(pattern);
    });
    persistance.addEventListener('newPattern', ({ pattern: pattern })=>{
        (0, $e444d6404c095fa5$export$2e2bcd8739ae039).capture('save_new_pattern', {
            pattern: pattern.type,
            config: JSON.stringify(pattern.config)
        });
    });
    (0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68)(document.querySelector('main'));
    initRouting();
    function initRouting() {
        setTimeout(()=>{
            const currentPanel = (0, $2509ceef6c629a64$export$235d49e7d4705350)();
            if (currentPanel) showPanel(currentPanel);
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('pattern', ({ pattern: pattern, renderer: renderer })=>{
            selectPattern(pattern);
            viewer.setPattern(pattern);
            thumbnails.close();
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).addEventListener('main', ()=>{
            thumbnails.open();
            unselectPattern();
        });
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).init();
    }
    function reset() {
        (0, $174f2c93f6348ee5$export$715f9d76bb8c1fea)({
            title: 'Reset options',
            description: currentPattern.isTemplate ? 'Are you sure you wish to reset options to defaults?' : 'Are you sure you wish to reset to the latest saved options?',
            submit: 'Reset'
        }).then(()=>{
            const pattern = (0, $92270d8b7d92e411$export$ebb1a6b9e8c15cc2)(currentPattern.id);
            (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToPattern(pattern);
        }, ()=>{});
    }
    function onInputsChange({ control: control }) {
        if (control.affectsStepCount !== false) player.update(viewer.getStepCount());
        (0, $a244379bf8b3b658$export$2e2bcd8739ae039).navigateToPattern(currentPattern, {
            renderer: viewer.renderer instanceof (0, $0649237e9259f2a7$export$2e2bcd8739ae039) ? 'svg' : undefined,
            replaceState: true
        });
        setIsDefaultConfig();
        if (showInfo) (0, $fc3e3d346052d3b6$export$2e2bcd8739ae039).setPattern(currentPattern, viewer.size);
    }
    function setIsDefaultConfig() {
        elements.main.dataset.isDefaultConfig = String(currentPattern.isDefaultConfig);
    }
    function selectPattern(pattern) {
        currentPattern = pattern;
        viewer.setPattern(pattern);
        controls?.destroy();
        persistance.setPattern(currentPattern);
        controls = new (0, $da037f8140467741$export$2e2bcd8739ae039)(pattern.configControls, pattern.config);
        controls.addEventListener('input', ({ control: control, value: value })=>{
            if (currentPattern) {
                currentPattern.setConfigValue(control.key, value);
                controls.config = currentPattern.config;
                viewer.update({
                    redrawNails: control.affectsNails !== false,
                    redrawStrings: control.affectsStrings !== false,
                    enableScheduler: true
                });
            }
        });
        controls.addEventListener('change', onInputsChange);
        thumbnails.setCurrentPattern(pattern);
        document.title = `${pattern.name} - String Art Studio`;
        document.body.setAttribute('data-pattern', pattern.id);
        document.body.querySelectorAll('.pattern_only').forEach((0, $8d5cef8e7fea78a8$export$f823a0c1cf7adf68));
        viewer.update();
        player.update(viewer.getStepCount(), {
            draw: false
        });
        if (showInfo) (0, $fc3e3d346052d3b6$export$2e2bcd8739ae039).setPattern(pattern, viewer.size);
        elements.main.dataset.isTemplate = String(currentPattern.isTemplate);
        setIsDefaultConfig();
    }
    function unselectPattern() {
        currentPattern = null;
        viewer.setPattern(null);
        thumbnails.setCurrentPattern(null);
        controls && controls.destroy();
        document.body.querySelectorAll('.pattern_only').forEach((0, $8d5cef8e7fea78a8$export$fe8985bb6374093c));
        document.body.removeAttribute('data-pattern');
    }
}


//# sourceMappingURL=string_art.e26c9579.js.map
